{
 " ao(à) paciente {nome}{cpf}": " al/alla paziente {nome}{cpf}",
 " junto ao plano de saúde {c}": " presso l'assicurazione sanitaria {c}",
 " às {h}": " alle {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" o \"Pagina 1 di 10\", nell'angolo che preferisci.",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" è su {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" non è JPG né PNG. Convertilo in JPG e riprova.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" non è un PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" alle {hora} si sovrappone a: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\" ora appartiene al gruppo. Entro 1 minuto gli altri membri vedranno tutto.",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" è stata creata con gli stessi dati.",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" è già stato aggiunto il {data}.",
 "% ao mês": "% al mese",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(Sul computer dell'amministratore: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(copia)",
 "(sem título)": "(senza titolo)",
 "+ Adicionar alerta": "+ Aggiungi avviso",
 "+ Adicionar outra OAB": "+ Aggiungi un'altra OAB",
 "+ Adicionar pausa": "+ Aggiungi pausa",
 "+ Adicionar subtarefa": "+ Aggiungi sottoattività",
 "+ Matéria em {nome}": "+ Materia in {nome}",
 "+ Perfil": "+ Profilo",
 "+ Subtarefa": "+ Sottoattività",
 "+5 min": "+5 min",
 "+{n} acompanhante(s)": "+{n} accompagnatore/i",
 "+{n} páginas acima da meta": "+{n} pagine sopra l'obiettivo",
 ", carteirinha nº {n},": ", tessera n. {n},",
 ", pago em {d}{f}": ", pagato il {d}{f}",
 "1 cápsula": "1 capsula",
 "1 dose": "1 dose",
 "1 dose (30 g)": "1 dose (30 g)",
 "1 pessoa": "1 persona",
 "1 publicação nova": "1 nuova pubblicazione",
 "1 página": "1 pagina",
 "1 tarja no documento": "1 banda nera nel documento",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Installa My Planner e crea il tuo account.  2. Riapri questo link (o inserisci il codice in Impostazioni › Gruppi e inviti).",
 "1. Quais dados tratamos": "1. Quali dati trattiamo",
 "1. Sobre o app": "1. Informazioni sull'app",
 "1ª dose": "1ª dose",
 "2 por folha": "2 per foglio",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 tazze di farina\n3 uova\n1 cucchiaio di lievito",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 o 9 pagine su ogni foglio (per stampare).",
 "2. Para que usamos": "2. Per cosa li usiamo",
 "2. Sua conta": "2. Il tuo account",
 "2ª dose": "2ª dose",
 "3 a 5 g": "da 3 a 5 g",
 "3. Bases legais (LGPD)": "3. Basi giuridiche (LGPD)",
 "3. Uso correto": "3. Uso corretto",
 "3ª dose": "3ª dose",
 "4 por folha": "4 per foglio",
 "4. Com quem compartilhamos": "4. Con chi li condividiamo",
 "4. Planos e testes": "4. Piani e prove",
 "5. Limites": "5. Limiti",
 "5. Segurança": "5. Sicurezza",
 "6 por folha": "6 per foglio",
 "6. Por quanto tempo": "6. Per quanto tempo",
 "7. Seus direitos (art. 18 da LGPD)": "7. I tuoi diritti (art. 18 della LGPD)",
 "8. Crianças e adolescentes": "8. Bambini e adolescenti",
 "9 por folha": "9 per foglio",
 "9. Mudanças": "9. Modifiche",
 "@letra-dom": "D",
 "@letra-qua": "M",
 "@letra-qui": "G",
 "@letra-sab": "S",
 "@letra-seg": "L",
 "@letra-sex": "V",
 "@letra-ter": "M",
 "A IA está classificando...": "L'IA sta classificando...",
 "A IA está lendo a caixa...": "L'IA sta leggendo il riquadro...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "L'IA legge le pagine e il PDF diventa ricercabile e copiabile.",
 "A IA lê o PDF e sugere um nome claro.": "L'IA legge il PDF e suggerisce un nome chiaro.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "L'IA non ha restituito una risposta nel formato previsto. Riprova.",
 "A IA não encontrou dados para esta ficha no arquivo.": "L'IA non ha trovato dati per questa scheda nel file.",
 "A IA não encontrou tarefas nesta caixa.": "L'IA non ha trovato attività in questo riquadro.",
 "A IA resume o PDF e responde perguntas.": "L'IA riassume il PDF e risponde alle domande.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "La SEFAZ registra che sei a conoscenza della fattura (non conferma né rifiuta l'acquisto) e rende disponibile l'XML completo alla prossima ricerca, entro 1 ora.",
 "A VENCER (7 DIAS)": "IN SCADENZA (7 GIORNI)",
 "A aba inteira": "L'intera scheda",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "La scheda {aba} è vicina al limite. Archivia o elimina gli elementi vecchi.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "La scheda {aba} non è in abbonamento. Il collegamento resta salvato e torna quando ti abboni.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "La ricerca di \"{nome}\" è troppo ampia. Usa il nome completo.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "La ricerca di GIF non è ancora attiva in questa app. Nel frattempo, usa gli sticker animati (🎉).",
 "A cada": "Ogni",
 "A cada N páginas": "Ogni N pagine",
 "A cada quantos dias": "Ogni quanti giorni",
 "A cada {n} dia(s)": "Ogni {n} giorno/i",
 "A cada {n} mês(es)": "Ogni {n} mese/i",
 "A cada {n} mês(es) · dia {d}": "Ogni {n} mese/i · giorno {d}",
 "A cada {n} semana(s)": "Ogni {n} settimana/e",
 "A cada {n} semana(s) · {dia}": "Ogni {n} settimana/e · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "Il riquadro è in {aba}, in \"Note ricevute\".",
 "A caixa foi para {destino}.": "Il riquadro è stato inviato a {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "La chiave resta salvata solo su questo dispositivo, nell'archivio sicuro del sistema. Su un altro dispositivo, inseriscila di nuovo.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "La chiave resta salvata solo in questo browser. Usalo su un computer personale.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "La connessione è cifrata. La cassaforte usa la crittografia end-to-end (AES-256): nemmeno l'assistenza può leggerla. L'app può essere bloccata con password, sequenza o biometria.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "La conferma tramite WhatsApp non è ancora attiva sul server.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "L'account e tutti i dati salvati nel cloud: attività, note, schede, schede dati, messaggi, file inviati all'app e impostazioni. Vengono eliminati anche i dati di questo dispositivo. Non si può annullare.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "Il colore appare nella barra, nei titoli e nelle attività collegate a questa scheda.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "Il colore di My Planner è il colore principale dell'app. Ogni attività può avere un colore proprio nella sua scheda.",
 "A data de fim é anterior à de início.": "La data di fine è precedente a quella di inizio.",
 "A data inicial precisa ser antes da final.": "La data di inizio deve essere prima di quella di fine.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "Il team esaminerà l'errore e lo correggerà in un prossimo aggiornamento.",
 "A equipe vê e altera conforme o papel de cada um": "Il team vede e modifica in base al ruolo di ciascuno",
 "A fazer": "Da fare",
 "A foto passa de 8 MB.": "La foto supera gli 8 MB.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "La foto è troppo grande. Installa la nuova versione dell'app per ritagliare la foto.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "La funzione \"nuvem\" non è ancora stata pubblicata sul server. Esegui 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "La funzione \"nuvem\" non è ancora stata pubblicata sul server. Esegui 9-LIGAR-DRIVE-ONEDRIVE.bat (vedi COMO RODAR, versione 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "La registrazione è ancora in preparazione. Riprova tra qualche minuto.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "L'ora resta fissata in questo fuso. In un altro fuso, l'app la mostra e ti avvisa all'orario convertito.",
 "A imagem original não está neste dispositivo.": "L'immagine originale non è su questo dispositivo.",
 "A pagar": "Da pagare",
 "A pagar: {v}": "Da pagare: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "L'autorizzazione al calendario è stata revocata. Riattivala nelle impostazioni del telefono.",
 "A pessoa sai do grupo e deixa de receber os envios.": "La persona esce dal gruppo e non riceve più gli invii.",
 "A receber": "Da ricevere",
 "A receber: {v}": "Da ricevere: {v}",
 "A reunião ainda está sendo gravada.": "La riunione è ancora in registrazione.",
 "A senha atual não confere.": "La password attuale non è corretta.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "La password della cassaforte deve avere almeno 6 caratteri.",
 "A senha precisa ter 8 caracteres ou mais.": "La password deve avere 8 caratteri o più.",
 "A senha precisa ter pelo menos 8 caracteres.": "La password deve avere almeno 8 caratteri.",
 "A senha é a mesma no celular e no My Planner Web.": "La password è la stessa sul telefono e su My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "La sincronizzazione avviene all'apertura dell'app e dopo ogni modifica. Le attività collegate al calendario mostrano 📆.",
 "A sua equipe num lugar só": "Il tuo team in un unico posto",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "Le faccende di casa non entrano da sole in My Planner. \"Invia a My Planner\" apre la scheda completa per scegliere giorno, orario, frequenza, pause e avvisi.",
 "A validade não pode ser antes da emissão.": "La scadenza non può essere precedente al rilascio.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "La versione per iPhone arriverà presto sull'App Store. Nel frattempo usa My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "La versione per iPhone arriverà presto sull'App Store. Nel frattempo, usa My Planner Web: in Safari, tocca Condividi > Aggiungi alla schermata Home per averlo come icona sul cellulare.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Lettera, A5 o Legale, senza tagliare nulla.",
 "ADICIONAR AMIGO": "AGGIUNGI AMICO",
 "AGUARDANDO RESPOSTA": "IN ATTESA DI RISPOSTA",
 "AMIGOS": "AMICI",
 "ANOTAÇÕES": "NOTE",
 "ANOTAÇÕES RECEBIDAS · {aba}": "NOTE RICEVUTE · {aba}",
 "ATIVIDADE": "ATTIVITÀ",
 "ATIVIDADE FÍSICA": "ATTIVITÀ FISICA",
 "ATRASADAS": "IN RITARDO",
 "Aba": "Scheda",
 "Aba bloqueada": "Scheda bloccata",
 "Aba {nome}": "Scheda {nome}",
 "Abas": "Schede",
 "Abas liberadas pelo suporte": "Schede sbloccate dall'assistenza",
 "Abas para comprar": "Schede da acquistare",
 "Abas que você já tem": "Schede che hai già",
 "Abastecimento": "Rifornimento",
 "Abastecimentos": "Rifornimenti",
 "Abdominal": "Addominali",
 "Abertura do prazo da declaração do IR": "Apertura del periodo per la dichiarazione IR",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Apri l'azienda e tocca \"Cerca fatture\" per inserire la password della cassaforte.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Apri My Planner Anne ed entra con il tuo documento e la password.",
 "Abra o My Planner no celular.": "Apri My Planner sul cellulare.",
 "Abra o cofre": "Apri la cassaforte",
 "Abra um PDF para começar.": "Apri un PDF per iniziare.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Apri una materia e tocca \"Studia ora\" per cronometrare. Imposta obiettivi settimanali per ogni materia.",
 "Abraço": "Abbraccio",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Apre il menu di condivisione del telefono: WhatsApp, e-mail, Google Drive, OneDrive, Salva in File e altro.",
 "Abre o PDF para ler aqui mesmo.": "Apre il PDF per leggerlo qui.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Apre lo Scanner PDF (bordi e ombre corretti).",
 "Abrir": "Apri",
 "Abrir Ajustes": "Apri Impostazioni",
 "Abrir PDF": "Apri PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "Apri PDF dal cellulare, Drive o OneDrive",
 "Abrir a aba": "Apri la scheda",
 "Abrir a cópia guardada": "Apri la copia salvata",
 "Abrir a pasta no Drive": "Apri la cartella su Drive",
 "Abrir com outro app": "Apri con un'altra app",
 "Abrir configurações": "Apri impostazioni",
 "Abrir em outro app": "Apri in un'altra app",
 "Abrir no DJEN": "Apri nel DJEN",
 "Abrir no modo seguro": "Apri in modalità sicura",
 "Abrir normalmente": "Apri normalmente",
 "Abrir nota fiscal": "Apri fattura",
 "Abrir o PDF": "Apri il PDF",
 "Abrir o PDF no {nome}": "Apri il PDF in {nome}",
 "Abrir o XML": "Apri l'XML",
 "Abrir o app": "Apri l'app",
 "Abrir o app My Planner": "Apri l'app My Planner",
 "Abrir o cartão": "Apri la carta",
 "Abrir o cofre": "Apri la cassaforte",
 "Abrir o cofre para ver": "Apri la cassaforte per vedere",
 "Abrir o diário oficial": "Apri la gazzetta ufficiale",
 "Abrir ou baixar": "Apri o scarica",
 "Abrir página": "Apri pagina",
 "Abrir site": "Apri sito",
 "Abrir {nome}": "Apri {nome}",
 "Acabamento": "Finiture",
 "Acabou": "Finito",
 "Academia": "Palestra",
 "Aceitar": "Accetta",
 "Aceitar, editar ou recusar": "Accetta, modifica o rifiuta",
 "Aceite os termos para continuar.": "Accetta i termini per continuare.",
 "Aceito": "Accettato",
 "Aceito com alterações": "Accettato con modifiche",
 "Acerto de contas": "Saldo dei conti",
 "Acerto de contas: {v}": "Saldo dei conti: {v}",
 "Acessibilidade": "Accessibilità",
 "Acesso ilimitado": "Accesso illimitato",
 "Acesso ilimitado a todas as funções, sem prazo": "Accesso illimitato a tutte le funzioni, senza scadenza",
 "Achatar": "Appiattisci",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Segue tutto, comprese le spese, e scrive nel diario.",
 "Acompanhamento": "Contorno",
 "Acompanhantes": "Accompagnatori",
 "Acrescentar no fim da página": "Aggiungi in fondo alla pagina",
 "Adaptador de tomada": "Adattatore per prese",
 "Adestramento": "Addestramento",
 "Adicionar": "Aggiungi",
 "Adicionar amigo": "Aggiungi amico",
 "Adicionar amigos do app": "Aggiungi amici dell'app",
 "Adicionar ao Planner?": "Aggiungere al Planner?",
 "Adicionar arquivo": "Aggiungi file",
 "Adicionar cômodo": "Aggiungi stanza",
 "Adicionar fotos e vídeos": "Aggiungi foto e video",
 "Adicionar imagem": "Aggiungi immagine",
 "Adicionar item (ex.: 2 ovos mexidos)": "Aggiungi elemento (es.: 2 uova strapazzate)",
 "Adicionar na página": "Aggiungi alla pagina",
 "Adicionar passo": "Aggiungi passaggio",
 "Adicionar país": "Aggiungi paese",
 "Adicionar página": "Aggiungi pagina",
 "Adicionar texto": "Aggiungi testo",
 "Adicionar {nome}": "Aggiungi {nome}",
 "Adicionar à equipe": "Aggiungi al team",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Aggiungi un amico con il suo codice o invia il tuo codice a chi vuoi.",
 "Admin": "Admin",
 "Administração": "Economia aziendale",
 "Adubar a cada quantos dias": "Concimare ogni quanti giorni",
 "Adubar: {p}": "Concimare: {p}",
 "Adubei hoje": "Concimata oggi",
 "Advogado": "Avvocato",
 "Advogados": "Avvocati",
 "Afundo": "Affondi",
 "Agachamento": "Squat",
 "Agenda do Google": "Google Calendar",
 "Agenda limpa": "Agenda pulita",
 "Agenda não liberada": "Calendario non autorizzato",
 "Agenda sincronizada ✓": "Calendario sincronizzato ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Agenda, note, finanze, studi, messaggi e molto altro in un'unica app.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Agenda, anagrafica pazienti e pagamenti, senza la cartella clinica.",
 "Agendado": "Pianificato",
 "Agendado no My Planner": "Programmato in My Planner",
 "Agendamento no pet shop": "Appuntamento dal toelettatore",
 "Agendar": "Pianifica",
 "Agendar no My Planner": "Programma in My Planner",
 "Agendar no My Planner (dias e horários)": "Programma in My Planner (giorni e orari)",
 "Agora não": "Non ora",
 "Agora o verso do documento.": "Ora il retro del documento.",
 "Agora, {hora}": "Ora, {hora}",
 "Agora: {ml}": "Ora: {ml}",
 "Aguardando o celular · {s}s": "In attesa del cellulare · {s}s",
 "Aguarde": "Attendi",
 "Aguarde um pouco": "Attendi un momento",
 "Aguarde...": "Attendi...",
 "Ainda a pagar no mês": "Ancora da pagare nel mese",
 "Ainda a receber no mês": "Ancora da incassare nel mese",
 "Ainda não confirmado": "Non ancora confermato",
 "Ainda não disponível: falta configurar no servidor.": "Non ancora disponibile: manca la configurazione sul server.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "Questo mese non hai ancora messo da parte niente. Che ne dici di accantonare {v} (il 10% di quanto è entrato) appena arrivano i soldi?",
 "Ainda não há feriados deste país para este ano.": "Non ci sono ancora festività di questo paese per quest'anno.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "Non c'è ancora niente da condividere in questa scheda. Crealo prima (es.: il viaggio) e torna qui.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "Non ci sono ancora altre persone nel gruppo (o non vedi l'elenco dei membri).",
 "Ainda não marcado como feito. Toque para abrir.": "Non ancora segnato come fatto. Tocca per aprire.",
 "Ainda não sincronizado": "Non ancora sincronizzato",
 "Ainda sem chave neste dispositivo.": "Ancora nessuna chiave su questo dispositivo.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking o diretto: prenotazioni, pulizia al check-out, entrate, spese e utile del mese",
 "Ajuda na organização": "Aiuta nell'organizzazione",
 "Ajudante": "Aiutante",
 "Ajustar": "Modifica",
 "Ajustar a data final": "Modifica la data di fine",
 "Ajustar a folha": "Regola il foglio",
 "Ajustar tamanho da página": "Adatta dimensione pagina",
 "Ajuste visual": "Regolazione visiva",
 "Ajustes": "Impostazioni",
 "Alarme dos remédios": "Sveglia dei farmaci",
 "Alarme que insiste até marcar como tomado": "Sveglia che insiste finché non segni l'assunzione",
 "Alemão": "Tedesco",
 "Alergia": "Allergia",
 "Alergias": "Allergie",
 "Alergias e alertas": "Allergie e avvisi",
 "Alertas": "Avvisi",
 "Alertas das tarefas": "Avvisi delle attività",
 "Alertas dos compromissos": "Avvisi degli impegni",
 "Algo deu errado, mas o app continua aberto": "Qualcosa è andato storto, ma l'app è ancora aperta",
 "Alguns arquivos foram guardados em outro dispositivo.": "Alcuni file sono stati salvati su un altro dispositivo.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Alcuni orologi (come quelli Huawei) potrebbero non inviare dati a Health Connect. In tal caso, inseriscili a mano.",
 "Alguém": "Qualcuno",
 "Alguém indicou o app para você?": "Qualcuno ti ha consigliato l'app?",
 "Alimentação": "Alimentazione",
 "Alimentação & Despensa": "Alimentazione & Dispensa",
 "Alimentação {semana}": "Alimentazione {semana}",
 "Alimento": "Alimento",
 "Alinhamento e balanceamento": "Convergenza ed equilibratura",
 "Almoço": "Pranzo",
 "Alongamento": "Stretching",
 "Alta": "Alta",
 "Alterado por último por {nome}": "Modificato l'ultima volta da {nome}",
 "Alterar metadados": "Modifica metadati",
 "Alterar o valor pago": "Modifica importo pagato",
 "Alterações": "Modifiche",
 "Alto-falante": "Altoparlante",
 "Aluga como": "Affitta come",
 "Alugar a casa ou um cômodo": "Affittare la casa o una stanza",
 "Aluguel": "Affitto",
 "Aluguel & Hospedagem": "Affitti & Ospitalità",
 "Aluguel de carro": "Noleggio auto",
 "Aluno": "Alunno",
 "Alunos": "Alunni",
 "Alvará ou licença": "Permesso o licenza",
 "Alvenaria": "Muratura",
 "Alvo": "Importo obiettivo",
 "Alíquota do ISS (%)": "Aliquota ISS (%)",
 "Alíquota do ISS deste serviço (%)": "Aliquota ISS di questo servizio (%)",
 "Amanhã": "Domani",
 "Ambiente": "Ambiente",
 "Ameno": "Mite",
 "Amigos": "Amici",
 "Amor": "Amore",
 "Amortização": "Ammortamento",
 "Ampliar a foto": "Ingrandisci la foto",
 "Amém": "Amen",
 "Analisar com IA": "Analizza con l'IA",
 "Anamnese e histórico (no cofre)": "Anamnesi e storia clinica (nella cassaforte)",
 "Anexar arquivos": "Allega file",
 "Anexar comprovante": "Allega ricevuta",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Allegare documenti, importare estratti conto e salvare report, PDF e backup.",
 "Anexos": "Allegati",
 "Anexos guardados aqui no dispositivo: {n}": "Allegati salvati solo su questo dispositivo: {n}",
 "Animais e natureza": "Animali e natura",
 "Animação": "Animazione",
 "Anime": "Anime",
 "Aniversário": "Compleanno",
 "Aniversário de Campo Grande": "Anniversario di Campo Grande",
 "Aniversário de São Paulo": "Anniversario di São Paulo",
 "Ano": "Anno",
 "Ano anterior": "Anno precedente",
 "Ano de lançamento": "Anno di uscita",
 "Ano de {ano}": "Anno {ano}",
 "Ano passado": "L'anno scorso",
 "Anotar pela foto da página": "Annota dalla foto della pagina",
 "Anotação": "Nota",
 "Anotação de {data}": "Nota del {data}",
 "Anotação do professor": "Nota dell'insegnante",
 "Anotação à mão": "Nota a mano",
 "Anotações": "Note",
 "Anotações Rápidas": "Note rapide",
 "Anotações arquivadas": "Note archiviate",
 "Anotações arquivadas ({n})": "Note archiviate ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Annota ogni prenotazione con date, provenienza e importi. La pulizia del check-out entra da sola nell'elenco delle pulizie.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Annota ogni giorno del cantiere con foto. Segna le foto come Prima o Dopo per vedere l'avanzamento.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Annota cosa hai prestato o preso in prestito, con foto e scadenza. L'app ti avvisa il giorno della restituzione.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Annota i posti che vuoi visitare. Cercali su Google Maps o Waze, traccia il percorso che passa per tutti e aggiungili all'itinerario del giorno.",
 "Anteriores ({n})": "Precedenti ({n})",
 "Antes": "Prima",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Prima di iniziare, scopri cosa usa l'app e perché. Puoi cambiare tutto in seguito in Impostazioni > Privacy e termini.",
 "Antes de uma data": "Prima di una data",
 "Antes do início": "Prima dell'inizio",
 "Antes e depois": "Prima e dopo",
 "Antes: {lista}": "Prima: {lista}",
 "Antipulgas": "Antipulci",
 "Anual": "Annuale",
 "Ao ar livre": "All'aperto",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "Se annulli, la scheda diventa in bianco e nero e i collegamenti spariscono dalle attività, ma non viene cancellato nulla.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "Creando l'account o continuando a usare l'app, accetti questi termini e l'informativa sulla privacy qui sotto.",
 "Ao fechar, a página é salva.": "Alla chiusura, la pagina viene salvata.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "Salvando, crei la password della cassaforte. Questo campo è cifrato sul dispositivo.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "Toccando \"File\" o \"Foto\" in Studio e Documenti, il selettore del telefono mostra Google Drive, OneDrive e Dropbox (se le app sono installate). Scegli il file direttamente da lì.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Toccando un file allegato, si apre nell'app del telefono che scegli (su Android, \"Solo una volta\" o \"Sempre\"). Ciò che modifichi lì viene salvato nel file stesso.",
 "Apaga a conta e todos os vencimentos dela.": "Elimina il conto e tutte le sue scadenze.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Elimina le materie e le pagine di questo raccoglitore. Le attività del planner restano.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Elimina le pagine di questa materia. Il tempo di studio resta nello storico.",
 "Apaga o cartão e as compras dele.": "Elimina la carta e i suoi acquisti.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Elimina per sempre l'account e tutti i dati nel cloud e su questo dispositivo. Non si può annullare.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Elimina tutte le attività dell'agenda, passate e future.",
 "Apaga todas as {n} parcelas.": "Elimina tutte le {n} rate.",
 "Apaga todos os meses desta conta.": "Elimina tutti i mesi di questo conto.",
 "Apagar": "Elimina",
 "Apagar \"{nome}\"?": "Eliminare \"{nome}\"?",
 "Apagar a caixa?": "Eliminare il riquadro?",
 "Apagar a chave": "Elimina la chiave",
 "Apagar a chave deste dispositivo?": "Eliminare la chiave da questo dispositivo?",
 "Apagar a conta?": "Eliminare l'account?",
 "Apagar a lista de erros?": "Cancellare l'elenco degli errori?",
 "Apagar a pasta (os documentos continuam)": "Elimina la cartella (i documenti restano)",
 "Apagar as da agenda": "Elimina quelle del calendario",
 "Apagar caixa": "Elimina riquadro",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Cancella davvero (le pagine con bande diventano immagini)",
 "Apagar de vez": "Elimina definitivamente",
 "Apagar desenho": "Elimina disegno",
 "Apagar envio": "Elimina invio",
 "Apagar lista": "Cancella elenco",
 "Apagar minha conta": "Elimina il mio account",
 "Apagar minha conta e todos os dados": "Elimina il mio account e tutti i dati",
 "Apagar o escritório": "Elimina l'ufficio",
 "Apagar o escritório?": "Eliminare l'ufficio?",
 "Apagar o grupo": "Elimina il gruppo",
 "Apagar o grupo?": "Eliminare il gruppo?",
 "Apagar o lançamento?": "Eliminare il movimento?",
 "Apagar para todos": "Elimina per tutti",
 "Apagar tudo": "Elimina tutto",
 "Apagar tudo antes de": "Elimina tutto prima del",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Elimina in un colpo solo le attività di oggi, del mese, di un periodo o per nome. Prima di eliminare, l'app mostra cosa verrà rimosso e chiede la tua password.",
 "Aparece na barra quando estiver liberada": "Appare nella barra quando è sbloccata",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Compaiono nel Planner, insieme alle giornate facoltative (Carnevale, Mercoledì delle Ceneri e Corpus Domini).",
 "Aplicar": "Applica",
 "Aponte a câmera do celular para este QR Code.": "Inquadra questo QR Code con la fotocamera del cellulare.",
 "Aponte para o QR Code na tela do computador": "Inquadra il QR Code sullo schermo del computer",
 "Apostila": "Dispensa",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Dispense, esercizi, slide, video, link e avvisi. Da ⋮ › Invia a un gruppo, ogni alunno lo riceve nella sua app.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "App usata dal pulsante \"Percorso\" degli indirizzi (attività, visite, itinerario del viaggio, lavori, scuola...).",
 "Apple Saúde": "Apple Salute",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: salva già tutto nell'app Salute dell'iPhone. Non devi fare nulla.",
 "Apresentação": "Presentazione",
 "Aprovação": "Approvazione",
 "Aqui": "Qui",
 "Ar-condicionado": "Aria condizionata",
 "Arco-íris": "Arcobaleno",
 "Arenoso": "Sabbioso",
 "Armazenamento": "Spazio di archiviazione",
 "Armário": "Armadio",
 "Arquivadas ({n})": "Archiviate ({n})",
 "Arquivados ({n})": "Archiviati ({n})",
 "Arquivar": "Archivia",
 "Arquivar a caixa de anotações?": "Archiviare il riquadro di note?",
 "Arquivar conversa": "Archivia chat",
 "Arquivo": "File",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "File (Drive, OneDrive, Dropbox o dal dispositivo)",
 "Arquivo OFX ou CSV do banco": "File OFX o CSV della banca",
 "Arquivo adicionado": "File aggiunto",
 "Arquivo menor (para WhatsApp e e-mail)": "File più leggero (per WhatsApp ed e-mail)",
 "Arquivo menor para WhatsApp e e-mail.": "File più leggero per WhatsApp ed e-mail.",
 "Arquivo não encontrado.": "File non trovato.",
 "Arquivo ou PDF": "File o PDF",
 "Arquivo ou documento": "File o documento",
 "Arquivos": "File",
 "Arquivos (frente, verso, PDF)": "File (fronte, retro, PDF)",
 "Arquivos (importar e exportar)": "File (importa ed esporta)",
 "Arquivos de {nome}": "File di {nome}",
 "Arquivos na nuvem e cópias de segurança": "File nel cloud e backup",
 "Arrasou!": "Spettacolo!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Trascina i punti sui 4 angoli del foglio. L'app ritaglia e raddrizza la pagina.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Trascina il dito su ciò che vuoi nascondere. Tocca una banda per toglierla.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Scorri a destra per eliminare, o a sinistra per inviare a un'altra scheda.",
 "Arraste para a direita para excluir.": "Trascina verso destra per eliminare.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Trascina per cambiare l'ordine, ruota, duplica, elimina e aggiungi pagine bianche.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Trascina per vedere il resto della bacheca. Si espande verso il basso e verso destra.",
 "Arraste um documento para a direita para excluir.": "Scorri un documento verso destra per eliminarlo.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Trascina un riquadro a sinistra per archiviarlo o a destra per eliminarlo.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Trascina un riquadro a sinistra per archiviarlo o a destra per eliminarlo. Tieni premuto ⋮⋮ per cambiare l'ordine.",
 "Arroz": "Riso",
 "Artes": "Arte",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Gli abbonamenti Claude Pro, ChatGPT Plus e Gemini Advanced non possono essere usati da altre app. Per attivare l'IA qui, crea una chiave API nel tuo account (Gemini ha un uso gratuito; Claude e ChatGPT si pagano a consumo, pochi centesimi per analisi).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "Le chiamate non sono ancora state attivate sul server (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "Anche i suoi acquisti vengono rimossi dalla Finanza.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "Gli acquisti a rate vengono registrati con tutte le rate: le prossime compaiono già negli estratti successivi.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "Le foto di questo documento sono sul dispositivo dove è stato scansionato. Lì puoi modificarlo, condividerlo e leggere il testo.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "Le immagini vanno solo all'IA che hai scelto, con la tua chiave.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "Le pulizie dei check-out compaiono qui da sole, con checklist e foto prima e dopo.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "Le fatture emesse qui, quelle trovate nella ricerca e gli XML importati compaiono in questa lista.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "Le rate compaiono qui. Allega la ricevuta (foto, PDF o screenshot del PIX) a ciascuna.",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "Le rate dei prossimi 12 mesi sono già nel My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "Le rate aperte vengono ricalcolate con l'importo, gli interessi e la durata attuali del contratto. Quelle pagate non cambiano.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "Le pagine di questo documento sono sul dispositivo dove è stato scansionato. Aprilo lì o usa la copia salvata su Drive o OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "Le pagine diventano immagini più leggere: ottimo per PDF scansionati. Il testo non è più ricercabile (usa l'OCR dopo, se serve).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "Le pagine vanno solo all'IA che hai scelto, con la tua chiave.",
 "As receitas do cardápio já têm tudo na despensa.": "In dispensa c'è già tutto per le ricette del menu.",
 "As senhas novas não conferem.": "Le nuove password non coincidono.",
 "As senhas não conferem.": "Le password non coincidono.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "Le attività restano in My Planner. Vuoi eliminare anche quelle arrivate da Google Calendar?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "Le attività della stanza restano in La mia casa, senza stanza.",
 "As tarefas vinculadas continuam no My Planner.": "Le attività collegate restano in My Planner.",
 "Aspirar e passar pano": "Aspirare e lavare i pavimenti",
 "Assinada": "In abbonamento",
 "Assinar": "Firma",
 "Assinar (simulação de teste)": "Abbonati (simulazione di prova)",
 "Assinar o documento": "Firma il documento",
 "Assinatura": "Firma",
 "Assinatura do profissional": "Firma del professionista",
 "Assinatura e segurança": "Firma e sicurezza",
 "Assinaturas (simulação de teste)": "Abbonamenti (simulazione di prova)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Abbonati alla scheda in Impostazioni per inviarle note.",
 "Assine a aba em Ajustes para vincular.": "Abbonati alla scheda in Impostazioni per collegarla.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Abbonati alla scheda in Impostazioni › Acquisti per inviarle note.",
 "Assine a aba em Ajustes › Compras para vincular.": "Abbonati alla scheda in Impostazioni › Acquisti per collegarla.",
 "Assine a aba para abrir o vínculo.": "Abbonati alla scheda per aprire il collegamento.",
 "Assisti mais uma aula": "Ho seguito un'altra lezione",
 "Assistido": "Visto",
 "Assistindo": "In visione",
 "Assistência técnica (nome)": "Assistenza tecnica (nome)",
 "Assistência: {nome}": "Assistenza: {nome}",
 "Assunto": "Argomento",
 "Assunto (ex.: Reunião semanal)": "Oggetto (es.: Riunione settimanale)",
 "Atender": "Rispondi",
 "Atendimento": "Visita",
 "Atendimentos": "Visite",
 "Ativar avisos": "Attiva notifiche",
 "Ativar monitor": "Attiva monitoraggio",
 "Ativas": "Attive",
 "Atividade": "Attività",
 "Atividade do roteiro": "Attività dell'itinerario",
 "Atividade hoje": "Attività di oggi",
 "Atividade: {blocos}": "Attività: {blocos}",
 "Atividades": "Attività",
 "Atividades de hoje": "Attività di oggi",
 "Atividades e materiais": "Attività e materiali",
 "Atividades físicas e saúde": "Sport e salute",
 "Atrasada": "In ritardo",
 "Atrasada há {n} dia(s)": "In ritardo di {n} giorno/i",
 "Atrasadas": "In ritardo",
 "Atrasados": "In ritardo",
 "Atuais": "Attuali",
 "Atualidades": "Attualità",
 "Atualizar": "Aggiorna",
 "Atualizar agora": "Aggiorna ora",
 "Atualizar alarmes no My Planner": "Aggiorna le sveglie in My Planner",
 "Atualizar rega e adubo na agenda": "Aggiorna annaffiature e concime in agenda",
 "Atualização automática disponível no app instalado (APK).": "Aggiornamento automatico disponibile nell'app installata (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Aggiornamento scaricato. Si applica alla riapertura dell'app o toccando l'avviso.",
 "Atualização pronta": "Aggiornamento pronto",
 "Atualizações": "Aggiornamenti",
 "Até": "Fino al",
 "Audiência": "Udienza",
 "Aula dada": "Lezione svolta",
 "Aula {a} de {n} ({p}%)": "Lezione {a} di {n} ({p}%)",
 "Aulas assistidas": "Lezioni seguite",
 "Autoajuda": "Crescita personale",
 "Autor": "Autore",
 "Avaliação": "Valutazione",
 "Avaliações e notas": "Valutazioni e voti",
 "Avançado": "Avanzate",
 "Aveia": "Avena",
 "Avisar a hora de sair": "Avvisami quando partire",
 "Avisar antes de vencer": "Avvisa prima della scadenza",
 "Avisar no celular quando alguém incluir algo": "Avvisami sul telefono quando qualcuno aggiunge qualcosa",
 "Aviso": "Avviso",
 "Aviso com as tarefas do dia": "Avviso con le attività del giorno",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Notifica di prova inviata dal server. Arriva in pochi secondi; esci dall'app per vederla nella barra del telefono.",
 "Aviso enviado": "Notifica inviata",
 "Aviso {dias} dia(s) antes e no dia": "Avviso {dias} giorno/i prima e il giorno stesso",
 "Avisos no celular": "Notifiche sul telefono",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Le notifiche passano attraverso i servizi di Expo, Google e Apple.",
 "Ação": "Azione",
 "Ações": "Azioni",
 "BOLETO E DOCUMENTOS": "BOLETO E DOCUMENTI",
 "Backup importado.": "Backup importato.",
 "Bairro": "Quartiere",
 "Baixa": "Bassa",
 "Baixando atualização...": "Download dell'aggiornamento...",
 "Baixar": "Scarica",
 "Baixar a versão {v}": "Scarica la versione {v}",
 "Baixar agora": "Scarica ora",
 "Baixar o My Planner para Android": "Scarica My Planner per Android",
 "Baixar o My Planner para Android (versão {v})": "Scarica My Planner per Android (versione {v})",
 "Baixar o My Planner para iPhone": "Scarica My Planner per iPhone",
 "Baixar o PDF da nota (DANFSe)": "Scarica il PDF della fattura (DANFSe)",
 "Baixar o PDF?": "Scaricare il PDF?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Scarica l'XML completo (dà presa visione alla SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Scarica l'ultima versione per Android: {apk}",
 "Baixe aqui a versão mais recente: {link}": "Scarica qui la versione più recente: {link}",
 "Balança": "Dondola",
 "Balanço e relatórios": "Bilancio e report",
 "Banana": "Banana",
 "Banco": "Banca",
 "Banco, financeira ou pessoa": "Banca, finanziaria o persona",
 "Bandeiras": "Bandiere",
 "Banheiro": "Bagno",
 "Banho": "Bagno",
 "Banho e tosa": "Bagno e tosatura",
 "Barra": "Barra",
 "Bateria": "Batteria",
 "Batimentos (média)": "Battito (media)",
 "Batizado": "Battesimo",
 "Bebida": "Bevanda",
 "Bebê": "Neonato",
 "Beijo": "Bacio",
 "Bem": "Bene",
 "Bem clara": "Molto chiara",
 "Bem-Estar": "Benessere",
 "Bem-Estar · Cronograma alimentar": "Benessere · Piano alimentare",
 "Bens": "Beni",
 "Bichos e diversão": "Animali e svago",
 "Bicicleta": "Bicicletta",
 "Bicicleta ergométrica": "Cyclette",
 "Biografia": "Biografia",
 "Biologia": "Biologia",
 "Biometria (digital ou rosto)": "Biometria (impronta o volto)",
 "Biometria ({tipos})": "Biometria ({tipos})",
 "Biometria não confirmada.": "Biometria non confermata.",
 "Bloqueado": "Bloccato",
 "Bloquear": "Blocca",
 "Bloquear agora": "Blocca ora",
 "Bloqueio": "Blocco",
 "Blusas de frio": "Maglioni",
 "Boa noite": "Buonanotte",
 "Boa sorte!": "In bocca al lupo!",
 "Boas-vindas ao My Planner": "Benvenuto in My Planner",
 "Boas-vindas pelo WhatsApp": "Benvenuto via WhatsApp",
 "Boleto": "Boleto",
 "Boleto anexado": "Boleto allegato",
 "Boleto do banco {b}": "Boleto della banca {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto e documenti (foto, PDF o file)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto o bolletta (foto, PDF o file)",
 "Boleto por foto": "Boleto da foto",
 "Bolinha": "Pallino",
 "Bom dia": "Buongiorno",
 "Bom dia!": "Buongiorno!",
 "Bom dia! Seu dia no My Planner": "Buongiorno! La tua giornata su My Planner",
 "Booking": "Booking",
 "Bora!": "Andiamo!",
 "Borboleta": "Farfalla",
 "Borracha": "Gomma",
 "Botas para neve": "Stivali da neve",
 "Brasil": "Brasile",
 "Braços acima da cabeça": "Braccia sopra la testa",
 "Brilho": "Brillio",
 "Brinquedo ou livro para a viagem": "Gioco o libro per il viaggio",
 "Busca de notas": "Ricerca fatture",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Cerca il nome nelle gazzette comunali raccolte da Querido Diário (Open Knowledge Brasil). Non tutti i comuni sono inclusi e le gazzette ufficiali non fanno parte del DJEN.",
 "Buscando...": "Ricerca in corso...",
 "Buscar": "Cerca",
 "Buscar GIF (ex.: parabéns, bom dia)": "Cerca GIF (es.: auguri, buongiorno)",
 "Buscar cidade, país ou GMT": "Cerca città, paese o GMT",
 "Buscar conversa": "Cerca chat",
 "Buscar documento, titular ou órgão": "Cerca documento, titolare o ente",
 "Buscar em {nome}": "Cerca in {nome}",
 "Buscar emoji (ex.: coração, risada)": "Cerca emoji (es.: cuore, risata)",
 "Buscar figurinha": "Cerca sticker",
 "Buscar notas": "Cerca fatture",
 "Buscar ou digitar um alimento": "Cerca o scrivi un alimento",
 "Buscar país": "Cerca paese",
 "Buscar pelo nome ou pelo texto": "Cerca per nome o per testo",
 "Buscar produto, loja ou observação": "Cerca prodotto, negozio o nota",
 "Buscar tarefas": "Cerca attività",
 "Buscar: processo, parte, tribunal, palavra...": "Cerca: causa, parte, tribunale, parola...",
 "CAIXA {n}": "SCATOLA {n}",
 "CARDS DE ANOTAÇÕES": "SCHEDE DI NOTE",
 "CARTÕES": "CARTE",
 "CEP": "CEP (CAP)",
 "CID (se o paciente pedir na declaração)": "CID (se il paziente lo chiede nella dichiarazione)",
 "CID: {c}": "CID: {c}",
 "CNH": "Patente (CNH)",
 "CNPJ (se tiver)": "CNPJ (se presente)",
 "CNPJ ou CPF": "CNPJ o CPF",
 "COMPROVANTE DE PAGAMENTO": "RICEVUTA DI PAGAMENTO",
 "COMPROVANTE DE RECEBIMENTO": "RICEVUTA DI INCASSO",
 "COMPROVANTES ANTERIORES": "RICEVUTE PRECEDENTI",
 "CONTAS DO MÊS": "CONTI DEL MESE",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Brasile)",
 "CPF de quem paga": "CPF di chi paga",
 "CPF do paciente": "CPF del paziente",
 "CPF do pagador": "CPF del pagante",
 "CPF inválido": "CPF non valido",
 "CPF ou CNPJ de quem recebeu": "CPF o CNPJ di chi ha ricevuto",
 "CPF ou senha incorretos.": "CPF o password errati.",
 "CRIAR CÔMODO": "CREA STANZA",
 "CRIAR UM GRUPO": "CREA UN GRUPPO",
 "CRONOGRAMA ALIMENTAR": "PIANO ALIMENTARE",
 "CUIDADOS PESSOAIS": "CURA PERSONALE",
 "Cabeleireiro": "Parrucchiere",
 "Cabelo": "Capelli",
 "Cachorro": "Cane",
 "Cactos e suculentas": "Cactus e succulente",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Ogni scheda extra: {n} giorni gratis; poi {preco} all'anno.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Ogni file pronto va su {nome}. I PDF aperti restano anche su questo dispositivo, nell'elenco qui sotto.",
 "Cada dia da semana": "Ogni giorno della settimana",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Ogni nuovo documento va su {nome} quando lo chiudi. Le foto delle pagine restano solo su questo dispositivo.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Ogni persona del team riceve la riunione in Ricevuti e la mette nel Planner con un tocco, con l'avviso.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Ogni persona del gruppo lo riceve e decide se accettarlo.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "Ogni pagina contiene un riassunto, una lezione o un capitolo. Segnala come ripassata quando hai finito.",
 "Cada página vira uma imagem JPG.": "Ogni pagina diventa un'immagine JPG.",
 "Cada refeição se repete nos dias dela": "Ogni pasto si ripete nei suoi giorni",
 "Cadastrar": "Aggiungi",
 "Cadastrar cartão de crédito": "Aggiungi carta di credito",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Registra dalla foto (pagina del corso, certificato, volantino)",
 "Cadastrar pela foto da capa": "Registra dalla foto della copertina",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Compila \"I miei dati\" perché le ricevute escano con il tuo nome, ordine professionale e numero.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Registra carta d'identità, patente, passaporto, contratti e certificati. L'app ti avvisa prima della scadenza e invia il documento con un tocco.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Registra l'azienda (o te stesso, come professionista) con CNPJ o CPF, comune e regime. Poi collega il certificato A1 per emettere NFS-e secondo il Padrão Nacional e cercare le fatture emesse e ricevute.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Crea il cantiere e, al suo interno, le fasi con il preventivo, il diario con foto, i professionisti e le consegne di materiale.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Crea il viaggio e, al suo interno, l'itinerario di ogni giorno, le prenotazioni e la valigia. Durante il viaggio, l'itinerario appare in My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Registra solo il tuo nome e la tua OAB.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Aggiungi i bambini: verifiche, riunioni, visite e vaccini stanno dentro ciascuno.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Aggiungi ogni animale: libretto delle vaccinazioni, vermifughi, farmaci e toelettatura stanno dentro.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Aggiungi ogni pianta con luce, terreno e ogni quanti giorni annaffiarla e concimarla. L'app crea il calendario in agenda.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Aggiungi ogni veicolo. Dentro ci sono le manutenzioni (con avviso per km e per data) e le scadenze di IPVA, immatricolazione e assicurazione.",
 "Cadastre digital ou rosto no aparelho para usar.": "Registra l'impronta o il volto sul dispositivo per usarla.",
 "Cadastre o cartão primeiro": "Aggiungi prima la carta",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Registra il finanziamento o il prestito con importo, interessi e numero di rate. L'app calcola le rate, il debito residuo e avvisa delle scadenze.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Registra l'intero alloggio o ogni stanza che affitti. Dentro ognuno ci sono prenotazioni, pulizie e spese.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Aggiungi il libro con il totale di pagine e l'obiettivo giornaliero. Tocca ⋮ per sommare le pagine lette.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Aggiungi il farmaco con gli orari e tocca ⋮ per metterlo nella cronologia con sveglia.",
 "Cadastre os alunos da turma na aba Alunos.": "Aggiungi gli alunni della classe nella scheda Alunni.",
 "Cadastre os clientes para separar as horas.": "Aggiungi i clienti per separare le ore.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Registra i clienti che ricevono le tue fatture. L'indirizzo è facoltativo (se lo compili, indica CEP, codice IBGE, via, numero civico e quartiere).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Registra i servizi che fatturi più spesso, con il codice tributario nazionale. Al momento dell'emissione basta un tocco.",
 "Cadastre primeiro em {nome}.": "Aggiungi prima in {nome}.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Inserisci nome, ordine professionale e numero di iscrizione. Compaiono su ricevute e dichiarazioni.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Registra i tuoi clienti nella scheda \"Committenti\" dell'azienda per sceglierli qui.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Inserisci i tuoi dati professionali (nome, ordine e numero) in \"I miei dati\" perché compaiano nel documento.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Inserisci i tuoi dati professionali (nome, ordine e numero) in \"I miei dati\" perché compaiano nella ricevuta.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Registra i tuoi pazienti. Dentro ognuno ci sono le visite con evoluzione, prescrizione, pagamento, ricevuta e dichiarazione per l'assicurazione sanitaria.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Aggiungi te stesso e ogni persona della famiglia. Ognuna contiene visite, esami, vaccini e farmaci. I dati sensibili vanno nella cassaforte cifrata.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Registrazione in attesa di abilitazione: disattiva \"Confirm email\" in Supabase (vedi COMO RODAR).",
 "Cadastro recebido": "Registrazione ricevuta",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Registrazione: nome, CPF o e-mail, password (conservata solo in forma protetta) ed e-mail di contatto.",
 "Cadastros": "Anagrafiche",
 "Cadastros e comprovantes": "Anagrafiche e ricevute",
 "Cadeira extensora": "Leg extension",
 "Café": "Caffè",
 "Café da manhã": "Colazione",
 "Café ou bar": "Caffè o bar",
 "Café?": "Caffè?",
 "Cafés": "Caffè",
 "Caixa": "Scatola",
 "Caixa arquivada": "Riquadro archiviato",
 "Caixa com checklist, lista ou texto livre": "Riquadro con checklist, elenco o testo libero",
 "Caixa {n}": "Scatola {n}",
 "Caixas": "Scatole",
 "Caixas e cronograma da mudança.": "Scatoloni e programma del trasloco.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Scatole per stanza con etichetta, voltura di acqua, luce e internet, sopralluoghi e il programma dei giorni.",
 "Calculadora": "Calcolatrice",
 "Calculando...": "Calcolo in corso...",
 "Calendário": "Calendario",
 "Calendário da planta": "Calendario della pianta",
 "Calendário do imposto": "Calendario fiscale",
 "Calendários": "Calendari",
 "Calorias em atividade": "Calorie in attività",
 "Calorias gastas em atividade (kcal)": "Calorie bruciate in attività (kcal)",
 "Calça térmica (segunda pele)": "Pantaloni termici (intimo tecnico)",
 "Calças ou bermudas": "Pantaloni o bermuda",
 "Cama": "Letto",
 "Caminhada": "Camminata",
 "Caminhão": "Camion",
 "Camisetas": "Magliette",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "Campi modulo",
 "Cancelada": "Annullata",
 "Canceladas": "Annullate",
 "Cancelar": "Annulla",
 "Cancelar a NFS-e": "Annulla la NFS-e",
 "Cancelar a NFS-e {n}?": "Annullare la NFS-e {n}?",
 "Cancelar a nota": "Annulla la fattura",
 "Cancelar a reunião \"{nome}\"?": "Annullare la riunione \"{nome}\"?",
 "Cancelar reunião": "Annulla riunione",
 "Caneta": "Penna",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Acquisizione automatica del server: ogni 2 ore, dalle 08:00 alle 20:00",
 "Captura automática: todos os dias às 08h e 12h": "Acquisizione automatica: ogni giorno alle 08:00 e alle 12:00",
 "Card": "Scheda",
 "Cardápio": "Menu",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Menu della settimana, ricette, lista della spesa automatica e scadenze della dispensa.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Menu solo per questo giorno. Gli altri giorni restano con quello della settimana.",
 "Carga (kg)": "Carico (kg)",
 "Carimbo": "Timbro",
 "Carnaval": "Carnevale",
 "Carne magra": "Carne magra",
 "Carregando feriados...": "Caricamento festività...",
 "Carregando...": "Caricamento...",
 "Carro": "Auto",
 "Carta": "Letter",
 "Carteira": "Portafoglio",
 "Carteira de trabalho": "Libretto di lavoro",
 "Carteira profissional (OAB, CRC, CREA...)": "Tesserino professionale (OAB, CRC, CREA...)",
 "Cartão": "Card",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Scheda contatto di Messaggi: la foto, il telefono, l'e-mail e la frase che scegli tu di mettere. La vedono solo chi chatta con te, i tuoi amici e chi condivide un gruppo dell'app con te.",
 "Cartão de crédito": "Carta di credito",
 "Cartão de débito": "Carta di debito",
 "Cartão parcelado": "Carta a rate",
 "Cartões": "Carte",
 "Cartões de visita": "Biglietti da visita",
 "Cartões e dinheiro": "Carte e contanti",
 "Casa": "Casa",
 "Casa e rotina": "Casa e routine",
 "Casa, família e veículos": "Casa, famiglia e veicoli",
 "Casaco leve": "Giacca leggera",
 "Casaco pesado": "Cappotto pesante",
 "Casamento": "Matrimonio",
 "Castanhas": "Frutta secca",
 "Categoria": "Categoria",
 "Categoria de \"{d}\"": "Categoria di \"{d}\"",
 "Categorias": "Categorie",
 "Caução": "Cauzione",
 "Ceia": "Spuntino serale",
 "Celular": "Cellulare",
 "Celular confirmado": "Cellulare confermato",
 "Celular e carregador": "Cellulare e caricabatterie",
 "Certidão": "Certificato",
 "Certificado digital": "Certificato digitale",
 "Certificado digital A1": "Certificato digitale A1",
 "Certificado ligado": "Certificato collegato",
 "Chamada": "Appello",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Appello non ancora fatto in questo giorno. Tocca chi è assente o conferma tutti presenti.",
 "Chamada, notas, planos de aula e materiais.": "Appello, voti, piani delle lezioni e materiali.",
 "Chamadas": "Chiamate",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "Le chiamate audio e video passano dai server di LiveKit, solo durante la chiamata e senza registrazione.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "Le chiamate audio e video passano dai server di LiveKit, solo per la durata della chiamata. La registrazione avviene solo nelle riunioni dello Studio, quando l'amministratore registra, e il file va direttamente nello spazio di archiviazione dell'app.",
 "Chamando...": "Chiamata in corso...",
 "Chapéu ou boné": "Cappello o berretto",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "Chiave IA non inserita su questo dispositivo (Impostazioni › Intelligenza artificiale).",
 "Chave de acesso": "Chiave di accesso",
 "Check-in": "Check-in",
 "Check-in: {d} a partir das {h}": "Check-in: {d} dalle {h}",
 "Check-in: {h} · {e}": "Check-in: {h} · {e}",
 "Check-out": "Check-out",
 "Check-out: {d} até as {h}": "Check-out: {d} entro le {h}",
 "Check-out: {h} · {e}": "Check-out: {h} · {e}",
 "Checklist": "Checklist",
 "Chinelo": "Infradito",
 "Chá de bebê": "Baby shower",
 "Cidade": "Città",
 "Cidade (para a data dos recibos)": "Città (per la data delle ricevute)",
 "Cidade de {nome}": "Città di {nome}",
 "Cidades": "Città",
 "Cifrão": "Simbolo del dollaro",
 "Cinza": "Grigio",
 "Cirurgia": "Intervento chirurgico",
 "Ciências": "Scienze",
 "Clara": "Chiara",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Schiarisce i PDF scansionati: sfondo bianco, grigio o bianco e nero.",
 "Claro": "Chiaro",
 "Classificar categorias com IA": "Classifica le categorie con l'IA",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT o Gemini",
 "Cliente": "Cliente",
 "Clientes": "Clienti",
 "Clima esperado": "Clima previsto",
 "Co-anfitrião": "Co-host",
 "Cobrança": "Addebito",
 "Cobranças": "Addebiti",
 "Coelho": "Coniglio",
 "Cofre (criptografia de ponta a ponta)": "Cassaforte (crittografia end-to-end)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Cassaforte aperta (si chiude da sola dopo 5 minuti di inattività)",
 "Cofre ainda não criado": "Cassaforte non ancora creata",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Cassaforte cifrata per carta d'identità, patente, passaporto, contratti e certificati, con conto alla rovescia alla scadenza e invio con un tocco.",
 "Cofre fechado": "Cassaforte chiusa",
 "Cofrinho": "Salvadanaio",
 "Cole aqui a chave ({ini}...)": "Incolla qui la chiave ({ini}...)",
 "Cole o link (https://...)": "Incolla il link (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Incolla o digita il codice a barre (o il Pix copia e incolla) nel campo del codice: l'app calcola da sola importo e scadenza. Con la tua IA attiva, legge tutto dalla foto.",
 "Coloca arquivos dentro do PDF.": "Inserisce file dentro il PDF.",
 "Colocar na agenda": "Metti in agenda",
 "Colocar na linha do tempo com alarme": "Metti nella cronologia con sveglia",
 "Colocar no My Planner": "Metti in My Planner",
 "Colocar rega e adubo na agenda": "Metti annaffiature e concime in agenda",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Inserisci la quota mensile nella classe (Modifica) o nell'alunno. Gli addebiti di questo mese già creati non si ripetono.",
 "Coluna": "Colonna",
 "Colágeno": "Collagene",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "Con la biometria attiva, appare per prima. Se non funziona, usa la sequenza o la password.",
 "Com convênio": "Con convenzione",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "Con prefisso internazionale e prefisso locale. Es.: +55 41 99999-0000",
 "Com outras pessoas": "Prestati ad altri",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "Con una scadenza, l'app calcola quanto mettere da parte al mese. I soldi accantonati contano come \"Risparmiato\" nel mese.",
 "Com quem": "Con chi",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Chi ha pagato, il paziente, la data e l'importo di ogni visita pagata. Come persona fisica, registra ognuna nell'app Receita Federal › Receita Saúde; con CNPJ, emetti la fattura di servizio.",
 "Com valor a receber": "Con importo da ricevere",
 "Com vencimento": "Con scadenza",
 "Combinado": "D'accordo",
 "Combinado 👍": "Perfetto 👍",
 "Combustível": "Carburante",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Inizia aggiungendo le spese fisse del mese (affitto, luce, internet) e la tua carta. Ti avviso prima di ogni scadenza.",
 "Comecei em": "Iniziato il",
 "Comentários": "Commenti",
 "Começa amanhã": "Inizia domani",
 "Começa às {hora} (em {m} min)": "Inizia alle {hora} (tra {m} min)",
 "Começar": "Avvia",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Inizia con il modello: colazione, spuntino, pranzo, merenda e cena",
 "Começar em": "Inizia da",
 "Começar o teste grátis": "Inizia la prova gratuita",
 "Comi outros alimentos ou quantidades": "Ho mangiato altri alimenti o quantità",
 "Comida": "Cibo",
 "Comidas e bebidas": "Cibo e bevande",
 "Comido": "Mangiato",
 "Comido / alterações": "Mangiato / modifiche",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "Mangiato conta i pasti segnati come fatti (o con modifiche) fino a oggi.",
 "Comigo": "Con me",
 "Comissão da plataforma": "Commissione della piattaforma",
 "Como apagar a sua conta e os seus dados": "Come eliminare il tuo account e i tuoi dati",
 "Como chegar": "Come arrivare",
 "Como ela está": "Come sta",
 "Como estou comparado ao mês passado?": "Come sto rispetto al mese scorso?",
 "Como funciona": "Come funziona",
 "Como planejado": "Come previsto",
 "Compartilhado no grupo": "Condiviso nel gruppo",
 "Compartilhado no grupo · só leitura": "Condiviso nel gruppo · sola lettura",
 "Compartilhamento indisponível neste dispositivo.": "Condivisione non disponibile su questo dispositivo.",
 "Compartilhar": "Condividi",
 "Compartilhar PDF": "Condividi PDF",
 "Compartilhar a limpeza": "Condividi la pulizia",
 "Compartilhar os dados": "Condividi i dati",
 "Compartilhar os dados com a equipe": "Condividi i dati con il team",
 "Compartilhar os dados com o grupo?": "Condividere i dati con il gruppo?",
 "Compartilhar texto": "Condividi testo",
 "Competência (mês de referência)": "Competenza (mese di riferimento)",
 "Competência {d}": "Competenza {d}",
 "Complemento": "Complemento",
 "Complete seus dados": "Completa i tuoi dati",
 "Compra": "Acquisto",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Compravendite di immobili, veicoli e azioni, ricevute detraibili e calendario fiscale.",
 "Compra feita": "Acquisto fatto",
 "Compra no cartão": "Acquisto con carta",
 "Compras": "Acquisti",
 "Compras da semana": "Spesa della settimana",
 "Comprimir": "Comprimi",
 "Compromisso": "Appuntamento",
 "Compromisso da escola": "Impegno scolastico",
 "Comprovante": "Ricevuta",
 "Comprovante guardado": "Ricevuta salvata",
 "Comprovantes": "Ricevute",
 "Computador": "Computer",
 "Comédia": "Commedia",
 "Concedi": "Ho prestato",
 "Concluir": "Completa",
 "Concluir (esquerda)": "Completa (sinistra)",
 "Concluída": "Completata",
 "Concluído": "Completato",
 "Concluído (%)": "Completato (%)",
 "Concluído!": "Completato!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Accetto che il mio nome, CPF ed e-mail siano usati solo per identificare il mio account e che le mie attività e note siano salvate al suo interno. Posso eliminare l'account e tutti i dati in qualsiasi momento in Impostazioni › Sicurezza.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "Accetto che il mio nome, CPF ed e-mail siano usati solo per identificare il mio account e che le mie attività e note siano salvate al suo interno. Posso eliminare l'account e tutti i dati in qualsiasi momento in Impostazioni.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Accetto che il mio nome, documento ed e-mail siano usati solo per identificare il mio account, e che le mie attività e note vi siano salvate. Posso eliminare l'account e tutti i dati in qualsiasi momento in Impostazioni › Sicurezza.",
 "Concursos": "Concorsi pubblici",
 "Condicionador": "Balsamo",
 "Condomínio": "Condominio",
 "Condomínio e IPTU": "Condominio e IPTU",
 "Conectado": "Connesso",
 "Conectando...": "Connessione...",
 "Conectar": "Collega",
 "Conectar navegador": "Collega browser",
 "Conectar o {nome}": "Collega {nome}",
 "Conectar relógio ou app de saúde": "Collega orologio o app salute",
 "Conectar {nome}": "Connetti {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Collega {nome} in Impostazioni › Google Drive e OneDrive.",
 "Conferindo...": "Verifica in corso...",
 "Conferir controles, chaves e Wi-Fi": "Controllare telecomandi, chiavi e Wi-Fi",
 "Conferir o prazo no sistema oficial": "Verifica il termine nel sistema ufficiale",
 "Confete": "Coriandoli",
 "Configuração geral": "Impostazioni generali",
 "Confira a senha da sua conta e tente de novo.": "Controlla la password del tuo account e riprova.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Controlla le date ufficiali sul sito della Receita Federal e modificale se serve.",
 "Confira o código. Ele tem 6 letras e números.": "Controlla il codice. Ha 6 lettere e numeri.",
 "Confira o e-mail ou deixe em branco.": "Controlla l'e-mail o lascia vuoto.",
 "Confira o e-mail.": "Controlla l'e-mail.",
 "Confira o prazo no sistema oficial.": "Verifica il termine nel sistema ufficiale.",
 "Confira os 11 números.": "Controlla le 11 cifre.",
 "Confira os campos antes de salvar.": "Controlla i campi prima di salvare.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Controlla che il tuo account Google sia aggiunto sul telefono e che il calendario sia in sincronizzazione.",
 "Confirmada": "Confermata",
 "Confirmado": "Confermato",
 "Confirmar": "Conferma",
 "Confirme a declaração sobre a empresa.": "Conferma la dichiarazione sull'azienda.",
 "Confirme o seu celular": "Conferma il tuo cellulare",
 "Confirme para ativar a biometria": "Conferma per attivare la biometria",
 "Confirme para excluir": "Conferma per eliminare",
 "Confirme sua senha para sincronizar": "Conferma la password per sincronizzare",
 "Confraternização": "Festa",
 "Confraternização Universal": "Capodanno",
 "Conselho": "Ordine professionale",
 "Consignado": "Cessione del quinto",
 "Consulta": "Visita",
 "Consulta ou vacina": "Visita o vaccino",
 "Consultas": "Visite",
 "Consultório": "Studio medico",
 "Consumo médio: {v} km/L": "Consumo medio: {v} km/L",
 "Conta": "Account",
 "Conta a pagar": "Conto da pagare",
 "Conta a receber": "Conto da incassare",
 "Conta de consumo ou tributo": "Bolletta o tributo",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Conta i giorni in cui ogni elemento era previsto (in base ai suoi giorni della settimana) e quelli segnati come fatti.",
 "Conta paga": "Conto pagato",
 "Conta recebida": "Conto incassato",
 "Conta vence hoje": "Conto in scadenza oggi",
 "Conta vencendo": "Conto in scadenza",
 "Contabilidade": "Contabilità",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "Accompagnatori inclusi. Tocca lo stato di un invitato per cambiarlo.",
 "Contando: {cliente}": "In corso: {cliente}",
 "Contas": "Pagamenti",
 "Contas a pagar": "Conti da pagare",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Conti da pagare e da incassare, spese del mese, avvisi di scadenza e gestione MEI (Mestre Achado).",
 "Contas a receber": "Conti da incassare",
 "Contas fixas": "Spese fisse",
 "Contato": "Contatto",
 "Contato de emergência": "Contatto di emergenza",
 "Contato do encarregado de dados:": "Contatto del responsabile della protezione dei dati:",
 "Conte a sua ideia para o app ficar melhor.": "Raccontaci la tua idea per migliorare l'app.",
 "Conte o que está difícil ou não funciona como deveria.": "Raccontaci cosa è difficile o non funziona come dovrebbe.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Racconta cosa hai fatto, cosa ti aspettavi e cosa è apparso. Se c'è un messaggio di errore, copialo qui.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Segnalaci problemi, errori e idee di miglioramento. Il tuo messaggio arriva direttamente al team di My Planner.",
 "Conteúdo": "Contenuto",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Contenuti che crei: attività, note, finanze, documenti, foto, allegati e dati delle schede.",
 "Conteúdo, matéria, tarefa de casa...": "Contenuto, materia, compiti...",
 "Continuar": "Continua",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Continua a usare My Planner e Note a {preco} all'anno. I tuoi dati restano salvati.",
 "Contratado": "Ingaggiato",
 "Contratado: {v}": "Ingaggiato: {v}",
 "Contrato": "Contratto",
 "Conversa": "Chat",
 "Conversa do grupo": "Chat del gruppo",
 "Conversar": "Chatta",
 "Conversar com o Mestre (precisa da sua IA)": "Parla con il Mestre (serve la tua IA)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Chatta con amici e gruppi e fai chiamate audio e video.",
 "Converter de PDF": "Converti da PDF",
 "Converter para PDF": "Converti in PDF",
 "Convidado": "Invitato",
 "Convidados": "Invitati",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Invitati con conferma di presenza, fornitori e il programma del grande giorno.",
 "Convidados e cronograma do dia, sem os valores.": "Invitati e programma della giornata, senza gli importi.",
 "Convidar": "Invita",
 "Convidar pelo WhatsApp": "Invita su WhatsApp",
 "Convite": "Invito",
 "Convite copiado. Cole onde quiser enviar.": "Invito copiato. Incollalo dove vuoi inviarlo.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Invito non valido o cambiato dall'amministratore. Chiedi un nuovo link.",
 "Convite para o My Planner": "Invito a My Planner",
 "Convênio": "Convenzione",
 "Copiar": "Copia",
 "Copiar a lista para uma tarefa": "Copia l'elenco in un'attività",
 "Copiar o código": "Copia il codice",
 "Copiar para hoje": "Copia a oggi",
 "Copo de outro tamanho": "Bicchiere di altra misura",
 "Copo {n}": "Bicchiere {n}",
 "Cor": "Colore",
 "Cor do fichário": "Colore del raccoglitore",
 "Cor do tema": "Colore del tema",
 "Cor do tema de cada aba": "Colore del tema di ogni scheda",
 "Coração": "Cuore",
 "Corações": "Cuori",
 "Cores das abas": "Colori delle schede",
 "Cores das conversas": "Colori delle chat",
 "Cores e opções desta aba": "Colori e opzioni di questa scheda",
 "Corpo": "Corpo",
 "Corporativo": "Aziendale",
 "Corpus Christi": "Corpus Domini",
 "Corredor": "Corridoio",
 "Correia dentada": "Cinghia di distribuzione",
 "Corrida": "Corsa",
 "Corta as bordas em branco ou partes da página.": "Taglia i bordi bianchi o parti della pagina.",
 "Cortesia": "Omaggio",
 "Coxa e sobrecoxa": "Coscia e sovracoscia di pollo",
 "Cozinha": "Cucina",
 "Creatina": "Creatina",
 "Criada em {data}": "Creata il {data}",
 "Criado com": "Creato con",
 "Criado em": "Creato il",
 "Criança": "Bambino",
 "Crianças": "Bambini",
 "Criar": "Crea",
 "Criar animada": "Crea animato",
 "Criar conta": "Crea account",
 "Criar do zero": "Crea da zero",
 "Criar documento, planilha ou apresentação": "Crea documento, foglio di calcolo o presentazione",
 "Criar em outro app": "Crea in un'altra app",
 "Criar escritório": "Crea ufficio",
 "Criar fichário": "Crea raccoglitore",
 "Criar figurinha": "Crea sticker",
 "Criar grupo": "Crea gruppo",
 "Criar grupo e convidar pessoas": "Crea gruppo e invita persone",
 "Criar minha chave de API": "Crea la mia chiave API",
 "Criar o cofre": "Crea la cassaforte",
 "Criar o grupo e convidar": "Crea il gruppo e invita",
 "Criar os prazos do IR de {ano}": "Crea le scadenze IR {ano}",
 "Criar uma meta (viagem, reserva, carro...)": "Crea un obiettivo (viaggio, riserva, auto...)",
 "Criar uma senha nova": "Crea una nuova password",
 "Criar {n} tarefa(s)": "Crea {n} attività",
 "Criação do Estado de MS": "Creazione dello Stato di MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Crea il trasloco e l'app prepara la lista delle volture (luce, acqua, internet...). Poi aggiungi le scatole per stanza, i sopralluoghi e il programma dei giorni.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Crea la cartella di ogni cliente, invita il cliente con il link (vede solo la sua cartella) e scambiatevi documenti in entrambe le direzioni: fatture, modelli di pagamento, buste paga, estratti, contratti.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Crea la classe (o gruppo di mentoring, allenamento, corso) e, al suo interno, alunni, appello, voti, piani di lezione, materiali e addebiti.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Crea la classe e, al suo interno, gli alunni, l'appello, le valutazioni con i voti e i piani di lezione.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Crea le faccende di casa (pulire il bagno, cambiare le lenzuola...) con la loro frequenza. L'app ti avvisa quando sono in ritardo, senza riempire My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Crea schede con checklist, elenco, testo libero o disegno per questa materia. Scorri a destra per eliminare e a sinistra per archiviare.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Crea l'ufficio, chiama il team (amici dell'app o invito tramite link) e scambiatevi messaggi e documenti, fissate riunioni e fate videoriunioni. Tu, che amministri, puoi registrare le riunioni.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Crea l'evento e, al suo interno, la lista degli invitati con conferma di presenza, i fornitori e il programma della giornata.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Crea il gruppo e invia il link: chi entra riceve data, luogo, avvisi e tutto ciò che invii, e può accettare, modificare o rifiutare.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Crea il gruppo e invia il link: chi entra vede e partecipa in base al ruolo che scegli. Solo chi amministra aggiunge o toglie persone.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Crea il gruppo e invia il link: chi entra vede tutto ciò che c'è qui dentro e partecipa (aggiunge, modifica, carica foto). Solo chi amministra aggiunge o toglie persone.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Crea il tuo account. I tuoi dati restano salvati nel cloud e su questo dispositivo.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Crea un raccoglitore (es.: Dottorato, Inglese, Concorso) e al suo interno le materie e le pagine.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Crea un gruppo (classe, pazienti, team, invitati, clienti), condividi il link di invito e invia appuntamenti, materiali e avvisi. Ognuno accetta, modifica o rifiuta ciò che riceve.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Crea un profilo con il nome e, se sei avvocato, la OAB.",
 "Criptografado no cofre, só neste dispositivo": "Cifrato nella cassaforte, solo su questo dispositivo",
 "Criptomoedas": "Criptovalute",
 "Cronograma": "Programma",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "Piano alimentare, cura personale passo per passo e acqua del giorno.",
 "Cronograma do dia": "Programma della giornata",
 "Cronograma físico-financeiro": "Cronoprogramma fisico-finanziario",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Cronoprogramma fisico-finanziario per fase, diario di cantiere con prima e dopo, professionisti e consegne.",
 "Cronômetro de horas": "Cronometro delle ore",
 "Crédito empresarial": "Credito aziendale",
 "Créditos": "Crediti",
 "Cuida das reservas, da limpeza e das despesas.": "Si occupa di prenotazioni, pulizie e spese.",
 "Cuidado": "Cura",
 "Cuidado pessoal": "Cura personale",
 "Cuidados": "Cure",
 "Cupom do mercado": "Scontrino della spesa",
 "Cupom do mercado (foto)": "Scontrino della spesa (foto)",
 "Cupom lançado": "Scontrino registrato",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "Corso",
 "Cursos": "Corsi",
 "Cursos livres e certificações": "Corsi liberi e certificazioni",
 "Cuscuz": "Cuscus di mais",
 "CÓDIGO PARA PAGAR": "CODICE PER PAGARE",
 "CÔMODOS": "STANZE",
 "Câmera": "Fotocamera",
 "Câmera e galeria": "Fotocamera e galleria",
 "Câmera não liberada": "Fotocamera non autorizzata",
 "Código IBGE do município": "Codice IBGE del comune",
 "Código IBGE do município (7 números)": "Codice IBGE del comune (7 cifre)",
 "Código NBS (9 números, opcional)": "Codice NBS (9 cifre, facoltativo)",
 "Código copiado": "Codice copiato",
 "Código da reserva (localizador)": "Codice di prenotazione",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Codice a barre, linea digitabile o Pix copia e incolla (facoltativo)",
 "Código de indicação": "Codice invito",
 "Código de indicação (opcional)": "Codice invito (facoltativo)",
 "Código de quem convidou você": "Codice di chi ti ha invitato",
 "Código de tributação nacional (6 números)": "Codice tributario nazionale (6 cifre)",
 "Código de tributação nacional (6 números, ex.: 171901)": "Codice tributario nazionale (6 cifre, es.: 171901)",
 "Código do amigo": "Codice dell'amico",
 "Código do convite": "Codice di invito",
 "Código do procedimento (TUSS ou do plano)": "Codice della prestazione (TUSS o del piano)",
 "Código errado. Confira e tente de novo.": "Codice errato. Controlla e riprova.",
 "Código não encontrado. Confira as letras e os números.": "Codice non trovato. Controlla lettere e numeri.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Codice non riconosciuto. Controlla i numeri (boleto: 47 o 48 cifre).",
 "Código: {c}": "Codice: {c}",
 "Cópia automática toda semana": "Backup automatico ogni settimana",
 "Cópia criada.": "Copia creata.",
 "Cópia de segurança": "Copia di sicurezza",
 "Cópia feita": "Backup eseguito",
 "Cópia restaurada.": "Backup ripristinato.",
 "Cômodo": "Stanza",
 "Cômodo ou quarto": "Stanza o locale",
 "Cômodos da casa e as tarefas de cada um.": "Le stanze della casa e le attività di ognuna.",
 "DAS de {mes} pago": "DAS di {mes} pagato",
 "DAS de {mes}: vence dia {dia}": "DAS di {mes}: scade il giorno {dia}",
 "DAS do MEI": "DAS del MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "DICHIARAZIONE DI PRESTAZIONE",
 "DICA DO MESTRE ACHADO": "IL CONSIGLIO DEL MESTRE ACHADO",
 "DPS nº {n}, série {s}": "DPS n. {n}, serie {s}",
 "Da galeria ou dos arquivos": "Dalla galleria o dai file",
 "Da meta de passos": "Dell'obiettivo passi",
 "Dados compartilhados": "Dati condivisi",
 "Dados compartilhados com o grupo": "Dati condivisi con il gruppo",
 "Dados compartilhados · seu papel: {p}": "Dati condivisi · il tuo ruolo: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "I dati sanitari che registri tu stesso sono trattati solo per te e per chi decidi di condividerli, con il tuo consenso (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Dati del dispositivo: lingua, paese e fuso orario (per date, festività e valuta), modello del dispositivo e codice per le notifiche.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "I dati dell'orologio e della salute non vengono usati per la pubblicità né condivisi con nessuno. Puoi scollegare e revocare il permesso in qualsiasi momento.",
 "Dança": "Danza",
 "Dar ciência": "Dai presa visione",
 "Dar ciência da operação?": "Dare presa visione dell'operazione?",
 "Data": "Data",
 "Data (embarque ou check-in)": "Data (imbarco o check-in)",
 "Data agendada": "Data fissata",
 "Data da aplicação": "Data di somministrazione",
 "Data da compra": "Data di acquisto",
 "Data da entrega": "Data di consegna",
 "Data da venda": "Data di vendita",
 "Data de nascimento": "Data di nascita",
 "Data do empréstimo": "Data del prestito",
 "Data do pagamento": "Data del pagamento",
 "Data em que foi feita": "Data di esecuzione",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Data suggerita con 2 giorni lavorativi di margine. Verificala nel sistema ufficiale.",
 "De": "Dal",
 "De uma foto": "Da una foto",
 "De {de} para {para} ({p}% menor).": "Da {de} a {para} ({p}% in meno).",
 "Declaração": "Dichiarazione",
 "Declaração de atendimento": "Dichiarazione di prestazione",
 "Declaração para reembolso (PDF)": "Dichiarazione per rimborso (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "Dichiaro che questa azienda è mia o di un cliente che ha autorizzato il monitoraggio.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "Dichiaro, ai fini del rimborso{conv}, che il/la paziente {nome}{cpf}{cart} è stato/a visitato/a da me il {data}{hora}, per: {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Imposta l'obiettivo di lezioni al giorno o alla settimana in Modifica.",
 "Defina a meta de páginas por dia em Editar.": "Imposta l'obiettivo di pagine al giorno in Modifica.",
 "Defina um horário": "Imposta un orario",
 "Defina um horário para usar pausas.": "Imposta un orario per usare le pause.",
 "Demaquilante ou água micelar": "Struccante o acqua micellare",
 "Demolição": "Demolizione",
 "Demonstração": "Demo",
 "Dentista": "Dentista",
 "Dependentes": "Familiari a carico",
 "Depois": "Dopo",
 "Depois da aula": "Dopo la lezione",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Una volta eliminate, le attività non tornano. Inserisci la password del tuo account per confermare.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "Dopo il download, apri il file e tocca Installa. Se il cellulare lo chiede, consenti l'installazione di app da questa origine.",
 "Depois de criar": "Dopo la creazione",
 "Depois de {nome}. Toque para pular.": "Dopo {nome}. Tocca per saltare.",
 "Depois é só ajustar horários e o que comer em cada um.": "Poi basta regolare gli orari e cosa mangiare in ciascuno.",
 "Desarquivar": "Ripristina dall'archivio",
 "Desbloquear": "Sblocca",
 "Desbloquear com": "Sblocca con",
 "Desbloquear com biometria": "Sblocca con la biometria",
 "Desbloquear o My Planner": "Sblocca My Planner",
 "Desbloqueio do app": "Sblocco dell'app",
 "Descanso": "Riposo",
 "Descartadas": "Scartate",
 "Descartar": "Scarta",
 "Descartar este tempo?": "Scartare questo tempo?",
 "Descobrir lugares em {d}": "Scopri luoghi a {d}",
 "Desconectar": "Disconnetti",
 "Desconectar o {nome}?": "Disconnettere {nome}?",
 "Desconto": "Sconto",
 "Desconto de {v}": "Sconto di {v}",
 "Descontos obtidos": "Sconti ottenuti",
 "Descrição": "Descrizione",
 "Descrição (cliente, nota fiscal...)": "Descrizione (cliente, fattura...)",
 "Descrição do serviço (sai na nota)": "Descrizione del servizio (compare in fattura)",
 "Descrição que sai na nota": "Descrizione che compare in fattura",
 "Desenhar a assinatura": "Disegna la firma",
 "Desenhar com caneta ou dedo": "Disegna con penna o dito",
 "Desenhe a assinatura e escolha a página e o lugar.": "Disegna la firma e scegli la pagina e la posizione.",
 "Desenhe a assinatura primeiro.": "Prima disegna la firma.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Disegna con il dito o con la penna (S Pen, Apple Pencil o penna per tablet).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Disegna con il dito o con la penna. Per scorrere la bacheca, tocca Sposta.",
 "Desenhe de novo para confirmar.": "Disegna di nuovo per confermare.",
 "Desenhe o seu padrão": "Disegna la tua sequenza",
 "Desenhe pelo menos uma tarja.": "Disegna almeno una banda.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Disegna una sequenza collegando almeno 4 punti.",
 "Desenho": "Disegno",
 "Desenho com caneta ou dedo": "Disegno con penna o dito",
 "Desenho incorreto": "Sequenza errata",
 "Desenho padrão": "Sequenza",
 "Desenho padrão salvo.": "Sequenza salvata.",
 "Desenvolvimento": "Lento avanti",
 "Desfazer": "Annulla",
 "Desfazer amizade": "Rimuovi amicizia",
 "Desligar": "Disattiva",
 "Desligar a sincronização?": "Disattivare la sincronizzazione?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Scorri di lato per vedere altri giorni (fino a 60 giorni avanti). Tocca un pasto per pianificare il menu solo di quel giorno. Trascina a destra per eliminare.",
 "Desmarcado": "Disdetto",
 "Desmarcar como recebida": "Segna come non ricevuta",
 "Desmarcar feita hoje": "Togli fatta oggi",
 "Desmarcar grupo": "Deseleziona gruppo",
 "Desmarcar pagamento": "Annulla pagamento",
 "Desodorante": "Deodorante",
 "Despensa": "Dispensa",
 "Despesa": "Spesa",
 "Despesas": "Spese",
 "Destino": "Destinazione",
 "Detalhes": "Dettagli",
 "Devolver até": "Restituire entro",
 "Devolver: {i} ({p})": "Da restituire: {i} ({p})",
 "Devolvido": "Restituito",
 "Devolvidos": "Restituiti",
 "Dia": "Giorno",
 "Dia a dia": "Giorno per giorno",
 "Dia da mudança": "Giorno del trasloco",
 "Dia de vencimento do DAS": "Giorno di scadenza del DAS",
 "Dia do Trabalho": "Festa dei Lavoratori",
 "Dia do vencimento": "Giorno di scadenza",
 "Dia em que a fatura fecha": "Giorno di chiusura dell'estratto",
 "Dia planejado": "Giorno previsto",
 "Dia {d} de {total}": "Giorno {d} di {total}",
 "Diagnóstico": "Diagnosi",
 "Dias e horários": "Giorni e orari",
 "Dias específicos": "Giorni specifici",
 "Dias úteis": "Giorni feriali",
 "Dias: {dias}": "Giorni: {dias}",
 "Dicas e observações": "Consigli e note",
 "Diesel": "Diesel",
 "Diferença": "Differenza",
 "Digitado": "Manuale",
 "Digitar": "Digita",
 "Digitar à mão": "Inserisci a mano",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Inserisci la password della cassaforte. Si chiude da sola dopo 5 minuti di inattività.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Inserisci i minuti (90) o ore e minuti (1:30 o 01:30) e tocca OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Inserisci nel formato HH:MM, ad esempio 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Inserisci il codice e ottieni 10 giorni con tutte le schede sbloccate. Se non ce l'hai, lascia vuoto.",
 "Digite o nome da tarefa.": "Inserisci il nome dell'attività.",
 "Dinheiro": "Denaro",
 "Dinheiro e documentos": "Soldi e documenti",
 "Direita": "Destra",
 "Direito": "Diritto",
 "Direito Administrativo": "Diritto amministrativo",
 "Direito Civil": "Diritto civile",
 "Direito Constitucional": "Diritto costituzionale",
 "Direito Empresarial": "Diritto commerciale",
 "Direito Penal": "Diritto penale",
 "Direito Tributário": "Diritto tributario",
 "Direito do Trabalho": "Diritto del lavoro",
 "Direto": "Diretto",
 "Disciplina": "Materia",
 "Dispensar": "Ignora",
 "Dispensar o aviso": "Ignora l'avviso",
 "Dispensar todas": "Ignora tutte",
 "Disponibilizada em": "Pubblicata il",
 "Disponível no app novo": "Disponibile nella nuova app",
 "Distância": "Distanza",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Dividi il corso in materie o moduli. In ognuna, segna la lezione a cui sei arrivato e crea schede di note.",
 "Dividir": "Dividi",
 "Dividir entre (nenhum marcado = todos)": "Dividi tra (nessuno selezionato = tutti)",
 "Divisão das despesas": "Divisione delle spese",
 "Diária": "Notte",
 "Diária padrão": "Prezzo standard a notte",
 "Diário": "Diario",
 "Diários municipais": "Gazzette comunali",
 "Do celular, do Google Drive ou do OneDrive": "Dal cellulare, da Google Drive o da OneDrive",
 "Do cliente": "Dal cliente",
 "Do escritório": "Dallo studio",
 "Doações": "Donazioni",
 "Docs": "Doc",
 "Documento": "Documento",
 "Documento (fundo branco)": "Documento (sfondo bianco)",
 "Documento do veículo (CRLV)": "Libretto del veicolo (CRLV)",
 "Documento pessoal": "Documento personale",
 "Documento vence hoje": "Il documento scade oggi",
 "Documento vencendo": "Documento in scadenza",
 "Documento: {o}": "Documento: {o}",
 "Documentos": "Documenti",
 "Documentos (contrato, nota, recibo...)": "Documenti (contratto, fattura, ricevuta...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Documenti (passaporto, carta d'identità, patente)",
 "Documentos e autorização das crianças": "Documenti e autorizzazione dei bambini",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "I documenti protetti, gli esami, la storia clinica e gli altri campi con 🔒 sono cifrati qui sul dispositivo (AES-256) con la password della cassaforte. Nemmeno l'assistenza può leggerli. Senza la password, questi dati non possono essere recuperati.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Documenti, ricevute, quaderni e lavagne, con più pagine",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Documenti, riunioni e registrazioni vengono eliminati per tutti. La chat resta in Messaggi.",
 "Documentário": "Documentario",
 "Doenças, cirurgias e observações": "Malattie, interventi e note",
 "Dois dedos ou toque duplo para ampliar": "Due dita o doppio tocco per ingrandire",
 "Domingo": "Domenica",
 "Dono da obra": "Committente",
 "Dose": "Dose",
 "Dose (ex.: 1 cápsula, 5 g)": "Dose (es.: 1 capsula, 5 g)",
 "Dose única": "Dose unica",
 "Drama": "Drammatico",
 "Duplicar": "Duplica",
 "Duplicar tarefa": "Duplica attività",
 "Duração": "Durata",
 "Duração de cada sessão": "Durata di ogni sessione",
 "Duração {dur}": "Durata {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "Posso comprare qualcosa da 3 mila in 10 rate?",
 "Débito automático": "Addebito diretto",
 "Débito, Pix ou dinheiro": "Bancomat, Pix o contanti",
 "Dê um nome ao cartão.": "Dai un nome alla carta.",
 "Dê um nome ao cuidado.": "Dai un nome alla cura.",
 "Dê um nome ao cômodo.": "Dai un nome alla stanza.",
 "Dê um nome ao fichário.": "Dai un nome al raccoglitore.",
 "Dê um nome ao grupo.": "Dai un nome al gruppo.",
 "Dê um nome ao suplemento.": "Dai un nome all'integratore.",
 "Dê um nome ao treino.": "Dai un nome all'allenamento.",
 "Dê um nome à conta.": "Dai un nome al conto.",
 "Dê um nome à matéria.": "Dai un nome alla materia.",
 "Dê um nome à meta.": "Dai un nome all'obiettivo.",
 "Dê um nome à refeição.": "Dai un nome al pasto.",
 "Dê um nome à tarefa.": "Dai un nome all'attività.",
 "E-MAIL (OPCIONAL)": "E-MAIL (FACOLTATIVA)",
 "E-mail": "E-mail",
 "E-mail (recebe a nota)": "E-mail (riceve la fattura)",
 "E-mail de contato": "E-mail di contatto",
 "E-mail do responsável": "Email del genitore",
 "E-mail inválido": "E-mail non valida",
 "E-mail inválido.": "E-mail non valida.",
 "E-mail ou WhatsApp para resposta (opcional)": "E-mail o WhatsApp per la risposta (facoltativo)",
 "E-mail para contato (opcional)": "E-mail di contatto (facoltativa)",
 "E-mail salvo.": "E-mail salvata.",
 "EM ATRASO": "IN RITARDO",
 "ENTRAR COM UM CÓDIGO": "ENTRA CON UN CODICE",
 "ENVIADOS": "INVIATI",
 "ESCOLHA AS ATIVIDADES": "SCEGLI LE ATTIVITÀ",
 "ESTA SEMANA": "QUESTA SETTIMANA",
 "EXERCÍCIO FÍSICO": "ATTIVITÀ FISICA",
 "Economia": "Economia",
 "Edita tudo": "Modifica tutto",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Modifica tutto: fasi, preventivo, diario e consegne.",
 "Editar": "Modifica",
 "Editar cartão": "Modifica carta",
 "Editar compra": "Modifica acquisto",
 "Editar cômodo": "Modifica stanza",
 "Editar desenho": "Modifica disegno",
 "Editar documento": "Modifica documento",
 "Editar fichário": "Modifica raccoglitore",
 "Editar garantia": "Modifica garanzia",
 "Editar matéria": "Modifica materia",
 "Editar meta": "Modifica obiettivo",
 "Editar perfil": "Modifica profilo",
 "Editar tarefa": "Modifica attività",
 "Editar {nome}": "Modifica {nome}",
 "Educação": "Istruzione",
 "Educação Física": "Educazione fisica",
 "Efeito de scanner": "Effetto scanner",
 "Ela sai da lista e dos Recebidos da equipe.": "Sparisce dall'elenco e dai Ricevuti del team.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "Viene salvato anche in \"I miei sticker\" per inviarlo di nuovo.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "Arriva dalla scheda Prestiti & Finanziamenti. Segnala qui come pagata o apri la scheda per vedere il contratto.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "Arriva dalla scheda Fatture. Segnala come ricevuta quando arrivano i soldi.",
 "Eleitorais": "Elettorali",
 "Eletrodoméstico": "Elettrodomestico",
 "Eletrodomésticos": "Elettrodomestici",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Elettrodomestici, elettronica e mobili: fattura, assistenza tecnica e avviso 15 giorni prima della fine della garanzia.",
 "Eletrônico": "Elettronica",
 "Elétrica": "Impianto elettrico",
 "Elétrico": "Elettrico",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "In Modifica, incolla il link del calendario (iCal) dell'annuncio. Su Airbnb: Calendario › Disponibilità › Collega calendari › Esporta calendario. Su Booking: Tariffe e disponibilità › Sincronizza calendari.",
 "Em aberto": "Da saldare",
 "Em alta": "Di tendenza",
 "Em andamento": "In corso",
 "Em atraso": "In ritardo",
 "Em branco": "Vuota",
 "Em casa": "A casa",
 "Em cima": "In alto",
 "Em construção": "In costruzione",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "Tutto aggiornato. I miglioramenti arrivano da soli all'apertura dell'app.",
 "Em limpeza": "In pulizia",
 "Em quais páginas": "In quali pagine",
 "Em qual agenda criar os eventos:": "In quale calendario creare gli eventi:",
 "Em qual página e onde": "Su quale pagina e dove",
 "Em tratamento": "In trattamento",
 "Em um horário específico": "A un orario specifico",
 "Em uso: {ia}": "In uso: {ia}",
 "Em {n} dia(s)": "Tra {n} giorno/i",
 "Embaixo": "In basso",
 "Embaixo à esquerda": "In basso a sinistra",
 "Emissão": "Rilascio",
 "Emissão +": "Rilascio +",
 "Emissão: {data}": "Rilascio: {data}",
 "Emitida": "Emessa",
 "Emitida em {data}": "Emessa il {data}",
 "Emitida ou recebida": "Emessa o ricevuta",
 "Emitidas": "Emesse",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Emesse: {v} · Ricevute: {r} · {n} fattura/e",
 "Emitir": "Emetti",
 "Emitir NFS-e": "Emetti NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "Emetti NFS-e secondo il Padrão Nacional con il certificato A1, cerca le fatture emesse e ricevute ed esporta XML, foglio di calcolo e PDF.",
 "Emitir a nota de verdade?": "Emettere la fattura sul serio?",
 "Emitir no ambiente de teste?": "Emettere nell'ambiente di test?",
 "Emojis": "Emoji",
 "Emojis animados": "Emoji animate",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Emoji animate: Noto, di Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Emoji, GIF e sticker",
 "Empresa": "Azienda",
 "Empresa de mudança": "Ditta di traslochi",
 "Empresa ou pessoa": "Azienda o persona",
 "Empresa, hotel ou voo": "Azienda, hotel o volo",
 "Empresas": "Aziende",
 "Emprestei": "Ho prestato",
 "Empréstimo": "Prestito",
 "Empréstimo entre pessoas": "Prestito tra persone",
 "Empréstimo pessoal": "Prestito personale",
 "Empréstimos": "Prestiti",
 "Empréstimos & Financiamentos": "Prestiti & Finanziamenti",
 "Encaminhada para {nome}.": "Inoltrato a {nome}.",
 "Encaminhar": "Inoltra",
 "Encaminhar para": "Inoltra a",
 "Encerrar e salvar": "Termina e salva",
 "Encontrada para {perfil}": "Trovata per {perfil}",
 "Endereço": "Indirizzo",
 "Endereço (opcional)": "Indirizzo (facoltativo)",
 "Endereço (se for presencial)": "Indirizzo (se in presenza)",
 "Endereço atual": "Indirizzo attuale",
 "Endereço da escola": "Indirizzo della scuola",
 "Endereço da oficina": "Indirizzo dell'officina",
 "Endereço de quem está com o item": "Indirizzo di chi ha l'oggetto",
 "Endereço do consultório": "Indirizzo dello studio",
 "Endereço do imóvel": "Indirizzo dell'immobile",
 "Endereço do laboratório": "Indirizzo del laboratorio",
 "Endereço do veterinário": "Indirizzo del veterinario",
 "Endereço no trabalho e na escola": "Indirizzo al lavoro e a scuola",
 "Endereço nos Correios e entregas": "Indirizzo alle Poste e per le consegne",
 "Endereço nos bancos e cartões": "Indirizzo presso banche e carte",
 "Endereço novo": "Nuovo indirizzo",
 "Endereço ou nome do lugar": "Indirizzo o nome del luogo",
 "Endereço ou terminal": "Indirizzo o terminal",
 "Energia": "Energia",
 "Enfermeiro": "Infermiere",
 "Engenharia": "Ingegneria",
 "Engenheiro ou arquiteto": "Ingegnere o architetto",
 "Enquadre o documento e toque no botão": "Inquadra il documento e tocca il pulsante",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Inquadra il viso e tocca il pulsante. 🔄 gira la fotocamera.",
 "Ensino Fundamental": "Scuola primaria e media",
 "Ensino Médio e ENEM": "Scuola superiore ed ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "Ho capito e accetto di usare il monitoraggio a queste condizioni.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Entra direttamente nel Planner, con orario, giorni e l’elenco degli elementi. Se l’orario è già occupato, scegli tu: sostituire, tenere entrambe o annullare.",
 "Entrada": "Entrata",
 "Entrada (imóvel novo)": "Ingresso (nuova casa)",
 "Entrada de dinheiro": "Entrata di denaro",
 "Entrando...": "Accesso in corso...",
 "Entrar": "Accedi",
 "Entrar com CPF e senha": "Accedi con CPF e password",
 "Entrar com outra conta": "Accedi con un altro account",
 "Entrar de novo": "Accedi di nuovo",
 "Entrar na chamada": "Partecipa alla chiamata",
 "Entrar na reunião": "Partecipa alla riunione",
 "Entrar na sala online": "Entra nella stanza online",
 "Entrar no grupo": "Entra nel gruppo",
 "Entrar no navegador?": "Accedere nel browser?",
 "Entre com seu CPF e sua senha.": "Accedi con il tuo CPF e la tua password.",
 "Entre com seu e-mail e sua senha.": "Accedi con la tua e-mail e la tua password.",
 "Entre na sua conta de novo.": "Accedi di nuovo.",
 "Entre na sua conta para usar as notas fiscais.": "Accedi al tuo account per usare le fatture.",
 "Entre no app com o seu e-mail e a senha nova.": "Accedi all'app con la tua e-mail e la nuova password.",
 "Entrega de material": "Consegna di materiale",
 "Entrega prevista": "Consegna prevista",
 "Entregas": "Consegne",
 "Entregue": "Consegnato",
 "Entrou": "Entrate",
 "Entrou no total da semana.": "Aggiunto al totale della settimana.",
 "Enviada": "Inviata",
 "Enviado": "Inviato",
 "Enviado para o Planner": "Inviato al Planner",
 "Enviado pelo cliente": "Inviato dal cliente",
 "Enviado pelo escritório": "Inviato dallo studio",
 "Enviado por {quem} no grupo {g}": "Inviato da {quem} nel gruppo {g}",
 "Enviando {f} de {n}...": "Invio di {f} su {n}...",
 "Enviando...": "Invio in corso...",
 "Enviar": "Invia",
 "Enviar \"{nome}\"": "Invia \"{nome}\"",
 "Enviar \"{nome}\" para…": "Invia \"{nome}\" a…",
 "Enviar \"{titulo}\" para": "Invia \"{titulo}\" a",
 "Enviar ao grupo": "Invia al gruppo",
 "Enviar convite": "Invia invito",
 "Enviar convite para {nome}": "Invia l'invito a {nome}",
 "Enviar convite pelo WhatsApp": "Invia invito via WhatsApp",
 "Enviar documento": "Invia documento",
 "Enviar instruções ao hóspede": "Invia le istruzioni all'ospite",
 "Enviar o convite": "Invia l'invito",
 "Enviar ou copiar o código": "Invia o copia il codice",
 "Enviar ou imprimir a etiqueta": "Invia o stampa l'etichetta",
 "Enviar para Estudos": "Invia a Studio",
 "Enviar para My Planner": "Invia a My Planner",
 "Enviar para a equipe": "Invia al team",
 "Enviar para o My Planner": "Invia a My Planner",
 "Enviar para o Planner": "Invia al Planner",
 "Enviar para o grupo": "Invia al gruppo",
 "Enviar para o grupo de estudos": "Invia al gruppo di studio",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Carica su {nome} i {n} file di questo dispositivo",
 "Enviar para um grupo": "Invia a un gruppo",
 "Enviar para {g}": "Invia a {g}",
 "Enviar para…": "Invia a…",
 "Enviar por e-mail": "Invia per e-mail",
 "Enviar relatório": "Invia segnalazione",
 "Enviar relatório para a equipe": "Invia la segnalazione al team",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Invia anche le attività già esistenti (da oggi in poi)",
 "Enviar tarefas do My Planner para a agenda": "Invia le attività di My Planner al calendario",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Invia modelli di pagamento, fatture e report al cliente, o guarda cosa ha mandato. Ogni documento accetta foto, PDF e link.",
 "Enxaguante": "Collutorio",
 "Episódio": "Episodio",
 "Equipe": "Team",
 "Equipe ({n})": "Team ({n})",
 "Equipe de limpeza": "Squadra delle pulizie",
 "Equipe do consultório": "Staff dello studio",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Staff dell'alloggio (pulizie e co-host)",
 "Erro": "Errore",
 "Erro na emissão": "Errore nell'emissione",
 "Erro: {erro}": "Errore: {erro}",
 "Erros registrados neste dispositivo ({n})": "Errori registrati su questo dispositivo ({n})",
 "Escanear documento": "Scansiona documento",
 "Escanear o verso": "Scansiona il retro",
 "Escanear para PDF": "Scansiona in PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Scansiona documenti, ricevute, quaderni e lavagne: bordi e ombre corretti, più pagine, documento d'identità fronte e retro, firma e PDF salvato sul telefono, su Google Drive o su OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Scansiona, rendi l'immagine più chiara, organizza in cartelle e invia il PDF via WhatsApp, e-mail o Drive. Con la tua IA attiva, l'app legge il testo, lo riassume e risponde alle domande sul documento.",
 "Escola": "Scuola",
 "Escolha a aba:": "Scegli la scheda:",
 "Escolha a data do compromisso.": "Scegli la data dell'appuntamento.",
 "Escolha a imagem.": "Scegli l'immagine.",
 "Escolha a matéria": "Scegli la materia",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Scegli la cartella del telefono (es.: Documenti). L'app salva lì da sola.",
 "Escolha a página": "Scegli la pagina",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Scegli almeno un tribunale o seleziona \"Tutti i tribunali\".",
 "Escolha ao menos uma agenda.": "Scegli almeno un calendario.",
 "Escolha o PDF": "Scegli il PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Scegli il file .pfx (o .p12) del certificato A1 dell'azienda e inserisci la sua password. Resta crittografato nella tua cassaforte.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Scegli il file .xml della NFS-e, NF-e o CT-e.",
 "Escolha o fichário": "Scegli il raccoglitore",
 "Escolha o grupo para enviar: {t}": "Scegli il gruppo a cui inviare: {t}",
 "Escolha os PDFs": "Scegli i PDF",
 "Escolha os arquivos.": "Scegli i file.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Scegli le festività che appaiono nel Planner e nel pulsante 🎉 Festività.",
 "Escolha para quem enviar.": "Scegli a chi inviare.",
 "Escolha pelo menos um dia.": "Scegli almeno un giorno.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Scegli almeno una pagina che esista nel PDF (es.: 1-3, 5).",
 "Escolha quem participa:": "Scegli chi partecipa:",
 "Escolher": "Scegli",
 "Escolher a imagem": "Scegli l'immagine",
 "Escolher a pasta": "Scegli la cartella",
 "Escolher agendas": "Scegli calendari",
 "Escolher alimento": "Scegli alimento",
 "Escolher arquivo": "Scegli file",
 "Escolher arquivos": "Scegli file",
 "Escolher arquivos do Drive ou do OneDrive": "Scegli file da Drive o OneDrive",
 "Escolher as imagens e criar o PDF": "Scegli le immagini e crea il PDF",
 "Escolher da galeria": "Scegli dalla galleria",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Scegli dalla galleria o da file (foto o PDF)",
 "Escolher data": "Scegli data",
 "Escolher fuso": "Scegli il fuso",
 "Escolher hora": "Scegli l'ora",
 "Escolher horário": "Scegli orario",
 "Escolher o certificado": "Scegli il certificato",
 "Escolher outro": "Scegli un altro",
 "Escolher pessoas": "Scegli persone",
 "Escolher tribunais": "Scegli tribunali",
 "Escolher ícone": "Scegli icona",
 "Esconder da equipe (só administradores)": "Nascondi al team (solo amministratori)",
 "Esconder detalhes": "Nascondi dettagli",
 "Esconder o texto completo": "Nascondi il testo completo",
 "Escondido de {n} pessoa(s)": "Nascosto a {n} persona/e",
 "Escondido de: {n}": "Nascosto a: {n}",
 "Escondidos no Planner.": "Nascosti nel Planner.",
 "Escova e pasta de dente": "Spazzolino e dentifricio",
 "Escovar os dentes": "Lavarsi i denti",
 "Escreva aqui": "Scrivi qui",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Scrivi e premi Invio (es.: fare la lavatrice)",
 "Escreva em uma ou em todas as páginas.": "Scrivi su una pagina o su tutte.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Scrivi il motivo in \"Motivo dell'annullamento\" nella scheda della fattura (almeno 15 lettere) e tocca di nuovo qui.",
 "Escreva o resumo, tópicos, dúvidas...": "Scrivi il riassunto, gli argomenti, i dubbi...",
 "Escreva o texto da marca d'água.": "Scrivi il testo della filigrana.",
 "Escreva o texto.": "Scrivi il testo.",
 "Escreva o título.": "Scrivi il titolo.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Scrivi o incolla il testo. Una riga che inizia con \"# \" diventa titolo.",
 "Escreva ou cole um texto e gere o PDF.": "Scrivi o incolla un testo e crea il PDF.",
 "Escritório": "Studio",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Studio: documenti e riunioni del team. Solo l'amministratore dello studio può registrare una riunione, e tutti i partecipanti vedono l'avviso \"Registrazione in corso\" mentre viene registrata. La registrazione resta nei documenti dello studio, visibile solo all'amministratore finché non la condivide con il team.",
 "Escuro": "Scuro",
 "Espanhol": "Spagnolo",
 "Espaço": "Alloggio",
 "Espaço livre, dados de cada aba e anexos": "Spazio libero, dati di ogni scheda e allegati",
 "Especialidade": "Specializzazione",
 "Espécie": "Specie",
 "Esquadro": "Squadra",
 "Esqueci a senha": "Password dimenticata",
 "Esquerda": "Sinistra",
 "Esse código é o seu.": "Questo è il tuo codice.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "Questo è il tuo codice. Usa il codice di chi ti ha consigliato l'app.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "Questo indirizzo non ha risposto come server delle fatture. Controlla e riprova.",
 "Esta aba ainda não está no seu plano.": "Questa scheda non è ancora nel tuo piano.",
 "Esta e todas as futuras": "Questa e tutte le future",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "Questo strumento deve vedere le pagine del PDF, cosa che arriva con la nuova app (versione 0.50). Usa il browser o installa il nuovo APK.",
 "Esta imagem foi guardada em outro dispositivo.": "Questa immagine è stata salvata su un altro dispositivo.",
 "Esta janela pode ser fechada.": "Puoi chiudere questa finestra.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "Questa persona non ha ancora compilato la scheda contatto.",
 "Esta semana: {a} de {m} aulas ({p}%)": "Questa settimana: {a} di {m} lezioni ({p}%)",
 "Esta senha é de outra conta.": "Questa password appartiene a un altro account.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "Questa attività non ha un orario: \"All'inizio\" e \"Prima dell'inizio\" non si applicano. Usa \"A un orario specifico\".",
 "Esta tarefa se repete. O que excluir?": "Questa attività si ripete. Cosa vuoi eliminare?",
 "Esta tela teve um problema": "Questa schermata ha avuto un problema",
 "Estado (UF) do registro": "Stato (UF) dell'iscrizione",
 "Estado de Mato Grosso do Sul": "Stato del Mato Grosso do Sul",
 "Estado de São Paulo": "Stato di São Paulo",
 "Estado do Paraná": "Stato del Paraná",
 "Estados": "Stati",
 "Estaduais": "Statali",
 "Estadual": "Statale",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "Queste schede appaiono nella barra in basso, in quest'ordine. My Planner, Schede e Impostazioni restano sempre. Le altre restano qui nella schermata Schede.",
 "Estatística": "Statistica",
 "Este CPF já tem cadastro. Use \"Entrar\".": "Questo CPF è già registrato. Usa \"Accedi\".",
 "Este PDF está no dispositivo onde foi aberto.": "Questo PDF è sul dispositivo dove è stato aperto.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "Questo PDF è sul dispositivo dove è stato aperto. Aprilo lì, oppure riapri la copia salvata su Drive o OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "Questo PDF è protetto da password. Togli la password nel programma in cui è stato creato e riprova.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "Questo PDF non ha campi modulo. Usa \"Aggiungi testo\" per scriverci sopra.",
 "Este ano": "Quest'anno",
 "Este dispositivo": "Questo dispositivo",
 "Este dispositivo não consegue abrir o arquivo.": "Questo dispositivo non riesce ad aprire il file.",
 "Este dispositivo não consegue compartilhar arquivos.": "Questo dispositivo non può condividere file.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "Questo dispositivo non ha dati sulla salute. Puoi inserirli a mano.",
 "Este arquivo foi guardado em outro dispositivo.": "Questo file è stato salvato su un altro dispositivo.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "Questo file è stato salvato sul telefono. Aprilo dall'app sul telefono.",
 "Este arquivo não é um backup do My Planner.": "Questo file non è un backup di My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "Questo telefono non riceve ancora notifiche con l'app chiusa. Installa l'app {v} o più recente (APK con le notifiche del server). Con l'app aperta, le notifiche funzionano già.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "Questo certificato è di {doc}, diverso dal CNPJ/CPF dell'azienda ({emp}).",
 "Este fichário ainda não tem matérias.": "Questo raccoglitore non ha ancora materie.",
 "Este grupo já está cheio.": "Questo gruppo è già pieno.",
 "Este mês": "Questo mese",
 "Este mês: emitidas {e} · recebidas {r}": "Questo mese: emesse {e} · ricevute {r}",
 "Este mês: {h}": "Questo mese: {h}",
 "Este navegador": "Questo browser",
 "Este país só tem feriados nacionais.": "Questo paese ha solo festività nazionali.",
 "Esteira": "Tapis roulant",
 "Esteticista": "Estetista",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "Uso My Planner per organizzare l'agenda, le finanze e molto altro. Scarica l'app e, quando crei il tuo account, usa il mio codice {codigo} per ottenere 10 giorni con tutte le schede sbloccate.",
 "Estratégia": "Strategia",
 "Estrela": "Stella",
 "Estudando": "Studio in corso",
 "Estudar agora": "Studia ora",
 "Estudar {nome}": "Studiare {nome}",
 "Estudar: {c}": "Studiare: {c}",
 "Estudo": "Studio",
 "Estudos": "Studio",
 "Estudos e exatas": "Studio e scienze",
 "Estudos, lazer e viagens": "Studio, svago e viaggi",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "Si trova in Patrimonio & Imposta sul reddito › Ricevute detraibili. Aprila lì per allegare la foto della ricevuta e il CPF o CNPJ di chi ha ricevuto.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "Si trova nella pagina \"{titulo}\" e in \"Vedi file\".",
 "Etanol": "Etanolo",
 "Etapa": "Fase",
 "Etapa do cronograma": "Fase del cronoprogramma",
 "Etapas": "Fasi",
 "Evento": "Evento",
 "Eventos": "Eventi",
 "Eventos & Celebrações": "Eventi & Feste",
 "Evolução (no cofre)": "Evoluzione (nella cassaforte)",
 "Ex.: 08:00 e 20:00": "Es.: 08:00 e 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "Es.: 08:00, 14:00 e 20:00",
 "Ex.: 09/2026": "Es.: 09/2026",
 "Ex.: 1 comprimido": "Es.: 1 compressa",
 "Ex.: 1-3, 4-10, 11-": "Es.: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "Es.: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "Es.: 171901 (consulenza), 010101 (programmazione)",
 "Ex.: 40 sacos de cimento": "Es.: 40 sacchi di cemento",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "Es.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "Es.: 3ª media B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "Es.: Stretching lombare, Dieta 1.800 kcal",
 "Ex.: Aniversário de 30 anos da Ana": "Es.: 30° compleanno di Ana",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "Es.: Appartamento al mare, Suite 1, Dépendance",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "Es.: Appartamento in via X, 100 azioni PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "Es.: Lezione di ripasso, Visita di controllo",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "Es.: Catering, DJ, allestimento, fotografo",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "Es.: RISERVATO, COPIA, BOZZA",
 "Ex.: Cardiologista": "Es.: Cardiologo",
 "Ex.: Consultoria mensal": "Es.: Consulenza mensile",
 "Ex.: Costela-de-adão da sala": "Es.: Monstera del soggiorno",
 "Ex.: DAS de setembro, Extrato do Itaú": "Es.: DAS di settembre, Estratto Itaú",
 "Ex.: Desmontar os móveis do quarto": "Es.: Smontare i mobili della camera",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "Es.: Disponibile · A lezione fino alle 18 · Si parte!",
 "Ex.: Eletricista, loja de material": "Es.: Elettricista, negozio di edilizia",
 "Ex.: Entrada dos noivos": "Es.: Ingresso degli sposi",
 "Ex.: Financiamento do carro": "Es.: Finanziamento dell'auto",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "Es.: Fisioterapista, Nutrizionista, Cardiologo",
 "Ex.: Furadeira, livro, R$ 200": "Es.: Trapano, libro, 200 €",
 "Ex.: Hemograma": "Es.: Emocromo",
 "Ex.: IPVA 2027, parcela 1": "Es.: IPVA 2027, rata 1",
 "Ex.: Lisboa, Portugal": "Es.: Lisbona, Portogallo",
 "Ex.: Mala da Ana": "Es.: Valigia di Ana",
 "Ex.: Mensalidade de outubro, material": "Es.: Quota di ottobre, materiale",
 "Ex.: Netflix, cinema": "Es.: Netflix, cinema",
 "Ex.: Notas de compra de setembro": "Es.: Fatture di acquisto di settembre",
 "Ex.: Onix 2022": "Es.: Panda 2022",
 "Ex.: Prova 1, Trabalho em grupo": "Es.: Verifica 1, lavoro di gruppo",
 "Ex.: Prova de matemática": "Es.: Verifica di matematica",
 "Ex.: Pôr do sol no Tejo": "Es.: Tramonto sul Tago",
 "Ex.: Reforma da cozinha": "Es.: Ristrutturazione della cucina",
 "Ex.: TAP TP 108": "Es.: TAP TP 108",
 "Ex.: Torre de Belém": "Es.: Torre di Belém",
 "Ex.: Troca da fiação da sala": "Es.: Rifare i cavi del soggiorno",
 "Ex.: V10, antirrábica": "Es.: Polivalente, antirabbica",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "Es.: Visita al Monastero dos Jerónimos",
 "Ex.: cerâmica 30 cm": "Es.: piastrelle 30 cm",
 "Ex.: kg, pacotes, latas": "Es.: kg, pacchi, lattine",
 "Ex.: seg e qua, 07:30": "Es.: lun e mer, 07:30",
 "Ex.: troquei o arroz por batata doce": "Es.: ho sostituito il riso con la patata dolce",
 "Ex.: varanda, sala": "Es.: balcone, soggiorno",
 "Exame": "Esame",
 "Exame da OAB": "Esame OAB",
 "Exames": "Esami",
 "Excel": "Excel",
 "Excluir": "Elimina",
 "Excluir \"{nome}\"?": "Eliminare \"{nome}\"?",
 "Excluir \"{titulo}\"?": "Eliminare \"{titulo}\"?",
 "Excluir a caixa?": "Eliminare il riquadro?",
 "Excluir a compra": "Elimina l'acquisto",
 "Excluir a compra?": "Eliminare l'acquisto?",
 "Excluir a meta \"{m}\"?": "Eliminare l'obiettivo \"{m}\"?",
 "Excluir cartão": "Elimina carta",
 "Excluir conta": "Elimina conto",
 "Excluir cuidado": "Elimina cura",
 "Excluir cômodo": "Elimina stanza",
 "Excluir esta página?": "Eliminare questa pagina?",
 "Excluir fichário": "Elimina raccoglitore",
 "Excluir matéria": "Elimina materia",
 "Excluir o cartão \"{c}\"?": "Eliminare la carta \"{c}\"?",
 "Excluir o documento": "Elimina il documento",
 "Excluir o fichário {nome}": "Elimina il raccoglitore {nome}",
 "Excluir página": "Elimina pagina",
 "Excluir refeição": "Elimina pasto",
 "Excluir suplemento": "Elimina integratore",
 "Excluir tarefa": "Elimina attività",
 "Excluir tarefa repetida": "Elimina attività ricorrente",
 "Excluir tarefa?": "Eliminare l'attività?",
 "Excluir treino": "Elimina allenamento",
 "Excluir {nome}?": "Eliminare {nome}?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Eliminate definitivamente 30 giorni dopo lo scarto.",
 "Executivo e profissional": "Executive e professionale",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Esecuzione del contratto (art. 7º, V), per fornire il servizio; consenso (art. 7º, I), per fotocamera, galleria, microfono e posizione; adempimento di un obbligo di legge (art. 7º, II); e legittimo interesse (art. 7º, IX), per sicurezza e prevenzione delle frodi.",
 "Exemplos: 13:30, 1330, 9:05": "Esempi: 13:30, 1330, 9:05",
 "Exercício": "Esercizio",
 "Exercício físico": "Attività fisica",
 "Experimente grátis por {n} dias": "Provalo gratis per {n} giorni",
 "Explique o motivo (para cancelar)": "Spiega il motivo (per annullare)",
 "Exportar arquivo": "Esporta file",
 "Exportar para o contador": "Esporta per il commercialista",
 "Extrair páginas": "Estrai pagine",
 "Extras (pet, check-in tardio...)": "Extra (animali, check-in tardivo...)",
 "Extrato": "Estratto conto",
 "Extrato bancário": "Estratto conto",
 "Extrato do banco (foto ou PDF)": "Estratto conto (foto o PDF)",
 "Extrato importado": "Estratto conto importato",
 "Extrato por foto": "Estratto conto da foto",
 "FRASE": "FRASE",
 "FRÁGIL": "FRAGILE",
 "Fabricante ou estendida: {n} meses": "Produttore o estesa: {n} mesi",
 "Facultativo": "Facoltativo",
 "Falar com a limpeza": "Parla con le pulizie",
 "Fale conosco": "Contattaci",
 "Falta": "Assente",
 "Falta XML": "Manca XML",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "Manca il collegamento al server delle fatture: sul computer, fai doppio clic su 13-LIGAR-NOTAS.bat e incolla qui l'indirizzo che mostra.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Manca Health Connect, l'app di Google che raccoglie i dati degli orologi e delle app salute.",
 "Faltam": "Da visitare",
 "Faltam {ml} ({n} copo(s))": "Mancano {ml} ({n} bicchiere/i)",
 "Faltam {n} dia(s) do seu período grátis": "Mancano {n} giorno/i al termine del periodo gratuito",
 "Faltam {n} dias": "Mancano {n} giorni",
 "Faltou": "Assente",
 "Família": "Famiglia",
 "Fantasia": "Fantasy",
 "Fatura": "Estratto carta",
 "Fatura com vencimento em {d}.": "Estratto carta con scadenza il {d}.",
 "Fatura de {mes}": "Estratto carta di {mes}",
 "Fatura de {mes}: vence {data}": "Estratto carta di {mes}: scade il {data}",
 "Fatura do cartão (foto ou PDF)": "Estratto della carta (foto o PDF)",
 "Fatura importada": "Estratto carta importato",
 "Fatura paga (toque para desfazer)": "Estratto carta pagato (tocca per annullare)",
 "Fatura {c}": "Estratto carta {c}",
 "Faturamento em {ano}: {v} de {lim}": "Fatturato nel {ano}: {v} su {lim}",
 "Faturas dos cartões": "Estratti delle carte",
 "Fazer agora, passo a passo": "Fallo ora, passo per passo",
 "Fazer com este PDF": "Cosa fare con questo PDF",
 "Fazer cópia agora": "Esegui backup ora",
 "Fecha dia {f} · vence dia {v}": "Chiude il {f} · scade il {v}",
 "Fecha {f} · vence {v}": "Chiude {f} · scade {v}",
 "Fechar": "Chiudi",
 "Fechar o cofre": "Chiudi la cassaforte",
 "Feche e abra o app de novo": "Chiudi e riapri l'app",
 "Federais": "Federali",
 "Feijão": "Fagioli",
 "Feita em {data}": "Fatta il {data}",
 "Feita hoje": "Fatta oggi",
 "Feitas": "Fatte",
 "Feitas (não se repetem) · {n}": "Fatte (non si ripetono) · {n}",
 "Feito": "Fatto",
 "Feito!": "Fatto!",
 "Feliz aniversário": "Buon compleanno",
 "Feminino": "Femminile",
 "Feminino e suave": "Femminile e delicato",
 "Feriado escolar": "Vacanza scolastica",
 "Feriado estadual": "Festività statale",
 "Feriado estadual: {nome}": "Festività statale: {nome}",
 "Feriado municipal": "Festività comunale",
 "Feriado municipal: {nome}": "Festività comunale: {nome}",
 "Feriado nacional": "Festività nazionale",
 "Feriado nacional: {nome}": "Festività nazionale: {nome}",
 "Feriado regional": "Festività regionale",
 "Feriado regional: {nome}": "Festività regionale: {nome}",
 "Feriados": "Festività",
 "Feriados nacionais": "Festività nazionali",
 "Feriados no planner": "Festività nel planner",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Festività, quotazioni, suggerimenti dell'intelligenza artificiale e letture automatiche di boleti e fatture possono contenere errori. Controlla prima di usarli.",
 "Ferramenta": "Attrezzo",
 "Ferramentas": "Attrezzi",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Scheda di ogni pianta, rinvaso e calendario di annaffiature e concime in agenda.",
 "Ficha preenchida": "Scheda compilata",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Raccoglitori, materie e pagine, cronometro di studio e obiettivi settimanali.",
 "Ficção": "Narrativa",
 "Figurinha": "Sticker",
 "Figurinhas": "Sticker",
 "Filme": "Film",
 "Filme ou série": "Film o serie",
 "Filmes e séries": "Film e serie",
 "Filosofia": "Filosofia",
 "Filtros": "Filtri",
 "Fim": "Fine",
 "Fim (vazio = uso contínuo)": "Fine (vuoto = uso continuo)",
 "Fim da garantia": "Fine della garanzia",
 "Fim da garantia:": "Fine garanzia:",
 "Fim da pausa. Continue: {tarefa}": "Fine della pausa. Continua: {tarefa}",
 "Fim de semana": "Fine settimana",
 "Fim previsto": "Fine prevista",
 "Fina": "Sottile",
 "Finados": "Commemorazione dei defunti",
 "Finalizador": "Prodotto finale",
 "Financeiro": "Finanze",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Finanziario: {gasto} su {orcado} ({p}%)",
 "Financiamento": "Finanziamento",
 "Financiamento de veículo": "Finanziamento auto",
 "Financiamento imobiliário": "Mutuo immobiliare",
 "Financiamentos": "Finanziamenti",
 "Financiamentos e empréstimos": "Finanziamenti e prestiti",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Finanziamenti e prestiti con rate, interessi, debito residuo e ricevute; oggetti prestati con foto e promemoria per la restituzione.",
 "Finanças": "Finanza",
 "Finanças {p}": "Finanza {p}",
 "Finanças · {p}": "Finanza · {p}",
 "Fins de semana": "Fine settimana",
 "Fio dental": "Filo interdentale",
 "Flex": "Flex",
 "Flexão de braço": "Piegamenti",
 "Flor": "Fiore",
 "Flutua": "Fluttua",
 "Foguete": "Razzo",
 "Fogão": "Fornello",
 "Foi no cartão de crédito? Lançar como compra no cartão": "Pagato con carta di credito? Registra come acquisto con carta",
 "Foi para {destino}.": "Inviato a {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "Inviato a {destino}. Vuoi toglierlo da qui?",
 "Folha de pagamento": "Busta paga",
 "Fone": "Auricolare",
 "Fone de ouvido": "Auricolari",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Fonti: Brasile, calcolato nell'app a partire dal decreto federale sulle festività e dalle leggi di ogni stato. Altri paesi: database pubblico Nager.Date (date.nager.at), scaricato da internet e salvato sul dispositivo.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Fonti: Brasile, calcolate nell'app in base al decreto federale sulle festività, alle leggi di ogni stato e ai calendari ufficiali delle capitali. Altri paesi: banca dati pubblica Nager.Date (date.nager.at), scaricata da internet e salvata sul dispositivo.",
 "Forma": "Metodo",
 "Forma das parcelas": "Tipo di rate",
 "Forma de pagamento": "Metodo di pagamento",
 "Forma de pagamento: {f}.": "Metodo di pagamento: {f}.",
 "Formas": "Forme",
 "Formato": "Formato",
 "Formatos": "Formati",
 "Formatura": "Laurea",
 "Fornecedor": "Fornitore",
 "Fornecedores": "Fornitori",
 "Forte": "Forte",
 "Foto": "Foto",
 "Foto da galeria": "Foto dalla galleria",
 "Foto do contato": "Foto del contatto",
 "Foto inteira": "Foto intera",
 "Foto ou PDF (lido pela sua IA)": "Foto o PDF (letto dalla tua IA)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Fotografa ogni stanza al sopralluogo di uscita e a quello di ingresso. Le foto ti tutelano quando riconsegni l'immobile.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Fotografa ogni ricevuta di medico, dentista, scuola e previdenza appena paghi. A fine anno è tutto pronto.",
 "Fotos": "Foto",
 "Fotos JPG, PNG e outras viram um PDF.": "Foto JPG, PNG e altre diventano un PDF.",
 "Fotos de {d}": "Foto del {d}",
 "Fotos do espaço pronto": "Foto dell'alloggio pronto",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "Foto e file di questa scheda vanno anche nella cartella del gruppo, così chi partecipa può aprirli.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "Foto e file restano salvati solo su questo dispositivo. I dati del documento vanno sul tuo account, protetti.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "Foto e file restano su questo dispositivo (e nel tuo Drive o OneDrive, se attivo in Impostazioni).",
 "Fotos e notas": "Foto e note",
 "Fotos e vídeos": "Foto e video",
 "Fotos, arquivos e links": "Foto, file e link",
 "Fraldas e lenços": "Pannolini e salviette",
 "Francês": "Francese",
 "Frango com osso": "Pollo con osso",
 "Frango sem osso": "Pollo disossato",
 "Frase (opcional, ex.: Bom dia!)": "Frase (facoltativa, es.: Buongiorno!)",
 "Freelancer & Projetos": "Freelance & Progetti",
 "Freezer": "Congelatore",
 "Freios": "Freni",
 "Frente": "Fronte",
 "Frente do documento": "Fronte del documento",
 "Frente e verso na mesma folha": "Fronte e retro sullo stesso foglio",
 "Frente pronta": "Fronte pronto",
 "Frequência": "Frequenza",
 "Frio": "Freddo",
 "Fruta": "Frutta",
 "Frágil": "Fragile",
 "Fundação e estrutura": "Fondazioni e struttura",
 "Fundo": "Sfondo",
 "Fundos e renda fixa": "Fondi e reddito fisso",
 "Fuso": "Fuso",
 "Fuso horário": "Fuso orario",
 "Fuso horário do destino": "Fuso orario della destinazione",
 "Futebol": "Calcio",
 "Física": "Fisica",
 "Físico (obra pronta): {p}%": "Fisico (lavori eseguiti): {p}%",
 "GASTOS POR CATEGORIA": "SPESE PER CATEGORIA",
 "GIF guardado nos seus GIFs.": "GIF salvata nelle tue GIF.",
 "Garagem": "Garage",
 "Garantia": "Garanzia",
 "Garantia até {data}.": "Garanzia fino al {data}.",
 "Garantia legal": "Garanzia legale",
 "Garantia vencendo": "Garanzia in scadenza",
 "Garantias": "Garanzie",
 "Garrafa de água": "Borraccia",
 "Gasolina": "Benzina",
 "Gasto": "Spesa",
 "Gasto até agora": "Speso finora",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Spesa di {v} registrata. {n} prezzo/i salvato/i per la tua lista della spesa.",
 "Gasto neste mês: {v}": "Speso questo mese: {v}",
 "Gasto: {v}": "Speso: {v}",
 "Gastos": "Spese",
 "Gastos por categoria": "Spese per categoria",
 "Gato": "Gatto",
 "Geladeira": "Frigorifero",
 "Geografia": "Geografia",
 "Gerado por": "Prodotto da",
 "Gerando QR Code...": "Generazione del QR Code...",
 "Gerar PDF": "Genera PDF",
 "Gerar as cobranças do mês": "Genera gli addebiti del mese",
 "Gerar as parcelas": "Genera le rate",
 "Gerar lista da mala": "Genera la lista della valigia",
 "Gerar pelo cardápio e pela despensa": "Genera da menu e dispensa",
 "Gesso e forro": "Cartongesso e controsoffitto",
 "Gira todas as páginas ou só as escolhidas.": "Ruota tutte le pagine o solo quelle scelte.",
 "Girar": "Ruota",
 "Google Drive e OneDrive": "Google Drive e OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive e Google Calendar: solo se li colleghi, e solo per salvare i tuoi file ed eventi.",
 "Gorro, cachecol e luvas": "Berretto, sciarpa e guanti",
 "Gota": "Goccia",
 "Graduação e Pós": "Laurea e Post-laurea",
 "Grande": "Grande",
 "Gravando": "Registrazione in corso",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Registrare promemoria e note vocali quando lo chiedi. Il microfono si attiva solo con un tuo tocco.",
 "Gravar reunião": "Registra riunione",
 "Gravação de áudio": "Registrazione audio",
 "Gravações das reuniões": "Registrazioni delle riunioni",
 "Grossa": "Spessa",
 "Grupo": "Gruppo",
 "Grupo com convite (turma, equipe, convidados)": "Gruppo con invito (classe, team, invitati)",
 "Grupo criado": "Gruppo creato",
 "Grupo da família": "Gruppo di famiglia",
 "Grupo da mudança (família e ajudantes)": "Gruppo del trasloco (famiglia e aiutanti)",
 "Grupo da obra (equipe)": "Gruppo del cantiere (squadra)",
 "Grupo da turma (convidar alunos)": "Gruppo della classe (invita gli studenti)",
 "Grupo da viagem (convidar quem vai)": "Gruppo del viaggio (invita chi viene)",
 "Grupo de cuidado (família ou profissional)": "Gruppo di assistenza (famiglia o professionista)",
 "Grupo de estudos (convidar colegas)": "Gruppo di studio (invita i compagni)",
 "Grupo de leitura (convidar)": "Gruppo di lettura (invita)",
 "Grupo do cliente": "Gruppo del cliente",
 "Grupo do evento (convidar)": "Gruppo dell'evento (invita)",
 "Grupos": "Gruppi",
 "Grupos de estudo": "Gruppi di studio",
 "Grupos de {aba}": "Gruppi di {aba}",
 "Grupos desta aba: {n}": "Gruppi di questa scheda: {n}",
 "Grupos e convites": "Gruppi e inviti",
 "Grátis no lançamento": "Gratis al lancio",
 "Guarda-chuva": "Ombrello",
 "Guardada nas suas figurinhas.": "Salvato nei tuoi sticker.",
 "Guardado": "Risparmiato",
 "Guardado até agora: {v}": "Risparmiato finora: {v}",
 "Guardado em outro dispositivo": "Salvato su un altro dispositivo",
 "Guardado na pasta \"{pasta}\" do celular.": "Salvato nella cartella \"{pasta}\" del cellulare.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Custodito nella cassaforte, con crittografia end-to-end.",
 "Guardado no {nome}.": "Salvato su {nome}.",
 "Guardado {onde} em {quando}": "Salvato {onde} il {quando}",
 "Guardando...": "Salvataggio...",
 "Guardar": "Metti da parte",
 "Guardar como recibo do IR": "Salva come ricevuta per l'IR",
 "Guardar dinheiro": "Metti da parte soldi",
 "Guardar e enviar": "Salva e invia",
 "Guardar na meta": "Aggiungi all'obiettivo",
 "Guardar nas minhas figurinhas": "Salva nei miei sticker",
 "Guardar nos meus GIFs": "Salva nelle mie GIF",
 "Guardar o PDF {onde}": "Salva il PDF {onde}",
 "Guardar os PDFs em": "Salva i PDF in",
 "Guardar os arquivos prontos em": "Salva i file pronti in",
 "Guardar sozinho cada arquivo pronto": "Salva automaticamente ogni file pronto",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Salva le prescrizioni e le indicazioni che usi sempre. Nella visita, tocca ⋮ › Usa modello.",
 "Guarde seus documentos num lugar só": "Tieni tutti i tuoi documenti in un unico posto",
 "Guarde {v} por mês até {d}": "Metti da parte {v} al mese fino al {d}",
 "Guardou": "Risparmiato",
 "Guia de imposto": "Modello di pagamento imposte",
 "Gás": "Gas",
 "Gênero ou categoria": "Genere o categoria",
 "HISTÓRICO DOS DADOS": "CRONOLOGIA DEI DATI",
 "HOJE": "OGGI",
 "Hall de entrada": "Ingresso",
 "Halteres": "Manubri",
 "Hexágono": "Esagono",
 "Hidratante": "Crema idratante",
 "Hidratante labial": "Burrocacao",
 "Hidráulica": "Impianto idraulico",
 "Higiene bucal": "Igiene orale",
 "Higienizar": "Pulisci",
 "História": "Storia",
 "Histórico": "Storico",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "Anamnesi familiare, esami protetti, vaccini, visite e sveglia dei farmaci nella cronologia.",
 "Hmm...": "Mmm...",
 "Hoje": "Oggi",
 "Hoje: {a} de {m} aulas ({p}%)": "Oggi: {a} di {m} lezioni ({p}%)",
 "Hoje: {n} página(s)": "Oggi: {n} pagina/e",
 "Hora": "Ora",
 "Hora da pausa": "Ora della pausa",
 "Hora de voltar": "È ora di tornare",
 "Hora de voltar!": "È ora di tornare!",
 "Hora do check-in": "Ora del check-in",
 "Hora do check-out": "Ora del check-out",
 "Horas": "Ore",
 "Horas de sono": "Ore di sonno",
 "Horário": "Orario",
 "Horário de check-in": "Orario di check-in",
 "Horário de check-out": "Orario di check-out",
 "Horário do lembrete": "Ora del promemoria",
 "Horário inválido": "Orario non valido",
 "Horário ocupado": "Orario occupato",
 "Horários": "Orari",
 "Horários (remédio diário)": "Orari (farmaco giornaliero)",
 "Hospedados agora": "Ospiti ora",
 "Hospedagem": "Alloggio",
 "Hospital ou pronto-socorro de referência": "Ospedale o pronto soccorso di riferimento",
 "Hotel": "Hotel",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "È disponibile una nuova versione di My Planner Web. Ricarica per usarla.",
 "Híbrido": "Ibrido",
 "Hóspede": "Ospite",
 "Hóspede ({c})": "Ospite ({c})",
 "Hóspedes (máximo)": "Ospiti (massimo)",
 "IA ligada": "IA attiva",
 "IA não ligada": "IA non attiva",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "IA non attiva. Attivala in Impostazioni › Intelligenza artificiale.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS trattenuto dal committente",
 "Ida": "Andata",
 "Identidade": "Documento d'identità",
 "Idioma": "Lingua",
 "Idiomas": "Lingue",
 "Ilimitados": "Illimitati",
 "Imagem": "Immagine",
 "Imagem escolhida (trocar)": "Immagine scelta (cambia)",
 "Imagem guardada no {nome}. Toque para abrir.": "Immagine salvata su {nome}. Tocca per aprirla.",
 "Imagens para PDF": "Immagini in PDF",
 "Imagens {data}": "Immagini {data}",
 "Imperdíveis": "Da non perdere",
 "Imperdível": "Da non perdere",
 "Importar": "Importa",
 "Importar XML de nota": "Importa XML di fattura",
 "Importar arquivo": "Importa file",
 "Importar backup?": "Importare il backup?",
 "Importar extrato": "Importa estratto conto",
 "Importar extrato do banco (OFX ou CSV)": "Importa estratto conto bancario (OFX o CSV)",
 "Importar fatura": "Importa estratto carta",
 "Importar fotos": "Importa foto",
 "Importar reservas do Airbnb, Booking...": "Importa prenotazioni da Airbnb, Booking...",
 "Importar {n} lançamento(s)": "Importa {n} movimento/i",
 "Imóveis e espaços": "Alloggi e spazi",
 "Imóvel": "Immobile",
 "Imóvel inteiro": "Intero alloggio",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Intero alloggio o per stanza: prenotazioni da Airbnb, Booking o dirette, pulizia al check-out, spese, occupazione e utile del mese.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Include {v} dalle fatture emesse nella scheda Fatture.",
 "Independência do Brasil": "Indipendenza del Brasile",
 "Indicação": "Passaparola",
 "Indique e ganhe": "Invita e guadagna",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Consiglia My Planner ad amici e familiari. Chi crea l'account con il tuo codice ottiene 10 giorni con tutte le schede sbloccate.",
 "Infantil": "Per bambini",
 "Informações do PDF": "Info PDF",
 "Informe a descrição e o valor.": "Inserisci la descrizione e l'importo.",
 "Informe de quantos em quantos dias regar ou adubar.": "Indica ogni quanti giorni annaffiare o concimare.",
 "Informe o nome do produto.": "Inserisci il nome del prodotto.",
 "Informe o rótulo e o nome.": "Inserisci l'etichetta e il nome.",
 "Informe o total de aulas da matéria em Editar.": "Indica il totale di lezioni della materia in Modifica.",
 "Informe o valor.": "Inserisci l'importo.",
 "Informe os horários": "Indica gli orari",
 "Informe quanto quer juntar.": "Indica quanto vuoi mettere da parte.",
 "Informe seu nome.": "Inserisci il tuo nome.",
 "Informática": "Informatica",
 "Inglês": "Inglese",
 "Ingredientes (um por linha)": "Ingredienti (uno per riga)",
 "Inscrição municipal (se tiver)": "Iscrizione comunale (se ce l'hai)",
 "Inspeção": "Revisione obbligatoria",
 "Instalar ou atualizar o Health Connect": "Installa o aggiorna Health Connect",
 "Instruções, receita, observações...": "Istruzioni, ricetta, note...",
 "Insumos (papel, sabonete, café)": "Forniture (carta, sapone, caffè)",
 "Inteligência artificial": "Intelligenza artificiale",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Intelligenza artificiale (Claude, ChatGPT o Gemini): solo se la attivi, con la tua chiave, che resta solo sul dispositivo. Il testo della domanda va direttamente al servizio scelto.",
 "Intensidade": "Intensità",
 "Internação": "Ricovero",
 "Internet": "Internet",
 "Intimação": "Notificazione",
 "Intimação com prazo": "Notifica con termine",
 "Investimento": "Investimento",
 "Investimentos": "Investimenti",
 "Início": "Inizio",
 "Início {ini} · Fim {fim} · Duração {dur}": "Inizio {ini} · Fine {fim} · Durata {dur}",
 "Iogurte": "Yogurt",
 "Ir para Ajustes (exportar meus dados)": "Vai a Impostazioni (esporta i miei dati)",
 "Ir para hoje": "Vai a oggi",
 "Ir para o My Planner Web": "Vai a My Planner Web",
 "Italiano": "Italiano",
 "Item": "Elemento",
 "Item da despensa": "Articolo della dispensa",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Elemento protetto: foto e file sono cifrati nella cassaforte, solo su questo dispositivo (non vanno su Drive né su OneDrive).",
 "Itens": "Articoli",
 "Itens de higiene (xampu, sabonete)": "Articoli da bagno (shampoo, sapone)",
 "Jantar": "Cena",
 "Japonês": "Giapponese",
 "Jaqueta impermeável": "Giacca impermeabile",
 "Jogo": "Gioco",
 "Jovem e divertido": "Giovane e divertente",
 "Juntar PDFs": "Unisci PDF",
 "Juros": "Interessi",
 "Juros ainda por vir: {v}": "Interessi ancora da pagare: {v}",
 "Juros ao mês": "Interesse mensile",
 "JÁ RESPONDIDOS": "GIÀ RISPOSTI",
 "Já aberta na casa nova": "Già aperta nella casa nuova",
 "Já enviado para a turma": "Già inviato alla classe",
 "Já está compacto": "È già compatto",
 "Já está no Planner": "Già nel Planner",
 "Já está pago": "Già pagato",
 "Já há horários deste item no My Planner": "Ci sono già orari di questo elemento in My Planner",
 "Já pago: {v}": "Già pagato: {v}",
 "Já tenho o app: abrir nele": "Ho già l'app: apri lì",
 "Já tenho o app: abrir o convite nele": "Ho già l'app: apri l'invito lì",
 "Já visitei": "Già visitato",
 "Kit de primeiros socorros": "Kit di pronto soccorso",
 "Kkkk": "Ahah",
 "Kkkkk": "Ahahah",
 "Km de hoje no painel": "Km di oggi sul cruscotto",
 "Km no dia": "Km quel giorno",
 "Km no painel": "Km sul cruscotto",
 "LANÇAMENTOS": "MOVIMENTI",
 "LINHA DO TEMPO": "CRONOLOGIA",
 "Laboratório": "Laboratorio",
 "Lanche": "Spuntino",
 "Lanche da manhã": "Spuntino del mattino",
 "Lanche da tarde": "Merenda",
 "Lanches e água": "Snack e acqua",
 "Lançamentos": "Movimenti",
 "Lavanderia": "Lavanderia",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Lavanderia, forniture, manutenzione, bollette e tasse. Rientrano nell'utile del mese.",
 "Lavar o rosto com sabonete facial": "Lavare il viso con il detergente",
 "Lazer": "Tempo libero",
 "Leg press": "Leg press",
 "Legenda": "Didascalia",
 "Legislação Específica": "Legislazione specifica",
 "Legumes": "Verdure",
 "Leia hoje para começar uma sequência": "Leggi oggi per iniziare una serie",
 "Leite": "Latte",
 "Leitura": "Lettura",
 "Leitura automática do texto": "Lettura automatica del testo",
 "Leitura da IA": "Lettura dell'IA",
 "Leitura, Cursos & Mídia": "Lettura, Corsi & Media",
 "Lembrete": "Promemoria",
 "Lembrete de hoje": "Promemoria di oggi",
 "Lembrete de renovação no Planner": "Promemoria di rinnovo nel Planner",
 "Lembrete no Planner": "Promemoria nel Planner",
 "Lembrete no planner": "Promemoria nel planner",
 "Lembrete pelo WhatsApp": "Promemoria via WhatsApp",
 "Lembrete: começa às {hora}": "Promemoria: inizia alle {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "Leggiamo tutti i messaggi. Se serve, ti rispondiamo via e-mail.",
 "Lendo": "In lettura",
 "Lendo a fatura...": "Lettura dell'estratto carta...",
 "Lendo a página": "Lettura pagina",
 "Lendo o boleto...": "Lettura del boleto...",
 "Lendo o cupom...": "Lettura dello scontrino...",
 "Lendo o documento...": "Lettura del documento...",
 "Lendo o extrato...": "Lettura dell'estratto conto...",
 "Lendo o relógio...": "Lettura dell'orologio...",
 "Lendo o texto": "Lettura del testo",
 "Ler a fatura": "Leggi l'estratto carta",
 "Ler a publicação inteira": "Leggi la pubblicazione intera",
 "Ler com a minha IA": "Leggi con la mia IA",
 "Ler de novo": "Rileggi",
 "Ler de novo agora": "Rileggi ora",
 "Ler o texto": "Leggi il testo",
 "Ler o texto completo": "Leggi il testo completo",
 "Ler publicação inteira": "Leggi pubblicazione intera",
 "Ler sozinho as publicações novas": "Leggi da sola le nuove pubblicazioni",
 "Leve": "Leggera",
 "Leve (sem perder qualidade)": "Leggera (senza perdita di qualità)",
 "Li e aceito os termos e a política de privacidade": "Ho letto e accetto i termini e l'informativa sulla privacy",
 "Li mais {n} páginas": "Ho letto altre {n} pagine",
 "Liberada pelo suporte": "Sbloccata dall'assistenza",
 "Liberar para a equipe": "Rendi visibile al team",
 "Liberar para a turma em": "Rendi disponibile alla classe il",
 "Liberar para o grupo": "Sblocca per il gruppo",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Sblocchi e crediti sono legati al tuo CPF. Si aggiorna con la sincronizzazione.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Autorizza la fotocamera per My Planner nelle impostazioni del cellulare per leggere il QR Code.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Consenti l'accesso alla fotocamera per My Planner nelle impostazioni del telefono.",
 "Libere outras abas em Ajustes › Compras.": "Sblocca altre schede in Impostazioni › Acquisti.",
 "Licenciamento": "Immatricolazione",
 "Lidas hoje": "Lette oggi",
 "Lido": "Letto",
 "Ligando. Toque para atender.": "Chiamata in arrivo. Tocca per rispondere.",
 "Ligar": "Chiama",
 "Ligar certificado": "Collega certificato",
 "Ligar para a assistência": "Chiama l'assistenza",
 "Ligar para {nome}": "Chiama {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Attiva la tua IA in Impostazioni › Intelligenza artificiale (Claude, ChatGPT o Gemini) per usare questo strumento.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Attiva la tua IA in Impostazioni › Intelligenza artificiale per leggere il testo, riassumere e fare domande sul documento.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Attiva la tua IA in Impostazioni › Intelligenza artificiale.",
 "Ligue o certificado A1 da empresa primeiro.": "Collega prima il certificato A1 dell'azienda.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Collega il tuo Google Drive o OneDrive per salvare foto e file (che si aprono poi su qualsiasi dispositivo) e avere backup completi.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Attivalo perché il gruppo lavori sugli stessi dati (cantiere, viaggio, classe, immobile, studio), ognuno con il proprio ruolo.",
 "Ligue pelo menos 4 pontos.": "Collega almeno 4 punti.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Limite annuale modificabile in Impostazioni › Schede › Scheda Finanza. Verifica sempre con il tuo commercialista.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Limite di ricerche raggiunto. Riprova tra 1 minuto.",
 "Limite de energia por dia": "Limite di energia al giorno",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "Limite di fatturato annuo del MEI (verifica l'importo in vigore con il tuo commercialista).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Limite di messaggi per oggi raggiunto. Riprova domani.",
 "Limite diário": "Limite giornaliero",
 "Limite livre: {v} de {l}": "Disponibile: {v} su {l}",
 "Limite total (opcional)": "Plafond totale (facoltativo)",
 "Limpar": "Cancella",
 "Limpar a agenda": "Pulisci l'agenda",
 "Limpar banheiro": "Pulire il bagno",
 "Limpar cozinha e louça": "Pulire cucina e stoviglie",
 "Limpar feitos": "Rimuovi completati",
 "Limpeza": "Pulizia",
 "Limpeza após {h}": "Pulizia dopo {h}",
 "Limpeza final": "Pulizia finale",
 "Limpeza · {e}": "Pulizia · {e}",
 "Limpeza: {e}": "Pulizia: {e}",
 "Limpezas": "Pulizie",
 "Linha do tempo, tarefas, energia e alertas.": "Cronologia, attività, energia e avvisi.",
 "Link": "Link",
 "Link (Drive, OneDrive, Dropbox)": "Link (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Link copiato. Incollalo dove vuoi inviarlo.",
 "Link da aula ou reunião online (opcional)": "Link della lezione o riunione online (facoltativo)",
 "Link da nota fiscal (Drive ou OneDrive)": "Link della fattura (Drive o OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Link della cartella su Drive o OneDrive (facoltativo)",
 "Link da reserva": "Link della prenotazione",
 "Link da sala online (Meet, Zoom...)": "Link della stanza online (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Link di un altro calendario (iCal)",
 "Link do calendário do Airbnb (iCal)": "Link del calendario Airbnb (iCal)",
 "Link do calendário do Booking (iCal)": "Link del calendario Booking (iCal)",
 "Link inválido": "Link non valido",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Link ai materiali (Drive, video, PDF), uno per riga",
 "Links: {n}": "Link: {n}",
 "Lista": "Elenco",
 "Lista da mala": "Lista della valigia",
 "Lista de compras": "Lista della spesa",
 "Lista de exercícios": "Esercizi",
 "Lista rápida": "Elenco rapido",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Elenchi rapidi e riquadri che diventano attività o vanno in un'altra scheda.",
 "Literatura": "Letteratura",
 "Litros": "Litri",
 "Livre": "Libero",
 "Livro": "Libro",
 "Livros": "Libri",
 "Local": "Luogo",
 "Local ou endereço": "Luogo o indirizzo",
 "Local: {l}": "Luogo: {l}",
 "Localização (país e fuso horário)": "Posizione (paese e fuso orario)",
 "Logo, foto ou rubrica nas páginas.": "Logo, foto o sigla sulle pagine.",
 "Loja (opcional)": "Negozio (facoltativo)",
 "Lote": "Lotto",
 "Lua": "Luna",
 "Lugar": "Luogo",
 "Lugar para visitar": "Luogo da visitare",
 "Lugares": "Luoghi",
 "Luz": "Luce",
 "Luz indireta": "Luce indiretta",
 "Luz, água, gás e internet": "Luce, acqua, gas e internet",
 "Lápis": "Matita",
 "Língua Portuguesa": "Lingua portoghese",
 "MAIS ADIANTE": "PIÙ AVANTI",
 "MAIS USADOS": "PIÙ USATI",
 "ME ou EPP do Simples": "ME o EPP del Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: fatturato {ano} di {v} (limite {l}).",
 "MEMBROS ({n})": "MEMBRI ({n})",
 "METAS": "OBIETTIVI",
 "MS": "MS",
 "Mais": "Altro",
 "Mais abas": "Altre schede",
 "Mais cidades entram nas próximas versões.": "Altre città arriveranno nelle prossime versioni.",
 "Mais emojis": "Altre emoji",
 "Mais ferramentas": "Altri strumenti",
 "Mais figurinhas animadas (KLIPY)": "Altri sticker animati (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "Altre opzioni di questa scheda arriveranno nelle prossime versioni.",
 "Mais uma": "Un'altra",
 "Mala": "Valigia",
 "Mala ({clima}, {n} dias)": "Valigia ({clima}, {n} giorni)",
 "Mamadeiras e leite": "Biberon e latte",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "Abbiamo inviato un codice di 6 cifre al WhatsApp del numero {tel}.",
 "Mandar as orientações pelo WhatsApp": "Invia le indicazioni via WhatsApp",
 "Mandar de novo": "Invia di nuovo",
 "Mandar e-mail": "Invia e-mail",
 "Mandar lembrete": "Invia promemoria",
 "Mandar meu código": "Invia il mio codice",
 "Mandar o acerto para o grupo": "Invia il saldo al gruppo",
 "Mandar para quem limpa (WhatsApp)": "Invia a chi pulisce (WhatsApp)",
 "Mandarim": "Cinese mandarino",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Invia un'e-mail chiedendo l'eliminazione, con il documento dell'account. Rispondiamo entro 15 giorni.",
 "Manter": "Mantieni",
 "Manter ambas": "Tieni entrambe",
 "Manter ambos": "Mantieni entrambi",
 "Manter aqui também": "Tienilo anche qui",
 "Manter tarefas": "Mantieni attività",
 "Manutenção": "Manutenzione",
 "Manutenções": "Manutenzioni",
 "Mapas (Apple)": "Mappe (Apple)",
 "Marca d'água": "Filigrana",
 "Marca-texto": "Evidenziatore",
 "Marcado": "Selezionato",
 "Marcado como feito hoje.": "Segnato come fatto oggi.",
 "Marcar como concluída ({dia})": "Segna come completata ({dia})",
 "Marcar como devolvido": "Segna come restituito",
 "Marcar como feita hoje": "Segna come fatta oggi",
 "Marcar como lido": "Segna come letto",
 "Marcar como paga": "Segna come pagato",
 "Marcar como pago": "Segna come pagato",
 "Marcar como quitado": "Segna come estinto",
 "Marcar como recebida": "Segna come incassato",
 "Marcar como recebida?": "Segnare come incassato?",
 "Marcar como recebido": "Segna come ricevuto",
 "Marcar como visto": "Segna come visto",
 "Marcar e avisar a equipe": "Fissa e avvisa il team",
 "Marcar esta conta como paga?": "Segnare questo conto come pagato?",
 "Marcar fatura como paga": "Segna estratto carta come pagato",
 "Marcar grupo": "Seleziona gruppo",
 "Marcar reunião": "Fissa riunione",
 "Marcenaria": "Falegnameria",
 "Margem": "Margine",
 "Marketing": "Marketing",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Segna le foto del diario come Prima o Dopo per creare la galleria.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Seleziona i giorni in cui studi e l'orario di ogni giorno. Ogni giorno diventa un'attività che si ripete ogni settimana, collegata a questo elemento.",
 "Marque um ou mais estados.": "Seleziona uno o più stati.",
 "Martelo": "Martello",
 "Masculino": "Maschile",
 "Masculino e minimalista": "Maschile e minimalista",
 "Matemática": "Matematica",
 "Materiais": "Materiali",
 "Material": "Materiale",
 "Matrícula, placa, código ou CNPJ": "Numero catastale, targa, codice o CNPJ",
 "Matéria ou material": "Materia o materiale",
 "Matéria ou módulo": "Materia o modulo",
 "Matérias": "Materie",
 "Meia-sombra": "Mezz'ombra",
 "Melhorando a imagem...": "Miglioramento dell'immagine...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "I nuovi miglioramenti sono già stati scaricati. Ci vogliono pochi secondi e i tuoi dati restano.",
 "Membros": "Membri",
 "Menos de 1 minuto": "Meno di 1 minuto",
 "Mensagem": "Messaggio",
 "Mensagem apagada": "Messaggio eliminato",
 "Mensagem enviada. Obrigado!": "Messaggio inviato. Grazie!",
 "Mensagem ou observações": "Messaggio o note",
 "Mensagens": "Messaggi",
 "Mensagens que você envia em Fale conosco.": "Messaggi che invii tramite Contattaci.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Messaggi: la tua lista di amici, le chat e le foto e i file inviati vengono salvati sul server per arrivare agli altri dispositivi. Le chiamate audio e video non vengono registrate.",
 "Mensalidade de {m}": "Quota di {m}",
 "Mensalidade ou valor por aluno": "Quota mensile o importo per alunno",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Quote mensili, lezioni singole e materiali. In ⋮ della classe, \"Genera gli addebiti del mese\" ne crea uno per ogni alunno.",
 "Mercado": "Spesa alimentare",
 "Mesa flexora": "Leg curl",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Capocantiere",
 "Meta": "Obiettivo",
 "Meta 100% batida": "Obiettivo raggiunto al 100%",
 "Meta atingida": "Obiettivo raggiunto",
 "Meta atingida!": "Obiettivo raggiunto!",
 "Meta da semana: {dur}": "Obiettivo della settimana: {dur}",
 "Meta de aulas": "Obiettivo di lezioni",
 "Meta de aulas batida": "Obiettivo di lezioni raggiunto",
 "Meta de copos por dia": "Obiettivo di bicchieri al giorno",
 "Meta de páginas por dia": "Obiettivo di pagine al giorno",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Obiettivo di pagine, avanzamento e riassunti di libri, film e serie da vedere e lezioni dei corsi.",
 "Meta diária": "Obiettivo giornaliero",
 "Meta por dia": "Obiettivo giornaliero",
 "Meta por semana:": "Obiettivo settimanale:",
 "Meta {meta} · copo de {copo} · {n} copos": "Obiettivo {meta} · bicchiere da {copo} · {n} bicchieri",
 "Metas": "Obiettivi",
 "Metodologia Científica": "Metodologia della ricerca",
 "Meu caderno": "Il mio quaderno",
 "Meu cartão de contato": "La mia scheda contatto",
 "Meu plano": "Il mio piano",
 "Meus GIFs ({n})": "Le mie GIF ({n})",
 "Meus PDFs": "I miei PDF",
 "Meus dados": "I miei dati",
 "Meus dados profissionais": "I miei dati professionali",
 "Microchip": "Microchip",
 "Microfone": "Microfono",
 "Microscópio": "Microscopio",
 "Militares estaduais": "Militari statali",
 "Minha Casa": "La mia casa",
 "Minha conta": "Il mio account",
 "Minhas anotações do livro": "Le mie note del libro",
 "Minhas figurinhas": "I miei sticker",
 "Minutos": "Minuti",
 "Minutos de exercício": "Minuti di esercizio",
 "Mirante": "Belvedere",
 "Mirantes": "Punti panoramici",
 "Modelo": "Modello",
 "Modelo de prescrição": "Modello di prescrizione",
 "Modelos": "Modelli",
 "Modificado em": "Modificato il",
 "Modo": "Modalità",
 "Modo de preparo": "Preparazione",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Modalità sicura: attività automatiche disattivate fino alla riapertura dell'app",
 "Moeda": "Valuta",
 "Moeda: {m}": "Valuta: {m}",
 "Moedas": "Monete",
 "Momento do evento": "Momento dell'evento",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Monitoraggio della Gazzetta giudiziaria elettronica (DJEN) per nome e OAB.",
 "Monitor ou co-professor": "Tutor o co-insegnante",
 "Montando o PDF: página {n} de {total}...": "Creazione del PDF: pagina {n} di {total}...",
 "Montar a mala pelo clima ({n} dias)": "Prepara la valigia in base al clima ({n} giorni)",
 "Monte o cronograma alimentar para ver o relatório.": "Prepara il programma dei pasti per vedere il report.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Crea l'itinerario giorno per giorno. Durante il viaggio, appare nella cronologia di My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Crea qui sotto il tuo piano alimentare e le tue cure. Quello che è previsto per oggi compare qui da spuntare.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Prepara qui sotto il programma dei pasti, cure, allenamenti e integratori. Quello di oggi compare qui da spuntare.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Componi i tuoi allenamenti con attività pronte: macchine della palestra, esercizi a casa, camminata, corsa, yoga, pilates...",
 "Mostrando as 120 mais recentes.": "Mostrate le 120 più recenti.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "Mostro solo l'itinerario. {n} attività del giorno nascoste.",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Mostrare date, orari, valuta e festività corretti per dove ti trovi. Non usiamo il GPS.",
 "Mostrar menos": "Mostra meno",
 "Mostrar só o roteiro durante a viagem": "Mostra solo l'itinerario durante il viaggio",
 "Motivo do cancelamento": "Motivo dell'annullamento",
 "Moto": "Moto",
 "Mover": "Sposta",
 "Mover para hoje": "Sposta a oggi",
 "Mudança": "Trasloco",
 "Mudança: {para}": "Trasloco: {para}",
 "Mudanças": "Traslochi",
 "Mudar e-mail": "Cambia e-mail",
 "Mudar o nome": "Rinomina",
 "Mudar senha": "Cambia password",
 "Mudo": "Muto",
 "Muitas tentativas": "Troppi tentativi",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Troppi tentativi errati. Riprova tra {s} secondi.",
 "Muitas tentativas. Aguarde alguns minutos.": "Troppi tentativi. Attendi qualche minuto.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Ottimo: questo mese hai già messo da parte {v}. La costanza conta più dell'importo.",
 "Multa": "Multa",
 "Multa e juros": "Mora e interessi",
 "Multa e juros de {v}": "Mora e interessi di {v}",
 "Multa e juros estimados: {v}": "Multa e interessi stimati: {v}",
 "Multas e juros pagos": "More e interessi pagati",
 "Mundo": "Mondo",
 "Municipal": "Comunale",
 "Município da prestação (IBGE), se for outro": "Comune della prestazione (IBGE), se diverso",
 "Município da prestação (código IBGE, 7 números)": "Comune della prestazione (codice IBGE, 7 cifre)",
 "Mural": "Bacheca",
 "Museu": "Museo",
 "Museus": "Musei",
 "My Planner (vira tarefa)": "My Planner (diventa attività)",
 "My Planner bloqueado": "My Planner bloccato",
 "Máxima": "Massima",
 "Média": "Media",
 "Média para aprovação": "Media per la promozione",
 "Média · repouso {n}": "Media · riposo {n}",
 "Médico": "Medico",
 "Médico ou clínica": "Medico o clinica",
 "Médio": "Medio",
 "Mês": "Mese",
 "Mês a mês": "Mese per mese",
 "Mês atual": "Mese corrente",
 "Mês passado": "Mese scorso",
 "Móveis e enxoval": "Mobili e biancheria",
 "Móvel": "Mobile",
 "Música": "Musica",
 "NAS ABAS": "NELLE SCHEDE",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: la SEFAZ richiede 1 ora tra una ricerca e l'altra. Prossima dalle {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: indica lo stato (UF) dell'azienda per cercare le fatture di prodotti.",
 "NFS-e emitida": "NFS-e emessa",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "Il (facoltativo):",
 "Na agenda": "In agenda",
 "Na agenda em {data}": "In agenda il {data}",
 "Na barra": "Nella barra",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "Nella demo non c'è il server delle fatture. Usa l'app con il tuo account.",
 "Na hora": "Subito",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "All'ora della pausa compare un grande avviso sullo schermo, con il conto alla rovescia.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "Nella cronologia, toccando il timer si apre anche questa pagina.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "Nella cartella \"{pasta}\" del cellulare. Ogni file pronto va lì.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "Nella cartella \"{pasta}\" del telefono. Ogni nuovo documento va lì quando lo chiudi.",
 "Na prévia de demonstração não há chamadas de verdade.": "Nell'anteprima demo non ci sono chiamate reali.",
 "Na prévia de demonstração não há gravação de verdade.": "Nell'anteprima demo non c'è una vera registrazione.",
 "Na prévia de demonstração os arquivos não abrem.": "Nell'anteprima demo i file non si aprono.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "Nella versione degli store, l'acquisto avverrà tramite Google Play o App Store. Per ora l'interruttore simula l'abbonamento per i test.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "Nella versione degli store, questo pulsante apre l'acquisto su Google Play o App Store.",
 "Nacional": "Nazionale",
 "Nada a gerar": "Niente da generare",
 "Nada encontrado.": "Nessun risultato.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Niente entra nell'agenda di nessuno senza autorizzazione: ognuno accetta, modifica o rifiuta.",
 "Nada foi registrado.": "Non è stato registrato nulla.",
 "Nada lançado neste mês.": "Nessun movimento questo mese.",
 "Nada no mês": "Niente nel mese",
 "Nada no roteiro deste dia.": "Niente nell'itinerario di questo giorno.",
 "Nada para apagar com esse filtro.": "Niente da eliminare con questo filtro.",
 "Nada para comprar": "Niente da comprare",
 "Nada para enviar.": "Niente da inviare.",
 "Nada planejado para este dia": "Niente in programma per questo giorno",
 "Nada planejado para hoje. Bom dia!": "Niente in programma per oggi. Buona giornata!",
 "Nada por aqui.": "Niente qui.",
 "Nada recebido ainda.": "Ancora niente ricevuto.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "Nelle chat, ogni persona vede il tuo nome e ciò che invii lì. Puoi eliminare un messaggio per tutti, uscire da un gruppo o bloccare qualcuno.",
 "Nascimento": "Nascita",
 "Natal": "Natale",
 "Natação": "Nuoto",
 "Navegador conectado": "Browser collegato",
 "Negrito": "Grassetto",
 "Negócios": "Business",
 "Nenhum": "Nessuno",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "Nessun XML in questo periodo (o sono stati salvati su un altro dispositivo).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "Nessun amico da aggiungere. Invita su WhatsApp o aggiungi amici in Messaggi (codice amico).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "Nessun file, immagine o link nelle pagine di questa materia.",
 "Nenhum arquivo.": "Nessun file.",
 "Nenhum atendimento pago neste mês.": "Nessuna visita pagata questo mese.",
 "Nenhum cartão": "Nessuna card",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "Nessuna ricevuta salvata finora. Quando paghi un conto, toccalo e allega la foto, il PDF o lo screenshot della ricevuta.",
 "Nenhum cômodo ainda": "Ancora nessuna stanza",
 "Nenhum dia": "Nessun giorno",
 "Nenhum documento ainda.": "Ancora nessun documento.",
 "Nenhum documento neste filtro.": "Nessun documento in questo filtro.",
 "Nenhum e-mail cadastrado": "Nessuna e-mail registrata",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "Nessun errore registrato. Se l'app si chiude da sola o una schermata dà problemi, l'errore compare qui per inviarlo al team.",
 "Nenhum feriado neste ano.": "Nessuna festività quest'anno.",
 "Nenhum fichário ainda": "Ancora nessun raccoglitore",
 "Nenhum grupo ainda.": "Ancora nessun gruppo.",
 "Nenhum item em {nome}": "Nessun elemento in {nome}",
 "Nenhum lançamento encontrado": "Nessun movimento trovato",
 "Nenhum país encontrado.": "Nessun paese trovato.",
 "Nenhum selecionado": "Nessuno selezionato",
 "Nenhuma (plano gratuito)": "Nessuna (piano gratuito)",
 "Nenhuma aba encontrada.": "Nessuna scheda trovata.",
 "Nenhuma aba fixada além do My Planner.": "Nessuna scheda fissata oltre a My Planner.",
 "Nenhuma aba liberada para receber": "Nessuna scheda sbloccata può riceverlo",
 "Nenhuma agenda encontrada": "Nessun calendario trovato",
 "Nenhuma agenda para trazer": "Nessun calendario da importare",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "Nessuna udienza o termine trovato in questa pubblicazione.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "Nessun riquadro archiviato. Trascina un riquadro a sinistra per archiviarlo.",
 "Nenhuma compra encontrada": "Nessun acquisto trovato",
 "Nenhuma compra nesta fatura.": "Nessun acquisto in questo estratto.",
 "Nenhuma conta a pagar cadastrada.": "Nessun conto da pagare registrato.",
 "Nenhuma conta a receber cadastrada.": "Nessun conto da incassare registrato.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "Nessun conto questo mese. Tocca + per aggiungerne uno (affitto, luce, carta...).",
 "Nenhuma cópia de segurança ainda.": "Ancora nessun backup.",
 "Nenhuma cópia encontrada.": "Nessun backup trovato.",
 "Nenhuma garantia ativa. Cadastre com o +.": "Nessuna garanzia attiva. Aggiungila con il +.",
 "Nenhuma garantia vencida.": "Nessuna garanzia scaduta.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "Ancora nessun messaggio. Saluta! 👋",
 "Nenhuma nota neste período.": "Nessuna fattura in questo periodo.",
 "Nenhuma opção ainda.": "Ancora nessuna opzione.",
 "Nenhuma publicação nova.": "Nessuna nuova pubblicazione.",
 "Nenhuma refeição neste dia.": "Nessun pasto in questo giorno.",
 "Nenhuma reunião marcada.": "Nessuna riunione fissata.",
 "Nesse ritmo, termina em {d}": "A questo ritmo, finisci il {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "In questa fase di lancio, tutte le schede sono sbloccate e gratuite.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "In questa fase di test, la password viene reimpostata dall'assistenza. Scrivi a {email} indicando il tuo CPF o la tua e-mail.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "In questa fase di prova, la password viene reimpostata dall'assistenza. Scrivi a {email} indicando il tuo CPF.",
 "Neve": "Neve",
 "Ninguém deve nada a ninguém.": "Nessuno deve niente a nessuno.",
 "Ninguém entrou ainda. Envie o convite.": "Nessuno è ancora entrato. Invia l'invito.",
 "Ninguém usou o seu código ainda.": "Nessuno ha ancora usato il tuo codice.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Su Android, l'app conserva solo il collegamento al file scelto: resta dov'è (Drive, OneDrive, Download) e si apre nell'app del telefono. Non viene copiato nulla. Questa opzione vale per le foto scattate con la fotocamera.",
 "No Google Drive ou OneDrive: {n}": "Su Google Drive o OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "In Google Drive, l'app vede solo i file che ha creato essa stessa nella cartella My Planner. L'uso delle informazioni ricevute dalle API di Google rispetta le Norme relative ai dati utente dei servizi API di Google, inclusi i requisiti di Uso limitato: nulla viene venduto, usato per pubblicità o letto da persone, salvo con la tua autorizzazione o per obbligo di legge.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "Nell'app del tuo orologio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), attiva l'opzione \"Health Connect\" o \"Sincronizza con Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "Nella nuova app (versione 0.49), il telefono trova da solo i bordi del foglio. In questa versione, regola i 4 angoli con il dito.",
 "No centro": "Al centro",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "Sul computer apri {url}, tocca il pulsante qui sopra e inquadra il QR Code sullo schermo.",
 "No dia (opcional):": "Il giorno (facoltativo):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "Su iPhone, l'app apre \"Salva in File\" per farti scegliere la cartella (anche iCloud Drive).",
 "No início": "All'inizio",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "In modalità sicura l'app si apre senza le attività automatiche (avvisi, Google Calendar, pubblicazioni, messaggi e orologio). I tuoi dati non cambiano e tutto torna normale alla prossima apertura.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "Nel browser, le pagine restano solo finché questa pagina è aperta.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "Nel browser, incolla il link del file da Drive, OneDrive o Dropbox (in Studio o Documenti, opzione Link). Sul telefono, il pulsante file mostra già Drive e OneDrive.",
 "No navegador, o PDF é baixado para o computador.": "Nel browser, il PDF viene scaricato sul computer.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "Nel browser puoi salvare solo immagini piccole (fino a 200 KB). Per altri file, aggiungi un link di Drive, OneDrive o Dropbox, oppure usa l'app sul telefono.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "Nell'altra app, copia il link del file (Condividi › Copia link) e incollalo nel blocco link aggiunto a questa pagina.",
 "No ritmo atual, o ano fecha em {v}.": "Al ritmo attuale, l'anno chiuderà a {v}.",
 "No seu fuso: {hora}{dia}": "Nel tuo fuso: {hora}{dia}",
 "Nome": "Nome",
 "Nome (cliente ou fornecedor)": "Nome (cliente o fornitore)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Nome (es.: 3ª B, Pazienti dello studio, Compleanno di Ana)",
 "Nome (ex.: Almoço)": "Nome (es.: Pranzo)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Nome (es.: Affitto incassato, Cliente X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Nome (es.: Affitto, Luce, Internet)",
 "Nome (ex.: Doutorado UFPR)": "Nome (es.: Dottorato UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Nome (es.: Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Nome (es.: Skincare serale)",
 "Nome (ex.: Treino A)": "Nome (es.: Allenamento A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Nome (es.: Viaggio delle vacanze, Fondo di emergenza)",
 "Nome (ex.: Vitamina C)": "Nome (es.: Vitamina C)",
 "Nome (opcional)": "Nome (facoltativo)",
 "Nome (opcional, ex.: CNH do Walter)": "Nome (facoltativo, es.: Patente di Walter)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Nome (modificabile, es.: \"Succo d'uva\")",
 "Nome completo": "Nome completo",
 "Nome curto": "Nome breve",
 "Nome da lista": "Nome della lista",
 "Nome da matéria": "Nome della materia",
 "Nome da obra": "Nome del cantiere",
 "Nome da pasta (ex.: Recibos, Contratos)": "Nome della cartella (es.: Ricevute, Contratti)",
 "Nome da tarefa": "Nome dell'attività",
 "Nome da tarefa (ex.: Academia)": "Nome dell'attività (es.: Palestra)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Nome dell'attività (es.: Pulire il bagno)",
 "Nome do PDF (opcional)": "Nome del PDF (facoltativo)",
 "Nome do conselho": "Nome dell'ordine professionale",
 "Nome do cômodo": "Nome della stanza",
 "Nome do documento": "Nome del documento",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Nome dell'ufficio (es.: Ravasco Contabilidade)",
 "Nome do evento": "Nome dell'evento",
 "Nome do grupo (ex.: Família)": "Nome del gruppo (es.: Famiglia)",
 "Nome do modelo": "Nome del modello",
 "Nome ou modelo": "Nome o modello",
 "Nome ou razão social": "Nome o ragione sociale",
 "Nome, subtarefa ou anotação": "Nome, sottoattività o nota",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "Nei gruppi, ognuno risponde di ciò che aggiunge. Chi amministra il gruppo decide chi partecipa.",
 "Nossa Senhora Aparecida": "Nostra Signora di Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Nostra Signora della Luce dei Pinhais",
 "Nota cancelada": "Fattura annullata",
 "Nota fiscal": "Fattura",
 "Nota fiscal emitida": "Fattura emessa",
 "Nota fiscal, certificado de garantia e fotos": "Fattura, certificato di garanzia e foto",
 "Nota importada": "Fattura importata",
 "Notas": "Fatture",
 "Notas Fiscais": "Fatture",
 "Notebook e carregador": "Portatile e caricabatterie",
 "Nova avaliação": "Nuova valutazione",
 "Nova caixa (ex.: Compras, Ideias)": "Nuovo riquadro (es.: Spesa, Idee)",
 "Nova conversa": "Nuova chat",
 "Nova garantia": "Nuova garanzia",
 "Nova matéria": "Nuova materia",
 "Nova meta": "Nuovo obiettivo",
 "Nova pasta": "Nuova cartella",
 "Nova página": "Nuova pagina",
 "Nova página com esta caixa": "Nuova pagina con questo riquadro",
 "Nova refeição": "Nuovo pasto",
 "Nova tarefa": "Nuova attività",
 "Nova tarefa da casa": "Nuova faccenda di casa",
 "Nova tarefa neste cômodo": "Nuova attività in questa stanza",
 "Novas": "Nuove",
 "Novo": "Nuovo",
 "Novo alerta:": "Nuovo avviso:",
 "Novo cartão": "Nuova carta",
 "Novo cartão de crédito": "Nuova carta di credito",
 "Novo cuidado": "Nuova cura",
 "Novo documento": "Nuovo documento",
 "Novo e-mail": "Nuova e-mail",
 "Novo fichário": "Nuovo raccoglitore",
 "Novo grupo": "Nuovo gruppo",
 "Novo item": "Nuovo elemento",
 "Novo perfil": "Nuovo profilo",
 "Novo suplemento": "Nuovo integratore",
 "Novo treino": "Nuovo allenamento",
 "Novo: {nome}": "Nuovo: {nome}",
 "Novos": "Nuovi",
 "Num período": "In un periodo",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Numera ogni scatola e indica la stanza e il contenuto. Usa la ricerca per trovare dov'è ogni cosa.",
 "Nº": "N.",
 "Não": "No",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "Non ho trovato il totale sullo scontrino. Prova con una foto più nitida.",
 "Não consegue entrar?": "Non riesci ad accedere?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "Non sono riuscito ad aprire \"{nome}\". Prova lo strumento Ripara PDF.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "Impossibile collegare la chiamata. Controlla la connessione e riprova.",
 "Não deu certo: {msg}": "Non è riuscito: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "Impossibile ridurre ancora questo PDF ({tam}).",
 "Não dá para tirar todas as páginas.": "Non puoi togliere tutte le pagine.",
 "Não encontrei texto neste PDF.": "Nessun testo trovato in questo PDF.",
 "Não encontrei texto neste documento.": "Non ho trovato testo in questo documento.",
 "Não foi possível": "Non è stato possibile",
 "Não foi possível abrir": "Impossibile aprire",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "Impossibile aprire il certificato salvato. Collega di nuovo il certificato.",
 "Não foi possível abrir.": "Impossibile aprire.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "Impossibile scaricare le festività di questo paese. Controlla la connessione a internet.",
 "Não foi possível conectar": "Impossibile connettersi",
 "Não foi possível conectar o {nome}": "Impossibile connettere {nome}",
 "Não foi possível consultar o DJEN agora.": "Impossibile consultare il DJEN ora.",
 "Não foi possível continuar": "Impossibile continuare",
 "Não foi possível criar um evento na agenda: {msg}": "Impossibile creare un evento nel calendario: {msg}",
 "Não foi possível entrar.": "Impossibile accedere.",
 "Não foi possível enviar": "Impossibile inviare",
 "Não foi possível enviar.": "Impossibile inviare.",
 "Não foi possível guardar: {erro}": "Impossibile salvare: {erro}",
 "Não foi possível ler o arquivo.": "Impossibile leggere il file.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "Impossibile leggere il calendario. Controlla il link in Modifica.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "Impossibile cercare ora. Riproverà da solo più tardi.",
 "Não foi possível reiniciar sozinho.": "Impossibile riavviare automaticamente.",
 "Não foi possível sincronizar com a agenda: {msg}": "Impossibile sincronizzare con il calendario: {msg}",
 "Não foi possível trocar a foto": "Impossibile cambiare la foto",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "Con l'app chiusa l'avviso non è garantito. Il controllo avviene all'apertura dell'app (ogni 6 ore) o con \"Controlla ora\".",
 "Não identificado": "Non identificato",
 "Não marcada como feita": "Non segnata come fatta",
 "Não optante pelo Simples": "Non aderente al Simples",
 "Não se repete": "Non si ripete",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "Non usare l'app per attività illegali, per conservare contenuti di terzi senza autorizzazione o per tentare di accedere ai dati di altre persone.",
 "Não vai": "Non viene",
 "Não vence": "Non scade",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "Non vendiamo i tuoi dati e non usiamo i tuoi contenuti per pubblicità.",
 "Não é possível adicionar esta pessoa.": "Impossibile aggiungere questa persona.",
 "Não é um XML de nota fiscal": "Non è un XML di fattura",
 "Número": "Numero",
 "Número (opcional)": "Numero (facoltativo)",
 "Número da OAB": "Numero OAB",
 "Número da caixa": "Numero della scatola",
 "Número da carteirinha": "Numero della tessera",
 "Número da guia do convênio": "Numero dell'autorizzazione della convenzione",
 "Número da parcela": "Numero della rata",
 "Número de hóspedes": "Numero di ospiti",
 "Número de parcelas": "Numero di rate",
 "Número do contrato": "Numero del contratto",
 "Número do registro": "Numero di iscrizione",
 "Número na chamada": "Numero di registro",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Numero {n}. L'XML è stato salvato nella fattura. Toccala per vedere il PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "Numero, ente di rilascio e note vengono cifrati (AES-256) sul dispositivo prima di andare nel cloud.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Numero, ente emittente, note, foto e PDF sono cifrati (AES-256) sul dispositivo. I file protetti restano solo su questo dispositivo.",
 "Número: {n}": "Numero: {n}",
 "Números de página": "Numeri di pagina",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT qui non legge i PDF. Scatta una foto o uno screenshot della pagina, oppure usa Claude o Gemini in Impostazioni › Intelligenza artificiale.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "Il DAS scade il giorno {dia}. Segnalo come pagato in Finanza.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "L'Ufficio non è ancora stato attivato sul server. Sul computer, esegui 29-SERVIDOR-0.45.bat (una sola volta).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Il Mestre Achado si prende cura dei tuoi soldi: pagamenti, carte ed estratti, budget per categoria, obiettivi, estratto conto e scontrino da foto, report e MEI.",
 "O Mestre está pensando...": "Il Mestre sta pensando...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner crea la cartella \"My Planner\" nel tuo Drive e vede solo ciò che ha salvato lì.",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner si è aperto sul computer, con i tuoi dati.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner legge i dati dell'orologio tramite {fonte}, dove l'orologio e le app di salute e allenamento salvano tutto.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner organizza la tua agenda, attività, finanze, documenti e altri ambiti della vita. È offerto da Walter Ravasco da Costa, titolare del trattamento dei dati personali trattati nell'app.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner usa solo la cartella App › My Planner del tuo OneDrive.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "Il PDF e le immagini verranno rimossi da questo dispositivo e dal cloud.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "Il PDF supera i 15 MB. Se WhatsApp o l'e-mail lo rifiutano, attiva \"File più leggero\".",
 "O QUE COMER": "COSA MANGIARE",
 "O QUE OS MEMBROS PODEM": "COSA POSSONO FARE I MEMBRI",
 "O QUE VOCÊ MANDA": "CIÒ CHE INVII",
 "O QUE VOCÊ RECEBE": "CIÒ CHE RICEVI",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "L'accesso resta tramite CPF. L'e-mail serve all'assistenza per contattarti.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "L'amministratore del gruppo potrà inviare appuntamenti, materiali e avvisi. Niente entra nella tua agenda senza che tu accetti.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "La sveglia suona di nuovo ogni 2 minuti (fino a 4 volte) finché il farmaco non viene segnato come preso.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "L'app aiuta a organizzarti, ma non sostituisce il parere di medici, avvocati, commercialisti o altri professionisti. Controlla scadenze, importi e date importanti.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "L'app ti avvisa 3 giorni prima e il giorno della scadenza, alle 9.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "L'app consulta il servizio pubblico del CNJ (DJEN) con i nomi e la OAB che registri. Questi dati vengono inviati a quel servizio a ogni controllo.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "L'app e il server di My Planner consultano il servizio pubblico del CNJ (DJEN) con i nomi e le OAB che registri e, se lo selezioni, Querido Diário (gazzette ufficiali comunali). Questi dati vengono inviati a tali servizi a ogni verifica.",
 "O app fechou sozinho {n} vezes seguidas": "L'app si è chiusa da sola {n} volte di fila",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "L'app installata su questo dispositivo è la versione {v}. Per fare chiamate audio e video, installa l'app 0.35 o più recente (nuovo APK). I messaggi funzionano già.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "L'app non si è chiusa e i tuoi dati sono ancora salvati. Riprova o invia la segnalazione perché il team la corregga.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "L'app chiede lo sblocco all'apertura e al ritorno dal background.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "L'app chiede lo sblocco all'apertura. Passare velocemente a un'altra app o schermata non lo richiede; se il telefono viene bloccato o l'app resta fuori dallo schermo più a lungo del tempo indicato sotto, lo richiede.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "L'app legge soltanto (passi, distanza, calorie, esercizio, battito e sonno) e non modifica mai i tuoi dati sulla salute. I totali di ogni giorno restano nel tuo account per comparire anche sul sito e sull'altro telefono.",
 "O app volta a pedir a senha para desbloquear.": "L'app tornerà a chiedere la password per sbloccare.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "L'app è pensata per maggiori di 18 anni. I dati dei bambini possono essere registrati solo dai genitori o tutori.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "Il file è rimasto solo su questo dispositivo. Impossibile salvarlo su {nome}: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "Il file non è più lì (è stato eliminato o spostato).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "Il file non è più lì (eliminato, spostato o la sua app ha tolto il permesso). Allegalo di nuovo.",
 "O arquivo passa de 15 MB.": "Il file supera i 15 MB.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "Il file supera i 15 MB. Attiva \"File più leggero\" e riprova.",
 "O arquivo passa de 25 MB.": "Il file supera i 25 MB.",
 "O arquivo passa de 50 MB.": "Il file supera i 50 MB.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "Il file esce da questo telefono. Le copie salvate su Drive, OneDrive o inviate a qualcuno restano lì.",
 "O arquivo sai do escritório para todos.": "Il file verrà rimosso dall'ufficio per tutti.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "L'avviso arriva alle 9, e di nuovo il giorno della scadenza.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "Il database non è ancora stato preparato. Esegui il file supabase/schema.sql in Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "La carta {c} ha il {p}% del plafond utilizzato. Per ora evita nuovi acquisti a rate su questa carta.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "Il telefono non avvisa l'app quando lo schermo viene bloccato, per questo l'app conta il tempo trascorso fuori. Con 1 minuto, bloccare il telefono e tornare dopo richiede la biometria; rispondere al volo a un messaggio, no.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "Il cellulare serve solo a confermare che l’account è tuo (codice via WhatsApp alla registrazione e al cambio di numero). Un numero per account.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "La condivisione non è ancora stata attivata sul server. Sul computer, apri la cartella C:\\MyPlanner e fai doppio clic su 12-LIGAR-COMPARTILHAMENTO.bat (una sola volta).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "Il computer aprirà My Planner con il tuo account. Fallo solo su computer di fiducia.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "L'invito contiene il link dell'app e dell'APK più recente. Chi entra dal link arriva direttamente nell'ufficio.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "Il codice invito vale solo nei primi 30 giorni dell'account.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "La sequenza resta salvata solo su questo dispositivo, protetta. La password continua a valere se dimentichi la sequenza.",
 "O dinheiro gasto está à frente do andamento da obra.": "La spesa è più avanti dell'avanzamento dei lavori.",
 "O documento não tem páginas.": "Il documento non ha pagine.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "L'estratto conto viene letto qui sul dispositivo. I conti da pagare con lo stesso importo e una data vicina vengono segnati come pagati automaticamente.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "L'estratto conto viene letto qui sul dispositivo. I pagamenti in sospeso con lo stesso importo e data vicina vengono saldati automaticamente. Il pagamento dell'estratto carta non viene contato due volte.",
 "O governo recusou a nota": "Il governo ha rifiutato la fattura",
 "O governo recusou a nota.": "Il governo ha rifiutato la fattura.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "La lingua vale per questo dispositivo. I dati che hai inserito non vengono tradotti.",
 "O item vinculado foi apagado ou movido.": "L'elemento collegato è stato eliminato o spostato.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "L'elemento collegato è stato eliminato o spostato. Modifica l'attività per sceglierne un altro.",
 "O link antigo deixa de funcionar.": "Il vecchio link smetterà di funzionare.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "Il vecchio link smette di funzionare. Chi è già nel gruppo resta.",
 "O link deve começar com https://": "Il link deve iniziare con https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "Il browser non permette di leggere il calendario delle piattaforme. Importa dall'app sul telefono.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "Il piano base e i periodi di prova delle schede seguono le regole indicate in Impostazioni > Acquisti. I vantaggi degli inviti valgono una volta per account.",
 "O que acontece": "Cosa succede",
 "O que apagar": "Cosa eliminare",
 "O que comprou": "Cosa hai comprato",
 "O que fazer": "Cosa fare",
 "O que foi comido:": "Cosa è stato mangiato:",
 "O que foi feito": "Cosa è stato fatto",
 "O que foi visto": "Cosa è stato visto",
 "O que funcionou, o que ajustar, metodologias, resumos...": "Cosa ha funzionato, cosa migliorare, metodologie, riassunti...",
 "O que já foi guardado continua nos lançamentos como investimento.": "Quanto già messo da parte resta nei movimenti come investimento.",
 "O que levar ou estudar": "Cosa portare o studiare",
 "O que o app pode usar": "Cosa può usare l'app",
 "O que o médico disse": "Cosa ha detto il medico",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "Ciò che hanno inviato i tuoi gruppi. Gli appuntamenti accettati vanno in My Planner; materiali e avvisi vanno in Note.",
 "O que precisa": "Cosa serve",
 "O que tem dentro": "Cosa c'è dentro",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "Cosa hai prestato o preso in prestito: foto, chi ce l'ha e avviso di restituzione.",
 "O que é apagado": "Cosa viene eliminato",
 "O quê": "Cosa",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "Il selettore mostra Google Drive, OneDrive e Dropbox quando queste app sono installate sul telefono. L'app conserva solo il collegamento: il file resta dov'è e si apre nell'app del telefono.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "Il selettore mostra Google Drive, OneDrive e Dropbox quando queste app sono installate sul telefono. Il file scelto viene salvato su questo dispositivo.",
 "O servidor ainda não buscou para os seus perfis.": "Il server non ha ancora cercato per i tuoi profili.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "Il server non è ancora pronto per i messaggi. Esegui 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "Il server non è ancora pronto per gli inviti. Riprova più tardi.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "Il server non è ancora pronto per la scheda contatto. Esegui 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Il server non è ancora pronto per i dati condivisi. Sul computer, apri la cartella C:\\MyPlanner e fai doppio clic su 15-LIGAR-GRUPOS-COLABORATIVOS.bat (una sola volta).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "Il server non è ancora pronto per Drive e OneDrive (vedi COMO RODAR, versione 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "Il server non è ancora stato preparato per l'accesso web (esegui supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "Il server non ha ancora la funzione \"qr-login\". Vedi il passaggio della versione 0.6 in COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "Il server delle chiamate ha rifiutato la chiave LiveKit. Sul computer dell'amministratore, esegui 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "Il server delle fatture ha risposto in modo inatteso (HTTP {s}). Controlla l'indirizzo.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Il server esegue l’acquisizione automatica ogni 2 ore, dalle 08:00 alle 20:00 (ora di Brasília), anche con l’app chiusa. Le pubblicazioni acquisite compaiono quando apri l’app. Puoi anche usare \"Controlla ora\".",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Il server esegue l'acquisizione automatica ogni giorno alle 08:00 e alle 12:00 (ora di Brasília), anche con l'app chiusa. Le pubblicazioni acquisite compaiono quando apri l'app. Puoi anche usare \"Controlla ora\".",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Il server ha rifiutato l'accesso: nella funzione \"nuvem\" di Supabase, disattiva \"Verify JWT\" (32-LIGAR-DRIVE-ONEDRIVE.bat lo fa già).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Il server ha rifiutato l'accesso: nella funzione \"nuvem\" di Supabase, disattiva \"Verify JWT\" (9-LIGAR-DRIVE-ONEDRIVE.bat lo fa già).",
 "O seu papel no grupo não permite incluir aqui.": "Il tuo ruolo nel gruppo non consente di aggiungere qui.",
 "O site deve começar com https://": "Il sito deve iniziare con https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "La misura predefinita del bicchiere ({copo}) si cambia in Modifica, nel riquadro dell’acqua.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "Il tema cambia i colori delle schede (le icone restano le stesse) e vale sia in modalità chiara sia scura. Poi puoi ancora cambiare il colore di una scheda in Impostazioni > Schede.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "Il timer si riempie di colore man mano che passa il tempo dell'attività. Toccandolo si apre il collegamento dell'attività.",
 "O teste grátis terminou": "La prova gratuita è terminata",
 "O texto": "Il testo",
 "O texto do PDF num arquivo .docx para editar.": "Il testo del PDF in un file .docx da modificare.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "Il testo è anche nascosto dentro il PDF: puoi cercarlo e copiarlo nel lettore PDF.",
 "O tom escolhido fica para os próximos emojis.": "Il tono scelto resta per le prossime emoji.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "Il totale compare in cima a My Planner. Se superi il limite, il fulmine diventa rosso. Le attività \"Relax\" valgono 0.",
 "OAB (opcional, para advogados)": "OAB (facoltativa, per avvocati)",
 "OBS": "NOTE",
 "OCR: texto pesquisável": "OCR: testo ricercabile",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "O SCEGLI UNA STANZA…",
 "Objetivos": "Obiettivi",
 "Objeto": "Oggetto",
 "Objetos": "Oggetti",
 "Objetos e valores": "Oggetti e denaro",
 "Obra": "Cantiere",
 "Obras": "Cantieri",
 "Obras & Reformas": "Lavori & Ristrutturazioni",
 "Obrigado": "Grazie",
 "Obrigado!": "Grazie!",
 "Observações": "Note",
 "Observações (alergias, ração...)": "Note (allergie, crocchette...)",
 "Observações (chave Pix, conta para depósito...)": "Note (chiave Pix, conto per il versamento...)",
 "Observações (código de barras, chave Pix...)": "Note (codice a barre, chiave Pix...)",
 "Observações (dados bancários, PIX...)": "Note (dati bancari, PIX...)",
 "Observações (estado do item...)": "Note (stato dell'oggetto...)",
 "Observações (garantia, seguro, CET...)": "Note (garanzia, assicurazione, TAEG...)",
 "Observações (nº de série, modelo...)": "Note (n. di serie, modello...)",
 "Observações (onde está o original, categoria da CNH...)": "Note (dove si trova l'originale, categoria della patente...)",
 "Observações (recibo de entrega, número...)": "Note (ricevuta di consegna, numero...)",
 "Observações (restrição alimentar...)": "Note (restrizioni alimentari...)",
 "Ocultar texto (tarja)": "Nascondi testo (banda)",
 "Ocupado": "Occupato",
 "Oficina": "Officina",
 "Ofício": "Legale",
 "Oi!": "Ciao!",
 "Oi! Tudo certo para sábado?": "Ciao! Tutto a posto per sabato?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "Ciao {pessoa}! Ho ancora {coisa} che mi hai prestato. Quando ti va bene che te lo restituisca?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "Ciao {pessoa}! Tutto bene? Ti ricordo {coisa} che ti ho prestato il {data}. Riesci a restituirmelo {quando}?",
 "Oi?!": "Eh?!",
 "Olá!": "Ciao!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "Ciao! Sono il Mestre Achado. Chiedimi delle tue spese, pagamenti, carte e obiettivi: rispondo con i tuoi numeri.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "Ciao! Ti ricordo il pagamento di {ref} ({v}), con scadenza il {d}. Grazie!",
 "Olá! Preciso de assistência técnica para: {item}": "Ciao! Ho bisogno di assistenza tecnica per: {item}",
 "Olá, {nome}!": "Ciao, {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "Ciao, {nome}! Benvenuto/a.",
 "Ombros: girar para trás": "Spalle: ruotare all'indietro",
 "Omelete": "Frittata",
 "Onde": "Dove",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Dove aiuta l'IA: Pubblicazioni (udienze e termini), Documenti (compilare la scheda dalla foto) e Note (trasformare un riquadro in attività).",
 "Onde assistir": "Dove guardarlo",
 "Onde eu mais gastei este mês?": "Dove ho speso di più questo mese?",
 "Onde fica": "Dove si trova",
 "Onde guardar fotos e arquivos novos": "Dove salvare nuove foto e file",
 "Onde na página": "Dove nella pagina",
 "Ontem": "Ieri",
 "Organizar": "Organizza",
 "Organizar barra": "Organizza la barra",
 "Organizar com IA": "Organizza con l'IA",
 "Organizar com IA (vira tarefas)": "Organizza con l'IA (diventa attività)",
 "Organizar páginas": "Organizza pagine",
 "Orgulho e vibrante": "Orgoglio e vivace",
 "Origem": "Origine",
 "Origem da reserva": "Provenienza della prenotazione",
 "Original": "Originale",
 "Orquídeas": "Orchidee",
 "Orçado": "Preventivato",
 "Orçamento": "Preventivo",
 "Orçamento do mês": "Budget del mese",
 "Orçamento por categoria": "Budget per categoria",
 "Orçamento total": "Budget totale",
 "Orçamento: {v}": "Budget: {v}",
 "Os alertas precisam de um horário.": "Gli avvisi richiedono un orario.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Gli allegati salvati solo sul dispositivo non compaiono sugli altri dispositivi e si perdono se cambi telefono. Collega Google Drive o OneDrive in Impostazioni per salvarne una copia.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "I file e i backup già presenti restano lì. My Planner smette solo di salvare cose nuove.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "Anche i file salvati su questo dispositivo verranno eliminati.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "I file nel tuo Google Drive, OneDrive o sul telefono restano tuoi. I registri che la legge obbliga a conservare (come quelli di accesso) possono essere conservati per il periodo legale e poi eliminati.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Gli avvisi del gruppo non sono ancora attivi sul server. Sul computer, fai doppio clic su 15-LIGAR-GRUPOS-COLABORATIVOS.bat (una sola volta).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "Le notifiche sono disattivate per My Planner. Tocca Apri impostazioni e attiva le notifiche.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "Le notifiche sul telefono funzionano nell'app installata (Android o iPhone).",
 "Os campos do formulário viram parte da página.": "I campi del modulo diventano parte della pagina.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "I dati attuali saranno sostituiti da quelli del file, qui e nel cloud.",
 "Os dados continuam salvos na nuvem.": "I dati restano salvati nel cloud.",
 "Os dados da aba ainda são só seus": "I dati della scheda sono ancora solo tuoi",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "I dati della scheda {aba} diventano visibili al team, ognuno in base al ruolo che scegli.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "I dati di questo gruppo non sono ancora stati sbloccati. Chiedi a chi ha creato il gruppo di aprire My Planner aggiornato: l'app li sblocca da sola.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "I dati di questo gruppo non sono ancora stati sbloccati. Chiedi a chi ha creato il gruppo di aggiornare My Planner e aprire il gruppo: lì compare il pulsante per sbloccare.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "I dati della cassaforte sono cifrati qui sul dispositivo (AES-256) prima di andare nel cloud. Nemmeno l'assistenza può leggerli. Se dimentichi la password della cassaforte, questi dati non possono essere recuperati.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "I dati restano conservati finché l'account esiste. Quando elimini l'account, i dati vengono cancellati, salvo ciò che la legge obbliga a conservare.",
 "Os desenhos não conferem. Comece de novo.": "Le sequenze non coincidono. Ricomincia.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "I giorni sono nell'app o nell'estratto della banca. Gli acquisti fatti dopo la chiusura finiscono nell'estratto successivo.",
 "Os emojis que você usar aparecem aqui.": "Le emoji che usi appaiono qui.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "I gruppi non sono ancora attivati sul server. Sul computer, apri la cartella C:\\MyPlanner e fai doppio clic su 11-LIGAR-GRUPOS.bat (una sola volta).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "I gruppi non sono ancora attivi sul server. Esegui supabase\\migracao-0.21.sql in Supabase (vedi COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "I luoghi si aprono in Google Maps, Waze o Mappe, come scelto in Impostazioni.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "I membri vedono sempre gli amministratori e ricevono solo ciò che è stato inviato a loro.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Gli altri membri non vedono più i dati (la copia sparisce dai loro dispositivi). Tutto resta a te.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "I profili e i risultati restano nel tuo account My Planner.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "I profili, le OAB e i tribunali si trovano nella scheda Pubblicazioni. La ricerca automatica viene eseguita sul server alle 08:00 e alle 12:00 (ora di Brasília).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "I prezzi vengono salvati e compaiono nella lista della spesa della scheda Alimentazione & Dispensa come prezzo dell'ultimo acquisto.",
 "Os resultados deste perfil também serão apagados.": "Anche i risultati di questo profilo saranno eliminati.",
 "Os termos foram atualizados": "I termini sono stati aggiornati",
 "Ou digite (ex.: 2 ovos mexidos)": "Oppure scrivi (es.: 2 uova strapazzate)",
 "Ou escreva o prato": "Oppure scrivi il piatto",
 "Ou escreva o seu": "Oppure scrivi il tuo",
 "Outra": "Altro",
 "Outra aba…": "Un'altra scheda…",
 "Outra atividade (digite e dê Enter)": "Altra attività (scrivi e premi Invio)",
 "Outro": "Altro",
 "Outro (ml)": "Altro (ml)",
 "Outro valor": "Altro importo",
 "Outros": "Altro",
 "Outros países": "Altri paesi",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Altri orologi (Garmin, Samsung, Xiaomi, Amazfit...): nell'app dell'orologio, attiva l'opzione per inviare i dati all'app Salute (Apple Salute).",
 "Ovo": "Uovo",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "PAGATO, RICEVUTO, RISERVATO, APPROVATO o il tuo testo, con la data.",
 "PARA ACERTAR": "DA SALDARE",
 "PARA QUEM": "DESTINATARI",
 "PARA {refeicao}": "PER {refeicao}",
 "PASSO A PASSO": "PASSO PER PASSO",
 "PASSO {n}": "PASSO {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF con testo digitale: pronto subito nel browser. PDF scansionato (foto): la tua IA legge ogni pagina.",
 "PDF grande": "PDF grande",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF salvato nella cartella \"{pasta}\" del telefono.",
 "PDF guardado no {nome}.": "PDF salvato su {nome}.",
 "PDF numa página só": "PDF in una sola pagina",
 "PDF para Word": "PDF in Word",
 "PDF para imagens": "PDF in immagini",
 "PDF para texto": "PDF in testo",
 "PDFs arquivados ({n})": "PDF archiviati ({n})",
 "PDFs juntados {data}": "PDF uniti {data}",
 "PEDIDOS RECEBIDOS": "RICHIESTE RICEVUTE",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX COPIA E INCOLLA",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "PROSSIMI ESTRATTI (GIÀ IMPEGNATO)",
 "Paciente": "Paziente",
 "Paciente ou aluno": "Paziente o alunno",
 "Pacientes": "Pazienti",
 "Padrão": "Predefinito",
 "Padrão da aba": "Predefinito della scheda",
 "Paga": "Pagata",
 "Paga (toque para desfazer)": "Pagato (tocca per annullare)",
 "Pagador": "Pagante",
 "Pagamento já contado": "Pagamento già contato",
 "Pagar": "Pagare",
 "Pagar parcela {n}/{t} · {c}": "Paga rata {n}/{t} · {c}",
 "Pagas": "Pagate",
 "Pago": "Pagato",
 "Pago com": "Pagato con",
 "Pago: {p} · Falta pagar: {f}": "Pagato: {p} · Da pagare: {f}",
 "Pagos": "Pagati",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "Hai pagato {v}? Se hai avuto uno sconto, una mora o interessi, inserisci l'importo pagato. Vuoi salvare la ricevuta ora?",
 "Paguei outro valor (desconto, multa ou juros)": "Ho pagato un altro importo (sconto, mora o interessi)",
 "Paixão de Cristo": "Venerdì Santo",
 "Palavras-chave (separe com vírgula)": "Parole chiave (separa con virgole)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "Per raggiungere l'obiettivo \"{m}\" in tempo, servirebbero {v} al mese. Conviene allungare la scadenza o iniziare con un importo più basso.",
 "Para clareza, firmo o presente.": "In fede.",
 "Para comprar": "Da acquistare",
 "Para continuar, digite a senha do app.": "Per continuare, inserisci la password dell'app.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Per chattare, attiva la tua IA in Impostazioni › Intelligenza artificiale (Claude, ChatGPT o Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "Per dividere le spese, scrivi in \"Chi viene\" i nomi separati da virgola (modifica il viaggio).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "Per emettere e cercare fatture, collega una volta il server delle fatture: sul computer, fai doppio clic su 13-LIGAR-NOTAS.bat e incolla qui l'indirizzo che mostra (termina con .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "Per esercitare i tuoi diritti, usa Contattaci nell'app o scrivi all'e-mail qui sotto. Rispondiamo entro 15 giorni.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "Per fare chiamate audio e video, installa la nuova versione dell'app (0.35). I messaggi funzionano già.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "Per far funzionare l'app: conservare e sincronizzare i tuoi dati tra dispositivi, inviare avvisi, condividere con i gruppi che hai scelto e offrire assistenza.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "Per salvare i PDF su {nome}, collega il tuo account in Impostazioni › Google Drive e OneDrive.",
 "Para hoje": "A oggi",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "Per leggere foto o PDF, attiva la tua IA in Impostazioni › Intelligenza artificiale (Claude, ChatGPT o Gemini). L'estratto conto in OFX o CSV funziona senza IA.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "Per leggere l'orologio in automatico, installa la nuova versione dell'app (0.33). Nel frattempo, puoi inserire i dati a mano.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "Per leggere l'orologio, collegalo dall'app sul telefono. I numeri compaiono anche qui.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "Per leggere l'orologio, consenti a My Planner l'accesso ai dati di attività.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Per leggere il testo, riassumere e fare domande, attiva la tua IA in Impostazioni › Intelligenza artificiale (Claude, ChatGPT o Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "Per attivarla, usa l'app sul telefono (Impostazioni > Google Calendar). Poi tutto apparirà anche qui.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "Per attivarla, usa l'app sul telefono (Impostazioni › Impostazioni generali › Google Calendar). Poi tutto apparirà anche qui.",
 "Para monitorar a OAB, informe o número e a UF.": "Per monitorare la OAB, inserisci il numero e lo stato (UF).",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "Per non chiederlo più, scegli l'app in Impostazioni › Impostazioni generali.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "Per i professionisti sanitari: pazienti, evoluzione nella cassaforte, prescrizioni con modelli, finanze, ricevuta e dichiarazione per rimborso in PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "Per i professionisti sanitari: pazienti, evoluzione, prescrizioni con modelli, finanze con convenzioni, ricevuta e dichiarazione per rimborso.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "Per proteggere il tuo account, confermiamo il tuo cellulare una sola volta, con un codice via WhatsApp. Viene richiesto di nuovo solo se cambi numero.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "Per chi affitta l'alloggio o una stanza per brevi periodi (Airbnb, Booking o diretto): prenotazioni, pulizie, spese e l'utile di ogni mese.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "Per ricevere programma, luogo e avvisi dell'evento sul telefono, entra nel gruppo: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "Per sincronizzare, consenti a My Planner l'accesso al calendario nelle impostazioni del telefono.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "Per revocare un permesso già concesso al sistema (fotocamera, foto, microfono), usa anche le impostazioni del telefono.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "Per una lettura più completa, attiva la tua IA in Impostazioni › Intelligenza artificiale.",
 "Parabéns": "Auguri",
 "Parabéns!": "Auguri!",
 "Parada": "Ferma",
 "Parar": "Interrompi",
 "Parar de compartilhar?": "Interrompere la condivisione?",
 "Parar e salvar": "Ferma e salva",
 "Parar gravação": "Ferma registrazione",
 "Parcela": "Rata",
 "Parcela de financiamento": "Rata del finanziamento",
 "Parcela {n}/{t}": "Rata {n}/{t}",
 "Parcela {n}/{t} · {c}": "Rata {n}/{t} · {c}",
 "Parcelas": "Rate",
 "Parcelas a pagar nos próximos meses": "Rate da pagare nei prossimi mesi",
 "Parcelas recalculadas": "Rate ricalcolate",
 "Parece que foi impresso e escaneado.": "Sembra stampato e scansionato.",
 "Parei": "Interrotto",
 "Parei na aula": "Arrivato alla lezione",
 "Parei na aula...": "Arrivato alla lezione...",
 "Pares de meia": "Paia di calze",
 "Parque ou natureza": "Parco o natura",
 "Parques": "Parchi",
 "Parte": "Parte",
 "Partes": "Parti",
 "Participa": "Partecipante",
 "Participantes": "Partecipanti",
 "Participação em empresa": "Partecipazione societaria",
 "Passa do limite do MEI: fale com seu contador.": "Supera il limite del MEI: parlane con il tuo commercialista.",
 "Passaporte": "Passaporto",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Passa il dito sul disegno per cancellare solo quella parte.",
 "Passeio": "Escursione",
 "Passeios": "Escursioni",
 "Passo a passo": "Passo per passo",
 "Passos": "Passi",
 "Passos, exercício, calorias, batimentos e sono": "Passi, esercizio, calorie, battito e sonno",
 "Passou do orçamento": "Budget superato",
 "Passou do orçamento em {v}": "Budget superato di {v}",
 "Pasta": "Cartella",
 "Patrimônio": "Patrimonio",
 "Patrimônio & Imposto de Renda": "Patrimonio & Imposta sul reddito",
 "Patrimônio pelo valor de compra: {v}": "Patrimonio al valore d'acquisto: {v}",
 "Pausa (s)": "Riposo (s)",
 "Pausa de {m} min": "Pausa di {m} min",
 "Pausado": "In pausa",
 "Pausar": "Pausa",
 "Pausas": "Pause",
 "Pausas de estudo": "Pause di studio",
 "Pauta (opcional)": "Ordine del giorno (facoltativo)",
 "Paz": "Pace",
 "Pediatra": "Pediatra",
 "Pedido": "Richiesta",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Richiesta inviata a {nome}. Quando la accetta, potrete chattare.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Richiesta inviata. Quando la persona la accetta, potrete chattare.",
 "Pedidos de documentos": "Richieste di documenti",
 "Pedir de novo depois de": "Richiedi di nuovo dopo",
 "Peguei emprestado": "Ho preso in prestito",
 "Peito de frango": "Petto di pollo",
 "Peixe": "Pesce",
 "Pela última compra: cerca de {v}": "Dall'ultimo acquisto: circa {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "Con i pagamenti che scadono ancora questo mese, mancheranno {v}. Guarda cosa puoi rimandare o tagliare prima di nuove spese.",
 "Pendente": "In attesa",
 "Pensão alimentícia": "Assegno di mantenimento",
 "Pequena": "Piccola",
 "Pequeno": "Piccolo",
 "Percentual de tributos do Simples (para sair na nota)": "Percentuale di tributi del Simples (da riportare in fattura)",
 "Perguntar ao Mestre": "Chiedi al Mestre",
 "Perguntar sempre": "Chiedi sempre",
 "Pergunte ao Mestre...": "Chiedi al Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Fai una domanda sul documento (es.: qual è la scadenza?)",
 "Permissões": "Permessi",
 "Personalizado": "Personalizzato",
 "Perto do limite do orçamento": "Vicino al limite del budget",
 "Período": "Periodo",
 "Período da meta": "Periodo dell'obiettivo",
 "Pescoço: inclinar para os lados": "Collo: inclinare ai lati",
 "Peso": "Peso",
 "Peso na média": "Peso nella media",
 "Pesquisar no mapa": "Cerca sulla mappa",
 "Pessoa": "Persona",
 "Pessoa de contato": "Persona di riferimento",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "Le persone dei tuoi gruppi vedono solo ciò che viene condiviso nel gruppo.",
 "Pet": "Animale",
 "Pet & Família": "Animali & Famiglia",
 "Pet shop": "Toelettatura",
 "Pet shop ou clínica": "Toelettatura o clinica",
 "Pets": "Animali",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Chiedi documenti al cliente con una scadenza. Lui riceve, allega e segna come consegnato.",
 "Pijamas": "Pigiami",
 "Pilates": "Pilates",
 "Pintura": "Tinteggiatura",
 "Pix copia e cola": "Pix copia e incolla",
 "Placa": "Targa",
 "Planejado": "Previsto",
 "Planejado e comido": "Previsto e mangiato",
 "Planilha": "Foglio di calcolo",
 "Planilha (Excel)": "Foglio di calcolo (Excel)",
 "Planilha do mês para o Receita Saúde": "Foglio del mese per Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Piano base: My Planner + Note",
 "Plano de aula": "Piano di lezione",
 "Plano de saúde": "Assicurazione sanitaria",
 "Planos de aula": "Piani di lezione",
 "Planta": "Pianta",
 "Plantas": "Piante",
 "Plantas & Jardim": "Piante & Giardino",
 "Plataforma ou escola": "Piattaforma o scuola",
 "Pneus novos": "Pneumatici nuovi",
 "Podcast": "Podcast",
 "Pode confirmar sua presença respondendo esta mensagem?": "Puoi confermare la tua presenza rispondendo a questo messaggio?",
 "Polichinelo": "Jumping jack",
 "Polo ativo": "Parte attrice",
 "Polo passivo": "Parte convenuta",
 "Política de privacidade (LGPD)": "Informativa sulla privacy (LGPD)",
 "Política de privacidade, LGPD e permissões": "Informativa sulla privacy, LGPD e permessi",
 "Política de privacidade, LGPD e termos": "Informativa sulla privacy, LGPD e termini",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Metti qui le foto e i video del viaggio. Nel gruppo tutti li vedono e tutti possono aggiungere i propri.",
 "Ponte de glúteos": "Ponte glutei",
 "Ponto facultativo": "Giorno facoltativo",
 "Ponto facultativo: {nome}": "Giorno festivo facoltativo: {nome}",
 "Ponto turístico": "Attrazione turistica",
 "Pontos turísticos": "Attrazioni turistiche",
 "Por dia": "Al giorno",
 "Por faixas": "Per intervalli",
 "Por mês": "Al mese",
 "Por nome": "Per nome",
 "Por semana": "A settimana",
 "Portal": "Portale",
 "Portal do Cliente": "Portale clienti",
 "Portal do cliente (convidar o cliente)": "Portale clienti (invita il cliente)",
 "Português": "Portoghese",
 "Porão": "Seminterrato",
 "Porções": "Porzioni",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Poco spazio libero: nuove foto e allegati potrebbero non essere salvati. Libera spazio o salva gli allegati su Google Drive o OneDrive.",
 "Praia": "Spiaggia",
 "Prancha": "Plank",
 "Prato do cardápio": "Piatto del menu",
 "Prato principal": "Piatto principale",
 "Prazo": "Termine",
 "Prazo (pagamento ou entrega)": "Scadenza (pagamento o consegna)",
 "Prazo até {fim} · fazer em {dia}": "Termine fino al {fim} · da fare il {dia}",
 "Prazo final: {fim}": "Termine finale: {fim}",
 "Prazo: {d}": "Scadenza: {d}",
 "Prazo: {t}": "Scadenza: {t}",
 "Prazos criados": "Scadenze create",
 "Precisa da sua IA": "Serve la tua IA",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Compila descrizione, codice tributario nazionale (6 cifre) e importo.",
 "Preenche os campos do PDF e, se quiser, trava.": "Compila i campi del PDF e, se vuoi, li blocca.",
 "Preencher formulário": "Compila modulo",
 "Preencher pela foto com a minha IA": "Compila dalla foto con la mia IA",
 "Preencher pela nota fiscal com a minha IA": "Compila dalla fattura con la mia IA",
 "Preparando a conversa da equipe...": "Preparazione della chat del team...",
 "Preparando a página {n} de {total}...": "Preparazione pagina {n} di {total}...",
 "Preparando o arquivo": "Preparazione del file",
 "Prescrição, conduta e orientações": "Prescrizione, condotta e indicazioni",
 "Presente": "Presente",
 "Presença": "Presenza",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Tieni premuto il codice per copiarlo, oppure tocca Invia e scegli \"Copia\".",
 "Pressione e segure o código para copiar.": "Tieni premuto il codice per copiarlo.",
 "Pressione e segure um lançamento para apagar.": "Tieni premuto un movimento per eliminarlo.",
 "Pressione e segure um perfil para removê-lo.": "Tieni premuto un profilo per rimuoverlo.",
 "Preto e branco": "Bianco e nero",
 "Previdência privada": "Previdenza integrativa",
 "Preço ou ingresso": "Prezzo o biglietto",
 "Price": "Francese (Price)",
 "Primeira": "Prima",
 "Primeira cota ou cota única do IR": "Prima rata o rata unica IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "Prima rata nell'estratto di {mes}, che scade il {data}.",
 "Prioridade": "Priorità",
 "Privacidade": "Privacy",
 "Privacidade e termos": "Privacy e termini",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Privacy: il testo o l'immagine analizzata va direttamente da questo dispositivo all'azienda dell'IA scelta, con la tua chiave. My Planner non ne conserva copia.",
 "Problema": "Problema",
 "Problemas, erros e sugestões": "Problemi, errori e suggerimenti",
 "Procedimento": "Procedura",
 "Procedimento: {c}": "Prestazione: {c}",
 "Processo": "Procedimento",
 "Processo Civil": "Procedura civile",
 "Processo Penal": "Procedura penale",
 "Processo do Trabalho": "Processo del lavoro",
 "Processo não informado": "Procedimento non indicato",
 "Proclamação da República": "Proclamazione della Repubblica",
 "Procurando a folha...": "Cerco il foglio...",
 "Procurando atualização...": "Ricerca aggiornamenti...",
 "Procurar aba": "Cerca scheda",
 "Procurar atualização agora": "Cerca aggiornamenti ora",
 "Procurar documento": "Cerca documento",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Cerca strumento (es.: unisci, firma, comprimi)",
 "Produto": "Prodotto",
 "Produto (ex.: Geladeira)": "Prodotto (es.: Frigorifero)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Prodotti, fatture, assistenza tecnica e avviso prima della scadenza.",
 "Produção (vale de verdade)": "Produzione (valida)",
 "Produção restrita (teste)": "Produzione ristretta (test)",
 "Produção restrita (teste, não vale)": "Produzione ristretta (test, non valida)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Produzione ristretta: ambiente di test del governo. Le fatture non sono valide. Prova tutto qui prima di passare a Produzione (in Modifica).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Produzione: le fatture emesse sono valide a tutti gli effetti e vanno al comune e alla Receita.",
 "Produção: vale de verdade": "Produzione: valida a tutti gli effetti",
 "Professor": "Insegnante",
 "Professor & Mentoria": "Insegnante & Mentoring",
 "Professor(a)": "Insegnante",
 "Profissionais": "Professionisti",
 "Profissional": "Professionista",
 "Profissional assistente": "Professionista assistente",
 "Profissional ou fornecedor": "Professionista o fornitore",
 "Profissional ou local": "Professionista o luogo",
 "Profissão ou especialidade": "Professione o specializzazione",
 "Profissões": "Professioni",
 "Programação": "Programmazione",
 "Progresso geral": "Progresso generale",
 "Projeto e licenças": "Progetto e permessi",
 "Projetos": "Progetti",
 "Prontas": "Pronti",
 "Pronto": "Fatto",
 "Pronto! Todas as abas estão liberadas até {data}.": "Fatto! Tutte le schede sono sbloccate fino al {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "Fatto. Blocca lo schermo e aspetta 1 minuto: l’avviso dovrebbe comparire con il suono.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Cartella clinica, decorso e prescrizioni, senza la parte economica.",
 "Protegendo a chave...": "Protezione della chiave...",
 "Proteger no cofre": "Proteggi nella cassaforte",
 "Protegido": "Protetto",
 "Protegido no cofre": "Protetto nella cassaforte",
 "Protegidos pelo cofre: {n}": "Protetti dalla cassaforte: {n}",
 "Protetor solar": "Crema solare",
 "Protocolo": "Numero di pratica",
 "Prova": "Verifica",
 "Próxima": "Prossima",
 "Próxima até a data": "Prossima entro il",
 "Próxima com quantos km": "Prossima a quanti km",
 "Próxima dose": "Prossima dose",
 "Próxima: {data}": "Prossima: {data}",
 "Próxima: {d} · {v}": "Prossima: {d} · {v}",
 "Próximas": "Prossime",
 "Próximo": "Avanti",
 "Próximo ano": "Anno successivo",
 "Próximo número da DPS": "Prossimo numero DPS",
 "Próximos 7 dias": "Prossimi 7 giorni",
 "Próximos vencimentos ({n})": "Prossime scadenze ({n})",
 "Publicação": "Pubblicazione",
 "Publicações": "Pubblicazioni",
 "Pula": "Salta",
 "Pulsa": "Pulsa",
 "Punho": "Pugno",
 "Puxada frontal": "Lat machine",
 "PÁGINAS": "PAGINE",
 "PÔR NA BARRA": "METTI NELLA BARRA",
 "Pág. {n}": "Pag. {n}",
 "Página": "Pagina",
 "Página 1": "Pagina 1",
 "Página 1 de 10": "Pagina 1 di 10",
 "Página em branco no fim": "Pagina bianca alla fine",
 "Página em que estou": "Pagina a cui sono",
 "Página escaneada": "Pagina scansionata",
 "Página inteira": "Pagina intera",
 "Página {a} de {n}": "Pagina {a} di {n}",
 "Página {n}": "Pagina {n}",
 "Página {n} de {total}": "Pagina {n} di {total}",
 "Página: {titulo}": "Pagina: {titulo}",
 "Páginas": "Pagine",
 "Páginas, tamanho, autor, datas e campos.": "Pagine, dimensione, autore, date e campi.",
 "Pássaro": "Uccello",
 "Pão francês": "Panino (rosetta)",
 "Pão integral": "Pane integrale",
 "Pôr a data de hoje": "Metti la data di oggi",
 "Pôr as parcelas no My Planner": "Metti le rate nel My Planner",
 "Pôr na barra": "Metti nella barra",
 "Pôr no roteiro da viagem": "Aggiungi all'itinerario del viaggio",
 "Pôr uma foto": "Metti una foto",
 "Quadro": "Bacheca",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Bacheca Kanban, cronometro delle ore per cliente e scadenze in My Planner.",
 "Quais contas vencem nos próximos dias?": "Quali pagamenti scadono nei prossimi giorni?",
 "Quais páginas ficam no PDF novo": "Quali pagine restano nel nuovo PDF",
 "Quais páginas sair": "Quali pagine togliere",
 "Qual IA": "Quale IA",
 "Qualidade alta": "Qualità alta",
 "Qualidade boa (menor)": "Qualità buona (più leggero)",
 "Quantidade": "Quantità",
 "Quanto cortar de cada lado (% da página)": "Quanto tagliare da ogni lato (% della pagina)",
 "Quanto já tem guardado (opcional)": "Quanto hai già messo da parte (facoltativo)",
 "Quanto paga por limpeza": "Quanto paga per pulizia",
 "Quanto preciso guardar por mês para as minhas metas?": "Quanto devo mettere da parte al mese per i miei obiettivi?",
 "Quanto quer juntar": "Quanto vuoi mettere da parte",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "Quanto vuoi spendere al massimo in ogni categoria al mese. Lascia vuoto per non controllare.",
 "Quarta": "Mercoledì",
 "Quarta-feira de Cinzas (até 14h)": "Mercoledì delle Ceneri (fino alle 14)",
 "Quarto": "Camera",
 "Quarto das crianças": "Cameretta",
 "Quarto de casal": "Camera matrimoniale",
 "Quarto de hóspedes": "Camera degli ospiti",
 "Quarto infantil": "Cameretta",
 "Queijo": "Formaggio",
 "Queixa principal": "Disturbo principale",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Chi apre il link scarica My Planner (o lo usa nel browser), accede e entra a far parte del gruppo.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Chi crea l'account con il tuo codice diventa subito tuo amico qui, senza bisogno di richiesta.",
 "Quem enviou": "Chi ha inviato",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Chi è in un gruppo dell'app con te (classe, famiglia, viaggio...) può già chattare senza essere amico. Tieni premuto un amico per rimuovere l'amicizia o bloccarlo.",
 "Quem faz a limpeza": "Chi fa le pulizie",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Chi paga, se non è il paziente (madre, padre, tutore)",
 "Quem pagou": "Chi ha pagato",
 "Quem recebeu (médico, escola...)": "Chi ha ricevuto (medico, scuola...)",
 "Quem vai": "Chi viene",
 "Quem vai limpar": "Chi pulirà",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Chi la vede: solo chi chatta con te, i tuoi amici e chi è in un gruppo dell'app con te. Lascia vuoto ciò che non vuoi mostrare.",
 "Quente": "Caldo",
 "Quer escanear mais uma página?": "Vuoi scansionare un'altra pagina?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "Vuoi salvare la ricevuta adesso? Foto, PDF o screenshot del Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "Vuoi inviare uno screenshot? Invialo per e-mail e allega l'immagine.",
 "Quer trocar pelos novos ou manter os dois?": "Vuoi sostituirli con i nuovi o mantenere entrambi?",
 "Quero assistir": "Da vedere",
 "Quero ir": "Voglio andarci",
 "Quero ler": "Da leggere",
 "Quero ver": "Da vedere",
 "Quilometragem atual": "Chilometraggio attuale",
 "Quilometragem: {km}": "Chilometraggio: {km}",
 "Quinta": "Giovedì",
 "Quintal": "Cortile",
 "Quitado": "Estinto",
 "Quitados": "Estinti",
 "Química": "Chimica",
 "RECIBO": "RICEVUTA",
 "RG / Carteira de identidade": "Carta d'identità (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "Identità, patente, passaporto, contratti e certificati, con avviso prima della scadenza e invio con un tocco.",
 "Raciocínio Lógico": "Ragionamento logico",
 "Razão social ou nome": "Ragione sociale o nome",
 "Razão social ou nome do consultório": "Ragione sociale o nome dello studio",
 "Razão social ou nome fantasia": "Ragione sociale o nome commerciale",
 "Raça": "Razza",
 "Realizado": "Eseguita",
 "Recado": "Messaggio",
 "Recalcular": "Ricalcola",
 "Recalcular as parcelas em aberto": "Ricalcola le rate aperte",
 "Recalcular as parcelas?": "Ricalcolare le rate?",
 "Receber": "Incassare",
 "Receber de volta: {i} ({p})": "Da riavere: {i} ({p})",
 "Receber o código no WhatsApp": "Ricevi il codice su WhatsApp",
 "Receber parcela {n}/{t} · {c}": "Ricevi rata {n}/{t} · {c}",
 "Recebeu um convite?": "Hai ricevuto un invito?",
 "Recebeu um código?": "Hai ricevuto un codice?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "Ho ricevuto da {pagador}{doc} la somma di {valor}{extenso}, relativa a: {tipo}, eseguita il {data}{paciente}.",
 "Recebi outro valor": "Ho ricevuto un altro importo",
 "Recebida": "Ricevuta",
 "Recebida (toque para desfazer)": "Incassato (tocca per annullare)",
 "Recebidas": "Ricevute",
 "Recebido": "Ricevuto",
 "Recebido: {v}": "Ricevuto: {v}",
 "Recebidos": "Ricevuti",
 "Recebidos dos grupos": "Ricevuti dai gruppi",
 "Recebimento": "Incasso",
 "Receita": "Ricetta",
 "Receitas": "Ricette",
 "Recibo": "Ricevuta",
 "Recibo em PDF": "Ricevuta in PDF",
 "Recibo emitido": "Ricevuta emessa",
 "Recibo guardado": "Ricevuta salvata",
 "Recibos dedutíveis": "Ricevute detraibili",
 "Recomendada": "Consigliata",
 "Recomeçar": "Ricomincia",
 "Recortar": "Ritaglia",
 "Recortar margens": "Ritaglia margini",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Ritaglio, rotazione e filtri arrivano con la nuova app (versione 0.49).",
 "Recusada": "Rifiutata",
 "Recusado": "Rifiutato",
 "Recusar": "Rifiuta",
 "Redação": "Scrittura",
 "Refazer": "Rifai",
 "Refeição": "Pasto",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Pasti, esercizi, cure e integratori previsti per oggi",
 "Referente a": "Relativo a",
 "Referência": "Riferimento",
 "Reforço": "Richiamo",
 "Regar a cada quantos dias": "Annaffiare ogni quanti giorni",
 "Regar hoje": "Annaffiare oggi",
 "Regar: {p}": "Annaffiare: {p}",
 "Regional": "Regionale",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Compila il diario, le fasi e le consegne, senza vedere gli importi.",
 "Registrar venda/serviço do MEI": "Registra vendita/servizio MEI",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Registra ogni visita: l'evoluzione resta nella cassaforte, criptata. La prescrizione può partire da un modello.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Registra acquisti e vendite di immobili, veicoli e investimenti con le ricevute. Aiuta molto al momento delle tasse.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Registra cosa è stato diverso dal programma (hai cambiato un alimento, il pasto). Entra nel report della settimana.",
 "Registro": "Nota",
 "Registro clínico": "Cartella clinica",
 "Registro de horas": "Registro ore",
 "Registro do diário": "Voce del diario",
 "Regiões com feriado próprio (marque as suas):": "Regioni con festività proprie (seleziona le tue):",
 "Regras da casa": "Regole della casa",
 "Regras da casa:": "Regole della casa:",
 "Reguei": "Annaffiata",
 "Reguei hoje": "Annaffiata oggi",
 "Reiniciar": "Riavvia",
 "Reiniciar o app": "Riavvia l'app",
 "Relatório": "Report",
 "Relatório da semana": "Report della settimana",
 "Relatório em PDF ou Excel": "Report in PDF o Excel",
 "Relatório enviado. Obrigado!": "Segnalazione inviata. Grazie!",
 "Relatórios": "Report",
 "Relatórios do Bem-Estar": "Report Benessere",
 "Relatórios gerados ({n})": "Report generati ({n})",
 "Relaxar": "Relax",
 "Religião": "Religione",
 "Relógio": "Orologio",
 "Relógio e apps de saúde": "Orologio e app salute",
 "Remada baixa": "Pulley basso",
 "Remover": "Rimuovi",
 "Remover \"{nome}\"?": "Rimuovere \"{nome}\"?",
 "Remover anotações": "Rimuovi annotazioni",
 "Remover este bloco?": "Rimuovere questo blocco?",
 "Remover páginas": "Rimuovi pagine",
 "Remover vínculo": "Rimuovi collegamento",
 "Remover {nome}?": "Rimuovere {nome}?",
 "Remédio": "Farmaco",
 "Remédio contínuo": "Farmaco continuativo",
 "Remédio na linha do tempo": "Farmaco nella cronologia",
 "Remédios": "Farmaci",
 "Remédios de uso contínuo": "Farmaci a uso continuativo",
 "Renavam ou chassi": "Renavam o telaio",
 "Renegociado": "Rinegoziato",
 "Renomear": "Rinomina",
 "Renomear com IA": "Rinomina con IA",
 "Renomear ou trocar ícone": "Rinomina o cambia icona",
 "Renomear pasta": "Rinomina cartella",
 "Renomear, ícone ou cor": "Rinomina, icona o colore",
 "Renovar: {nome}": "Rinnova: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Riorganizza il file internamente. Aiuta poco nei PDF con foto.",
 "Reparar PDF": "Ripara PDF",
 "Repelente": "Repellente",
 "Repete": "Ripeti",
 "Repetir a cada quantos dias": "Ripeti ogni quanti giorni",
 "Repetições": "Ripetizioni",
 "Repita a senha": "Ripeti la password",
 "Repita a senha do cofre": "Ripeti la password della cassaforte",
 "Repita a senha nova": "Ripeti la nuova password",
 "Replantio": "Rinvaso",
 "Replantios": "Rinvasi",
 "Repor papel higiênico, sabonete e café": "Rifornire carta igienica, sapone e caffè",
 "Representatividade": "Inclusività",
 "Reserva": "Prenotazione",
 "Reservas": "Prenotazioni",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Prenotazioni, pulizie, entrate e spese nella scheda Affitti & Ospitalità",
 "Respirar fundo 5 vezes": "Respirare profondamente 5 volte",
 "Respondendo a {nome}": "Rispondi a {nome}",
 "Responder": "Rispondi",
 "Responsável": "Responsabile",
 "Responsável (imobiliária, vistoriador)": "Responsabile (agenzia, perito)",
 "Resposta da SEFAZ": "Risposta della SEFAZ",
 "Resta {tempo}": "Resta {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "Mancano {ml} = {n} bicchiere/i da {copo}",
 "Restaurante": "Ristorante",
 "Restaurantes": "Ristoranti",
 "Restaurar": "Ripristina",
 "Restaurar esta cópia?": "Ripristinare questo backup?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "Il ripristino sostituisce TUTTI i dati attuali con quelli del backup, qui e nel tuo account.",
 "Restaurar uma cópia": "Ripristina un backup",
 "Resultado": "Risultato",
 "Resultado nas vendas: {v}": "Risultato delle vendite: {v}",
 "Resumir": "Riassumi",
 "Resumir e perguntar": "Riassumi e chiedi",
 "Resumo": "Riepilogo",
 "Resumo (falta o XML completo)": "Riepilogo (manca l'XML completo)",
 "Resumo da manhã": "Riepilogo del mattino",
 "Resumo da pasta": "Riepilogo della cartella",
 "Resumo e opinião": "Riassunto e opinione",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Riepilogo, spese per categoria, pagamenti, estratti, obiettivi e tutti i movimenti. Utile da mandare al commercialista o da conservare per l'IR.",
 "Retirar": "Preleva",
 "Retirar da meta": "Preleva dall'obiettivo",
 "Retorno": "Controllo",
 "Reunião": "Riunione",
 "Reunião agora": "Riunione ora",
 "Reunião de equipe": "Riunione del team",
 "Reuniões": "Riunioni",
 "Revestimento e pisos": "Rivestimenti e pavimenti",
 "Revisão": "Tagliando",
 "Revolução Constitucionalista": "Rivoluzione costituzionalista",
 "Rico em matéria orgânica": "Ricco di materia organica",
 "Rodízio de pneus": "Rotazione degli pneumatici",
 "Roedor": "Roditore",
 "Romance": "Romantico",
 "Rosca direta": "Curl con bilanciere",
 "Rota": "Percorso",
 "Rota passando pelos {n} lugares que faltam": "Percorso per i {n} luoghi rimasti",
 "Rotas e mapas": "Percorsi e mappe",
 "Roteiro": "Itinerario",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Itinerario giornaliero nella cronologia durante il viaggio, valigia in base al clima, prenotazioni e fusi orari.",
 "Rotina": "Routine",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Routine passo per passo: skincare, stretching, capelli... Tocca \"+ Cura\" per scegliere un modello o crearne uno tuo.",
 "Roupa": "Abbigliamento",
 "Roupa social": "Abito elegante",
 "Roupas de banho": "Costumi da bagno",
 "Roupas extras das crianças": "Cambi extra per i bambini",
 "Roupas íntimas": "Intimo",
 "Rua": "Via",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Via, numero civico, quartiere, città (o nome del luogo)",
 "Régua": "Righello",
 "Réptil": "Rettile",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Etichetta (es.: Il mio nome, Azienda del cliente)",
 "SAC": "Italiano (SAC)",
 "SEM HORÁRIO": "SENZA ORARIO",
 "SEU MÊS EM NÚMEROS": "IL TUO MESE IN NUMERI",
 "SEU TREINO": "IL TUO ALLENAMENTO",
 "SEUS GRUPOS DO APP": "I TUOI GRUPPI DELL'APP",
 "SP": "SP",
 "SUBTAREFA": "SOTTOATTIVITÀ",
 "SUBTAREFAS": "SOTTOATTIVITÀ",
 "SUPLEMENTAÇÃO": "INTEGRATORI",
 "Sabonete facial": "Detergente viso",
 "Sabão para lavar roupa": "Detersivo per bucato",
 "Sacada": "Balcone",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Esce solo dall'elenco di questa app. La copia salvata su Drive, OneDrive o nella cartella del cellulare resta lì.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Esce solo dall'elenco. Il file resta dove è stato salvato.",
 "Sair": "Esci",
 "Sair da conta?": "Uscire dall'account?",
 "Sair do escritório": "Esci dall'ufficio",
 "Sair do escritório?": "Uscire dall'ufficio?",
 "Sair do grupo": "Esci dal gruppo",
 "Sair do grupo?": "Uscire dal gruppo?",
 "Sair sem baixar": "Esci senza scaricare",
 "Saiu": "Uscite",
 "Sala": "Aula",
 "Sala de estar": "Soggiorno",
 "Sala de jantar": "Sala da pranzo",
 "Sala virtual": "Aula virtuale",
 "Salada": "Insalata",
 "Saldo": "Saldo",
 "Saldo depois desta parcela": "Saldo dopo questa rata",
 "Saldo devedor: {v}": "Debito residuo: {v}",
 "Saldo do mês": "Saldo del mese",
 "Salvar": "Salva",
 "Salvar backup do My Planner": "Salva backup di My Planner",
 "Salvar cuidado": "Salva cura",
 "Salvar cômodo": "Salva stanza",
 "Salvar e colocar no My Planner": "Salva e metti in My Planner",
 "Salvar e sincronizar": "Salva e sincronizza",
 "Salvar e testar": "Salva e prova",
 "Salvar endereço": "Salva indirizzo",
 "Salvar no My Planner": "Salva in My Planner",
 "Salvar refeição": "Salva pasto",
 "Salvar suplemento": "Salva integratore",
 "Salvar tarefa": "Salva attività",
 "Salvar treino": "Salva allenamento",
 "Sanduíche natural": "Panino leggero",
 "Santo Antônio": "Sant'Antonio",
 "Sapato confortável": "Scarpe comode",
 "Saudade": "Mi manchi",
 "Saída (imóvel antigo)": "Uscita (vecchia casa)",
 "Saída de praia": "Copricostume",
 "Saúde": "Salute",
 "Saúde & Prontuário": "Salute & Cartella clinica",
 "Saúde (médicos, dentistas, exames, plano)": "Salute (medici, dentisti, esami, assicurazione sanitaria)",
 "Saúde e bem-estar": "Salute e benessere",
 "Scanner": "Scanner",
 "Scanner PDF": "Scanner PDF",
 "Sci-Fi": "Fantascienza",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "Se qualcosa non risponde, riavvia l'app. I tuoi dati sono salvati.",
 "Se der tempo": "Se c'è tempo",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "Se questa informativa cambia in modo rilevante, l'app ti avvisa e ti chiede di nuovo di accettarla.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "Se è comparso questo avviso, gli avvisi degli impegni funzionano.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "Se esiste un account con {email}, abbiamo inviato un link per creare una nuova password. Controlla anche lo spam.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "Se l’avviso arriva in ritardo o non compare: nelle impostazioni dell’app, lascia attive le notifiche, la batteria \"Senza restrizioni\" e consenti \"Sveglie e promemoria\".",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "Se l'orologio è collegato, i suoi numeri sostituiscono quelli inseriti a mano quando ha il dato.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "Se colleghi l'orologio: totali giornalieri di passi, distanza, calorie, esercizio, battito e sonno, letti da Health Connect (Android) o dall'app Salute (iPhone). L'app legge soltanto e non modifica mai questi dati.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "Se hai già usato questa scheda, non è stato cancellato nulla: tutto torna com'era quando ti abboni.",
 "Secretária ou recepção": "Segreteria o reception",
 "Seg a sex": "Lun-ven",
 "Seguir": "Avanti",
 "Segunda": "Lunedì",
 "Segurança": "Sicurezza",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Tieni premuto e trascina per cambiare l'ordine. ↻ ruota, ⧉ duplica e ✕ toglie la pagina.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Tieni premuta una GIF in una chat e tocca \"Salva\" per farla apparire qui.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Tieni premuta una stanza per spostarla. Con la stanza aperta, tieni premuta un'attività e rilasciala su un'altra stanza per spostarla lì.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Tieni premuto un raccoglitore, una materia o una pagina per cambiare l'ordine. Rilascia una materia su un altro raccoglitore per spostarla lì.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Tieni premuta una chat per silenziarla o archiviarla. Archiviata continua a ricevere e inviare, ma senza avvisi.",
 "Seguro": "Assicurazione",
 "Seguro da casa": "Assicurazione casa",
 "Seguro viagem": "Assicurazione di viaggio",
 "Selecionar": "Seleziona",
 "Sem": "Nessuno",
 "Sem alerta": "Nessun avviso",
 "Sem categoria": "Senza categoria",
 "Sem comprovante": "Senza ricevuta",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "Nessuna connessione al server delle fatture. Controlla internet e l'indirizzo del server.",
 "Sem conexão com o servidor. Confira a internet.": "Nessuna connessione al server. Controlla internet.",
 "Sem conexão com os GIFs agora.": "Nessuna connessione alle GIF ora.",
 "Sem cômodo": "Senza stanza",
 "Sem data de fim": "Senza data di fine",
 "Sem exercícios": "Nessun esercizio",
 "Sem fatura em {mes}": "Nessun estratto a {mes}",
 "Sem fim": "Senza fine",
 "Sem horário": "Senza orario",
 "Sem internet ou servidor ainda não preparado.": "Nessuna connessione o server non ancora pronto.",
 "Sem internet. Envia quando voltar.": "Nessuna connessione. Invierà quando torna.",
 "Sem internet. Tente de novo.": "Nessuna connessione. Riprova.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Senza questo, la banda copre soltanto: il testo sotto resta nel file e si può copiare.",
 "Sem itens": "Nessun elemento",
 "Sem juros": "Senza interessi",
 "Sem limite": "Senza limite",
 "Sem link de calendário": "Nessun link di calendario",
 "Sem margem": "Senza margine",
 "Sem nome": "Senza nome",
 "Sem número na primeira página (capa)": "Nessun numero sulla prima pagina (copertina)",
 "Sem pasta": "Senza cartella",
 "Sem pausas": "Nessuna pausa",
 "Sem permissão": "Nessun permesso",
 "Sem prazo": "Senza scadenza",
 "Sem recibo": "Senza ricevuta",
 "Sem tarefas": "Nessuna attività",
 "Sem texto.": "Nessun testo.",
 "Sem tomador identificado": "Nessun committente identificato",
 "Sem título": "Senza titolo",
 "Sem validade": "Senza scadenza",
 "Semana": "Settimana",
 "Semana completa": "Settimana intera",
 "Semana de {de} a {ate}": "Settimana dal {de} al {ate}",
 "Semanal": "Settimanale",
 "Semanal · dias úteis": "Settimanale · giorni feriali",
 "Semanal · todos os dias": "Settimanale · tutti i giorni",
 "Semanal · {dias}": "Settimanale · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Appaiono sempre, insieme ai giorni facoltativi (Carnevale, Mercoledì delle Ceneri e Corpus Domini).",
 "Senha": "Password",
 "Senha (8 caracteres ou mais)": "Password (8 caratteri o più)",
 "Senha alterada.": "Password modificata.",
 "Senha atual": "Password attuale",
 "Senha atual do cofre": "Password attuale della cassaforte",
 "Senha da conta": "Password dell'account",
 "Senha do certificado": "Password del certificato",
 "Senha do cofre": "Password della cassaforte",
 "Senha do cofre alterada.": "Password della cassaforte cambiata.",
 "Senha do cofre incorreta.": "Password della cassaforte errata.",
 "Senha incorreta": "Password errata",
 "Senha incorreta.": "Password errata.",
 "Senha nova (8 caracteres ou mais)": "Nuova password (8 caratteri o più)",
 "Senha nova do cofre (6 caracteres ou mais)": "Nuova password della cassaforte (6 caratteri o più)",
 "Senha, biometria, bloqueio e privacidade": "Password, biometria, blocco e privacy",
 "Senha, e-mail e formas de desbloquear": "Password, e-mail e modi di sblocco",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Raccogliere le certificazioni dei redditi (banche, datore di lavoro, broker)",
 "Servidor de notas": "Server delle fatture",
 "Servidor não configurado (lib/config.ts).": "Server non configurato (lib/config.ts).",
 "Servidor não configurado.": "Server non configurato.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Server non configurato: mancano i dati di Supabase in lib/config.ts.",
 "Serviço": "Servizio",
 "Serviço não prestado": "Servizio non prestato",
 "Serviços": "Servizi",
 "Será excluída em 1 dia": "Verrà eliminata tra 1 giorno",
 "Será excluída em {n} dias": "Verrà eliminata tra {n} giorni",
 "Será excluída hoje": "Verrà eliminata oggi",
 "Sessão": "Seduta",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "Il tuo accesso deve ancora essere abilitato. Prova ad accedere tra qualche istante.",
 "Seu código": "Il tuo codice",
 "Seu código de amigo": "Il tuo codice amico",
 "Seu código para amigos ganharem 10 dias com todas as abas": "Il tuo codice per regalare agli amici 10 giorni con tutte le schede",
 "Seu nome": "Il tuo nome",
 "Seu papel: {p}": "Il tuo ruolo: {p}",
 "Seu papel: {p}. {d}": "Il tuo ruolo: {p}. {d}",
 "Seu scanner de bolso": "Il tuo scanner tascabile",
 "Seus dados continuam salvos na nuvem.": "I tuoi dati restano salvati nel cloud.",
 "Seus dados na nuvem do My Planner": "I tuoi dati nel cloud di My Planner",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "I tuoi dati sono tuoi: non li vendiamo e non li usiamo per pubblicità. Puoi esportare o eliminare tutto quando vuoi.",
 "Seus {n} meses grátis terminaram": "I tuoi {n} mesi gratuiti sono terminati",
 "Sexta": "Venerdì",
 "Sextou": "Venerdì",
 "Sextou!": "Finalmente venerdì!",
 "Shampoo": "Shampoo",
 "Show ou passeio": "Spettacolo o escursione",
 "Silenciar avisos": "Silenzia notifiche",
 "Sim": "Sì",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Sincronizzato il {data}",
 "Sincronizando pelo dispositivo {nome}": "Sincronizzazione dal dispositivo {nome}",
 "Sincronizando...": "Sincronizzazione...",
 "Sincronizar agora": "Sincronizza ora",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Sincronizzazione ferma: conferma la password. Non si perde nulla.",
 "Site da assistência": "Sito dell'assistenza",
 "Site da assistência (https://...)": "Sito dell'assistenza (https://...)",
 "Site ou ingresso online": "Sito o biglietto online",
 "Situação": "Stato",
 "Situação agora": "Stato attuale",
 "Skincare da manhã": "Skincare mattutina",
 "Skincare da noite": "Skincare serale",
 "Slides": "Slide",
 "Smileys e pessoas": "Faccine e persone",
 "Sobremesa": "Dolce",
 "Sobrou no mês": "Avanzato nel mese",
 "Sociologia": "Sociologia",
 "Sofá": "Divano",
 "Sol": "Sole",
 "Sol pleno": "Pieno sole",
 "Solo ou substrato": "Terreno o substrato",
 "Solte numa matéria para mover a página para lá:": "Rilascia su una materia per spostarci la pagina:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Somma la garanzia legale e quella del produttore. Verifica nel certificato di garanzia. Avvisa 15 e 3 giorni prima.",
 "Sombra": "Ombra",
 "Somente esta tarefa": "Solo questa attività",
 "Sono": "Sonno",
 "Sono da noite": "Sonno della notte",
 "Sopa": "Zuppa",
 "Sou MEI": "Sono MEI",
 "Status": "Stato",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "La connessione al cloud è scaduta (succede quando l'app resta a lungo chiusa o la password è stata cambiata su un altro dispositivo). Non si perde nulla: ciò che è qui verrà inviato appena confermi.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "Il tuo team in un unico posto: chat, documenti, videoriunioni con registrazione e invito tramite link.",
 "Sua rotina em um só lugar": "La tua routine in un unico posto",
 "Sua senha": "La tua password",
 "Suas abas": "Le tue schede",
 "Substituir": "Sostituisci",
 "Substrato usado": "Substrato usato",
 "Subtarefa {n}": "Sottoattività {n}",
 "Suco": "Succo",
 "Sugerir nome": "Suggerisci nome",
 "Sugestão": "Suggerimento",
 "Sugestões de {categoria}": "Suggerimenti: {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: conserva l'account e i dati sincronizzati, come responsabile del trattamento. I server possono trovarsi fuori dal Brasile, con le garanzie dell'art. 33 della LGPD.",
 "Superiores": "Superiori",
 "Supino reto": "Panca piana",
 "Suplemento": "Integratore",
 "Suspense": "Thriller",
 "Suíte": "Camera con bagno",
 "Sábado": "Sabato",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "Sono più di 60 file. Usa \"Ogni N pagine\".",
 "Série": "Serie",
 "Série da DPS": "Serie DPS",
 "Série e turma": "Anno e sezione",
 "Séries": "Serie",
 "Sérum": "Siero",
 "Símbolos": "Simboli",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Lo vede solo il team dell'ufficio. Fino a 50 MB per file.",
 "Só acompanha": "Solo visione",
 "Só acompanha, sem valores": "Solo visione, senza importi",
 "Só administradores": "Solo amministratori",
 "Só em {data}": "Solo il {data}",
 "Só leitura": "Sola lettura",
 "Só mandar para a aba Estudos (sem escolher página)": "Invia solo alla scheda Studio (senza scegliere la pagina)",
 "Só neste dispositivo": "Solo su questo dispositivo",
 "Só neste dispositivo: {n}": "Solo su questo dispositivo: {n}",
 "Só o código": "Solo il codice",
 "Só o dia {data}": "Solo il giorno {data}",
 "Só os dados (texto)": "Solo i dati (testo)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "Solo i totali della Finanza vengono inviati alla tua IA. Non è un consiglio di investimento.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Solo tuo: studi, strategie didattiche e cosa ha funzionato o no in ogni lezione. Gli alunni non lo vedono.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "Solo un telefono si sincronizza con il calendario. Per passare a questo, tocca qui sotto.",
 "Só uma vez": "Solo una volta",
 "Só uma vez (abrir a ficha da tarefa)": "Solo una volta (apri la scheda dell'attività)",
 "Só áudio": "Solo audio",
 "Sótão": "Soffitta",
 "TAREFAS DA CASA": "FACCENDE DI CASA",
 "TELEFONE (OPCIONAL)": "TELEFONO (FACOLTATIVO)",
 "TRAZER PARA O MY PLANNER": "PORTA IN MY PLANNER",
 "TV por assinatura": "Pay TV",
 "Tabela": "Tabella",
 "Talvez": "Forse",
 "Tamanho": "Dimensione",
 "Tamanho da foto": "Dimensione della foto",
 "Tamanho da página": "Dimensione pagina",
 "Tamanho das páginas": "Dimensione delle pagine",
 "Tamanho do arquivo": "Dimensione del file",
 "Tamanho do copo": "Dimensione del bicchiere",
 "Também procurar nos Diários Oficiais dos municípios": "Cerca anche nelle Gazzette Ufficiali dei comuni",
 "Também serão excluídos {n} item(ns) dentro dele.": "Verranno eliminati anche {n} elementi al suo interno.",
 "Tapioca": "Crêpe di tapioca",
 "Tarefa": "Attività",
 "Tarefa da casa": "Faccenda di casa",
 "Tarefa de casa": "Compiti a casa",
 "Tarefa duplicada": "Attività duplicata",
 "Tarefa ou entrega": "Attività o consegna",
 "Tarefa para {nome}": "Attività per {nome}",
 "Tarefas da casa": "Faccende di casa",
 "Tarefas e itens de todas as abas": "Attività ed elementi di tutte le schede",
 "Tarefas novas do My Planner vão para: {agenda}": "Le nuove attività di My Planner vanno in: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "Le attività ricorrenti che vanno oltre il periodo continuano negli altri giorni; vengono rimossi solo i giorni scelti.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Bande nere su CPF, importi e nomi. Cancella davvero.",
 "Tartaruga": "Tartaruga",
 "Taxa de limpeza": "Costo delle pulizie",
 "Taxa de limpeza cobrada do hóspede": "Costo delle pulizie addebitato all'ospite",
 "Taxas e anúncios": "Commissioni e annunci",
 "Te amo": "Ti amo",
 "Tecnologia": "Tecnologia",
 "Tela cheia": "Schermo intero",
 "Teleconsulta": "Televisita",
 "Telefone": "Telefono",
 "Telefone da assistência": "Telefono dell'assistenza",
 "Telefone da empresa": "Telefono dell'azienda",
 "Telefone da escola": "Telefono della scuola",
 "Telefone da limpeza": "Telefono delle pulizie",
 "Telefone de emergência": "Telefono di emergenza",
 "Telefone do veterinário": "Telefono del veterinario",
 "Telhado": "Tetto",
 "Tem anexos": "Ha allegati",
 "Tem certeza?": "Sei sicuro?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "Hai {n} pagamento/i in ritardo per un totale di {v}. Paga prima quelli con gli interessi più alti, come la carta e lo scoperto.",
 "Tema": "Tema",
 "Tempo de preparo": "Tempo di preparazione",
 "Temporada": "Stagione",
 "Temporizador (direita)": "Timer (destra)",
 "Tenta consertar um PDF que não abre direito.": "Prova a riparare un PDF che non si apre bene.",
 "Tentar de novo": "Riprova",
 "Tente uma foto mais nítida, com a página inteira.": "Prova con una foto più nitida, con la pagina intera.",
 "Termina às {hora}": "Termina alle {hora}",
 "Terminar até": "Finire entro",
 "Terminei em": "Finito il",
 "Terminou": "Finito",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Terminato il {data}. Non è stato eliminato nulla: tutto torna com'era quando ti abboni.",
 "Termos de uso": "Termini di utilizzo",
 "Termos de uso e privacidade": "Termini di utilizzo e privacy",
 "Terror": "Horror",
 "Terça": "Martedì",
 "Testando...": "Test in corso...",
 "Testar alerta (1 minuto)": "Prova avviso (1 minuto)",
 "Testar aviso": "Prova notifica",
 "Teste de alerta do Planner": "Prova avviso del Planner",
 "Teste grátis até {data} ({n} dia(s))": "Prova gratuita fino al {data} ({n} giorno/i)",
 "Teste grátis: {n} dia(s)": "Prova gratuita: {n} giorno/i",
 "Teste terminado": "Prova terminata",
 "Teste terminou em {data}": "Prova terminata il {data}",
 "Teste: aviso feito pelo próprio celular.": "Prova: notifica generata dal telefono stesso.",
 "Texto": "Testo",
 "Texto completo": "Testo completo",
 "Texto copiado. Cole onde quiser enviar.": "Testo copiato. Incollalo dove vuoi inviarlo.",
 "Texto do documento": "Testo del documento",
 "Texto extra do convite (traje, presentes...)": "Testo aggiuntivo dell'invito (dress code, regali...)",
 "Texto livre": "Testo libero",
 "Texto ou recado": "Testo o avviso",
 "Texto para PDF": "Testo in PDF",
 "Texto {data}": "Testo {data}",
 "Tipo": "Tipo",
 "Tipo sanguíneo": "Gruppo sanguigno",
 "Tira as páginas que você não quer.": "Toglie le pagine che non vuoi.",
 "Tira autor, programas, comandos escondidos e anexos.": "Toglie autore, programmi, comandi nascosti e allegati.",
 "Tira comentários, destaques e desenhos de outros programas.": "Toglie commenti, evidenziazioni e disegni di altri programmi.",
 "Tira o texto do PDF (arquivo .txt).": "Estrae il testo dal PDF (file .txt).",
 "Tiradentes": "Tiradentes",
 "Tirar": "Rimuovi",
 "Tirar a assinatura": "Togli la firma",
 "Tirar a foto": "Rimuovi la foto",
 "Tirar a foto agora": "Scatta la foto ora",
 "Tirar admin": "Togli admin",
 "Tirar alarmes do My Planner": "Togli le sveglie da My Planner",
 "Tirar arquivos anexados": "Togli file allegati",
 "Tirar comentários, destaques e links": "Togli commenti, evidenziazioni e link",
 "Tirar da agenda": "Togli dall'agenda",
 "Tirar da barra": "Togli dalla barra",
 "Tirar daqui": "Togli da qui",
 "Tirar das minhas figurinhas?": "Togliere dai miei sticker?",
 "Tirar de administrador": "Rimuovi da amministratore",
 "Tirar do escritório": "Rimuovi dall'ufficio",
 "Tirar dos meus GIFs?": "Togliere dalle mie GIF?",
 "Tirar este copo": "Rimuovi questo bicchiere",
 "Tirar foto": "Scatta foto",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Fotografare boleti, scontrini e documenti e scegliere foto e video dalla galleria.",
 "Tirar o desenho padrão?": "Rimuovere la sequenza?",
 "Tirar o lixo": "Portare fuori la spazzatura",
 "Tire a foto e a sua IA preenche a ficha": "Scatta la foto e la tua IA compila la scheda",
 "Titular (de quem é o documento)": "Titolare (di chi è il documento)",
 "Titular: {nome}": "Titolare: {nome}",
 "Toalha de praia": "Telo mare",
 "Tocar os pés": "Toccare i piedi",
 "Toda a agenda": "Tutta l'agenda",
 "Toda semana": "Ogni settimana",
 "Todas": "Tutte",
 "Todas (passadas, esta e futuras)": "Tutte (passate, questa e future)",
 "Todas ({n})": "Tutte ({n})",
 "Todas as abas liberadas até {data}.": "Tutte le schede sbloccate fino al {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "Tutte le capitali. Seleziona una o più città.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "Tutti gli strumenti PDF: unisci, dividi, organizza, firma, timbro, oscuramento, numeri di pagina, moduli, comprimi, converti, OCR e IA. Salva sul cellulare, su Google Drive o su OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "Tutti gli strumenti sono nella schermata della scheda.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "Tutte le foto del viaggio sono qui: quelle che aggiungi all'album e quelle dell'itinerario, dei luoghi e delle prenotazioni.",
 "Todas as plantas estão regadas.": "Tutte le piante sono annaffiate.",
 "Todas as páginas, uma embaixo da outra.": "Tutte le pagine, una sotto l'altra.",
 "Todo ano": "Ogni anno",
 "Todo dia": "Ogni giorno",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Ogni giorno all'orario scelto: quante attività ha la giornata, la prima e l'energia totale.",
 "Todo mês": "Ogni mese",
 "Todo mês · dia {d}": "Ogni mese · giorno {d}",
 "Todo o histórico": "Tutto lo storico",
 "Todos": "Tutti",
 "Todos ({n})": "Tutti ({n})",
 "Todos do grupo": "Tutto il gruppo",
 "Todos do grupo veem": "Visibile a tutto il gruppo",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Tutti nella riunione vedono l'avviso \"Registrazione in corso\". Il file va nei Documenti dell'ufficio, visibile solo a te finché non lo rendi visibile al team.",
 "Todos os cuidados": "Tutte le cure",
 "Todos os dias": "Tutti i giorni",
 "Todos os suplementos": "Tutti gli integratori",
 "Todos os treinos": "Tutti gli allenamenti",
 "Todos os tribunais": "Tutti i tribunali",
 "Todos presentes": "Tutti presenti",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Tutti escono dal gruppo. Ciò che ognuno ha già accettato resta nella sua agenda.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Tutti lavorano sugli stessi dati, ognuno in base al ruolo. Tocca il ruolo di ogni persona in Membri per cambiarlo.",
 "Tomador": "Committente",
 "Tomador (quem contratou)": "Committente (chi ha contrattato)",
 "Tomadores": "Committenti",
 "Tomei": "Ho preso in prestito",
 "Toque aqui ou no + para criar uma tarefa": "Tocca qui o il + per creare un'attività",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Tocca \"Elimina il mio account e tutti i dati\" e conferma.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Tocca + › Nuova carta di credito e indica i giorni di chiusura e di scadenza.",
 "Toque em Ajustes e depois em Segurança.": "Tocca Impostazioni e poi Sicurezza.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Tocca Collega e, nella schermata di Apple, attiva le voci che My Planner può leggere.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Tocca Collega e, nella schermata di Health Connect, consenti a My Planner di leggere i dati.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Tocca chi NON deve vedere questa scheda (e il suo contenuto). Es.: il regalo a sorpresa.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Tocca una scheda per aprirla. Quelle bloccate mostrano come abbonarsi.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Tocca una scheda per aprirla. Ogni scheda extra si può provare gratis per 10 giorni.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Tocca una scheda per aprirla. Tocca 📌 per mettere o togliere la scheda dalla barra in basso. Ogni scheda extra si può provare gratis per 10 giorni.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Tocca un'area per aprirla. Quelle bloccate mostrano come abbonarsi.",
 "Toque no desenho para continuar desenhando.": "Tocca il disegno per continuare a disegnare.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Tocca ciò che questo gruppo condividerà. Tutto quello che contiene (itinerario, foto, prenotazioni...) viene incluso e tutti partecipano.",
 "Toque nos PDFs na ordem em que devem ficar.": "Tocca i PDF nell'ordine in cui devono stare.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Tocca un bicchiere per cambiare il volume; tieni premuto + per un bicchiere di altra misura.",
 "Toque num feriado para adicioná-lo ao Planner.": "Tocca una festività per aggiungerla al Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Tocca un movimento per cambiare categoria, salvare la ricevuta per l'IR o eliminarlo.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Tocca un movimento per cambiare la categoria. Tieni premuto per eliminarlo.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Tocca un profilo per modificarlo. Tieni premuto per rimuoverlo.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Tocca un testo, un disegno o una checklist e trascinalo in qualsiasi punto del foglio.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Tocca una pagina per ritagliarla, ruotarla o cambiare il filtro. Tieni premuto e trascina per cambiare l'ordine.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Tocca un'attività per copiarla o spostarla a oggi.",
 "Toque onde quer a checklist.": "Tocca dove vuoi la checklist.",
 "Toque onde quer escrever.": "Tocca dove vuoi scrivere.",
 "Toque para abrir": "Tocca per aprire",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Tocca per aprire nell'app del telefono. Scorri a destra per togliere dall'elenco.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Tocca per aprire, tieni premuto per rinominare. Scorri a sinistra per archiviare o a destra per eliminare.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Tocca per aprire. Scorri a destra per togliere dall'elenco.",
 "Toque para aceitar ou recusar.": "Tocca per accettare o rifiutare.",
 "Toque para aceitar, editar ou recusar.": "Tocca per accettare, modificare o rifiutare.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Tocca per applicarlo ora. Oppure si applica da solo alla riapertura dell'app.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Tocca per scaricare e installare sopra. I tuoi dati restano.",
 "Toque para conversar": "Tocca per chattare",
 "Toque para enviar o emoji animado": "Tocca per inviare l'emoji animata",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Tocca per inviare. Tieni premuto per salvare o togliere dai tuoi.",
 "Toque para escolher": "Tocca per scegliere",
 "Toque para fechar": "Tocca per chiudere",
 "Toque para gerar um novo QR Code": "Tocca per generare un nuovo QR Code",
 "Tornar admin": "Rendi admin",
 "Tornar administrador": "Rendi amministratore",
 "Tosa": "Tosatura",
 "Totais por alimento": "Totali per alimento",
 "Total": "Totale",
 "Total bruto": "Totale lordo",
 "Total das reservas: {v}": "Totale prenotazioni: {v}",
 "Total de aulas": "Totale lezioni",
 "Total de capítulos": "Totale capitoli",
 "Total de módulos": "Totale moduli",
 "Total de páginas": "Totale pagine",
 "Total de recibos: {v}": "Totale ricevute: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Totale: {n}. Ogni scheda può avere fino a {lim} di testo (foto e file non contano: restano sul dispositivo o nel tuo Drive).",
 "Total: {v}": "Totale: {v}",
 "Trabalhando...": "Elaborazione...",
 "Trabalho": "Lavoro",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Porta gli impegni del tuo Google Calendar in My Planner e modificali qui: le modifiche tornano nel calendario.",
 "Trans": "Trans",
 "Transferir: {s}": "Voltura: {s}",
 "Transferência": "Voltura",
 "Transferências": "Volture",
 "Transporte": "Trasporti",
 "Tratamento": "Trattamento",
 "Travar depois de preencher": "Blocca dopo la compilazione",
 "Trazer todas para hoje": "Porta tutte a oggi",
 "Trazer tudo para hoje?": "Portare tutto a oggi?",
 "Trecho ou ideia": "Passo o idea",
 "Treino": "Allenamento",
 "Trem ou ônibus": "Treno o autobus",
 "Treme": "Trema",
 "Tribunais": "Tribunali",
 "Trilha": "Escursionismo",
 "Triste": "Triste",
 "Triângulo": "Triangolo",
 "Troca de óleo": "Cambio olio",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Cambio olio, rotazione pneumatici, tagliandi per km, IPVA, immatricolazione e assicurazione.",
 "Trocador portátil": "Fasciatoio portatile",
 "Trocar": "Cambia",
 "Trocar a categoria": "Cambia categoria",
 "Trocar a foto": "Cambia la foto",
 "Trocar a pasta": "Cambia cartella",
 "Trocar a senha do cofre": "Cambia la password della cassaforte",
 "Trocar número": "Cambia numero",
 "Trocar o certificado": "Cambia certificato",
 "Trocar o código": "Cambia codice",
 "Trocar o código?": "Cambiare il codice?",
 "Trocar o desenho": "Cambia sequenza",
 "Trocar o emoji": "Cambia emoji",
 "Trocar o modelo": "Cambia modello",
 "Trocar o número": "Cambia il numero",
 "Trocar o número do celular": "Cambia il numero di cellulare",
 "Trocar por:": "Sostituisci con:",
 "Trocar roupa de cama e toalhas": "Cambiare lenzuola e asciugamani",
 "Tríceps na polia": "Push down tricipiti",
 "Tubo de ensaio": "Provetta",
 "Tudo": "Tutto",
 "Tudo certo": "Tutto a posto",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "Tutto in ordine qui. Registra le spese di tutti i giorni così vedo dove vanno i soldi.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "È già tutto salvato nel tuo account. Il file è una copia extra da conservare dove vuoi.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Tutto ciò che si trova in \"{nome}\" diventa visibile al gruppo, ognuno in base al ruolo che scegli (chi entra parte dal ruolo più limitato).",
 "Tudo! Já comprei os ingressos.": "Sì! Ho già comprato i biglietti.",
 "Turma": "Classe",
 "Turma (opcional)": "Classe (facoltativo)",
 "Turmas": "Classi",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Classi e gruppi (lezioni, mentoring, allenamento): alunni, appello, voti, piani, materiali, addebiti e il tuo quaderno.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Classi, alunni, appello, voti e piani di lezione.",
 "Turmas, pacientes, equipes e convidados": "Classi, pazienti, team e invitati",
 "Técnico": "Tecnico",
 "Título": "Titolo",
 "Título (ex.: Capítulo 3)": "Titolo (es.: Capitolo 3)",
 "Título (opcional)": "Titolo (facoltativo)",
 "Título da caixa": "Titolo del riquadro",
 "Título de eleitor": "Tessera elettorale",
 "Título, autor, assunto e palavras-chave.": "Titolo, autore, oggetto e parole chiave.",
 "Tô chegando": "Sto arrivando",
 "Tônico": "Tonico",
 "UF": "UF",
 "Uau": "Wow",
 "Uhuul!": "Evviva!",
 "Um PDF novo só com as páginas escolhidas.": "Un nuovo PDF solo con le pagine scelte.",
 "Um texto clarinho na diagonal de todas as páginas.": "Un testo leggero in diagonale su tutte le pagine.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "Una cartella per ogni cliente: vi scambiate documenti in entrambe le direzioni e ogni cliente vede solo la sua cartella.",
 "Uma página por arquivo": "Una pagina per file",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "Una pagina per file, ogni N pagine o per intervalli.",
 "Unicórnio": "Unicorno",
 "Unidade": "Unità",
 "Universal": "Universale",
 "União": "Unione",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Usa l'account Google già presente sul telefono. My Planner non chiede mai la password di Google.",
 "Usado: {u} · livre: {v} · limite {l}": "Usato: {u} · disponibile: {v} · plafond {l}",
 "Usar": "Usa",
 "Usar \"{nome}\"": "Usa \"{nome}\"",
 "Usar biometria": "Usa la biometria",
 "Usar desenho padrão": "Usa sequenza",
 "Usar este celular": "Usa questo telefono",
 "Usar este nome": "Usa questo nome",
 "Usar modelo: {m}": "Usa modello: {m}",
 "Usar no navegador (My Planner Web)": "Usa nel browser (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Usa il file già allegato ({nome})",
 "Usar o código": "Usa il codice",
 "Usar senha": "Usa la password",
 "Usar {ia}": "Usa {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Usa la nuova password al prossimo accesso, qui e su My Planner Web.",
 "Use a senha para desbloquear.": "Usa la password per sbloccare.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Usa la tua IA per leggere pubblicazioni, documenti e note e suggerire appuntamenti. Confermi sempre prima che qualcosa entri nel Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Usa questo codice quando crei il tuo account e ottieni 10 giorni con tutte le schede sbloccate.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Usa l'estratto conto in OFX (consigliato) o CSV, scaricato dall'app o dal sito della tua banca.",
 "Use o seu planner no computador, sincronizado com o celular.": "Usa il tuo planner sul computer, sincronizzato con il cellulare.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Usa un link https di Google Drive, Google Docs, OneDrive o SharePoint.",
 "Uso": "Utilizzo",
 "Uso próprio": "Uso personale",
 "VRBO": "VRBO",
 "Vacina": "Vaccino",
 "Vacina {nome}: {pet}": "Vaccino {nome}: {pet}",
 "Vacina: {nome}": "Vaccino: {nome}",
 "Vacinas": "Vaccini",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Vaccini e farmaci degli animali, toelettatura e la routine di scuola e salute dei bambini.",
 "Vai na viagem": "Partecipa al viaggio",
 "Vale até {d}": "Valido fino al {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "Vale per Studio e Documenti. Nel cloud, il file si apre su qualsiasi dispositivo e in My Planner Web (fino a 15 MB per file).",
 "Vale quantos pontos": "Quanti punti vale",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Vale solo per te. Al massimo un avviso ogni 3 minuti per persona, anche se aggiunge più cose.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Vale una volta, nei primi 30 giorni del tuo account.",
 "Validade": "Scadenza",
 "Validade do certificado A1": "Validità del certificato A1",
 "Validade: {data}": "Scadenza: {data}",
 "Valor": "Importo",
 "Valor ({m})": "Importo ({m})",
 "Valor a pagar": "Importo da pagare",
 "Valor combinado": "Importo concordato",
 "Valor combinado por atendimento": "Importo concordato per visita",
 "Valor da hora": "Tariffa oraria",
 "Valor da parcela (1ª)": "Importo della rata (1ª)",
 "Valor da venda": "Prezzo di vendita",
 "Valor de costume": "Importo abituale",
 "Valor do atendimento: {v}{pago}.": "Importo della prestazione: {v}{pago}.",
 "Valor emprestado ou financiado": "Importo prestato o finanziato",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Prezzo finale stabilito da Google Play o dall'App Store, già nella valuta del tuo paese.",
 "Valor maior que o guardado nesta meta.": "Importo superiore a quanto messo da parte in questo obiettivo.",
 "Valor padrão da consulta ou sessão": "Prezzo standard della visita o seduta",
 "Valor pago": "Importo pagato",
 "Valor pago (com multa ou desconto)": "Importo pagato (con mora o sconto)",
 "Valor pago (opcional)": "Importo pagato (facoltativo)",
 "Valor pago: {v}": "Importo pagato: {v}",
 "Valor que este aluno paga (se for diferente)": "Importo che paga questo alunno (se diverso)",
 "Valor recebido": "Importo ricevuto",
 "Valor recebido: {v}": "Importo ricevuto: {v}",
 "Valor total da compra": "Importo totale dell'acquisto",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Importi e dati clinici compaiono solo a chi ha un ruolo che lo consente. Puoi disattivarlo quando vuoi: i dati restano a te.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Importi da verificare con il tuo commercialista. Le regole sulle detrazioni cambiano ogni anno.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "Chattiamo su My Planner? Aggiungimi come amico con il codice {codigo} (scheda Messaggi > Amici).",
 "Vaso": "Vaso",
 "Veja os planos em Ajustes › Compras.": "Vedi i piani in Impostazioni › Acquisti.",
 "Vem da aba Empréstimos & Financiamentos": "Viene dalla scheda Prestiti & Finanziamenti",
 "Vence em {data}.": "Scade il {data}.",
 "Vence em {fim} (data informada na publicação).": "Scade il {fim} (data indicata nella pubblicazione).",
 "Vence em {n} dia(s)": "Scade tra {n} giorno/i",
 "Vence hoje": "Scade oggi",
 "Vence {data}": "Scade {data}",
 "Vencendo": "In scadenza",
 "Venceu há {n} dia(s)": "Scaduta da {n} giorno/i",
 "Vencidas": "Scadute",
 "Vencidos": "Scaduti",
 "Vencimento": "Scadenza",
 "Vencimento (guias e boletos)": "Scadenza (modelli di pagamento e bollettini)",
 "Vencimento da 1ª parcela": "Scadenza della 1ª rata",
 "Vencimentos": "Scadenze",
 "Venda": "Vendita",
 "Venda/serviço do MEI": "Vendita/servizio MEI",
 "Vendidos": "Venduti",
 "Ver": "Vedi",
 "Ver a lista de membros": "Vedere l'elenco dei membri",
 "Ver a rota": "Vedi il percorso",
 "Ver arquivos": "Vedi file",
 "Ver detalhes do erro": "Vedi dettagli dell'errore",
 "Ver e editar": "Visualizza e modifica",
 "Ver em Compras": "Vedi in Acquisti",
 "Ver mais": "Mostra altro",
 "Ver mais páginas": "Mostra altre pagine",
 "Ver no My Planner": "Vedi in My Planner",
 "Ver o dia": "Vedi il giorno",
 "Ver os feriados do ano": "Vedi le festività dell'anno",
 "Ver participantes": "Vedi partecipanti",
 "Ver páginas": "Vedi pagine",
 "Ver todos": "Vedi tutti",
 "Ver todos ({n})": "Vedi tutti ({n})",
 "Ver {nome}": "Vedi {nome}",
 "Verificar agora": "Controlla ora",
 "Vermífugo": "Vermifugo",
 "Vermífugo ou remédio": "Vermifugo o farmaco",
 "Vermífugos e remédios": "Vermifughi e farmaci",
 "Verso": "Retro",
 "Verso do documento": "Retro del documento",
 "Versão do PDF": "Versione PDF",
 "Versão instalada": "Versione installata",
 "Versão {versao} disponível": "Versione {versao} disponibile",
 "Versão {v}": "Versione {v}",
 "Veterinário": "Veterinario",
 "Veterinário ou clínica": "Veterinario o clinica",
 "Veículo": "Veicolo",
 "Veículo e acessórios": "Veicolo e accessori",
 "Veículos": "Veicoli",
 "Veículos & Manutenção": "Veicoli & Manutenzione",
 "Vi mais um episódio": "Ho visto un altro episodio",
 "Viagem": "Viaggio",
 "Viagens": "Viaggi",
 "Viagens & Lazer": "Viaggi & Svago",
 "Viagens e lugares": "Viaggi e luoghi",
 "Vida noturna": "Vita notturna",
 "Vidros e esquadrias": "Vetri e infissi",
 "Vigente": "In corso",
 "Vigentes": "In corso",
 "Virar": "Gira",
 "Virar a câmera": "Gira la fotocamera",
 "Virar tarefa (levar à assistência)": "Trasforma in attività (portare in assistenza)",
 "Visita domiciliar": "Visita a domicilio",
 "Visitados": "Visitati",
 "Visto": "Visto",
 "Vistoria": "Sopralluogo",
 "Vistoria: {i}": "Sopralluogo: {i}",
 "Vistorias": "Sopralluoghi",
 "Visualizar feriados": "Vedi festività",
 "Vitamina": "Vitamina",
 "Vitamina D": "Vitamina D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Vitamine, whey, creatina... ognuno con la sua frequenza. Quello di oggi compare in \"Oggi\" da spuntare.",
 "Você": "Tu",
 "Você aceitou os termos em {data}.": "Hai accettato i termini il {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "Non hai ancora amici nell'app. Aggiungili con il codice.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "Non hai ancora raccoglitori. Creane uno nella scheda Studio.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "Non vedrai più la chat, i documenti e le riunioni.",
 "Você deve: {v}": "Devi: {v}",
 "Você entrou no grupo": "Sei entrato nel gruppo",
 "Você entrou no grupo \"{nome}\".": "Sei entrato nel gruppo \"{nome}\".",
 "Você está convidado(a) para: {evento}": "Sei invitato/a a: {evento}",
 "Você foi convidado para o My Planner": "Sei stato invitato su My Planner",
 "Você foi convidado para o grupo": "Sei stato invitato nel gruppo",
 "Você juntou {v} para \"{m}\".": "Hai messo da parte {v} per \"{m}\".",
 "Você já tem todas as abas.": "Hai già tutte le schede.",
 "Você já usou um código de indicação nesta conta.": "Hai già usato un codice invito su questo account.",
 "Você ligou": "Hai chiamato",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "Puoi eliminare l'account in qualsiasi momento, dall'app del telefono o dal sito:",
 "Você não tem permissão para isso neste grupo.": "Non hai il permesso per farlo in questo gruppo.",
 "Você não vê os outros membros deste grupo.": "Non vedi gli altri membri di questo gruppo.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "Puoi eliminare l'account in qualsiasi momento in Impostazioni > Sicurezza. Così cancelli per sempre i dati nel cloud e sul dispositivo.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Puoi: sapere se trattiamo i tuoi dati, accedervi, correggerli, chiederne la portabilità (esporta il file in Impostazioni > Impostazioni generali), chiederne la cancellazione, sapere con chi li condividiamo, revocare il consenso e presentare reclamo all'ANPD.",
 "Você recebe (líquido)": "Ricevi (netto)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "Sei responsabile della tua password e di ciò che viene fatto sul tuo account. Usa dati veri nella registrazione.",
 "Volta": "Ritorno",
 "Volta ou check-out": "Ritorno o check-out",
 "Volta às {hora}": "Ritorno alle {hora}",
 "Voltar": "Indietro",
 "Voltar ao cardápio da semana neste dia": "Torna al menu della settimana in questo giorno",
 "Voltar ao cálculo": "Torna al calcolo",
 "Voltar ao foco": "Torna alla concentrazione",
 "Voltar ao padrão": "Ripristina predefinito",
 "Voltar ao planejado": "Torna al previsto",
 "Voltar para Anotações": "Torna a Note",
 "Voltar para as cores do My Planner": "Torna ai colori di My Planner",
 "Voltar para novas": "Torna alle nuove",
 "Voltar para o QR Code": "Torna al QR Code",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Torna all'app My Planner sul telefono. La schermata Impostazioni si aggiorna da sola.",
 "Voo": "Volo",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Voli, hotel, auto ed escursioni in un unico posto, con codice e ricevuta.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Vai in Impostazioni e tocca \"Collega browser\".",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Vai in Impostazioni › Impostazioni generali e tocca \"Collega browser\".",
 "Várias páginas por folha": "Più pagine per foglio",
 "Vários PDFs num só, na ordem que você escolher.": "Più PDF in uno, nell'ordine che scegli.",
 "Vê as aulas e os materiais liberados.": "Vede le lezioni e i materiali pubblicati.",
 "Vê as etapas e registra o diário.": "Vede le fasi e scrive nel diario.",
 "Vê e altera tudo, inclusive os valores.": "Vede e modifica tutto, compresi gli importi.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Vede e invia i documenti della propria cartella e risponde alle richieste.",
 "Vê o andamento, sem os valores e sem alterar.": "Vede l'avanzamento, senza importi e senza modificare.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Vede check-in e check-out e segna le pulizie fatte, senza importi.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Vede tutto e inserisce spese, luoghi, itinerario e bagaglio.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Vede tutto, aggiunge, modifica, commenta e carica foto. Solo non aggiunge né toglie persone dal gruppo.",
 "Vê tudo, inclusive os valores, sem alterar.": "Vede tutto, compresi gli importi, senza modificare.",
 "Vídeo": "Video",
 "Vínculo": "Collegamento",
 "Vínculo perdido": "Collegamento perso",
 "WhatsApp da assistência": "WhatsApp dell'assistenza",
 "Whey": "Whey",
 "Wi-Fi (rede e senha)": "Wi-Fi (rete e password)",
 "Yoga": "Yoga",
 "Zumbi e Consciência Negra": "Zumbi e Coscienza Nera",
 "Zzz": "Zzz",
 "a cada {n} dias": "ogni {n} giorni",
 "a pagar": "da pagare",
 "a receber": "da ricevere",
 "a receber {v}": "da ricevere {v}",
 "a reserva": "la prenotazione",
 "a última execução falhou; avise o suporte": "l’ultima esecuzione non è riuscita; avvisa l’assistenza",
 "abr": "apr",
 "abril": "aprile",
 "acabou": "finito",
 "achatado": "appiattito",
 "administra": "admin",
 "ago": "ago",
 "agosto": "agosto",
 "ajustado": "modificata",
 "algo novo": "qualcosa di nuovo",
 "alterou": "ha modificato",
 "amanhã": "domani",
 "anual": "annuale",
 "apagou": "ha eliminato",
 "aplicada em {d}": "somministrato il {d}",
 "app {v} · atualização {p} de {data}": "app {v} · aggiornamento {p} del {data}",
 "assinado": "firmato",
 "atrasada": "in ritardo",
 "atrasada há {n} dia(s)": "in ritardo di {n} giorno/i",
 "até": "fino a",
 "até {data}": "fino al {data}",
 "até {d}": "entro il {d}",
 "aula {a} de {n}": "lezione {a} di {n}",
 "avisos silenciados": "notifiche silenziate",
 "caixa": "riquadro",
 "colher(es)": "cucchiaio/i",
 "coluna": "colonna",
 "com anexos": "con allegati",
 "com imagem": "con immagine",
 "com tarjas": "oscurato",
 "com texto": "con testo",
 "com {p}": "presso {p}",
 "como planejado": "come previsto",
 "comprado em {data}": "acquistato il {data}",
 "comprado em {d} por {v}": "acquistato il {d} per {v}",
 "comprimido": "compresso",
 "comprovante": "ricevuta",
 "concha(s)": "mestolo/i",
 "confirmados": "confermati",
 "consulta recusada": "consultazione rifiutata",
 "contratado": "ingaggiato",
 "contínuo": "continuativo",
 "copo(s)": "bicchiere/i",
 "corridos": "di calendario",
 "criou o grupo": "ha creato il gruppo",
 "de": "di",
 "de Anotações": "da Note",
 "de {meta} passos": "di {meta} passi",
 "de {n}": "di {n}",
 "de {p}": "di {p}",
 "dentro / fora do planejado": "in / fuori programma",
 "desconto {v}": "sconto {v}",
 "desfazer": "annulla",
 "destino": "destinazione",
 "deve {v}": "deve {v}",
 "devolvido em {d}": "restituito il {d}",
 "dez": "dic",
 "dezembro": "dicembre",
 "dia": "giorno",
 "dias": "giorni",
 "dias com a meta batida": "giorni con obiettivo raggiunto",
 "dias com a meta de passos": "giorni con l’obiettivo di passi",
 "digital": "impronta digitale",
 "diária média": "prezzo medio a notte",
 "do cliente": "dal cliente",
 "do escritório": "dallo studio",
 "dom": "dom",
 "domingo": "domenica",
 "e mais {n}": "e altri {n}",
 "em aberto": "aperto",
 "em atraso": "in ritardo",
 "em {n} dias": "tra {n} giorni",
 "emitida": "emessa",
 "entregue": "consegnato",
 "entrou no escritório": "è entrato nell'ufficio",
 "enviado": "inviato",
 "escaneado": "scansionato",
 "escolha": "scegli",
 "este": "questo",
 "este dispositivo": "questo dispositivo",
 "este item": "questo elemento",
 "exercícios concluídos": "esercizi completati",
 "falta {v}": "mancano {v}",
 "faltam {km}": "mancano {km}",
 "fatia(s)": "fetta/e",
 "faturamento": "fatturato",
 "feita em {d}": "fatta il {d}",
 "feito {dur}": "fatto {dur}",
 "fev": "feb",
 "fevereiro": "febbraio",
 "frequência {p}%": "frequenza {p}%",
 "gasto {v}": "speso {v}",
 "girado": "ruotato",
 "guardado": "salvato",
 "higienizado": "pulito",
 "hoje": "oggi",
 "hora fixa no dia": "ora fissa del giorno",
 "há {n} dias": "{n} giorni fa",
 "iPhone ou computador: {link}": "iPhone o computer: {link}",
 "incluiu": "ha aggiunto",
 "jan": "gen",
 "janeiro": "gennaio",
 "jul": "lug",
 "julho": "luglio",
 "jun": "giu",
 "junho": "giugno",
 "já importado": "già importato",
 "liberar em {d}": "disponibile dal {d}",
 "ligou o compartilhamento": "ha attivato la condivisione",
 "linha": "riga",
 "lucro líquido": "utile netto",
 "mai": "mag",
 "maio": "maggio",
 "mar": "mar",
 "marca d'água": "filigrana",
 "marcada por {nome}": "fissata da {nome}",
 "março": "marzo",
 "menos de 1 ano": "meno di 1 anno",
 "mensalidade": "quota mensile",
 "meta batida!": "obiettivo raggiunto!",
 "metadados": "metadati",
 "min": "min",
 "min antes": "min prima",
 "min antes do início": "min prima dell'inizio",
 "min · {de} às {ate}": "min · dalle {de} alle {ate}",
 "multa e juros {v}": "mora e interessi {v}",
 "média {m}": "media {m}",
 "mês(es)": "mese/i",
 "na nuvem": "nel cloud",
 "na pasta \"{pasta}\"": "nella cartella \"{pasta}\"",
 "na pasta escolhida": "nella cartella scelta",
 "neste dispositivo": "su questo dispositivo",
 "neste celular": "su questo telefono",
 "no Planner": "nel Planner",
 "no {nome}": "su {nome}",
 "nos próximos dias": "nei prossimi giorni",
 "nov": "nov",
 "novembro": "novembre",
 "numerado": "numerato",
 "nunca verificado": "mai controllato",
 "não vão": "non vengono",
 "o documento mudou depois disso: guarde de novo": "il documento è cambiato da allora: salvalo di nuovo",
 "ocupação": "occupazione",
 "ontem": "ieri",
 "organizado": "organizzato",
 "orçando": "preventivo in corso",
 "out": "ott",
 "outubro": "ottobre",
 "paga": "pagata",
 "paga em {d}": "pagata il {d}",
 "pago": "pagato",
 "pago em {d}": "pagato il {d}",
 "pago por {p}": "pagato da {p}",
 "pagou {v}": "ha pagato {v}",
 "parcela {a} de {n}": "rata {a} di {n}",
 "parece já lançado": "sembra già registrato",
 "parte {n}": "parte {n}",
 "passos por dia (média)": "passi al giorno (media)",
 "passou {km}": "superati di {km}",
 "pausa {p}": "riposo {p}",
 "pausado": "in pausa",
 "peso {n}": "peso {n}",
 "pesquisável": "ricercabile",
 "por dia": "al giorno",
 "por dia (média)": "al giorno (media)",
 "por dia disponível": "per giorno disponibile",
 "por semana": "a settimana",
 "por {p}": "di {p}",
 "porção(ões)": "porzione/i",
 "preenchido": "compilato",
 "primeira às {hora}: {tarefa}": "prima alle {hora}: {tarefa}",
 "produção": "produzione",
 "próxima em {data}": "prossima il {data}",
 "próxima rega {d}": "prossima annaffiatura {d}",
 "publicação": "pubblicazione",
 "página de estudo": "pagina di studio",
 "página única": "pagina unica",
 "páginas": "pagine",
 "páginas {p}": "pagine {p}",
 "qua": "mer",
 "quarta": "mercoledì",
 "quarta-feira": "mercoledì",
 "qui": "gio",
 "quinta": "giovedì",
 "quinta-feira": "giovedì",
 "quitada": "saldata",
 "recebe {v}": "riceve {v}",
 "recebida": "ricevuta",
 "reconhecimento facial": "riconoscimento facciale",
 "recortado": "ritagliato",
 "refeições feitas": "pasti fatti",
 "rega a cada {n} dias": "annaffiare ogni {n} giorni",
 "regar hoje": "annaffiare oggi",
 "reparado": "riparato",
 "retorno {d}": "controllo {d}",
 "saldo {v}": "saldo {v}",
 "seg": "lun",
 "segunda": "lunedì",
 "segunda-feira": "lunedì",
 "sem anotações": "senza annotazioni",
 "sem as páginas {p}": "senza le pagine {p}",
 "sem cliente": "senza cliente",
 "sem dias previstos": "nessun giorno previsto",
 "sem horário": "senza orario",
 "sem meta": "nessun obiettivo",
 "sem resposta": "nessuna risposta",
 "sem tempo": "nessun tempo",
 "semana(s)": "settimana/e",
 "set": "set",
 "setembro": "settembre",
 "seu@email.com": "tu@email.com",
 "sex": "ven",
 "sexta": "venerdì",
 "sexta-feira": "venerdì",
 "sáb": "sab",
 "sábado": "sabato",
 "talvez": "forse",
 "tarefa da casa": "faccenda di casa",
 "tarefa: {t}": "attività: {t}",
 "taxas e despesas": "commissioni e spese",
 "ter": "mar",
 "termina em {d}": "finisce il {d}",
 "terça": "martedì",
 "terça-feira": "martedì",
 "teste": "test",
 "todas": "tutte",
 "todo ano em {d}": "ogni anno il {d}",
 "todo dia {d}": "ogni mese il giorno {d}",
 "todos": "tutti",
 "toque para abrir": "tocca per aprire",
 "toque para pausar": "tocca per mettere in pausa",
 "toque para ver o contato": "tocca per vedere il contatto",
 "toque para voltar a hoje": "tocca per tornare a oggi",
 "treinos concluídos": "allenamenti completati",
 "uma vez em {d}": "una volta il {d}",
 "unidade(s)": "unità",
 "vale {n}": "vale {n}",
 "vence em {n} dias": "scade tra {n} giorni",
 "vence {d}": "scade {d}",
 "venceu em {data}": "scaduta il {data}",
 "vencido": "scaduto",
 "vendido com ganho de {v}": "venduto con guadagno di {v}",
 "vendido com perda de {v}": "venduto con perdita di {v}",
 "verificado {quando}": "controllato {quando}",
 "você": "tu",
 "você administra": "sei admin",
 "xícara(s)": "tazza/e",
 "{aba} bloqueada": "{aba} bloccata",
 "{aba} está bloqueada": "{aba} è bloccata",
 "{aba}, em \"Anotações recebidas\"": "{aba}, in \"Note ricevute\"",
 "{a} aula(s) feita(s)": "{a} lezione/i fatte",
 "{a} de {n} aulas": "{a} di {n} lezioni",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} ha raggiunto il {p}% del budget ({g} di {l}).",
 "{c} confirmados de {n} convidados": "{c} confermati su {n} invitati",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} è al {p}% del budget del mese. Mancano ancora {dias} giorno/i alla fine del mese.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} è già {v} sopra l'intero mese scorso. Controlla se è stato qualcosa di insolito.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} ha già superato il budget: {g} di {l}. Frena questa spesa fino al nuovo mese.",
 "{c} passou do orçamento: {g} de {l}.": "{c} ha superato il budget: {g} di {l}.",
 "{de} paga {v} para {para}": "{de} paga {v} a {para}",
 "{de} às {ate}": "dalle {de} alle {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia} {d} {mes} {a}",
 "{dia}, {d} {mes}": "{dia} {d} {mes}",
 "{dia}, {d}/{m}": "{dia} {d}/{m}",
 "{dur} na semana": "{dur} nella settimana",
 "{dur} registrados": "{dur} registrati",
 "{d}/{n} notas": "{d}/{n} voti",
 "{feito} de {meta}": "{feito} di {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} su {n} fatte",
 "{f}/{n} transferências feitas": "{f}/{n} volture fatte",
 "{hora} em {fuso}": "{hora} a {fuso}",
 "{h} este mês": "{h} questo mese",
 "{h} h": "{h} h",
 "{h} h {m} min": "{h} h {m} min",
 "{h} no seu relógio": "{h} sul tuo orologio",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} collegato. {n} modello/i disponibile/i nel tuo account.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: chiave API non valida o senza autorizzazione.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: limite di utilizzo raggiunto. Controlla il saldo o il limite del tuo account API.",
 "{item}: em {n} dias ({data}).": "{item}: tra {n} giorni ({data}).",
 "{item}: hoje ({data}).": "{item}: oggi ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: scade tra {n} giorni ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: scade tra {n} giorni ({data}).",
 "{item}: vence hoje ({data}).": "{item}: scade oggi ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: è scaduto il {data} e non è ancora segnato come fatto.",
 "{livre} livres de {total}": "{livre} liberi su {total}",
 "{m} min": "{m} min",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} ora è tuo amico. Potete già chattare.",
 "{nome} conectado!": "{nome} connesso!",
 "{nome} ligou": "{nome} ha chiamato",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} nuove, {atualizadas} aggiornate, {enviadas} inviate, {removidas} rimosse",
 "{n} ITEM(NS)": "{n} ARTICOLO/I",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} scheda/e nel tuo piano · colori e opzioni di ognuna",
 "{n} aba(s) para comprar": "{n} scheda/e da acquistare",
 "{n} adicionada(s)": "{n} aggiunta/e",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} avviso/i programmato/i su questo cellulare per i prossimi giorni.",
 "{n} aluno(s)": "{n} alunno/i",
 "{n} anexo(s)": "{n} allegato/i",
 "{n} ano(s)": "{n} anno/i",
 "{n} arquivo(s)": "{n} file",
 "{n} atendimento(s)": "{n} visita/e",
 "{n} atrasada(s)": "{n} in ritardo",
 "{n} atrasado(s)": "{n} in ritardo",
 "{n} caixa(s)": "{n} scatola/e",
 "{n} caixa(s) frágil(eis)": "{n} scatola/e fragile/i",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} scatola/e · {a} già aperta/e nella casa nuova",
 "{n} cancelada(s).": "{n} annullata/e.",
 "{n} cartão(ões) abertos": "{n} card aperte",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{n} addebito/i creato/i con scadenza il {d}.",
 "{n} com vencimento": "{n} con scadenza",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} acquisto/i con la carta {c}. Le rate future compaiono già nei prossimi estratti.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} conto/i segnato/i come pagato/i automaticamente.",
 "{n} copo(s), {ml} de {meta}": "{n} bicchiere/i, {ml} su {meta}",
 "{n} de {meta} copos": "{n} di {meta} bicchieri",
 "{n} de {total}": "{n} di {total}",
 "{n} de {total} dias": "{n} su {total} giorni",
 "{n} de {total} hoje": "{n} su {total} oggi",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} di {t} articolo/i con prezzo, dagli scontrini letti in Finanza.",
 "{n} dia(s)": "{n} giorno/i",
 "{n} dia(s) seguido(s) lendo": "{n} giorno/i di lettura di fila",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "{n} giorno/i rimosso/i da attività ricorrenti",
 "{n} dias": "{n} giorni",
 "{n} dias grátis": "{n} giorni gratis",
 "{n} dias grátis para testar": "{n} giorni gratis per provare",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} giorni {tipo}: pubblicata il {pub}, conteggio dal {ini}, scade il {fim}.",
 "{n} documento(s)": "{n} documento/i",
 "{n} em atraso": "{n} in ritardo",
 "{n} etapa(s) atrasada(s)": "{n} fase/i in ritardo",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} eliminazione/i in attesa della sincronizzazione del telefono.",
 "{n} falta(s)": "{n} assenza/e",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "{n} scheda/e nel gruppo. Scegli il ruolo di ogni persona in Membri.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} foto e video del viaggio, di tutto il gruppo. Anche le foto dell'itinerario, dei luoghi e delle prenotazioni compaiono qui.",
 "{n} item(ns) adicionado(s).": "{n} elemento/i aggiunto/i.",
 "{n} item(ns) com outras pessoas": "{n} elemento/i prestati ad altri",
 "{n} item(ns) no Planner.": "{n} elemento/i nel Planner.",
 "{n} lançamento(s) encontrado(s)": "{n} movimento/i trovato/i",
 "{n} lançamento(s) novo(s).": "{n} nuovo/i movimento/i.",
 "{n} lembrete(s) colocado(s) no My Planner.": "{n} promemoria aggiunti a My Planner.",
 "{n} livro(s) lido(s) este ano": "{n} libro/i letto/i quest'anno",
 "{n} marcado(s)": "{n} selezionato/i",
 "{n} matéria(s)": "{n} materia/e",
 "{n} membro(s) · abrir a conversa do grupo": "{n} membro/i · apri la chat del gruppo",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} mesi gratis dalla creazione dell'account; poi {preco} all'anno.",
 "{n} min": "{n} min",
 "{n} min antes": "{n} min prima",
 "{n} módulo(s)": "{n} modulo/i",
 "{n} noite(s)": "{n} notte/i",
 "{n} nota(s) nova(s).": "{n} fattura/e nuova/e.",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "{n} fattura/e senza XML su questo dispositivo sono state escluse.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} fattura/e · emesse {e} · ricevute {r}",
 "{n} nova(s)": "{n} nuova/e",
 "{n} novo(s) do cliente": "{n} nuovo/i dal cliente",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} nuovo/i da accettare, modificare o rifiutare.",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} rata/e aggiunta/e al My Planner.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} rata/e aperta/e ricalcolata/e. Quelle pagate sono rimaste com'erano.",
 "{n} parcela(s) em atraso": "{n} rata/e in ritardo",
 "{n} parcela(s) em atraso: {v}": "{n} rata/e in ritardo: {v}",
 "{n} participantes · toque para ver": "{n} partecipanti · tocca per vedere",
 "{n} passo(s)": "{n} passaggio/i",
 "{n} pausa(s)": "{n} pausa/e",
 "{n} pedido(s) de amizade": "{n} richiesta/e di amicizia",
 "{n} pedido(s) em aberto": "{n} richiesta/e aperta/e",
 "{n} pessoa(s)": "{n} persona/e",
 "{n} pessoa(s) já entraram com o seu código.": "{n} persona/e sono entrate con il tuo codice.",
 "{n} pessoas": "{n} persone",
 "{n} por folha": "{n} per foglio",
 "{n} porções": "{n} porzioni",
 "{n} publicação(ões) nova(s).": "{n} nuova/e pubblicazione/i.",
 "{n} publicações novas": "{n} nuove pubblicazioni",
 "{n} página(s)": "{n} pagina/e",
 "{n} página(s) · {r} revisada(s)": "{n} pagina/e · {r} ripassata/e",
 "{n} páginas": "{n} pagine",
 "{n} recebido(s) dos seus grupos": "{n} ricevuto/i dai tuoi gruppi",
 "{n} recebido(s) para responder": "{n} ricevuto/i da rispondere",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} pasto/i, con il menu di quel giorno",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} prenotazione/i nuova/e o modificata/e.",
 "{n} resultado(s) em todas as publicações": "{n} risultato/i in tutte le pubblicazioni",
 "{n} selecionado(s): {lista}": "{n} selezionato/i: {lista}",
 "{n} tarefa(s)": "{n} attività",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} attività eliminata/e del tutto",
 "{n} tarefa(s) criada(s)": "{n} attività create",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} faccenda/e di casa sono uscite da My Planner e ora restano solo in La mia casa. Per portarne una nel Planner, apri l'attività e tocca \"Invia a My Planner\".",
 "{n} tarefa(s) de ontem sem concluir": "{n} attività di ieri non completata/e",
 "{n} tarefa(s) dos últimos dias sem concluir": "{n} attività degli ultimi giorni non completata/e",
 "{n} tarefa(s) hoje": "{n} attività oggi",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} attività in sospeso passano all'elenco di oggi.",
 "{n} tarjas no documento": "{n} bande nere nel documento",
 "{n} treino(s), cada um nos dias dele": "{n} allenamento/i, ognuno nei suoi giorni",
 "{n} tribunais": "{n} tribunali",
 "{n}x de {v}": "{n}x da {v}",
 "{n}º alerta": "{n}º avviso",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} caricato/i, {falhas} con errore. Riprova più tardi.",
 "{ok} enviado(s).": "{ok} caricato/i.",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} notti occupate su {d}. Le prenotazioni a cavallo di due mesi vengono divise per notti.",
 "{preco} por ano": "{preco} all'anno",
 "{p} de {t} parcelas pagas ({pct}%)": "{p} rate pagate su {t} ({pct}%)",
 "{p} presentes · {f} faltas": "{p} presenti · {f} assenti",
 "{p}% da meta de {m} páginas": "{p}% dell'obiettivo di {m} pagine",
 "{p}% feito": "{p}% fatto",
 "{p}% ocupado no mês": "{p}% occupato nel mese",
 "{p}% pronta": "{p}% completato",
 "{p}/{t} pagas": "{p}/{t} pagate",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} ti ha invitato nel gruppo \"{grupo}\" su My Planner. Tocca il link per entrare (l'app è gratuita per iniziare): {link}\nCodice di invito: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} e altri hanno aggiunto {n} elementi al gruppo.",
 "{quem} incluiu {item} no grupo.": "{quem} ha aggiunto {item} al gruppo.",
 "{servico} do veículo": "{servico} del veicolo",
 "{s} de {a}": "{s} di {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: torna alle {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (copia)",
 "{uso} usados de {total} reservados para o site": "{uso} usati su {total} riservati al sito",
 "{v} · atualização de {data}": "{v} · aggiornamento del {data}",
 "{v}/hora": "{v}/ora",
 "À direita": "A destra",
 "À vista": "In un'unica soluzione",
 "Às": "Alle",
 "Às {hora}": "Alle {hora}",
 "ÁGUA": "ACQUA",
 "Ácido": "Acido",
 "Água": "Acqua",
 "Água hoje": "Acqua oggi",
 "Área externa": "Esterno",
 "Áreas": "Aree",
 "Áudio": "Audio",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "È un supporto e non sostituisce il controllo delle notificazioni nei canali ufficiali. I termini vanno verificati nel sistema ufficiale.",
 "Ética Profissional": "Etica professionale",
 "Ícone e aba": "Icona e scheda",
 "Óculos de sol": "Occhiali da sole",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Ente di rilascio (es.: DETRAN-MS, Polizia Federale)",
 "Órgão emissor: {nome}": "Rilasciato da: {nome}",
 "Ômega 3": "Omega 3",
 "Última": "Ultima",
 "Última adubação": "Ultima concimazione",
 "Última aplicação": "Ultima somministrazione",
 "Última busca do servidor para você: {quando}": "Ultima ricerca del server per te: {quando}",
 "Última cópia de segurança: {data}": "Ultimo backup: {data}",
 "Última rega": "Ultima annaffiatura",
 "Última sincronização: {quando}": "Ultima sincronizzazione: {quando}",
 "Última: {data}": "Ultima: {data}",
 "Último dia para entregar a declaração do IR": "Ultimo giorno per presentare la dichiarazione IR",
 "Último erro: {m}": "Ultimo errore: {m}",
 "Últimos 30 dias": "Ultimi 30 giorni",
 "Últimos 7 dias": "Ultimi 7 giorni",
 "íris": "iride",
 "última vez em {data}": "ultima volta il {data}",
 "último em {d}": "ultima il {d}",
 "úteis": "lavorativi",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ è il colore di My Planner. La scelta vale per tutte le chat di questo dispositivo e del tuo account.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} ti sta chiamando (video)",
 "📆 Conectar a agenda deste celular": "📆 Collega il calendario di questo telefono",
 "📞 {nome} está ligando (áudio)": "📞 {nome} ti sta chiamando (audio)",
 "Link bloqueado por segurança.": "Link bloccato per sicurezza.",
 "Este arquivo não é uma imagem válida.": "Questo file non è un'immagine valida.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "La ricerca automatica del server segue i primi 5 profili. Gli altri vengono controllati quando tocchi \"Verifica ora\".",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "Questa schermata mostra la cronologia del viaggio, con le attività e i luoghi che hanno un giorno fissato. Per aggiungere o modificare le informazioni complete di un luogo, usa la scheda Luoghi.",
 "Para a viagem {d}": "Per il viaggio {d}",
 "sem nome": "senza nome",
 "Foi para a viagem {d}.": "Spostato nel viaggio {d}.",
 "Orçamento total (se não for detalhar)": "Budget totale (se non lo dettagli)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Organizza l'itinerario giorno per giorno. I luoghi con un giorno fissato compaiono qui da soli. Durante il viaggio, l'itinerario compare nella cronologia di My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Imposta giorno e ora nel luogo perché compaia da solo nell'Itinerario.",
 "No roteiro": "Nell'itinerario",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" è nell'itinerario del {data}. Per cambiare giorno o ora, modifica il luogo.",
 "Para o roteiro desta viagem": "Per l'itinerario di questo viaggio",
 "Orçamento e gastos": "Budget e spese",
 "Parada (cidade)": "Tappa (città)",
 "Item da categoria": "Voce della categoria",
 "Orçamento da viagem inteira": "Budget dell'intero viaggio",
 "Orçamento geral da viagem": "Budget generale del viaggio",
 "Previsto {p} · gasto {g}": "Previsto {p} · speso {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Qui ci sono i costi del viaggio che non riguardano una tappa (es.: biglietti, assicurazione). Ogni tappa ha il suo budget.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Indica quanto pensi di spendere in ogni categoria. Registrando le spese, l'app mostra quanto è già stato usato.",
 "Orçamento por parada": "Budget per tappa",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "Passi per più di una città? Aggiungi le tappe (scheda Tappe): ognuna ha il suo budget e le spese di quelle date vi finiscono da sole.",
 "Coloque o valor do gasto.": "Inserisci l'importo della spesa.",
 "Orçamento de {c}": "Budget di {c}",
 "Lançar um gasto nesta parada": "Registra una spesa in questa tappa",
 "Lançar gasto": "Registra spesa",
 "Orçamento e gastos da parada": "Budget e spese della tappa",
 "Gastos lançados ({n})": "Spese registrate ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "Per correggere o eliminare una spesa, usa la scheda Budget e spese del viaggio.",
 "Paradas": "Tappe",
 "Cidade ou lugar": "Città o luogo",
 "Ex.: Porto": "Es.: Porto",
 "Chegada": "Arrivo",
 "Saída": "Partenza",
 "Onde vai ficar": "Dove alloggerai",
 "gasto {g} de {p}": "speso {g} di {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "Passi per più di una città? Aggiungi ogni tappa con le date. Ognuna ha il suo budget (alloggio, pasti, trasporti...) e le spese di quelle date vi finiscono da sole.",
 "Café da tarde": "Merenda",
 "Outros / Lanches": "Altro / Spuntini",
 "Gasto {v}": "Speso {v}",
 "Gasto {g} de {p} · {a} acima": "Speso {g} di {p} · {a} oltre",
 "Gasto {g} de {p}": "Speso {g} di {p}",
 "Tirar \"{nome}\" do orçamento?": "Togliere \"{nome}\" dal budget?",
 "Os gastos já lançados nela continuam na lista de gastos.": "Le spese già registrate restano nell'elenco delle spese.",
 "Previsto para {nome}": "Previsto per {nome}",
 "Tirar {nome}": "Togli {nome}",
 "Nome do item (ex.: Jantar especial)": "Nome della voce (es.: Cena speciale)",
 "Adicionar item": "Aggiungi voce",
 "Detalhar em itens": "Dettaglia in voci",
 "Nova categoria (ex.: Seguro, Presentes)": "Nuova categoria (es.: Assicurazione, Regali)",
 "Voltar às categorias sugeridas?": "Tornare alle categorie suggerite?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "Gli importi previsti di questo elenco verranno cancellati. Le spese registrate restano.",
 "Voltar às categorias sugeridas": "Torna alle categorie suggerite",
 "Previsto": "Previsto",
 "Ainda pode gastar": "Puoi ancora spendere",
 "Passou do previsto": "Oltre il previsto",
 "Não foi possível buscar o câmbio": "Impossibile ottenere il cambio",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "Niente internet o la valuta {m} non è nella tabella. Modifica il viaggio e inserisci il cambio a mano.",
 "Câmbio de {m} ainda não definido": "Cambio di {m} non ancora impostato",
 "Câmbio de hoje": "Cambio di oggi",
 "Atualizado em {d}": "Aggiornato il {d}",
 "Valor em {m}": "Importo in {m}",
 "Moeda do destino": "Valuta della destinazione",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Cambio: quanto vale 1 della valuta di destinazione nella tua valuta",
 "Sem dia marcado": "Nessun giorno impostato",
 "Valor na moeda do destino": "Importo nella valuta di destinazione",
 "Tirar só desta lista ou excluir de vez?": "Togliere solo da questa lista o eliminare definitivamente?",
 "Excluir de vez": "Elimina definitivamente",
 "Relatório da viagem (PDF)": "Resoconto del viaggio (PDF)",
 "Planilha da viagem (Excel)": "Foglio del viaggio (Excel)",
 "Geral da viagem": "Viaggio intero",
 "Viagem {d}": "Viaggio {d}",
 "Quem vai: {p}": "Chi va: {p}",
 "Outros gastos": "Altre spese",
 "Orçamento · {n}": "Budget · {n}",
 "Código": "Codice",
 "Pagou": "Pagato da",
 "Permissão internacional para dirigir": "Patente di guida internazionale",
 "Vacina (certificado)": "Vaccino (certificato)",
 "Autorização de viagem de menor": "Autorizzazione al viaggio per minore",
 "Vence antes da volta": "Scade prima del ritorno",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Scade meno di 6 mesi dopo il ritorno (molti paesi non lo accettano)",
 "A lista básica já está aqui.": "La lista base è già qui.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} documento/i con scadenza che può ostacolare il viaggio",
 "Lista básica: passaporte de cada um e seguro viagem": "Lista base: passaporto di ciascuno e assicurazione di viaggio",
 "Lista básica: identidade de cada um": "Lista base: documento d'identità di ciascuno",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Inserisci la scadenza di ogni documento: l'app ti avvisa prima che scada e verifica che il passaporto sia valido per 6 mesi dopo il ritorno. Le foto dei documenti restano protette nella cassaforte.",
 "De quem": "Di chi",
 "Número (protegido no cofre)": "Numero (protetto nella cassaforte)",
 "Está em mãos": "Ce l'ho",
 "Válido até {d}": "Valido fino al {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Passaporto, visto, assicurazione di viaggio, vaccino, autorizzazione per minore... con scadenza e foto. Segna quando ce l'hai.",
 "acerto entre os viajantes (não entra no orçamento)": "rimborso tra viaggiatori (fuori budget)",
 "Só gastos": "Solo spese",
 "Acertos": "Rimborsi",
 "Marcar como pago?": "Segnare come pagato?",
 "{de} já pagou {v} para {para}?": "{de} ha già pagato {v} a {para}?",
 "Já pagou": "Già pagato",
 "Acerto: {de} pagou {para}": "Rimborso: {de} ha pagato {para}",
 "Conferir minhas assinaturas": "Controlla i miei abbonamenti",
 "Gerenciar ou cancelar assinaturas na loja": "Gestisci o annulla gli abbonamenti nello store",
 "Restaurar compras": "Ripristina acquisti",
 "Procurando...": "Ricerca...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} abbonamento/i trovato/i e sbloccato/i.",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Abbonamento annuale, si rinnova da solo. Annulla quando vuoi negli abbonamenti dello store, fino a 24 ore prima del rinnovo.",
 "Assinaturas da loja": "Abbonamenti dello store",
 "Gerenciar assinaturas (App Store)": "Gestisci abbonamenti (App Store)",
 "Gerenciar assinaturas (Google Play)": "Gestisci abbonamenti (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "L'abbonamento si fa nell'app del telefono (Google Play o App Store) e vale anche qui sul sito.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "Questo abbonamento non è ancora disponibile nello store. Riprova più tardi.",
 "Assinatura feita": "Abbonamento fatto",
 "Já assinei no celular: conferir": "Mi sono già abbonato sul telefono: controlla",
 "Nenhuma assinatura encontrada nesta conta da loja.": "Nessun abbonamento trovato in questo account dello store.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Controlla la connessione e riprova. Non è stato addebitato nulla.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} sbloccata. Vale anche sugli altri dispositivi e sul sito.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "Per abbonarti, aggiorna My Planner da Google Play o dall'App Store.",
 "Assinada, renova em {data}": "Abbonata, si rinnova il {data}",
 "Não deu para assinar agora": "Impossibile abbonarsi ora",
 "Assinar por {preco} por ano": "Abbonati a {preco} all'anno",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" è andato nella Bacheca, in Conquiste.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" fa ormai parte della tua routine. È andato nella Bacheca, in Conquiste.",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" è tornato al suo posto.",
 "1 ano": "1 anno",
 "1 mês": "1 mese",
 "A IA não achou o valor no comprovante.": "L'IA non ha trovato l'importo nella ricevuta.",
 "A cada {n} dias": "Ogni {n} giorni",
 "A carta está vazia": "La lettera è vuota",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "La lettera resta bloccata fino al {d}. Fino ad allora non puoi rileggerla né modificarla. Per cambiare qualcosa, scrivi un'altra lettera.",
 "A lixeira está vazia.": "Il cestino è vuoto.",
 "A mesma do app e do celular": "La stessa dell'app e del telefono",
 "A mesma forma de desbloqueio do app e do celular": "Lo stesso metodo di sblocco dell'app e del telefono",
 "A senha do diário precisa ter 6 caracteres ou mais.": "La password del diario deve avere almeno 6 caratteri.",
 "A senha precisa ter 6 caracteres ou mais.": "La password deve avere almeno 6 caratteri.",
 "A turma ainda não tem grupo": "La classe non ha ancora un gruppo",
 "AS 4 BOLINHAS DE COR": "I 4 PALLINI COLORATI",
 "Aberta em {d}": "Aperta il {d}",
 "Abra a aba para poder restaurar": "Apri la scheda per poter ripristinare",
 "Abra o diário primeiro": "Apri prima il diario",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "Si apre con la biometria, il riconoscimento facciale o la password dell'app. La password del diario viene chiesta solo la prima volta su ogni dispositivo.",
 "Abre em {d}": "Si apre il {d}",
 "Abrir carta para o futuro": "Apri lettera per il futuro",
 "Abrir em {aba}": "Apri in {aba}",
 "Abrir o Diário": "Apri il Diario",
 "Abrir o diário": "Apri il diario",
 "Abrir {aba}": "Apri {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Segue l'immobile, le prenotazioni, l'occupazione, le spese e il profitto, senza modificare nulla.",
 "Adicionar foto": "Aggiungi foto",
 "Apaga tudo o que está no quadro desta página.": "Cancella tutto ciò che c'è sulla lavagna di questa pagina.",
 "Apagar o desenho?": "Cancellare il disegno?",
 "Apagar o diário": "Elimina il diario",
 "Apagar para todos?": "Eliminare per tutti?",
 "Aplicar a todas as páginas desta matéria": "Applica a tutte le pagine di questa materia",
 "Aplicar a todas as páginas desta pasta": "Applica a tutte le pagine di questa cartella",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Dispense, esercizi, slide, video, link e avvisi. Da ⋮ › Invia alla classe, ogni alunno li riceve nella sua app.",
 "Aquarela": "Acquerello",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Qui appare, gratis, ciò che i gruppi hanno condiviso con te. Per usare la scheda con i tuoi dati, abbonati alla scheda.",
 "Arquivados": "Archiviati",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Trascina a destra per eliminare o a sinistra per archiviare.",
 "As cobranças desta aula extra já existem.": "Gli addebiti di questa lezione extra esistono già.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "I voti vanno solo a ciascun alunno. Per questo, il nome della persona nel gruppo deve essere uguale al nome dell'alunno o del responsabile in anagrafica.",
 "Atestado": "Certificato",
 "Atestados": "Certificati",
 "Até quando (opcional)": "Fino a quando (facoltativo)",
 "Até {d}": "Fino al {d}",
 "Aula extra": "Lezione extra",
 "Aula extra (fora dos dias de aula)": "Lezione extra (fuori dai giorni di lezione)",
 "Aula extra de {d}": "Lezione extra del {d}",
 "Avaliação de {d}": "Valutazione del {d}",
 "Avaliação salva": "Valutazione salvata",
 "Avançar": "Avanti",
 "Aviso da revisão do mês": "Avviso della revisione del mese",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Avviso l'ultimo giorno del mese: \"Che ne dici di rivedere il tuo mese? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Avviso senza alcun contenuto del diario: \"Com'è andata la tua giornata? ✍️\"",
 "Avulsa": "Singola",
 "Avulsas": "Singole",
 "Azul": "Blu",
 "Baixar na App Store": "Scarica su App Store",
 "Baixar na Google Play": "Scarica su Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Scarica My Planner dallo store: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Biometria, riconoscimento facciale o password dell'app. La password del diario resta salvata per la prima volta su ogni dispositivo.",
 "Branco": "Bianco",
 "Buscando o clima…": "Recupero del meteo…",
 "Básicas": "Base",
 "COMO ESTOU": "COME STO",
 "COMO O DIÁRIO ABRE": "COME SI APRE IL DIARIO",
 "COR DA FOLHA": "COLORE DEL FOGLIO",
 "Caixinha no My Planner": "Salvadanaio in My Planner",
 "Caixinha {m}": "Salvadanaio {m}",
 "Carta de {d}": "Lettera del {d}",
 "Carta guardada": "Lettera salvata",
 "Carta para o futuro": "Lettera per il futuro",
 "Carta trancada": "Lettera bloccata",
 "Cartas abertas podem ser lidas, mas não editadas.": "Le lettere aperte si possono leggere, ma non modificare.",
 "Cartas para o Futuro": "Lettere per il Futuro",
 "Cartões arquivados": "Carte archiviate",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "È arrivata una lettera da {nome} di {tempo} fa 💌",
 "Chegou! Toque para abrir 💌": "È arrivata! Tocca per aprirla 💌",
 "Cinza-escuro": "Grigio scuro",
 "Clara (segue o tema)": "Chiara (segue il tema)",
 "Claras e pastel (boas para folha escura)": "Chiari e pastello (adatti al foglio scuro)",
 "Clima (toque para preencher)": "Meteo (tocca per compilare)",
 "Clima automático": "Meteo automatico",
 "Clima do dia": "Meteo del giorno",
 "Cobrar a aula extra": "Addebita la lezione extra",
 "Cobrar a aula extra dos presentes": "Addebita la lezione extra ai presenti",
 "Cobrar a turma toda": "Addebita a tutta la classe",
 "Cole um link que comece com https://": "Incolla un link che inizi con https://",
 "Coloque o valor da aula extra na turma (Editar).": "Inserisci il costo della lezione extra nella classe (Modifica).",
 "Coloque o valor.": "Inserisci l'importo.",
 "Colunas": "Colonne",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "Con la tua IA attiva (Impostazioni › Intelligenza artificiale), l'app legge importo, data e descrizione dalla foto.",
 "Como cuidei de mim hoje?": "Come mi sono preso cura di me oggi?",
 "Como foi o seu dia? ✍️": "Com'è andata la tua giornata? ✍️",
 "Compartilhar este projeto (convidar)": "Condividi questo progetto (invita)",
 "Compartilhar o texto": "Condividi il testo",
 "Completa": "Completa",
 "Comprovante (foto, PDF ou print)": "Ricevuta (foto, PDF o screenshot)",
 "Comprovante anexado": "Ricevuta allegata",
 "Comprovante de pagamento (foto ou PDF)": "Ricevuta di pagamento (foto o PDF)",
 "Concluído: hábito formado": "Completato: abitudine formata",
 "Concluídos": "Completati",
 "Configurar o Diário": "Configura il Diario",
 "Confirmar pagamento": "Conferma pagamento",
 "Confirmar recebimento": "Conferma incasso",
 "Conquistas": "Conquiste",
 "Contas arquivadas": "Conti archiviati",
 "Continuar escrevendo": "Continua a scrivere",
 "Copiado ✓": "Copiato ✓",
 "Copiar código": "Copia codice",
 "Copiar link": "Copia link",
 "Cor atual": "Colore attuale",
 "Cor {n}": "Colore {n}",
 "Creme": "Crema",
 "Criada em {d}": "Creata il {d}",
 "Criar as cobranças": "Crea gli addebiti",
 "Criar o grupo da turma": "Crea il gruppo della classe",
 "Criar o meu diário": "Crea il mio diario",
 "Crie a senha do diário (6 ou mais)": "Crea la password del diario (6 o più)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Crea il gruppo della classe e invia l'invito agli alunni. Poi l'invio andrà direttamente a loro.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Crea il tuo primo traguardo, obiettivo o sogno con il pulsante + qui sotto.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Crea un progetto, invita chi partecipa e dividi i passaggi. Ognuno segna ciò che ha fatto.",
 "Crie uma senha nova para começar.": "Crea una nuova password per iniziare.",
 "Cuidados arquivados": "Cure archiviate",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Cure personali del giorno fatte (Benessere)",
 "Curto prazo": "Breve termine",
 "Custos": "Costi",
 "Céu estrelado": "Cielo stellato",
 "Círculo": "Cerchio",
 "Cômodos arquivados": "Stanze archiviate",
 "DIAS CUMPRIDOS": "GIORNI RISPETTATI",
 "Data (opcional)": "Data (facoltativa)",
 "De {d}": "Di {d}",
 "Desafixar do topo": "Rimuovi dall'alto",
 "Desenho mais fraco ou mais forte": "Disegno più tenue o più marcato",
 "Desfazer \"Concluído\" ({d})": "Annulla \"Completato\" ({d})",
 "Desligado": "Disattivato",
 "Desmarcar": "Deseleziona",
 "Desmarcar como paga?": "Segnare come non pagata?",
 "Desmarcar como recebida?": "Segnare come non incassata?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Deseleziona ciò che non usi: sparisce dallo schermo e rende la scheda più semplice. Puoi cambiarlo poi in Impostazioni › Schede › {aba} › Parti di questa scheda.",
 "Dias da semana": "Giorni della settimana",
 "Dias de aula": "Giorni di lezione",
 "Dias de aula: {d}": "Giorni di lezione: {d}",
 "Dias escritos": "Giorni scritti",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Suggerimento: disegna la forma a mano e tieni il dito fermo alla fine del tratto per renderla perfetta.",
 "Ditado": "Dettatura",
 "Ditar (falar para escrever)": "Detta (parla per scrivere)",
 "Diário apagado": "Diario eliminato",
 "Diário protegido": "Diario protetto",
 "Dom": "Dom",
 "Dê um nome a ele na pasta Hábitos.": "Dagli un nome nella cartella Abitudini.",
 "EVOLUÇÃO": "EVOLUZIONE",
 "Editada em {d}": "Modificata il {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "Si apre il {d} ({n} giorni). Fino ad allora non puoi rileggerla né modificarla.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "Si apre il {d}. Riceverai un avviso quel giorno.",
 "Ela fica guardada com a data de hoje para comparar depois.": "Resta salvata con la data di oggi per confrontarla più avanti.",
 "Enorme": "Enorme",
 "Enviado ao paciente": "Inviato al paziente",
 "Enviado em": "Inviato il",
 "Enviar \"{t}\" para todos do grupo {g}?": "Inviare \"{t}\" a tutti nel gruppo {g}?",
 "Enviar a nota para cada aluno": "Invia il voto a ciascun alunno",
 "Enviar as notas": "Invia i voti",
 "Enviar o arquivo: {nome}": "Invia il file: {nome}",
 "Enviar o recado para a turma": "Invia l'avviso alla classe",
 "Enviar o título para outra aba": "Invia il titolo a un'altra scheda",
 "Enviar para a turma": "Invia alla classe",
 "Enviar para outra aba": "Invia a un'altra scheda",
 "Escolha a cor desta bolinha": "Scegli il colore di questo pallino",
 "Escolha uma data no futuro": "Scegli una data futura",
 "Escolher qualquer cor": "Scegli un colore qualsiasi",
 "Esconder a barra": "Nascondi la barra",
 "Escreva a frase": "Scrivi la frase",
 "Escreva a que se refere a cobrança.": "Scrivi a cosa si riferisce l'addebito.",
 "Escreva alguma coisa antes de guardar.": "Scrivi qualcosa prima di salvare.",
 "Escreva alguma coisa antes de salvar.": "Scrivi qualcosa prima di salvare.",
 "Escreva hoje, abra no futuro": "Scrivi oggi, apri in futuro",
 "Escreva o que você quer mudar a partir de hoje": "Scrivi cosa vuoi cambiare da oggi",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Scrivi al te stesso del futuro. La lettera resta bloccata fino al giorno di apertura.",
 "Escrever uma carta": "Scrivi una lettera",
 "Escrita em {e} · abre em {a}": "Scritta il {e} · si apre il {a}",
 "Escuras (boas para folha clara)": "Scuri (adatti al foglio chiaro)",
 "Esperado": "Previsto",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Previsto: {e} · Fatto: {f} · Mancante: {fa}",
 "Esqueceu a senha do diário?": "Hai dimenticato la password del diario?",
 "Esqueci a senha do diário": "Ho dimenticato la password del diario",
 "Esta semana": "Questa settimana",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "Questa registrazione proviene da un'altra parte dell'app e non si elimina qui.",
 "Estudo: {h}": "Studio: {h}",
 "Esvaziar": "Svuota",
 "Esvaziar a lixeira": "Svuota il cestino",
 "Esvaziar a lixeira?": "Svuotare il cestino?",
 "Ex.: Comer uma fruta por dia": "Es.: Mangiare un frutto al giorno",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "Es.: Compiti per casa, Certificato di 2 giorni",
 "Ex.: Reservar a pousada": "Es.: Prenotare la pensione",
 "Ex.: Viagem em família, juntar para a festa": "Es.: Viaggio in famiglia, risparmiare per la festa",
 "Excluir de vez?": "Eliminare definitivamente?",
 "Excluir esta avaliação?": "Eliminare questa valutazione?",
 "Excluir este bloco?": "Eliminare questo blocco?",
 "Excluir este desenho?": "Eliminare questo disegno?",
 "Excluir este item?": "Eliminare questo elemento?",
 "Excluir {n} item(ns)?": "Eliminare {n} elemento/i?",
 "Exportar como imagem": "Esporta come immagine",
 "Exportar em PDF": "Esporta in PDF",
 "FOTOS": "FOTO",
 "FRASE DO DIA": "FRASE DEL GIORNO",
 "FREQUÊNCIA": "FREQUENZA",
 "Falta o valor": "Manca l'importo",
 "Feriado": "Festivo",
 "Feriado: {f}": "Festivo: {f}",
 "Fica 30 dias na lixeira.": "Resta 30 giorni nel cestino.",
 "Ficam 30 dias na lixeira.": "Restano 30 giorni nel cestino.",
 "Fichários arquivados": "Raccoglitori archiviati",
 "Fixar no topo": "Fissa in alto",
 "Floral": "Floreale",
 "Folha": "Foglio",
 "Folha, tema e cores das páginas com escrita": "Foglio, tema e colori delle pagine di scrittura",
 "Folhas e plantas": "Foglie e piante",
 "Foto adicionada": "Foto aggiunta",
 "Foto do sonho": "Foto del sogno",
 "Fotos do dia": "Foto del giorno",
 "Frase": "Frase",
 "Frase do dia (aparece no topo do Meu Dia)": "Frase del giorno (appare in cima a La mia giornata)",
 "Frases, textos, vídeos e fotos que motivam": "Frasi, testi, video e foto che motivano",
 "Geométrico": "Geometrico",
 "Gerar": "Genera",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Registrare promemoria e note a voce e dettare testi (🎤) quando lo chiedi. Il microfono si attiva solo con un tuo tocco e l'audio della dettatura non viene salvato.",
 "Guardar e trancar": "Salva e blocca",
 "Guardar e trancar?": "Salvare e bloccare?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Conserva qui ciò che ti motiva: frasi, tuoi testi, video e foto.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Conserva bene questa password: senza di essa il diario non può essere recuperato.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Oggi è festivo: {f}. Registrare comunque?",
 "Humor do mês": "Umore del mese",
 "Humor do período": "Umore del periodo",
 "HÁBITOS LIGADOS": "ABITUDINI COLLEGATE",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "Ci sono elementi grandi nella selezione. Si possono eliminare solo uno alla volta, con conferma e password.",
 "Há um ano": "Un anno fa",
 "Há um mês": "Un mese fa",
 "Hábito": "Abitudine",
 "Hábito criado": "Abitudine creata",
 "Hábitos": "Abitudini",
 "Hábitos cumpridos": "Abitudini rispettate",
 "Hábitos cumpridos: {f} de {n}": "Abitudini rispettate: {f} di {n}",
 "Hábitos formados": "Abitudini formate",
 "INSPIRAÇÃO": "ISPIRAZIONE",
 "Imagem adicionada": "Immagine aggiunta",
 "Imagem não encontrada": "Immagine non trovata",
 "Incrível": "Fantastico",
 "Informação nutricional": "Informazioni nutrizionali",
 "Inserir": "Inserisci",
 "Inspiração": "Ispirazione",
 "Item para o paciente": "Elemento per il paziente",
 "Itens grandes só se excluem um por um.": "Gli elementi grandi si eliminano solo uno alla volta.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Raccogli foto di ciò che vuoi vivere. Tieni premuto e trascina per organizzare.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "COLLEGA A UN SOGNO DEL PROGETTO DI VITA (FACOLTATIVO)",
 "LIGAR A UMA META (OPCIONAL)": "COLLEGA A UN TRAGUARDO (FACOLTATIVO)",
 "LINKS DE VÍDEO": "LINK VIDEO",
 "Lance as notas antes de enviar.": "Inserisci i voti prima di inviare.",
 "Lançamentos arquivados": "Registrazioni archiviate",
 "Legenda (opcional)": "Didascalia (facoltativa)",
 "Lembrete diário": "Promemoria giornaliero",
 "Lendo o comprovante...": "Lettura della ricevuta...",
 "Ler o comprovante com a minha IA": "Leggi la ricevuta con la mia IA",
 "Ligado": "Attivato",
 "Ligar um texto de motivação (Inspiração)": "Collega un testo motivazionale (Ispirazione)",
 "Lilás": "Lilla",
 "Limpar a folha inteira?": "Pulire tutto il foglio?",
 "Linha reta": "Linea retta",
 "Linhas": "Righe",
 "Link do vídeo (YouTube, Instagram...)": "Link del video (YouTube, Instagram...)",
 "Lisa": "Bianca",
 "Liste os passos do projeto e diga quem faz cada um.": "Elenca i passaggi del progetto e indica chi fa ciascuno.",
 "Lixeira": "Cestino",
 "Longo prazo": "Lungo termine",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "SEGNA IN AUTOMATICO DA BENESSERE (FACOLTATIVO)",
 "META OU SONHO LIGADO (OPCIONAL)": "TRAGUARDO O SOGNO COLLEGATO (FACOLTATIVO)",
 "Mais opções": "Altre opzioni",
 "Mal": "Male",
 "Mandar ao paciente pelo WhatsApp": "Invia al paziente via WhatsApp",
 "Marque o que fez em cada dia": "Segna cosa hai fatto ogni giorno",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Segna i giorni di lezione nella classe (Modifica) perché l'appello mostri solo quei giorni.",
 "Matérias arquivadas": "Materie archiviate",
 "Mensalidade": "Quota mensile",
 "Meta de água do Bem-Estar": "Obiettivo d'acqua di Benessere",
 "Metas arquivadas": "Traguardi archiviati",
 "Metas e sonhos concluídos": "Traguardi e sogni completati",
 "Metas em andamento": "Traguardi in corso",
 "Metas que avançaram": "Traguardi che sono avanzati",
 "Metas, objetivos e sonhos, com passos e prazos": "Traguardi, obiettivi e sogni, con passaggi e scadenze",
 "Meu Dia": "La mia giornata",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "La mia giornata con pagina libera, progetto di vita, abitudini, bacheca dei sogni, ruota della vita, lettere per il futuro e conquiste. Protetto da password.",
 "Minimalista": "Minimalista",
 "Mostrar as contas antes do vencimento": "Mostra i conti prima della scadenza",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Mostrare date, orari, valuta e festività corretti per dove ti trovi. La posizione approssimativa del telefono viene usata solo quando chiedi il meteo del giorno nel Diario e non viene salvata.",
 "Muito bem": "Molto bene",
 "Muito mal": "Molto male",
 "Mural de fotos dos seus sonhos": "Bacheca di foto dei tuoi sogni",
 "Mural, relatório e revisão do mês": "Bacheca, report e revisione del mese",
 "Médio prazo": "Medio termine",
 "N dias cumpridos no mês": "N giorni rispettati nel mese",
 "N dias seguidos": "N giorni di fila",
 "NESTE DIA": "IN QUESTO GIORNO",
 "Nada a enviar": "Niente da inviare",
 "Nenhum estudo registrado nesta semana.": "Nessuno studio registrato questa settimana.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "Ancora nessuna abitudine. Es.: \"Mangiare un frutto al giorno\", \"Bere 2 L d'acqua\", \"Non saltare la colazione\".",
 "Nenhum no período.": "Nessuno nel periodo.",
 "Nenhuma": "Nessuna",
 "Nenhuma carta ainda.": "Ancora nessuna lettera.",
 "Nenhuma foto ainda.": "Ancora nessuna foto.",
 "Neutras e opacas": "Neutri e opachi",
 "Ninguém encontrado no grupo": "Nessuno trovato nel gruppo",
 "No computador: {link}": "Sul computer: {link}",
 "No navegador, a senha do diário é pedida sempre.": "Nel browser la password del diario viene chiesta sempre.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "L'ultimo giorno del mese: \"Che ne dici di rivedere il tuo mese? ✨\"",
 "Nome da página (opcional)": "Nome della pagina (facoltativo)",
 "Nome de quem faz este passo": "Nome di chi fa questo passaggio",
 "Nome do vídeo (opcional)": "Nome del video (facoltativo)",
 "Normal": "Normale",
 "Nota de 0 a 10 para cada área da vida": "Voto da 0 a 10 per ogni area della vita",
 "Nota: {a}": "Voto: {a}",
 "Nova caixa": "Nuovo riquadro",
 "Nova carta": "Nuova lettera",
 "Nova meta, objetivo ou sonho": "Nuovo traguardo, obiettivo o sogno",
 "Nova senha (6 caracteres ou mais)": "Nuova password (6 o più caratteri)",
 "Nova área (ex.: Espiritualidade)": "Nuova area (es.: Spiritualità)",
 "Novo cômodo": "Nuova stanza",
 "Novo hábito": "Nuova abitudine",
 "Não dá para excluir em grupo": "Non si può eliminare in gruppo",
 "Não enviados": "Non inviati",
 "Não estão no grupo (ou com outro nome): {l}": "Non sono nel gruppo (o hanno un altro nome): {l}",
 "Não foi possível exportar": "Impossibile esportare",
 "Não foi possível ouvir agora ({erro}).": "Impossibile ascoltare ora ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "Non chiede la password del diario. È l'unica parte che si può condividere.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "Non è un giorno di lezione di questa classe. L'appello resta come recupero o lezione extra.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "L'app avvisa {n} giorno/i prima e il giorno della scadenza, alle 9. Puoi cambiarlo in Impostazioni › Schede › Finanza.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "Il meteo automatico usa la posizione del telefono. Senza permesso, resta da compilare qui.",
 "O conteúdo desta carta não foi encontrado.": "Il contenuto di questa lettera non è stato trovato.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "La dettatura arriva con la nuova versione dell'app. Aggiorna My Planner dallo store (o installa il nuovo APK) per usare il microfono.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "Il diario chiede la password ogni volta che entri, anche con l'app sbloccata.",
 "O diário só abre com essa senha, sempre.": "Il diario si apre solo con questa password, sempre.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "Il diario è crittografato: senza la password nessuno può aprirlo, nemmeno l'assistenza. Se vuoi, puoi eliminare il diario e iniziarne uno nuovo (i Progetti di gruppo restano).",
 "O que aprendi hoje?": "Cosa ho imparato oggi?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "Cosa ti ha insegnato questo mese? Cosa vuoi portare nel prossimo?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "Ciò che resta deselezionato sparisce dallo schermo. I dati restano salvati.",
 "O que foi bom hoje?": "Cosa è andato bene oggi?",
 "O que foi excluído nos últimos 30 dias": "Ciò che è stato eliminato negli ultimi 30 giorni",
 "O que quero melhorar amanhã?": "Cosa voglio migliorare domani?",
 "O que quero mudar agora": "Cosa voglio cambiare adesso",
 "O que você escreveu nesta carta vai se perder.": "Ciò che hai scritto in questa lettera andrà perso.",
 "O que você quer fazer com o arquivo?": "Cosa vuoi fare con il file?",
 "Objetivo": "Obiettivo",
 "Oculta": "Nascosta",
 "Orientação": "Indicazione",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Indicazioni, ricette, certificati e materiali da consegnare al paziente, con file. Viene inviato solo ciò che è qui: la cartella clinica non esce mai da questa cartella.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "I giorni con una pagina scritta restano segnati. Tocca un giorno per aprirlo.",
 "Os itens saem de vez e não podem mais ser restaurados.": "Gli elementi vengono eliminati definitivamente e non si possono più ripristinare.",
 "Outra data": "Altra data",
 "Outras moedas": "Altre valute",
 "Ouvindo…": "In ascolto…",
 "PASSOS": "PASSAGGI",
 "PDF com seus dados e assinatura": "PDF con i tuoi dati e la firma",
 "POR DIA": "PER GIORNO",
 "POR MATÉRIA": "PER MATERIA",
 "PROGRESSO": "PROGRESSI",
 "Paciente: {nome}": "Paziente: {nome}",
 "Para o paciente": "Per il paziente",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "Per cambiare il metodo di apertura, entra nel Diario con la sua password e torna qui.",
 "Para {nome} de {tempo} depois": "Per {nome} di {tempo} dopo",
 "Parar o ditado": "Ferma la dettatura",
 "Parcelado": "Rateizzato",
 "Partes desta aba": "Parti di questa scheda",
 "Passo": "Passaggio",
 "Pastas arquivadas": "Cartelle archiviate",
 "Pastas arquivadas ({n})": "Cartelle archiviate ({n})",
 "Pautada": "A righe",
 "Pautada com margem": "A righe con margine",
 "Pedido de exame": "Richiesta di esami",
 "Pelo que sou grata hoje?": "Per cosa sono grata oggi?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Consenti il microfono e il riconoscimento vocale per My Planner nelle impostazioni del telefono.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Personalizza: tipo, colore e tema del foglio e colori dei pallini, solo per questa scheda",
 "Pontilhada": "Puntinata",
 "Posto": "Distributore",
 "Preenche o clima do Meu Dia pela localização do celular.": "Compila il meteo de La mia giornata con la posizione del telefono.",
 "Preencher pela foto do comprovante": "Compila dalla foto della ricevuta",
 "Primeira vez neste aparelho: digite a senha do diário.": "Prima volta su questo dispositivo: inserisci la password del diario.",
 "Projeto": "Progetto",
 "Projeto de Vida": "Progetto di Vita",
 "Projetos com amigos e família (compartilhados)": "Progetti con amici e famiglia (condivisi)",
 "Projetos em Grupo": "Progetti di gruppo",
 "Proprietário / Locador": "Proprietario / Locatore",
 "Páginas arquivadas": "Pagine archiviate",
 "Páginas desta aba": "Pagine di questa scheda",
 "QUANDO ELA ABRE": "QUANDO SI APRE",
 "Qua": "Mer",
 "Quadriculada": "A quadretti",
 "Quadro dos Sonhos": "Bacheca dei Sogni",
 "Quais partes você vai usar?": "Quali parti userai?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "Quando completi un traguardo o formi un'abitudine, appare qui per festeggiare. 🎉",
 "Quanto você pagou?": "Quanto hai pagato?",
 "Quanto você recebeu?": "Quanto hai ricevuto?",
 "Que tal revisar o seu mês? ✨": "Che ne dici di rivedere il tuo mese? ✨",
 "Quem faz": "Chi lo fa",
 "Quem fez o meu dia melhor?": "Chi ha reso migliore la mia giornata?",
 "Quer guardar o comprovante agora?": "Vuoi salvare la ricevuta adesso?",
 "Qui": "Gio",
 "REFLEXÃO DO MÊS": "RIFLESSIONE DEL MESE",
 "Recebeu {v} a mais": "Hai ricevuto {v} in più",
 "Recebeu {v} a menos": "Hai ricevuto {v} in meno",
 "Receita médica": "Ricetta medica",
 "Receitas médicas": "Ricette mediche",
 "Recolher": "Comprimi",
 "Refeições arquivadas": "Pasti archiviati",
 "Refeições do cronograma feitas (Bem-Estar)": "Pasti del piano fatti (Benessere)",
 "Referente a (ex.: material, passeio, inscrição)": "Riferito a (es.: materiale, gita, iscrizione)",
 "Registrar": "Registra",
 "Relacionamentos": "Relazioni",
 "Relatório de estudos": "Report degli studi",
 "Relatório de realizações": "Report dei risultati",
 "Relatório em PDF": "Report in PDF",
 "Renomear, adicionar ou tirar áreas": "Rinomina, aggiungi o rimuovi aree",
 "Reposição": "Recupero",
 "Restaurado": "Ripristinato",
 "Resumida": "Riassunta",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Riassunta: solo una riga con il totale. Completa: mostra gli elementi del giorno. Nascosta: non appare. Niente di questa scheda diventa un'attività da solo.",
 "Resumo de {nome}": "Riepilogo di {nome}",
 "Resumo do dia": "Riepilogo del giorno",
 "Retângulo": "Rettangolo",
 "Revisar antes": "Rivedi prima",
 "Revisão do mês": "Revisione del mese",
 "Roda da Vida": "Ruota della Vita",
 "Rosa": "Rosa",
 "Sair sem guardar?": "Uscire senza salvare?",
 "Salvar avaliação de hoje": "Salva la valutazione di oggi",
 "Salvar ou enviar": "Salva o invia",
 "Seg": "Lun",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Tieni premuto e trascina le cartelle per cambiare l'ordine. Trascina a sinistra per archiviare.",
 "Sem chamada neste dia: cobra todos os alunos.": "Nessun appello in questo giorno: addebita a tutti gli alunni.",
 "Sem ideia do que escrever? Toque numa pergunta:": "Non sai cosa scrivere? Tocca una domanda:",
 "Sem registros de humor.": "Nessuna registrazione dell'umore.",
 "Sem tema": "Nessun tema",
 "Semana de {d}": "Settimana del {d}",
 "Senha atual do diário": "Password attuale del diario",
 "Senha do diário": "Password del diario",
 "Senha do diário incorreta.": "Password del diario errata.",
 "Senha do diário trocada": "Password del diario cambiata",
 "Senha própria só do diário": "Password propria solo per il diario",
 "Sequência dos hábitos": "Serie delle abitudini",
 "Seta": "Freccia",
 "Seu diário, só seu": "Il tuo diario, solo tuo",
 "Seu texto de motivação": "Il tuo testo motivazionale",
 "Sex": "Ven",
 "Sonho": "Sogno",
 "Suplementos arquivados": "Integratori archiviati",
 "Sáb": "Sab",
 "Só abre com a senha do diário.": "Si apre solo con la password del diario.",
 "TEMA DECORATIVO": "TEMA DECORATIVO",
 "TIPO DE FOLHA": "TIPO DI FOGLIO",
 "Tarefas arquivadas": "Attività archiviate",
 "Ter": "Mar",
 "Texto para o paciente": "Testo per il paziente",
 "Tipo, cor e tema da folha": "Tipo, colore e tema del foglio",
 "Tirar a área \"{a}\"?": "Rimuovere l'area \"{a}\"?",
 "Tirar da frase do dia": "Rimuovi dalla frase del giorno",
 "Tirar do arquivo": "Togli dall'archivio",
 "Tirar esta foto do quadro?": "Rimuovere questa foto dalla bacheca?",
 "Tirar esta pergunta?": "Rimuovere questa domanda?",
 "Tirar este vídeo?": "Rimuovere questo video?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Ogni giorno alle {h}: \"Com'è andata la tua giornata? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "Tutti gli alunni hanno già un addebito con questo riferimento.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Tocca di nuovo per \"Altro\" (esonerato, certificato...): non conta né come assenza né come lezione.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Tocca il cerchio per segnare ciò che hai fatto oggi. Le abitudini non vanno in My Planner da sole: usa Invia, nel menu ⋮.",
 "Toque num dia para marcar ou desmarcar.": "Tocca un giorno per segnarlo o deselezionarlo.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Tocca un pallino per cambiarne il colore. Nella pagina, tenere premuto il pallino fa lo stesso.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Tocca per aprire. Trascina a sinistra per archiviare o duplicare, o a destra per eliminare.",
 "Treino do dia feito (Bem-Estar)": "Allenamento del giorno fatto (Benessere)",
 "Treinos arquivados": "Allenamenti archiviati",
 "Trocar a senha do diário": "Cambia la password del diario",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Tutto ciò che scrivi nel diario viene crittografato su questo dispositivo prima di andare sul tuo account. Nessun altro può leggerlo, nemmeno l'assistenza.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Tutto ciò che elimini resta qui per 30 giorni. Dopo viene eliminato definitivamente.",
 "Título (ex.: Ter uma boa alimentação)": "Titolo (es.: Mangiare in modo sano)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "Un addebito singolo per ciascuno dei {n} alunno/i. Per addebitare un solo alunno, tocca +.",
 "Uma senha própria, só do diário": "Una password propria, solo per il diario",
 "Usar a senha do diário": "Usa la password del diario",
 "Usar como frase do dia": "Usa come frase del giorno",
 "Usar este valor": "Usa questo importo",
 "Usar o padrão do app": "Usa l'impostazione predefinita dell'app",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "Vale per gli importi di tutte le schede (Finanza, affitto, quote mensili...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "Vale per tutte le pagine di scrittura (Studio, Note, Diario, Documenti...). Ogni scheda può avere la propria impostazione in Impostazioni › Schede, e ogni pagina può cambiare il foglio da ⋮ › Foglio.",
 "Valor da aula extra (por aluno)": "Costo della lezione extra (per alunno)",
 "Valor por aluno": "Importo per alunno",
 "Valor previsto: {v}": "Importo previsto: {v}",
 "Vencimento: {d}": "Scadenza: {d}",
 "Ver o comprovante": "Vedi la ricevuta",
 "Verde": "Verde",
 "Visualizar": "Anteprima",
 "Você está como convidado": "Sei un ospite",
 "Voltar a acompanhar este hábito": "Torna a seguire questa abitudine",
 "Voltar ao início da folha": "Torna all'inizio del foglio",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Torna all'impostazione iniziale (foglio a righe; nero, blu, rosso e verde)",
 "Voltar para a nova avaliação": "Torna alla nuova valutazione",
 "Vídeos": "Video",
 "X vezes por semana": "X volte a settimana",
 "abre em {n} dias": "si apre tra {n} giorni",
 "agradável": "piacevole",
 "arquivo": "file",
 "aula extra": "lezione extra",
 "calor": "caldo",
 "chuva": "pioggia",
 "concluído": "completato",
 "céu limpo": "cielo sereno",
 "de {n} planejados": "su {n} pianificati",
 "dentro de {p}": "entro {p}",
 "enviado em {d}": "inviato il {d}",
 "estudados na semana": "studiati nella settimana",
 "excluído em {d}": "eliminato il {d}",
 "falta 1 dia": "manca 1 giorno",
 "faltam {n} dias": "mancano {n} giorni",
 "feito {dur} na semana": "fatto {dur} nella settimana",
 "fresco": "fresco",
 "frio": "freddo",
 "garoa": "pioggerella",
 "hoje não está planejado": "oggi non è pianificato",
 "hábito formado ✨": "abitudine formata ✨",
 "incorreta": "errata",
 "neblina": "nebbia",
 "neve": "neve",
 "nublado": "nuvoloso",
 "não enviado": "non inviato",
 "parcela {k}/{n}": "rata {k}/{n}",
 "passou há {n} dias": "scaduto da {n} giorni",
 "pelo Bem-Estar": "da Benessere",
 "poucas nuvens": "poco nuvoloso",
 "reposição": "recupero",
 "sai de vez em {n} dia(s)": "eliminato definitivamente tra {n} giorno/i",
 "sem registros": "nessuna registrazione",
 "tempestade": "temporale",
 "tracejado: {d}": "tratteggiato: {d}",
 "ver mais": "mostra di più",
 "ver menos": "mostra di meno",
 "{aluno}: {n} de {max}": "{aluno}: {n} su {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "Il {d} è festivo: {f}. Registrare comunque?",
 "{f} de {n} passos feitos": "{f} di {n} passaggi fatti",
 "{f}/{n} passos": "{f}/{n} passaggi",
 "{nome} daqui a 1 ano": "{nome} tra 1 anno",
 "{nome} daqui a 10 anos": "{nome} tra 10 anni",
 "{nome} daqui a 6 meses": "{nome} tra 6 mesi",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} alunno/i ricevono solo il proprio voto di \"{a}\".",
 "{n} aluno(s) receberam a nota.": "{n} alunno/i hanno ricevuto il voto.",
 "{n} aluno(s) · {v} cada": "{n} alunno/i · {v} ciascuno",
 "{n} anos": "{n} anni",
 "{n} dia(s) antes": "{n} giorno/i prima",
 "{n} dia(s) cumprido(s) no mês": "{n} giorno/i rispettato/i nel mese",
 "{n} dia(s) registrado(s) · média {e}": "{n} giorno/i registrato/i · media {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} giorno/i registrato/i, media {m} su 6",
 "{n} dia(s) seguido(s)": "{n} giorno/i di fila",
 "{n} dispensada(s) hoje": "{n} esonerato/i oggi",
 "{n} meses": "{n} mesi",
 "{n} outro(s)": "{n} altro/i",
 "{n} selecionado(s)": "{n} selezionato/i",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} attività completata/e in My Planner",
 "{n} vez(es) por semana": "{n} volta/e a settimana",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Acqua: {a} di {m} ml",
 "ÚLTIMAS 8 SEMANAS": "ULTIME 8 SETTIMANE",
 "Última parcela em {d}": "Ultima rata il {d}",
 "é hoje!": "è oggi!",
 "A mesma do app": "Uguale a quella dell'app",
 "Abrir com o código": "Apri con il codice",
 "Ainda não criado": "Non ancora creato",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "Alla creazione, l'app mostra un codice di recupero da conservare.",
 "Apagar o diário e começar de novo": "Elimina il diario e ricomincia",
 "Biometria ou código do dispositivo": "Biometria o codice del dispositivo",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Biometria, PIN del dispositivo o password dell'app. Non serve creare un'altra password.",
 "Bloquear o app": "Blocca l'app",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Registra impronta, volto o un codice di blocco sul dispositivo per usarla.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "Con la biometria attiva, appare per prima. Se non riesce, la stessa finestra offre il codice/PIN/sequenza del dispositivo; la password dell'app resta valida.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "Con esso recuperi il diario se dimentichi la password o cambi dispositivo.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "Con questo codice recuperi il diario se dimentichi la password o cambi dispositivo. Conservalo in un luogo sicuro e non mostrarlo a nessuno.",
 "Como funciona a Roda da Vida": "Come funziona la Ruota della Vita",
 "Como o diário abre": "Come si apre il diario",
 "Crie a senha que vai abrir o diário.": "Crea la password che aprirà il diario.",
 "Crie o PIN do diário (4 a 6 números)": "Crea il PIN del diario (da 4 a 6 cifre)",
 "Crie o diário de novo para começar.": "Crea di nuovo il diario per iniziare.",
 "Código aceito. Crie uma senha nova para o diário.": "Codice accettato. Crea una nuova password per il diario.",
 "Código de recuperação": "Codice di recupero",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Codice di recupero (es.: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Codice di recupero errato.",
 "Cômodos": "Stanze",
 "Depois de 1 minuto": "Dopo 1 minuto",
 "Depois de {n} minutos": "Dopo {n} minuti",
 "Desenhe o padrão do diário": "Disegna la sequenza del diario",
 "Dias no mês": "Giorni nel mese",
 "Dias seguidos": "Giorni consecutivi",
 "Digite o seu PIN": "Inserisci il tuo PIN",
 "Diário ainda não criado": "Diario non ancora creato",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Dai un voto da 0 a 10 a come ti senti oggi in ogni area della vita. Il disegno mostra dove la tua vita è equilibrata e dove ha bisogno di attenzione. Salva la valutazione e ripetila di tanto in tanto (per esempio, ogni mese) per confrontare e vedere i tuoi progressi. Puoi rinominare, aggiungere o togliere aree.",
 "Entre na aba Diário para criar o seu diário.": "Vai nella scheda Diario per creare il tuo diario.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Entra nel Diario (con la sua password o lo sblocco dell'app) e torna qui.",
 "Esconder a senha": "Nascondi la password",
 "Gerar novo código": "Genera nuovo codice",
 "Gerar um código de recuperação novo?": "Generare un nuovo codice di recupero?",
 "Guarde este código": "Conserva questo codice",
 "Já guardei": "L'ho già salvato",
 "Ligar um hábito que já existe": "Collega un'abitudine esistente",
 "Mostrar a senha": "Mostra la password",
 "Mudar como o diário abre": "Cambia come si apre il diario",
 "My Planner · Código de recuperação do Diário": "My Planner · Codice di recupero del Diario",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "Impossibile aprire con la chiave di questo dispositivo. Usa la password del diario o il codice di recupero.",
 "O Caps Lock parece estar ligado.": "Il Bloc Maiusc sembra attivo.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "Il PIN resta salvato solo su questo dispositivo, protetto. La password resta valida se dimentichi il PIN.",
 "O PIN precisa ter de 4 a 6 números.": "Il PIN deve avere da 4 a 6 cifre.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "Il codice precedente non sarà più valido. Per sicurezza, il codice non viene salvato nell'app: puoi vederlo solo nel momento in cui viene generato.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "Il codice non viene salvato in nessun luogo visibile all'assistenza. Senza password e senza codice, il diario non può essere recuperato.",
 "O diário agora abre só com a senha dele.": "Ora il diario si apre solo con la sua password.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "Il riconoscimento del volto di questo dispositivo non può essere usato dalle app. Usa l'impronta o il codice/PIN del dispositivo.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "Il tempo parte dal momento in cui l'app esce dallo schermo (altra app, schermata Home o schermo spento). Abbassare le notifiche, la finestra della biometria, una richiesta di autorizzazione o scegliere una foto o un file non contano.",
 "Os PINs não conferem.": "I PIN non coincidono.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (da 4 a 6 cifre)",
 "PIN (só números, 4 a 6)": "PIN (solo numeri, da 4 a 6)",
 "PIN do diário": "PIN del diario",
 "PIN incorreto": "PIN errato",
 "PIN salvo.": "PIN salvato.",
 "Padrão do app": "Predefinito dell'app",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "Per eliminare, conferma con la password dell'app, la biometria o il PIN del dispositivo. Verranno eliminati La mia giornata, obiettivi, abitudini, lettere e foto del diario. I Progetti di gruppo restano.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "Per continuare, inserisci la password dell'app o usa la biometria/il codice del dispositivo.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "Per recuperare il diario se dimentichi la password o cambi dispositivo.",
 "Pastas": "Cartelle",
 "Pedir a senha de novo": "Richiedi di nuovo la password",
 "Personalizada": "Personalizzata",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "Prima volta su questo dispositivo: inserisci la password del diario o usa il codice di recupero.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "Prima volta su questo dispositivo: inserisci il codice di recupero del diario.",
 "Reconhecimento de rosto": "Riconoscimento del volto",
 "Repita o PIN": "Ripeti il PIN",
 "Salvar a senha nova": "Salva la nuova password",
 "Salvar em arquivo / no Drive": "Salva in un file / su Drive",
 "Salvar o código de recuperação": "Salva il codice di recupero",
 "Senha (letras e números)": "Password (lettere e numeri)",
 "Senha do app": "Password dell'app",
 "Senha nova do diário": "Nuova password del diario",
 "Senha própria": "Password propria",
 "Senha própria do diário": "Password propria del diario",
 "Tarefas": "Attività",
 "Trocar o PIN": "Cambia il PIN",
 "Usar a senha": "Usa la password",
 "Usar o PIN": "Usa il PIN",
 "Usar o código de recuperação": "Usa il codice di recupero",
 "Usar o desbloqueio do app": "Usa lo sblocco dell'app",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Usa la biometria o il codice/PIN/sequenza del dispositivo.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Usa il codice di recupero che è apparso quando è stato creato il diario. Senza password e senza codice, nessuno può aprire il diario, nemmeno l'assistenza.",
 "Voltar a usar só a senha?": "Tornare a usare solo la password?",
 "incorreto": "errato",
 "1 h": "1 h",
 "12 horas (2:30 PM)": "12 ore (2:30 PM)",
 "15 min": "15 min",
 "24 horas (14:30)": "24 ore (14:30)",
 "30 min": "30 min",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Il cestino contiene elementi grandi. Conferma con la password dell'app, la biometria o il codice del dispositivo.",
 "A semana começa na": "La settimana inizia di",
 "Abra o Diário primeiro": "Apri prima il Diario",
 "Abrir configurações do celular": "Apri le impostazioni del telefono",
 "Agenda e mapas": "Calendario e mappe",
 "Agora: {m}": "Ora: {m}",
 "Ajuda e sobre": "Aiuto e info",
 "Alarme (som)": "Allarme (suono)",
 "Alarme ou vibração das pausas": "Allarme o vibrazione delle pause",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Elimina per sempre l'account e tutti i dati nel cloud e su questo dispositivo. Prima chiede la tua password.",
 "Apagar todas ({n})": "Elimina tutte ({n})",
 "Apagar {n} selecionada(s)": "Elimina {n} selezionata/e",
 "Aparência": "Aspetto",
 "App das rotas": "App per i percorsi",
 "Ardósia": "Ardesia",
 "Arrastar para a direita": "Scorri verso destra",
 "Arrastar para a esquerda": "Scorri verso sinistra",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "I conti di Finanza compaiono in My Planner con questo anticipo.",
 "Atualizações e sobre": "Aggiornamenti e info",
 "Avisar antes do vencimento": "Avvisa prima della scadenza",
 "Aviso marcado": "Avviso impostato",
 "Aviso no começo e no fim de cada pausa": "Avviso all'inizio e alla fine di ogni pausa",
 "Avisos desta aba": "Avvisi di questa scheda",
 "Avisos e alarmes": "Avvisi e allarmi",
 "Avisos silenciosos": "Avvisi silenziosi",
 "Avisos: som e vibração": "Avvisi: suono e vibrazione",
 "Avisos: só som": "Avvisi: solo suono",
 "Avisos: só vibração": "Avvisi: solo vibrazione",
 "Azul elétrico": "Blu elettrico",
 "Azul-aço": "Blu acciaio",
 "Azul-bebê": "Azzurro baby",
 "Azul-marinho": "Blu navy",
 "Baixar meus dados": "Scarica i miei dati",
 "Baixar todos os meus dados": "Scarica tutti i miei dati",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Scarica tutti i miei dati ed elimina l'account (LGPD)",
 "Biometria": "Biometria",
 "Bissexual": "Bisessuale",
 "Brilhante": "Brillante",
 "Buscar abas": "Cerca schede",
 "Buscar nos ajustes": "Cerca nelle impostazioni",
 "Cancelar aviso": "Annulla avviso",
 "Cinza-chumbo": "Grigio piombo",
 "Cofre": "Cassaforte",
 "Coloque pelo menos uma matéria.": "Aggiungi almeno una materia.",
 "Como usar": "Come si usa",
 "Conexões": "Connessioni",
 "Cor da aba": "Colore della scheda",
 "Cor de destaque": "Colore principale",
 "Crie uma matéria primeiro": "Crea prima una materia",
 "Cítrico": "Agrumi",
 "Cópia de segurança em arquivo": "Backup su file",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Dati dei pazienti e cartelle cliniche. Conferma con la password dell'app, la biometria o il codice del dispositivo.",
 "Desligadas": "Disattivate",
 "Digite a senha da sua conta para confirmar.": "Inserisci la password del tuo account per confermare.",
 "Duração padrão de uma tarefa nova": "Durata predefinita di una nuova attività",
 "Editar sessão": "Modifica sessione",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "Si ripete senza data di fine: compaiono le occorrenze fino al {data}. Se le selezioni tutte, viene rimossa l'intera attività.",
 "Em atividade": "In corso",
 "Em pausa": "In pausa",
 "Emoji da pausa": "Emoji della pausa",
 "Encerrar": "Termina",
 "Encerrar a sessão?": "Terminare la sessione?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Entra in modalità selezione, per scegliere più elementi alla volta.",
 "Escolha um horário no futuro.": "Scegli un orario nel futuro.",
 "Escolher a matéria": "Scegli la materia",
 "Esconde os valores em dinheiro (R$ •••)": "Nasconde gli importi in denaro (R$ •••)",
 "Esconder o CPF": "Nascondi il CPF",
 "Esconder os valores": "Nascondi gli importi",
 "Esta e as próximas": "Questa e le successive",
 "Esta tarefa se repete. Onde aplicar a mudança?": "Questa attività si ripete. Dove applicare la modifica?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Questo elemento contiene molte cose. Conferma con la password dell'app, la biometria o il codice del dispositivo.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Elimina l'elemento (chiede conferma). Poi puoi annullare o ripristinarlo dal Cestino.",
 "Excluir minha conta": "Elimina il mio account",
 "Ficha protegida": "Scheda protetta",
 "Formato da hora": "Formato dell'ora",
 "Foto do Quadro dos Sonhos": "Foto della Bacheca dei Sogni",
 "Geral": "Generale",
 "Gestos": "Gesti",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive e file di backup",
 "Grafite": "Grafite",
 "Guardar em": "Salva in",
 "Hábito do Diário": "Abitudine del Diario",
 "Idioma e moeda": "Lingua e valuta",
 "Inspiração do Diário": "Ispirazione del Diario",
 "Intenso": "Intenso",
 "Item arquivado": "Elemento archiviato",
 "Item excluído": "Elemento eliminato",
 "Lavanda": "Lavanda",
 "Ligadas": "Attivate",
 "Limite de energia": "Limite di energia",
 "Lésbica": "Lesbica",
 "Marque as vezes que vão ser apagadas.": "Seleziona le occorrenze da eliminare.",
 "Matéria": "Materia",
 "Me avise em…": "Avvisami tra…",
 "Menta": "Menta",
 "Menu ⋮": "Menu ⋮",
 "Meta do Diário": "Obiettivo del Diario",
 "Modo discreto": "Modalità discreta",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Imposta la sessione una volta (materie, tempo di ciascuna e pause) e ripetila negli altri giorni toccando Avvia. Il tempo di studio viene conteggiato da solo nell'obiettivo.",
 "Mostra Arquivar e Duplicar.": "Mostra Archivia e Duplica.",
 "Mostrar feriados no topo": "Mostra le festività in alto",
 "Mostrar os valores": "Mostra gli importi",
 "Muda a ordem dos itens.": "Cambia l'ordine degli elementi.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Cambia solo il colore di My Planner. Il colore principale dell'app è in Impostazioni > Aspetto. Ogni attività può avere un colore proprio nella sua scheda.",
 "Nada encontrado nos ajustes.": "Nessun risultato nelle impostazioni.",
 "Nenhuma sessão salva ainda.": "Ancora nessuna sessione salvata.",
 "Neon": "Neon",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "In questa fascia oraria l'app non suona né vibra. Gli avvisi continuano ad arrivare, in silenzio.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "Nel menu ⋮ di qualsiasi elemento: il telefono ti avvisa all'ora scelta, senza creare un'attività in My Planner.",
 "Nome (ex.: Sessão do mestrado)": "Nome (es.: Sessione del master)",
 "Nova sessão": "Nuova sessione",
 "Nuvem e cópias de segurança": "Cloud e backup",
 "Não perturbe": "Non disturbare",
 "Não perturbe {de}–{ate}": "Non disturbare {de}–{ate}",
 "Não-binário": "Non binario",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "Il pulsante 🎉 Festività in alto in My Planner. Il paese e l'elenco delle festività sono in Impostazioni > Festività.",
 "O celular avisa às {h}.": "Il telefono ti avviserà alle {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "Ciò che esce dal Diario resta cifrato nel cestino. Entra nel Diario e poi torna qui per ripristinarlo.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "Ciò che viene rimosso resta nel Cestino per 30 giorni. Inserisci la password del tuo account per confermare.",
 "O que saiu fica na Lixeira por 30 dias.": "Ciò che è stato rimosso resta nel Cestino per 30 giorni.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "Il tema cambia i colori delle schede, il colore principale e una leggera sfumatura nello sfondo, in modalità chiara e scura. Per cambiare il colore di una sola scheda, vai in Impostazioni > Schede.",
 "O tempo estudado até agora entra na meta.": "Il tempo di studio finora viene conteggiato nell'obiettivo.",
 "Oliva": "Oliva",
 "Orgulho": "Orgoglio",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Gli avvisi funzionano nell'app installata, con le notifiche attive.",
 "Os gestos do app": "I gesti dell'app",
 "Outro (escolher a hora)": "Altro (scegli l'ora)",
 "Pansexual": "Pansessuale",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "Per attivarlo, usa l'app sul telefono (Impostazioni › Calendario e mappe › Google Calendar). Dopo, tutto compare anche qui.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "Per non doverlo più chiedere, scegli l'app in Impostazioni › Calendario e mappe.",
 "Pausa": "Pausa",
 "Petróleo": "Blu petrolio",
 "Pink elétrico": "Rosa elettrico",
 "Preto total": "Nero assoluto",
 "Progresso": "Progresso",
 "Pêssego": "Pesca",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "Quanti giorni prima compaiono i conti si imposta in Impostazioni > Avvisi e allarmi.",
 "Rosa-chá": "Rosa antico",
 "Roxo-profundo": "Viola intenso",
 "Segurança e dados": "Sicurezza e dati",
 "Segurar e arrastar": "Tieni premuto e trascina",
 "Segurar e soltar": "Tieni premuto e rilascia",
 "Selecionar todas": "Seleziona tutte",
 "Semana começa na {dia}": "La settimana inizia di {dia}",
 "Sessão de estudo": "Sessione di studio",
 "Sessão encerrada": "Sessione terminata",
 "Sessão pausada": "Sessione in pausa",
 "Som e vibração": "Suono e vibrazione",
 "Suave": "Tenue",
 "Só esta semana": "Solo questa settimana",
 "Só hoje": "Solo oggi",
 "Só neste dia ({data})": "Solo in questo giorno ({data})",
 "Tamanho das caixas": "Dimensione dei riquadri",
 "Tamanho do texto": "Dimensione del testo",
 "Tarefa nova": "Nuova attività",
 "Tela inicial": "Schermata iniziale",
 "Tema e cor de destaque": "Tema e colore principale",
 "Testar alerta": "Prova avviso",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Prova avviso, \"Non disturbare\" e le impostazioni del telefono sono in Impostazioni > Avvisi e allarmi.",
 "Testar e conferir": "Prova e verifica",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "Tutte le opzioni dell'elemento: modifica, sposta, condividi, archivia, elimina...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Tocca un colore del tema {tema} da usare nei pulsanti, nel pulsante + e nell'elemento selezionato.",
 "Total: {dur}": "Totale: {dur}",
 "Tropical": "Tropicale",
 "Turquesa": "Turchese",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "Un file con tutti i tuoi dati di My Planner, da conservare o portare altrove (portabilità, LGPD).",
 "Usar no computador, pelo navegador": "Usa sul computer, dal browser",
 "Usar o padrão": "Usa il predefinito",
 "Usar o padrão ({emoji})": "Usa il predefinito ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Usa l'app sul telefono per scaricare il file.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "Vale per tutte le schede. Ogni scheda può avere il suo in Impostazioni > Schede.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "Valgono per le attività con pause. Ogni attività può cambiare l'allarme e l'emoji nella propria scheda.",
 "Ver lista": "Vedi elenco",
 "Ver o CPF inteiro": "Vedi il CPF completo",
 "Verde-floresta": "Verde foresta",
 "Verde-água": "Verde acqua",
 "Vibração": "Vibrazione",
 "Vinho": "Bordeaux",
 "Você pediu para ser avisado agora.": "Hai chiesto di essere avvisato ora.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Puoi: confermare se trattiamo i tuoi dati, accedervi, correggerli, chiedere la portabilità (scaricare i tuoi dati in Impostazioni > I miei dati), chiederne la cancellazione, sapere con chi li condividiamo, revocare il consenso e presentare reclamo all'ANPD.",
 "Voltar ao filtro": "Torna al filtro",
 "Voltar à lista": "Torna all'elenco",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Vai in Impostazioni › My Planner Web e tocca \"Collega browser\".",
 "atividade {n} de {total}": "attività {n} di {total}",
 "matéria {n} de {t}": "materia {n} di {t}",
 "padrão": "predefinito",
 "pausa em {n} min": "pausa tra {n} min",
 "pausa {n} de {total}": "pausa {n} di {total}",
 "termina em {n} min": "termina tra {n} min",
 "todas as vezes": "tutte le occorrenze",
 "troca em {n} min": "cambio tra {n} min",
 "volta em {n} min": "riprende tra {n} min",
 "{nome} · {n} dia(s)": "{nome} · {n} giorno/i",
 "{n} de {total} vezes": "{n} di {total} occorrenze",
 "{n} itens arquivados": "{n} elementi archiviati",
 "{n} itens excluídos": "{n} elementi eliminati",
 "{n} marcada(s)": "{n} selezionata/e",
 "{n} vezes": "{n} volte",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} min / {total}",
 "📔 Diário": "📔 Diario",
 "Agendados": "Programmati",
 "Atrasado": "In ritardo",
 "Atrasado: {v}": "In ritardo: {v}",
 "Atualizar o a receber": "Aggiorna gli importi da ricevere",
 "Até (fim do contrato, se houver)": "Fino a (fine del contratto, se presente)",
 "Clínica": "Clinica",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Conta ogni giorno con appello fatto o con piano di lezione segnato come \"Lezione svolta\".",
 "Data do recebimento": "Data di incasso",
 "Data prevista do pagamento": "Data di pagamento prevista",
 "Desmarcar como recebido": "Segna come non ricevuto",
 "Dia do pagamento": "Giorno di pagamento",
 "Diferença: {v} (juros/multa)": "Differenza: {v} (interessi/penale)",
 "Diferença: {v} (taxas/descontos)": "Differenza: {v} (commissioni/trattenute)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Scuole, università e corsi che ti pagano. Con stipendio fisso, l'app genera l'importo da ricevere di ogni mese; a ora di lezione, somma le lezioni svolte nelle classi collegate all'istituto.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Scegli il tipo di pagamento (Modifica) perché l'app calcoli quanto devi ricevere.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "Questo importo proviene dalla sezione \"Dove lavoro\" della scheda {aba}. Segnalo qui come ricevuto o apri la scheda per vedere l'istituto.",
 "Ex.: Colégio Estadual, Universidade Federal": "Es.: Liceo statale, Università federale",
 "Ex.: Hospital Santa Casa, Clínica Vida": "Es.: Ospedale Santa Casa, Clinica Vida",
 "Ex.: Salário de outubro, 13º, férias": "Es.: Stipendio di ottobre, tredicesima, ferie",
 "Feitos": "Fatti",
 "Horas-aula de cada aula": "Ore di lezione per lezione",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Ospedali e cliniche che ti pagano. Con stipendio fisso, l'app genera l'importo da ricevere di ogni mese; a turno o prestazione, segna quelli fatti e l'app calcola.",
 "Hospital": "Ospedale",
 "Instituição": "Istituto",
 "Instituição (Onde trabalho)": "Istituto (Dove lavoro)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Collega le classi a questo istituto (nella classe, Modifica › Istituto) perché l'app sommi le lezioni svolte.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Segna ogni turno o prestazione come fatto: l'app somma e calcola l'importo del mese.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Segna ogni turno o prestazione fatto in questo istituto. L'app somma e calcola l'importo da ricevere del mese.",
 "Nome da instituição": "Nome dell'istituto",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "Ciò che l'istituto ti deve pagare, mese per mese. Segna come ricevuto quando arrivano i soldi: passa anche nella scheda Finanze.",
 "Onde trabalho": "Dove lavoro",
 "Plantão": "Turno",
 "Plantão ou atendimento": "Turno o prestazione",
 "Plantões e atendimentos": "Turni e prestazioni",
 "Por atendimento ou procedimento": "A prestazione o procedura",
 "Por hora-aula": "A ora di lezione",
 "Por plantão": "A turno",
 "Previsto: {v}": "Previsto: {v}",
 "Previsão do mês: {v}": "Previsione del mese: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Quantità (lezioni, turni o prestazioni)",
 "Recebe no mês seguinte ao trabalhado": "Pagato il mese successivo a quello lavorato",
 "Receber: {t}": "Ricevere: {t}",
 "Recebimentos": "Incassi",
 "Salário": "Stipendio",
 "Salário (valor do mês)": "Stipendio (importo del mese)",
 "Salário fixo": "Stipendio fisso",
 "Telefone (RH ou financeiro)": "Telefono (HR o amministrazione)",
 "Tipo de pagamento": "Tipo di pagamento",
 "Universidade": "Università",
 "Valor da hora-aula": "Compenso per ora di lezione",
 "Valor de cada um (se for diferente)": "Importo di ciascuno (se diverso)",
 "Valor do plantão": "Compenso per turno",
 "Valor por atendimento ou procedimento": "Importo per prestazione o procedura",
 "Valor previsto": "Importo previsto",
 "feito": "fatto",
 "recebido em {d}": "ricevuto il {d}",
 "{n} aula(s) dada(s)": "{n} lezione/i svolta/e",
 "{n} hora(s)-aula": "{n} ora/e di lezione",
 "{n} plantão(ões)": "{n} turno/i",
 "Abas do My Planner Anne": "Schede di My Planner Anne",
 "Acesso ao Não perturbe": "Accesso a Non disturbare",
 "Alarme dos remédios (mesmo no silencioso)": "Allarme dei farmaci (anche in silenzioso)",
 "Algodão-doce": "Zucchero filato",
 "Aplicar tema": "Applica tema",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "I colori propri di ogni tema: floreale rosa, foglie verdi, cielo azzurro...",
 "Assim ficam as letras no app.": "Ecco come appare il testo nell'app.",
 "Automática": "Automatica",
 "Baht tailandês": "Baht thailandese",
 "Boliviano": "Boliviano boliviano",
 "Bolívar venezuelano": "Bolívar venezuelano",
 "Botão": "Pulsante",
 "Buscar moeda": "Cerca valuta",
 "Cor do desenho": "Colore del disegno",
 "Coroa dinamarquesa": "Corona danese",
 "Coroa norueguesa": "Corona norvegese",
 "Coroa sueca": "Corona svedese",
 "Coroa tcheca": "Corona ceca",
 "Crepúsculo": "Crepuscolo",
 "Crescente": "Crescente",
 "Curta": "Breve",
 "Despesas em outra moeda (fora do lucro): {v}": "Spese in altra valuta (escluse dal profitto): {v}",
 "Dirham dos Emirados Árabes Unidos": "Dirham degli Emirati Arabi Uniti",
 "Dirham marroquino": "Dirham marocchino",
 "Do seu país": "Del tuo paese",
 "Dong vietnamita": "Dong vietnamita",
 "Dupla": "Doppia",
 "Dólar americano": "Dollaro statunitense",
 "Dólar australiano": "Dollaro australiano",
 "Dólar canadense": "Dollaro canadese",
 "Dólar de Hong Kong": "Dollaro di Hong Kong",
 "Dólar de Singapura": "Dollaro di Singapore",
 "Dólar neozelandês": "Dollaro neozelandese",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Invia tutti gli elementi di questa lista, compresi quelli nuovi creati in seguito.",
 "Enviar todos para a equipe": "Invia tutti al team",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Scegli se l'allarme di questo farmaco deve suonare anche con il telefono in silenzioso.",
 "Euro": "Euro",
 "Exemplo": "Esempio",
 "Falta uma resposta": "Manca una risposta",
 "Folha, tema e cores da caneta e das letras": "Foglio, tema e colori della penna e del testo",
 "Franco suíço": "Franco svizzero",
 "Guarani paraguaio": "Guaraní paraguaiano",
 "Hryvnia ucraniana": "Grivnia ucraina",
 "Iene japonês": "Yen giapponese",
 "Kwanza angolano": "Kwanza angolano",
 "Libra egípcia": "Sterlina egiziana",
 "Libra esterlina": "Sterlina britannica",
 "Lira turca": "Lira turca",
 "Longa": "Lunga",
 "Mais usadas": "Più usate",
 "Metical moçambicano": "Metical mozambicano",
 "Na página, segurar a bolinha faz o mesmo.": "Nella pagina, tenere premuto il pallino fa lo stesso.",
 "Naira nigeriana": "Naira nigeriana",
 "Nenhuma moeda encontrada": "Nessuna valuta trovata",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Su Android, perché l'allarme del farmaco suoni con \"Non disturbare\" attivo, il telefono deve consentire a My Planner l'accesso a \"Non disturbare\". Tocca \"Apri impostazioni\", cerca My Planner nell'elenco e attiva l'autorizzazione.",
 "No My Planner": "In My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Su iPhone, la modalità silenziosa può impedire l'allarme. Lascia il telefono in modalità normale.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "Su iPhone, ▶ dà un'idea di ogni tipo. Gli avvisi reali usano la vibrazione predefinita dell'iPhone.",
 "Novo dólar taiwanês": "Nuovo dollaro taiwanese",
 "Novo shekel israelense": "Nuovo siclo israeliano",
 "Ouvir/Sentir": "Ascolta/Senti",
 "Peso argentino": "Peso argentino",
 "Peso chileno": "Peso cileno",
 "Peso colombiano": "Peso colombiano",
 "Peso filipino": "Peso filippino",
 "Peso mexicano": "Peso messicano",
 "Peso uruguaio": "Peso uruguaiano",
 "Política de privacidade": "Informativa sulla privacy",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "Fatto. Blocca lo schermo e attendi 1 minuto: l'avviso dovrebbe comparire in silenzio.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "Fatto. Blocca lo schermo e attendi 1 minuto: l'avviso dovrebbe comparire con vibrazione, senza suono.",
 "Páginas e canetas": "Pagine e penne",
 "Pôr do sol": "Tramonto",
 "Rand sul-africano": "Rand sudafricano",
 "Real brasileiro": "Real brasiliano",
 "Ringgit malaio": "Ringgit malese",
 "Riyal saudita": "Riyal saudita",
 "Rublo russo": "Rublo russo",
 "Rupia indiana": "Rupia indiana",
 "Rupia indonésia": "Rupia indonesiana",
 "Rupia paquistanesa": "Rupia pakistana",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "Se My Planner non compare nell'elenco, questa autorizzazione arriverà nella prossima versione dell'app (aggiorna dallo store).",
 "Sentir": "Senti",
 "Sol peruano": "Sol peruviano",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "Sono i colori rapidi della penna e del testo nelle pagine. Il primo è il colore predefinito all'apertura di una pagina. Tocca un pallino per cambiarne il colore.",
 "Taka bengali": "Taka bengalese",
 "Teste grátis por {n} dias": "Prova gratuita per {n} giorni",
 "Tipo de vibração": "Tipo di vibrazione",
 "Tirar do My Planner": "Togli da My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "Suona anche in silenzioso e Non disturbare",
 "Tocar só se o celular estiver no normal": "Suona solo se il telefono è in modalità normale",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "Tutti gli elementi di questa lista compaiono in My Planner, compresi quelli nuovi.",
 "Vaga-lume": "Lucciola",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "Vale per tutti gli avvisi che vibrano (Vibrazione e Suono e vibrazione).",
 "Won sul-coreano": "Won sudcoreano",
 "Xelim queniano": "Scellino keniota",
 "Yuan chinês": "Yuan cinese",
 "Zloty polonês": "Złoty polacco",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 L'allarme di questo farmaco deve suonare anche con il telefono in silenzioso?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "La galleria foto arriva nella prossima versione dell'app. Per ora, usa File o Scatta foto.",
 "Abrir o fichário do grupo": "Apri il raccoglitore del gruppo",
 "Arrastar a barra": "Trascina la barra",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "Appena il raccoglitore viene condiviso, appare qui.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Cerca icona per nome (es.: libro, casa, caffè)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "Con la scheda Studio crei i tuoi raccoglitori, usi il timer, segui il tuo report e molto altro. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "Con la scheda {aba} crei ciò che è tuo e usi tutte le funzioni. ✨",
 "Conhecer a aba": "Scopri la scheda",
 "Crie um fichário em Estudos e volte aqui.": "Crea un raccoglitore in Studio e torna qui.",
 "Em sessão": "In sessione",
 "Encerrar e salvar o cronômetro e começar a sessão?": "Fermare e salvare il timer e iniziare la sessione?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "Fermare e salvare il timer e continuare la sessione?",
 "Enquadre e toque no botão": "Inquadra e tocca il pulsante",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Scegli il raccoglitore che i compagni vedranno sullo schermo (sola lettura).",
 "Esconder": "Nascondi",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "Questo file è salvato solo sul dispositivo o nel Drive di chi l'ha condiviso, per questo non appare qui.",
 "Fichário do grupo": "Raccoglitore del gruppo",
 "Guia passo a passo do app e de cada aba": "Guida passo passo all'app e a ogni scheda",
 "Há um cronômetro em andamento.": "C'è un timer in corso.",
 "Há uma sessão em andamento.": "C'è una sessione in corso.",
 "Inserir imagem": "Inserisci immagine",
 "Mais ícones": "Altre icone",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "Nessuna icona con questo nome. Prova un'altra parola o scegli una categoria.",
 "Nenhuma matéria neste fichário ainda.": "Ancora nessuna materia in questo raccoglitore.",
 "Nenhuma página nesta matéria ainda.": "Ancora nessuna pagina in questa materia.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "Nel gruppo di studio, immagini e PDF si aprono qui sullo schermo. Questo tipo di file non ha un'anteprima nell'app.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "Impossibile mostrarlo ora. Controlla la connessione internet e riprova.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "La condivisione dei raccoglitori è ancora in preparazione. Torna tra poco.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "Il raccoglitore di questo gruppo è su un altro tuo dispositivo. Resta condiviso da lì.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Scopri la scheda · Annulla = Non ora",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "I compagni non vedranno più il raccoglitore. Tutto resta a te.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "I compagni vedono questo raccoglitore sullo schermo, in sola lettura: non modificano, non scaricano, non stampano e non condividono. I tuoi obiettivi, il timer e le pagine ripassate restano solo tuoi.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "Per vedere i PDF qui sullo schermo, installa la versione più recente dell'app dallo store.",
 "Parar de compartilhar": "Interrompi condivisione",
 "Pausar a sessão": "Metti in pausa la sessione",
 "Pausar a sessão e estudar só esta?": "Mettere in pausa la sessione e studiare solo questa?",
 "Página em branco.": "Pagina vuota.",
 "Quer estudar com tudo isso?": "Vuoi studiare con tutto questo?",
 "Quer usar tudo isso?": "Vuoi usare tutto questo?",
 "Selecionar todos": "Seleziona tutto",
 "Trocar fichário": "Cambia raccoglitore",
 "Você está participando do grupo de {nome}": "Stai partecipando al gruppo di {nome}",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "Vedi sullo schermo ciò che è stato condiviso in questo gruppo, per leggere e seguire.",
 "abacate, fruta": "avocado, frutta",
 "academia, musculação, treino, peso": "palestra, pesi, allenamento, bodybuilding",
 "acampamento, camping": "campeggio, camping",
 "alfinete, fixar, importante": "puntina, fissare, importante",
 "almoço, arroz, prato": "pranzo, riso, piatto",
 "alvo, meta, objetivo, foco": "bersaglio, meta, obiettivo, focus",
 "aniversário, bolo": "compleanno, torta",
 "anotação, nota, lista, escrever": "appunto, nota, lista, scrivere",
 "arco-íris": "arcobaleno",
 "avião, viagem, voo": "aereo, viaggio, volo",
 "balança, direito, justiça, lei, processo": "bilancia, diritto, giustizia, legge, processo",
 "balde, limpeza": "secchio, pulizia",
 "banana, fruta": "banana, frutta",
 "banheira, banho, banheiro": "vasca, bagno, bagno di casa",
 "barbear, barba, lâmina": "rasatura, barba, rasoio",
 "bicicleta, pedalar, bike": "bicicletta, pedalare, bici",
 "bolo, doce, sobremesa": "torta, dolce, dessert",
 "brilho, mágica": "scintille, magia",
 "cabelo, cabeleireiro, corte": "capelli, parrucchiere, taglio",
 "cachorro, cão, pet": "cane, cucciolo, animale domestico",
 "caderno": "quaderno",
 "caderno, fichário, amarelo": "quaderno, raccoglitore, giallo",
 "café, xícara, pausa": "caffè, tazza, pausa",
 "caixa, pacote, mudança, entrega": "scatola, pacco, trasloco, consegna",
 "calendário, agenda, data": "calendario, agenda, data",
 "cama, quarto": "letto, camera da letto",
 "caminhada, caminhar, andar": "camminata, camminare, passeggiata",
 "camisa, gravata, roupa, trabalho": "camicia, cravatta, vestiti, lavoro",
 "carne, churrasco": "carne, grigliata",
 "carrinho, mercado, compras, supermercado": "carrello, mercato, spesa, supermercato",
 "carro, dirigir, veículo": "auto, guidare, veicolo",
 "certo, feito, visto": "spunta, fatto, ok",
 "cesto, roupa, lavanderia, lavar roupa": "cesto, vestiti, lavanderia, bucato",
 "chave de fenda, ferramenta, conserto": "cacciavite, attrezzo, riparazione",
 "chave, senha": "chiave, password",
 "chocolate, doce": "cioccolato, dolce",
 "chuveiro, banho": "doccia, bagno",
 "chá, xícara": "tè, tazza",
 "compras, sacolas, shopping": "shopping, buste, centro commerciale",
 "computador, monitor, tela": "computer, monitor, schermo",
 "computador, notebook, informática": "computer, portatile, informatica",
 "coração amarelo": "cuore giallo",
 "coração azul": "cuore blu",
 "coração branco": "cuore bianco",
 "coração laranja": "cuore arancione",
 "coração roxo": "cuore viola",
 "coração verde": "cuore verde",
 "coração, amor, saúde, vermelho": "cuore, amore, salute, rosso",
 "corrida, correr": "corsa, correre",
 "creme, hidratante, pele, skincare": "crema, idratante, pelle, skincare",
 "croissant, pão, café da manhã": "cornetto, pane, colazione",
 "câmera, foto, fotografia": "fotocamera, foto, fotografia",
 "cérebro, mente, memória, pensar": "cervello, mente, memoria, pensare",
 "dado, jogo de tabuleiro": "dado, gioco da tavolo",
 "dente, dentista": "dente, dentista",
 "despertador, relógio, alarme, acordar": "sveglia, orologio, allarme, svegliarsi",
 "diamante, joia": "diamante, gioiello",
 "dinheiro, pagar, conta, pagamento": "soldi, pagare, bolletta, pagamento",
 "dormir, sono, descanso": "dormire, sonno, riposo",
 "e-mail, mensagem, carta": "e-mail, messaggio, lettera",
 "escada": "scala",
 "escova de dentes, dentes": "spazzolino, denti",
 "escrever, redação, caneta": "scrivere, tema, penna",
 "esponja, lavar louça": "spugna, lavare i piatti",
 "esquadro, régua, geometria, desenho técnico": "squadra, righello, geometria, disegno tecnico",
 "estrela brilhante, destaque": "stella brillante, in evidenza",
 "estrela, favorito": "stella, preferito",
 "etiqueta, marcador": "etichetta, tag",
 "extintor, segurança, incêndio": "estintore, sicurezza, incendio",
 "falar, idioma, inglês, conversa": "parlare, lingua, inglese, conversazione",
 "feito, concluído, certo": "fatto, completato, spunta",
 "ferramenta, conserto, manutenção": "attrezzo, riparazione, manutenzione",
 "festa, comemoração": "festa, celebrazione",
 "filme, cinema, série": "film, cinema, serie",
 "fogo, urgente, sequência": "fuoco, urgente, serie",
 "folha, natureza, erva, chá": "foglia, natura, erba, tè",
 "fone de ouvido, áudio, música, podcast": "cuffie, audio, musica, podcast",
 "formatura, capelo, faculdade, diploma, universidade": "laurea, tocco, facoltà, diploma, università",
 "força, braço, músculo": "forza, braccio, muscolo",
 "frango, coxa": "pollo, coscia",
 "frigideira, cozinhar, ovo, cozinha": "padella, cucinare, uovo, cucina",
 "futebol, bola, esporte": "calcio, pallone, sport",
 "gato, pet": "gatto, animale domestico",
 "gelo, geladeira, congelador": "ghiaccio, frigorifero, congelatore",
 "gráfico, planilha, finanças, relatório": "grafico, foglio di calcolo, finanze, report",
 "ingresso, show, evento": "biglietto, concerto, evento",
 "jogo, videogame, game": "gioco, videogioco, gaming",
 "lancha, barco": "motoscafo, barca",
 "leite, copo": "latte, bicchiere",
 "letras, alfabeto, português": "lettere, alfabeto, italiano",
 "link, corrente": "link, catena",
 "livro aberto, leitura, ler": "libro aperto, lettura, leggere",
 "livro azul, caderno": "libro blu, quaderno",
 "livro laranja, caderno": "libro arancione, quaderno",
 "livro verde, caderno": "libro verde, quaderno",
 "livro vermelho, caderno": "libro rosso, quaderno",
 "livros, estudo, estudar, biblioteca": "libri, studio, studiare, biblioteca",
 "lixo, lixeira": "spazzatura, cestino",
 "lua, noite": "luna, notte",
 "lâmpada, ideia, luz": "lampadina, idea, luce",
 "macarrão, massa": "spaghetti, pasta",
 "maleta, trabalho, escritório, negócios": "valigetta, lavoro, ufficio, affari",
 "massagem, relaxar": "massaggio, rilassarsi",
 "maçã, fruta": "mela, frutta",
 "microfone, cantar, karaokê, palestra": "microfono, cantare, karaoke, conferenza",
 "microscópio, ciência, biologia": "microscopio, scienza, biologia",
 "mochila, escola, filhos": "zaino, scuola, figli",
 "montanha, trilha": "montagna, sentiero",
 "mundo, planeta, geografia": "mondo, pianeta, geografia",
 "médico, consulta, exame, saúde": "medico, visita, esame, salute",
 "música, nota musical": "musica, nota musicale",
 "natação, nadar, piscina": "nuoto, nuotare, piscina",
 "olho, visão, oftalmologista": "occhio, vista, oculista",
 "oração, orar, gratidão, igreja": "preghiera, pregare, gratitudine, chiesa",
 "ovo": "uovo",
 "pastas, arquivo, fichário, divisórias": "cartelle, archivio, raccoglitore, divisori",
 "peixe": "pesce",
 "pescaria, pescar": "pesca, pescare",
 "pessoas, reunião, equipe, grupo": "persone, riunione, squadra, gruppo",
 "piano, teclado musical": "pianoforte, tastiera",
 "pintura, arte, desenho": "pittura, arte, disegno",
 "pipa": "aquilone",
 "pipoca, cinema": "popcorn, cinema",
 "pizza": "pizza",
 "planta, vaso, regar": "pianta, vaso, annaffiare",
 "porta, entrada": "porta, ingresso",
 "praia, férias": "spiaggia, vacanze",
 "prato, refeição, louça, jantar": "piatto, pasto, stoviglie, cena",
 "prédio, história, governo, tribunal": "edificio, storia, governo, tribunale",
 "pão, padaria": "pane, panetteria",
 "pé, podólogo": "piede, podologo",
 "pôr do sol, amanhecer": "tramonto, alba",
 "quebra-cabeça, peça": "puzzle, tessera",
 "queijo": "formaggio",
 "raio, energia, rápido": "fulmine, energia, veloce",
 "refrigerante, suco, bebida": "bibita, succo, bevanda",
 "remédio, medicamento, vitamina, farmácia": "medicina, farmaco, vitamina, farmacia",
 "sabão, sabonete, lavar": "sapone, saponetta, lavare",
 "salada, dieta, verdura": "insalata, dieta, verdura",
 "sanduíche, lanche": "panino, spuntino",
 "sino, aviso, lembrete": "campanella, avviso, promemoria",
 "skate": "skateboard",
 "sofá, sala": "divano, soggiorno",
 "sol, manhã, dia": "sole, mattina, giorno",
 "spa, sauna, autocuidado": "spa, sauna, cura di sé",
 "teatro, máscaras": "teatro, maschere",
 "telefone, ligação, ligar": "telefono, chiamata, chiamare",
 "tigela, cereal, sopa, mingau": "ciotola, cereali, zuppa, porridge",
 "trevo, sorte": "quadrifoglio, fortuna",
 "troféu, conquista, prêmio": "trofeo, traguardo, premio",
 "tubo de ensaio, química, laboratório": "provetta, chimica, laboratorio",
 "tênis, esporte": "scarpe da ginnastica, sport",
 "unha, manicure": "unghia, manicure",
 "vassoura, limpeza, faxina, varrer": "scopa, pulizia, faccende, spazzare",
 "violão, guitarra": "chitarra, chitarra acustica",
 "yoga, meditação, alongamento": "yoga, meditazione, stretching",
 "{n} selecionada": "{n} selezionata",
 "{n} selecionadas": "{n} selezionate",
 "{n} selecionado": "{n} selezionato",
 "{n} selecionados": "{n} selezionati",
 "ábaco, matemática, contas, cálculo, contabilidade": "abaco, matematica, conti, calcolo, contabilità",
 "água, gota, hidratar": "acqua, goccia, idratarsi",
 "árvore, jardim, quintal": "albero, giardino, cortile",
 "ônibus, transporte": "autobus, trasporti",
 "1 dia antes": "1 giorno prima",
 "1 dia depois": "1 giorno dopo",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "L'abbonamento si attiva nell'app del telefono, tramite lo store delle app, e vale anche qui sul sito.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "La chiave è incompleta (troppo corta). Copiala di nuovo con il pulsante di copia della pagina della chiave.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "La chiave contiene caratteri che non fanno parte di una chiave. Copiala di nuovo, solo la chiave, senza testo intorno.",
 "A galeria chega na próxima atualização do app.": "La galleria arriva con il prossimo aggiornamento dell'app.",
 "ALERTAS": "AVVISI",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Apri una scheda a pagamento e inizia la prova gratuita. Poi torna qui.",
 "Abrir a barra do editor": "Apri la barra dell'editor",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "Ora è l'orario Non disturbare dell'app: l'avviso arriva entro 5 secondi, senza suono né vibrazione.",
 "Aguardando confirmação": "In attesa di conferma",
 "Aguardando envio ao My Planner": "In attesa di invio a My Planner",
 "Alertas de cada fatura": "Avvisi per ogni fattura",
 "Alertas do fim da garantia": "Avvisi di fine garanzia",
 "Alertas do vencimento": "Avvisi di scadenza",
 "Alertas: {campo}": "Avvisi: {campo}",
 "Alvorada": "Albeggiare",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "Quando apri questa scheda, l'app chiede lo stesso sblocco dell'app (password, biometria o PIN). Puoi cambiarlo in Impostazioni > Schede.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Quando tocchi un file allegato, si apre nell'app del telefono che scegli (se il telefono lo chiede, \"Solo una volta\" o \"Sempre\"). Quello che modifichi lì viene salvato nel file stesso.",
 "App instalado": "App installata",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: registra già tutto nell'app Salute del telefono. Non devi fare nulla.",
 "Arquivados e fixados": "Archiviati e fissati",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "File da leggere e conservare, organizzato per scheda. Generato il {data}.",
 "As notificações do My Planner estão desligadas no celular.": "Le notifiche di My Planner sono disattivate sul telefono.",
 "Atualização automática disponível no app instalado.": "Aggiornamento automatico disponibile nell'app installata.",
 "Aurora": "Aurora",
 "Avisos: alarme (som)": "Avvisi: sveglia (suono)",
 "Baixar o app": "Scarica l'app",
 "Baixar o arquivo técnico": "Scarica il file tecnico",
 "Baixar para ler (PDF)": "Scarica da leggere (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Barra dell'editor (penna, evidenziatore, testo)",
 "Brisa": "Brezza",
 "Campainha": "Campanello",
 "Canal": "Canale",
 "Cole a chave antes de testar.": "Incolla la chiave prima di provare.",
 "Começa em": "Inizia il",
 "Como avisar": "Come avvisare",
 "Confira a chave": "Controlla la chiave",
 "Conta de teste de compras": "Account di prova degli acquisti",
 "Conta vencida": "Bolletta scaduta",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Copia subito la chiave (compare una sola volta). Inizia con \"sk-\".",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Copia subito la chiave (compare una sola volta). Inizia con \"sk-ant-\".",
 "Cristal": "Cristallo",
 "Daqui a 1 hora": "Tra 1 ora",
 "Daqui a 1 semana": "Tra 1 settimana",
 "Daqui a 3 dias": "Tra 3 giorni",
 "Depois de 5 min fora": "Dopo 5 min fuori",
 "Depois de 5 minutos fora": "Dopo 5 minuti fuori",
 "Desligar a senha desta aba": "Disattiva la password di questa scheda",
 "Detalhes técnicos": "Dettagli tecnici",
 "Dia {n} de {t}": "Giorno {n} di {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Consiglio: la chiave è come una password. Non inviarla per messaggio e non pubblicarla. Se viene divulgata, eliminala sul sito e creane un'altra.",
 "Documento vencido": "Documento scaduto",
 "Ela abre em {d}.": "Si apre il {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "Si apre il {d}. Riceverai degli avvisi: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "Si apre il {d}. Riceverai un avviso: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "In \"API keys\", tocca \"Create key\" (Crea chiave) e dalle un nome, per esempio \"My Planner\".",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "In \"Billing\" (Fatturazione), aggiungi una carta e qualche dollaro di credito. L'abbonamento ChatGPT Plus non vale qui.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "In \"Billing\" (Fatturazione), acquista crediti. L'abbonamento Claude Pro non vale qui.",
 "Em breve": "Prossimamente",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Accedi con lo stesso account di ChatGPT o creane uno.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Accedi con il tuo account Google (va bene quello di Gmail).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Accedi o crea un account (può essere la stessa email di Claude).",
 "Enviados para o My Planner": "Inviati a My Planner",
 "Enviar agora": "Invia ora",
 "Escolha hoje ou uma data futura.": "Scegli oggi o una data futura.",
 "Escolhas lembradas": "Scelte ricordate",
 "Escolher a data": "Scegli la data",
 "Escolher células": "Scegli celle",
 "Escolher quando": "Scegli quando",
 "Espessura": "Spessore",
 "Esquecer": "Dimentica",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "Questa chiave è di un altro servizio ({servico}). Qui funzionano solo chiavi di Claude, ChatGPT o Gemini.",
 "Esta chave é do {ia}, não do {escolhida}.": "Questa chiave è di {ia}, non di {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "Questo account vede l'app come un account nuovo, senza nessuna scheda sbloccata, per controllare i lucchetti, la prova gratuita e l'acquisto. Gli altri account non cambiano.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "Questo strumento deve vedere le pagine del PDF, funzione che arriva con la nuova app (versione 0.50). Usa il browser o aggiorna My Planner dallo store.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "Questa non sembra una chiave di {ia}. Le chiavi di {ia} iniziano con {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "Questo avviso è impostato su \"Disattivato\": non suonerà nulla.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "Questo telefono non riceve ancora avvisi con l'app chiusa. Aggiorna My Planner dallo store (versione {v} o più recente). Con l'app aperta, gli avvisi funzionano già.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "Questo tipo di avviso è disattivato nelle impostazioni di notifica del telefono.",
 "Estudado": "Studiato",
 "Estudado: {dur}": "Studiato: {dur}",
 "Faltou: {dur}": "Mancato: {dur}",
 "Fazer os testes terminarem agora": "Fai terminare le prove ora",
 "Fechar a barra do editor": "Chiudi la barra dell'editor",
 "Fichário": "Raccoglitore",
 "Figurinhas e emojis": "Sticker ed emoji",
 "Garantia terminou": "Garanzia terminata",
 "Gerando…": "Generazione in corso…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Conserva documenti, esami e storico sanitario con una password tutta sua. Nemmeno l'assistenza può leggerlo. Se dimentichi la password, non c'è modo di recuperarla.",
 "Harpa": "Arpa",
 "Horas por dia": "Ore al giorno",
 "Identificação": "Identificazione",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "Questo sembra un link o un'email, non una chiave. Copia la chiave intera dalla pagina delle chiavi API.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "Questo compare in My Planner solo se lo invii. Vuoi inviarlo ora?",
 "Já dá para confirmar {titulo}?": "Puoi già confermare {titulo}?",
 "Lembrar minha escolha nesta aba": "Ricorda la mia scelta in questa scheda",
 "Lembrete para confirmar: {data}": "Promemoria per confermare: {data}",
 "Marimba": "Marimba",
 "Marque pelo menos um dia da semana no plano.": "Seleziona almeno un giorno della settimana nel piano.",
 "Me lembre de confirmar": "Ricordami di confermare",
 "Me lembre depois": "Ricordamelo dopo",
 "Menos": "Meno",
 "Meta somada": "Obiettivo totale",
 "Meta somada: {dur}": "Obiettivo totale: {dur}",
 "Meus dados - My Planner {data}": "I miei dati - My Planner {data}",
 "Meus dados do My Planner": "I miei dati di My Planner",
 "Mostrar a barra": "Mostra la barra",
 "Mudar senha do diário": "Cambia password del diario",
 "Na primeira vez, aceite os termos de uso.": "La prima volta, accetta i termini d'uso.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "Nella versione degli store, l'acquisto avverrà tramite lo store delle app del telefono. Per ora la chiave simula l'abbonamento per i test.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Niente delle altre schede va da solo in My Planner. Questi elementi hanno una data e non sono ancora stati inviati.",
 "Nenhum estudo registrado neste mês.": "Nessuno studio registrato in questo mese.",
 "Nenhum item aguardando envio.": "Nessun elemento in attesa di invio.",
 "Nenhum teste começado": "Nessuna prova iniziata",
 "Nesta tela não há nada para adicionar.": "In questa schermata non c'è niente da aggiungere.",
 "No dia": "Il giorno stesso",
 "Nova nota rápida": "Nuova nota rapida",
 "Nova página do dia": "Nuova pagina del giorno",
 "Não deu certo": "Non ha funzionato",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "Non sono inclusi: il contenuto del Diario e i campi della cassaforte (restano protetti dalla password), foto e file allegati. Per ripristinare i dati nell'app, usa il file tecnico.",
 "Não foi possível gerar o PDF.": "Impossibile generare il PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "Impossibile provare ora. Riprova tra qualche secondo.",
 "Não lembrar": "Non ricordare",
 "Não, obrigada": "No, grazie",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "Il Diario è protetto dalla sua password e non è incluso in questo file.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "L'app apre \"Salva su File\" per farti scegliere la cartella (può essere iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "L'app conserva solo il collegamento al file scelto: rimane dov'è (Drive, OneDrive, Download) e si apre nell'app del telefono. Non viene copiato nulla. Questa opzione vale per le foto scattate con la fotocamera.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "L'app installata su questo dispositivo è la versione {v}. Per fare chiamate audio e video, aggiorna My Planner dallo store (versione 0.35 o più recente). I messaggi funzionano già.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "L'avviso arriverà in silenzio, direttamente nell'elenco delle notifiche: attiva gli avvisi di My Planner nelle impostazioni del telefono.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "L'avviso arriverà senza suono: il suono di questo tipo di avviso è stato disattivato nelle impostazioni del telefono.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "L'avviso arriverà, ma il suono delle notifiche di My Planner è disattivato sul telefono.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "L'invito contiene il link per scaricare l'app. Chi entra dal link arriva direttamente nello studio.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "La dettatura arriva con la nuova versione dell'app. Aggiorna My Planner dallo store per usare il microfono.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "Lo stesso sblocco dell'app: password, biometria o PIN. Viene chiesto una volta all'ingresso; dentro la scheda non viene richiesto di nuovo. Aprire la galleria, la fotocamera o i file non conta come uscire. Gli elementi grandi continuano a chiedere la password per essere eliminati.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "La modalità silenziosa del telefono può impedire la sveglia. Lascia il telefono in modalità normale.",
 "O plano fica só em Estudos (não vai para o My Planner).": "Il piano resta solo in Studi (non va in My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Facoltativo: scadenza, ore al giorno e giorni della settimana.",
 "Os avisos do celular funcionam no app instalado.": "Gli avvisi del telefono funzionano nell'app installata.",
 "Os avisos no celular funcionam no app instalado.": "Gli avvisi sul telefono funzionano nell'app installata.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "Le prove iniziate sono terminate. Apri la scheda per vedere \"La prova gratuita è terminata\".",
 "Outros dados": "Altri dati",
 "Ouvir": "Ascolta",
 "Pacote em uso": "Pacchetto in uso",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "Per abbonarti, aggiorna My Planner dallo store delle app del telefono.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "Da leggere (PDF): organizzato per scheda, con titoli e date. Si apre su qualsiasi dispositivo o computer.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Perché la sveglia del farmaco suoni con \"Non disturbare\" attivo, il telefono deve consentire a My Planner l'accesso a \"Non disturbare\". Tocca \"Apri impostazioni\", cerca My Planner nell'elenco e attiva il permesso.",
 "Passo a passo para criar a chave": "Passo dopo passo per creare la chiave",
 "Pedir de novo": "Chiedi di nuovo",
 "Pedir senha ao abrir esta aba": "Chiedi la password all'apertura di questa scheda",
 "Plano com período": "Piano con periodo",
 "Plano começa em {d}": "Il piano inizia il {d}",
 "Por matéria": "Per materia",
 "Prolongar": "Prolunga",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "Fatto: l'avviso arriva entro 5 secondi, con suono. Se non suona, controlla se il telefono è in silenzioso.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "Fatto: l'avviso arriva entro 5 secondi, solo con vibrazione.",
 "Publicado em": "Pubblicato il",
 "Pulso": "Battito",
 "Quando o app bloquear": "Quando l'app si blocca",
 "Quer proteger esta aba com senha?": "Vuoi proteggere questa scheda con una password?",
 "Recolher ou arrastar a barra": "Comprimi o trascina la barra",
 "Recomeçar os testes grátis": "Ricomincia le prove gratuite",
 "Recomeçar os testes grátis?": "Ricominciare le prove gratuite?",
 "Rolar a folha para os lados": "Scorri il foglio lateralmente",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "Se colleghi l'orologio: totali giornalieri di passi, distanza, calorie, esercizio, battito cardiaco e sonno, letti da Health Connect o dall'app Salute del telefono. L'app legge soltanto e non modifica mai questi dati.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "Niente internet o la connessione è caduta. Controlla il Wi-Fi o i dati mobili e riprova.",
 "Senha desta aba": "Password di questa scheda",
 "Seu plano terminou": "Il tuo piano è terminato",
 "Sino": "Campana",
 "Som do alarme": "Suono della sveglia",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Somma la garanzia legale e quella del produttore. Controlla il certificato di garanzia.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "Sono due file con i tuoi dati di My Planner (portabilità, LGPD):",
 "Só quando o app bloquear": "Solo quando l'app si blocca",
 "Tamanho da borracha": "Dimensione della gomma",
 "Tamanho da letra": "Dimensione del testo",
 "Tempo": "Tempo",
 "Termina em": "Termina il",
 "Testar": "Prova",
 "Texto de exemplo": "Testo di esempio",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Suona negli avvisi impostati su \"Sveglia (suono)\". \"Suono e vibrazione\" usa il suono di notifica del telefono.",
 "Toda vez que sair": "Ogni volta che esci",
 "Toda vez que sair da aba": "Ogni volta che esci dalla scheda",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "Tutte le schede tornano a \"{n} giorni gratis per provare\", come in un account nuovo. Gli abbonamenti simulati vengono disattivati.",
 "Todos os fichários": "Tutti i raccoglitori",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Tocca \"Create API key\" (Crea chiave API). Se chiede un progetto, scegli quello che compare o creane uno nuovo.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Tocca \"Crea la mia chiave API\" qui sopra. Si apre la piattaforma di OpenAI (non è il sito di ChatGPT).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Tocca \"Crea la mia chiave API\" qui sopra. Si apre la Console di Anthropic (non è il sito di Claude).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Tocca \"Crea la mia chiave API\" qui sopra. Si apre Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Tocca Connetti e, nella schermata dell'app Salute, attiva gli elementi che My Planner può leggere.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Tocca l'icona di copia accanto alla chiave. Inizia con \"AIza\" o \"AQ.\".",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Tocca una cella della tabella (o \"Scegli celle\") per cambiarne la dimensione del testo.",
 "Transparência": "Trasparenza",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Tecnico (per ripristinare): copia completa che solo My Planner può leggere. Per usarla, vai in Impostazioni › Cloud e backup › Importa file.",
 "Uma carta da {nome} abre em {n} dias 💌": "Una lettera di {nome} si apre tra {n} giorni 💌",
 "Usa a senha do app": "Usa la password dell'app",
 "Usar no {ia}": "Usa con {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "Usa l'app sul telefono per scaricare il file tecnico.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Prezzo finale stabilito dallo store delle app, già nella valuta del tuo paese.",
 "Você ainda não enviou {titulo} para o My Planner.": "Non hai ancora inviato {titulo} a My Planner.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Torna qui, incollala nel campo qui sotto e tocca \"Salva e prova\".",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Torna in \"API keys\" e tocca \"Create new secret key\" (Crea chiave).",
 "atualização automática": "aggiornamento automatico",
 "erro desconhecido": "errore sconosciuto",
 "estudados no mês": "studiati nel mese",
 "faltou {dur}": "mancano {dur}",
 "hoje {feito} de {meta}": "oggi {feito} su {meta}",
 "hoje é folga": "oggi è giorno libero",
 "login do Google (não é chave de API)": "accesso Google (non è una chiave API)",
 "meta cumprida": "obiettivo raggiunto",
 "o que veio com a instalação": "ciò che è arrivato con l'installazione",
 "outro": "altro",
 "provisório": "provvisorio",
 "superou {dur}": "superato di {dur}",
 "token de login (não é chave de API)": "token di accesso (non è una chiave API)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} ha impiegato troppo tempo a rispondere. Riprova tra un attimo.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} non è raggiungibile o è sovraccarico in questo momento. Non è un problema della tua chiave: riprova più tardi.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} ha risposto al test con il modello {modelo}. Ora puoi usarlo nelle schede.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} si è rifiutato di leggere questo contenuto (filtro di sicurezza dell'azienda).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: la chiave esiste, ma non ha il permesso di usare l'IA. Crea una nuova chiave nella pagina indicata nella guida passo passo.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: chiave non valida. Controlla di aver copiato la chiave intera o creane una nuova.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: questa chiave è stata bloccata dall'azienda perché è comparsa pubblicata su internet. Eliminala e creane un'altra.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: limite di utilizzo raggiunto. Attendi qualche minuto (o fino a domani, con il piano gratuito) e riprova.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: il modello scelto non è disponibile per il tuo account. Scegline un altro in \"Modello\".",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: il servizio non è disponibile nella tua regione o per questo tipo di account.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: il tuo account API non ha credito o non ha un metodo di pagamento. Aggiungi crediti sul sito dell'azienda.",
 "{item}: a garantia termina hoje ({data}).": "{item}: la garanzia termina oggi ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: la garanzia è terminata il {data}.",
 "{item}: venceu em {data}.": "{item}: scaduto il {data}.",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} protetta da password",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: terminare il piano o prolungarlo con una nuova data di fine? Non viene eliminato nulla.",
 "{n} dias antes": "{n} giorni prima",
 "{n} dias de estudo no plano · {dur} por dia": "{n} giorni di studio nel piano · {dur} al giorno",
 "{n} dias de plano": "{n} giorni di piano",
 "{n} dias depois": "{n} giorni dopo",
 "{n} item(ns) aguardando envio ao My Planner": "{n} elemento/i in attesa di invio a My Planner",
 "{n} itens aguardando envio": "{n} elementi in attesa di invio",
 "{quando} às {hora}": "{quando} alle {hora}",
 "ÚLTIMOS 6 MESES": "ULTIMI 6 MESI",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Apri My Planner Anne e accedi con il tuo CPF o la tua email e la tua password.",
 "Anexo": "Allegato",
 "Assédio ou ameaça": "Molestie o minacce",
 "Bloquear {nome}": "Blocca {nome}",
 "Conte mais (opcional)": "Raccontaci di più (facoltativo)",
 "Conteúdo impróprio": "Contenuto inappropriato",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "Contenuti offensivi e utenti molesti non sono tollerati. Le segnalazioni vengono esaminate dal nostro team entro 24 ore.",
 "Denunciar": "Segnala",
 "Denunciar contato": "Segnala contatto",
 "Denunciar grupo": "Segnala gruppo",
 "Denunciar mensagem": "Segnala messaggio",
 "Denúncia enviada": "Segnalazione inviata",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Le segnalazioni che fai in Messaggi: il motivo, chi è stato segnalato e il brano del messaggio segnalato. Le legge solo il team di My Planner, per esaminare il caso.",
 "Enviar denúncia": "Invia segnalazione",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Invia un'email chiedendo l'eliminazione, con il CPF o l'email dell'account. Rispondiamo entro 15 giorni.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "Non tolleriamo contenuti offensivi, illegali o inappropriati né utenti molesti in Messaggi e nei gruppi. Chiunque può segnalare un messaggio, un contatto o un gruppo (tieni premuto il messaggio o tocca ⋮ > Segnala) e bloccare chi vuole. Le segnalazioni vengono esaminate dal nostro team entro 24 ore: il contenuto può essere rimosso e chi l'ha inviato può vedersi sospendere o chiudere l'account.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Grazie. Il nostro team esaminerà entro 24 ore.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "Per gli account che accedono con il CPF, la nuova password viene creata dalla nostra assistenza, dopo aver confermato che l'account è tuo. Scrivi a {email} indicando il tuo CPF o l'email registrata.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "Perché stai segnalando? La persona segnalata non saprà chi l'ha segnalata.",
 "Spam": "Spam",
 "{nome} não pode mais conversar com você.": "{nome} non può più chattare con te.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nValido fino al {d}. Resta crittografato nella tua cassaforte, solo su questo dispositivo e nella tua copia sul cloud.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. Sul computer, apri {url} e scegli Accedi con codice QR.",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Qui, tocca Collega browser e inquadra il codice QR del computer.",
 "Abandonados": "Abbandonati",
 "Bloquear o computador": "Blocca il computer",
 "Cheguei na página...": "Sono arrivato a pagina...",
 "Computador conectado": "Computer collegato",
 "Computador desconectado": "Computer scollegato",
 "Conectado em {d}": "Collegato il {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea il gruppo e invia il link: chi entra vede il materiale del libro e segue la lettura. Chi amministra aggiunge, modifica e mette foto, e può permetterlo a chi usa anche la scheda. Solo chi amministra aggiunge o toglie persone.",
 "Depois de {n} minutos parado": "Dopo {n} minuti di inattività",
 "Desconectar o computador?": "Scollegare il computer?",
 "Difícil demais": "Troppo difficile",
 "Editar livro": "Modifica libro",
 "Entrar com o QR Code": "Accedi con il codice QR",
 "Escreva (ex.: filosofia)": "Scrivi (es.: filosofia)",
 "Este computador": "Questo computer",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "Questo computer è stato scollegato (dal telefono o perché è entrato un altro computer). Per usarlo di nuovo, accedi con il codice QR.",
 "Já existe um computador conectado": "C'è già un computer collegato",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "C'è già un computer collegato. Passare a questo? L'altro verrà scollegato.",
 "Navegador": "Browser",
 "Nenhum computador conectado": "Nessun computer collegato",
 "Novo livro": "Nuovo libro",
 "Não gostei": "Non mi è piaciuto",
 "Não, abandonei": "No, l'ho abbandonato",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner si chiuderà sul computer. Per usarlo di nuovo, collegati con il codice QR.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "Il codice QR cambia ogni 3 minuti e vale una sola volta. Su un computer condiviso, usa Impostazioni › Esci da questo computer alla fine.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "I tuoi dati restano salvati nel cloud e sul telefono. Per entrare di nuovo, usa il codice QR.",
 "Parei em": "Interrotto il",
 "Perdi o interesse": "Ho perso interesse",
 "Por que parei": "Perché ho smesso",
 "Páginas e meta": "Pagine e obiettivo",
 "Quero voltar a ler?": "Voglio riprenderlo?",
 "Sair deste computador": "Esci da questo computer",
 "Sair deste computador?": "Uscire da questo computer?",
 "Se quiser, escreva com as suas palavras": "Se vuoi, scrivilo con parole tue",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "Senza usare mouse o tastiera per questo tempo, My Planner si blocca. Per tornare, digita la password dell'account (o accedi di nuovo con il codice QR).",
 "Sem tempo": "Niente tempo",
 "Sim, depois": "Sì, più avanti",
 "Só um computador pode ficar conectado por vez.": "Si può collegare un solo computer alla volta.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "La foto o il PDF del certificato va in \"Foto, file e link\": segnalo come Certificato.",
 "ABNT copiada": "ABNT copiata",
 "APA copiada": "APA copiata",
 "Ano inválido": "Anno non valido",
 "Ano ou data de publicação": "Anno o data di pubblicazione",
 "Assisti em": "Visto il",
 "Buscando os dados...": "Cerco i dati...",
 "Calculado pelos módulos": "Calcolato dai moduli",
 "Carga horária (horas)": "Monte ore (ore)",
 "Certificado": "Certificato",
 "Certificado emitido em": "Certificato rilasciato il",
 "Cheguei na aula": "Sono alla lezione",
 "Cheguei na aula...": "Sono alla lezione...",
 "Cheguei na temporada": "Sono alla stagione",
 "Cheguei no episódio": "Sono all'episodio",
 "Citação copiada": "Citazione copiata",
 "Colocar em pasta": "Metti in una cartella",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Metti libri, film o corsi in questa cartella per creare l'elenco.",
 "Comentário": "Commento",
 "Copiar ABNT": "Copia ABNT",
 "Copiar APA": "Copia APA",
 "Copiar citação (ABNT)": "Copia citazione (ABNT)",
 "Copiar citação (APA)": "Copia citazione (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Crea schede con checklist, elenco, testo libero o disegno per questa materia. Scorri a destra per eliminare e a sinistra per Archiviare o Duplicare.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea il gruppo e invia il link: chi entra vede l'elenco e lo segue. Chi amministra aggiunge, modifica e mette foto, e può permetterlo a chi usa anche la scheda. Solo chi amministra aggiunge o toglie persone.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea il gruppo e invia il link: chi entra vede il materiale del corso e lo segue. Chi amministra aggiunge, modifica e mette foto, e può permetterlo a chi usa anche la scheda. Solo chi amministra aggiunge o toglie persone.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Crea prima una cartella, nella parte 📁 Cartelle di questa scheda.",
 "DOI (artigos)": "DOI (articoli)",
 "Data de acesso": "Data di accesso",
 "Deixar avulsas": "Lasciarle a parte",
 "Descrição (objetivo)": "Descrizione (obiettivo)",
 "Digite o ano com 4 números (ex.: {a}).": "Scrivi l'anno con 4 cifre (es.: {a}).",
 "Direção": "Regia",
 "Editar pasta": "Modifica cartella",
 "Editora": "Editore",
 "Edição": "Edizione",
 "Em 1 mês": "Tra 1 mese",
 "Em {n} meses": "Tra {n} mesi",
 "Episódios por temporada (opcional)": "Episodi per stagione (facoltativo)",
 "Escreva o trecho na anotação para copiar a citação.": "Scrivi il brano nella nota per copiare la citazione.",
 "Este item já está em todas as pastas.": "Questo elemento è già in tutte le cartelle.",
 "Ex.: 10.1590/...": "Es.: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "Es.: Tesi — Etica e Diritto",
 "Ex.: {a}": "Es.: {a}",
 "Fazendo": "In corso",
 "Grupo de filmes e séries": "Gruppo di film e serie",
 "Grupo de leitura": "Gruppo di lettura",
 "Grupo do curso": "Gruppo del corso",
 "ISBN": "ISBN",
 "Ideia minha": "Idea mia",
 "Instrutor": "Docente",
 "Itens da pasta": "Elementi della cartella",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Raccogli libri, film e corsi in una cartella (es.: \"Tesi\", \"Solo romanzi\"). Lo stesso elemento può stare in più cartelle.",
 "Link (material online)": "Link (materiale online)",
 "Lista copiada": "Elenco copiato",
 "Lista de referências": "Elenco dei riferimenti",
 "Mais de um autor: separe com ponto e vírgula (;).": "Più autori: separali con il punto e virgola (;).",
 "Módulo": "Modulo",
 "Nada novo": "Niente di nuovo",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "Nel ⋮ di un libro, film o corso, tocca \"Metti in una cartella\".",
 "Nome da pasta": "Nome della cartella",
 "Não achei dados novos para completar a ficha.": "Non ho trovato nuovi dati per completare la scheda.",
 "Não foi possível preencher": "Impossibile compilare",
 "O módulo não tem cards de anotações.": "Il modulo non ha schede di note.",
 "Organizador": "Curatore",
 "Os dados vêm da ficha do livro (Editar › Referência).": "I dati vengono dalla scheda del libro (Modifica › Riferimento).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "Libri, film e corsi della cartella NON vengono eliminati: restano nella scheda.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "Anche le {n} schede di note di questo modulo vanno nel cestino.",
 "Pasta vazia": "Cartella vuota",
 "Preencha o título (e o que mais tiver) na ficha.": "Compila il titolo (e il resto che hai) nella scheda.",
 "Preencher pelo DOI": "Compila dal DOI",
 "Preencher pelo link": "Compila dal link",
 "Produtora ou país": "Casa di produzione o paese",
 "Quero fazer": "Da fare",
 "Quero voltar?": "Voglio riprenderlo?",
 "Referência vazia": "Riferimento vuoto",
 "Referências": "Riferimenti",
 "Se deixar avulsas, elas continuam somando no total do curso.": "Se le lasci a parte, continuano a contare nel totale del corso.",
 "Subtítulo": "Sottotitolo",
 "Tirar da pasta": "Togli dalla cartella",
 "Total de episódios (opcional)": "Totale episodi (facoltativo)",
 "Total de temporadas (opcional)": "Totale stagioni (facoltativo)",
 "Tradutor": "Traduttore",
 "Trecho (citação)": "Brano (citazione)",
 "Trecho vazio": "Brano vuoto",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "Hai già visto {n} lezioni. In quale modulo metterle?",
 "Volume": "Volume",
 "{n} item(ns)": "{n} elementi",
 "{n} referência(s) em ordem alfabética.": "{n} riferimenti in ordine alfabetico.",
 "Ícone": "Icona",
 "ASSISTIDOS POR DIA": "VISTI AL GIORNO",
 "ASSISTIDOS POR MÊS": "VISTI AL MESE",
 "AULAS POR DIA": "LEZIONI AL GIORNO",
 "AULAS POR MÊS": "LEZIONI AL MESE",
 "Apagar a meta": "Elimina l'obiettivo",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Visti {a} · In visione {b} · Interrotti {c} · Da vedere {d}",
 "Aulas": "Lezioni",
 "CURSOS": "CORSI",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Completati {a} · In corso {b} · Interrotti {c}",
 "Datas": "Date",
 "Datas escolhidas": "Date scelte",
 "Datas à escolha": "Date a scelta",
 "Definir meta de {ano}": "Imposta obiettivo {ano}",
 "Definir meta do ano": "Imposta un obiettivo per l'anno",
 "FILMES E SÉRIES": "FILM E SERIE",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "Mancano {f} corsi: circa {m} al mese",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "Mancano {f} libri: circa {m} al mese",
 "Faltam {f} título(s): dá cerca de {m} por mês": "Mancano {f} titoli: circa {m} al mese",
 "Gênero": "Genere",
 "Incluir lista de referências no PDF": "Includi l'elenco dei riferimenti nel PDF",
 "LIVROS": "LIBRI",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Letti {a} libri · Interrotti {b} · In lettura {c}",
 "Meta de {ano}": "Obiettivo {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "Obiettivo {ano}: usare quello del {antes} ({n})?",
 "Meta do ano cumprida": "Obiettivo dell'anno raggiunto",
 "Mudar": "Cambia",
 "Nada neste período.": "Niente in questo periodo.",
 "Nota": "Voto",
 "O PDF não leva as suas anotações, resumos e comentários.": "Il PDF non include note, riassunti e commenti.",
 "POR ITEM": "PER ELEMENTO",
 "Plataforma": "Piattaforma",
 "PÁGINAS POR DIA": "PAGINE AL GIORNO",
 "PÁGINAS POR MÊS": "PAGINE AL MESE",
 "Quantos no ano?": "Quanti nell'anno?",
 "Quero ler {a} · Abandonei {b}": "Da leggere {a} · Abbandonati {b}",
 "Relatório de leitura e mídia": "Report di lettura e media",
 "concluídos no período": "completati nel periodo",
 "cursos concluídos no período": "corsi completati nel periodo",
 "livros lidos no período": "libri letti nel periodo",
 "pág. {a} de {n}": "pag. {a} di {n}",
 "títulos assistidos no período": "titoli visti nel periodo",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} lezioni seguite nel periodo · {h} ore di corsi completati",
 "{a} de {n} aulas ({p}%)": "{a} di {n} lezioni ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} di {n} corsi completati nel {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} di {n} libri nel {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} di {n} titoli visti nel {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} elementi senza data di cambio di stato: ho usato la data di creazione.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} pagine lette in {d} giorni · serie migliore: {s} giorni",
 "{p}% lido · falta {f}%": "{p}% letto · manca {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "Questa scheda chiede la password. Sbloccala prima e la guida riprende da qui.",
 "Abrir esta aba": "Apri questa scheda",
 "Mostrar na tela": "Mostra sullo schermo",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "Non trovo questo punto sullo schermo. Controlla che sia aperta la schermata giusta e riprova.",
 "Primeiros passos": "Primi passi",
 "Buscar no guia": "Cerca nella guida",
 "Entendi": "Capito",
 "{n} de {total} passos feitos": "{n} di {total} passi fatti",
 "Já fiz": "Fatto",
 "Guia em construção": "Guida in preparazione",
 "Limpar marcações": "Cancella i segni",
 "Este ponto ainda não está marcado no app.": "Questo punto non è ancora segnato nell'app.",
 "Dicas e atalhos": "Consigli e scorciatoie",
 "Gestos do app": "Gesti dell'app",
 "Procurando na tela…": "Cerco sullo schermo…",
 "Guia das abas": "Guida delle schede",
 "Voltar ao guia": "Torna alla guida",
 "Para que serve": "A cosa serve",
 "Disponível no app do celular.": "Disponibile nell'app del telefono.",
 "Nada encontrado no guia.": "Niente trovato nella guida.",
 "Recursos que valem para todas as abas": "Funzioni valide per tutte le schede",
 "Perguntas comuns": "Domande frequenti",
 "Ligar e desligar partes": "Attiva e disattiva parti",
 "Entrada cancelada. Este computador não foi conectado.": "Accesso annullato. Questo computer non è stato collegato.",
 "Alterações ainda não enviadas": "Modifiche non ancora inviate",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Alcune modifiche non sono ancora state inviate al server (niente internet?). Se esci ora, andranno perse. Uscire comunque?",
 "Sair mesmo assim": "Esci comunque",
 "O seu papel no grupo não permite mudar aqui.": "Il tuo ruolo nel gruppo non consente modifiche qui.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "Impossibile consultare il DOI ora (niente internet?). Riprova.",
 "DOI inválido.": "DOI non valido.",
 "DOI não encontrado.": "DOI non trovato.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "Il sito non ha permesso di leggere i dati da qui (capita spesso nel browser del computer). Prova con l’app sul telefono, usa il DOI o compila i campi.",
 "Atualizando...": "Aggiornamento...",
 "Banco de dados (Supabase, plano grátis)": "Database (Supabase, piano gratuito)",
 "Cadeado (HTTPS) até": "Lucchetto (HTTPS) fino al",
 "Dados das abas: {d}": "Dati delle schede: {d}",
 "Disco": "Disco",
 "Esta conta não tem acesso a estas informações.": "Questo account non ha accesso a queste informazioni.",
 "Ligado há": "Acceso da",
 "Livre: {l} · site: {s}": "Libero: {l} · sito: {s}",
 "Maiores tabelas": "Tabelle più grandi",
 "Memória em uso": "Memoria in uso",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "Il server non ha ancora inviato il rapporto. Lo invia ogni 10 minuti dopo il 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "Il server non ha ancora questa funzione. Esegui 53-SERVIDOR-0.78.bat sul computer.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "Il sistema del server richiede un riavvio (aggiornamento di sicurezza installato).",
 "Processador": "Processore",
 "Relatório do servidor: {q}": "Rapporto del server: {q}",
 "Servidor": "Server",
 "Servidor do site (Locaweb)": "Server del sito (Locaweb)",
 "Sistema": "Sistema",
 "Só você vê este quadro.": "Solo tu vedi questo riquadro.",
 "Versão do site no ar": "Versione del sito online",
 "atrasado: confira se o servidor está ligado": "in ritardo: controlla che il server sia acceso",
 "sem cadeado": "senza lucchetto",
 "{a} ({n} guardadas)": "{a} ({n} conservate)",
 "{d} dia(s) e {h} h": "{d} giorno/i e {h} h",
 "{n} núcleo(s) · carga {c}": "{n} core · carico {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} nuovi e {ativas} attivi in 7 giorni",
 "{u} de {t} ({p}%)": "{u} di {t} ({p}%)",
 "Fechar teclado": "Chiudi tastiera",
 "Mostrar as ferramentas": "Mostra gli strumenti",
 "Últimas cores usadas": "Ultimi colori usati",
 "Voltar ao topo": "Torna in cima",
 "Topo": "Su",
 "1 atividade do roteiro por fazer": "1 attività dell'itinerario da fare",
 "1 dia": "1 giorno",
 "1 item por pôr na mala": "1 oggetto da mettere in valigia",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 lista di Viaggi veniva inviata intera a My Planner ed è stata rimossa da lì. Ora l'invio è voce per voce, dal ⋮ di ciascuna voce.",
 "1 lugar não visitado": "1 luogo non visitato",
 "1 reserva por confirmar": "1 prenotazione da confermare",
 "Abrir o bloco": "Apri la sezione",
 "Adicionar pessoa": "Aggiungi persona",
 "Ainda pode gastar {v}": "Puoi ancora spendere {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "Se attivo, l'importo entra in Spese come pagato.",
 "Até (dd/mm/aaaa)": "Fino al (gg/mm/aaaa)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Aggiungi le persone in \"Chi viene\" (modifica il viaggio).",
 "Como foi?": "Com'è andata?",
 "Concluído em {d}": "Completato il {d}",
 "Confirmada em {d}": "Confermata il {d}",
 "Confirmadas": "Confermate",
 "Dia anterior": "Giorno precedente",
 "Dias": "Giorni",
 "Dias × valor por dia": "Giorni × importo al giorno",
 "Documentos (só o tipo e a validade)": "Documenti (solo tipo e scadenza)",
 "EXIGÊNCIAS DO DESTINO": "REQUISITI DELLA DESTINAZIONE",
 "Em mãos": "In mano",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Scrivi cosa richiede la destinazione (es.: 2 pagine bianche nel passaporto, certificato di vaccinazione). Verifica sul sito ufficiale del paese.",
 "Ex.: Lisboa (LIS)": "Es.: Lisbona (LIS)",
 "Ex.: São Paulo (GRU)": "Es.: San Paolo (GRU)",
 "Falta confirmar": "Da confermare",
 "Falta pôr": "Da mettere",
 "Faltou ({n}): {l}": "Dimenticato ({n}): {l}",
 "Foi ({n}): {l}": "Portato ({n}): {l}",
 "Fotos (lista das legendas)": "Foto (elenco delle didascalie)",
 "Gasto de {nome} em {d}": "Spesa di {nome} il {d}",
 "Gastos do dia": "Spese del giorno",
 "Gastos em outras moedas (não convertidos): {v}": "Spese in altre valute (non convertite): {v}",
 "Gastos por dia": "Spese per giorno",
 "Horário de chegada": "Orario di arrivo",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Luoghi (visitati, mancanti, imperdibili e il voto)",
 "Mala (o que foi e o que faltou)": "Valigia (cosa è stato portato e cosa è mancato)",
 "Marcar como acertado": "Segna come saldato",
 "Marcar como acertado?": "Segnare come saldato?",
 "Na mala": "In valigia",
 "Nenhuma parada ainda": "Nessuna tappa ancora",
 "Nova exigência": "Nuovo requisito",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "I numeri dei documenti e ciò che è nella cassaforte non finiscono mai nel resoconto. Gli importi in valute diverse appaiono separati.",
 "O QUE AINDA FALTA": "COSA MANCA ANCORA",
 "O QUE INCLUIR": "COSA INCLUDERE",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Facoltativo. L'app avvisa se il passaporto scade prima, contando dal rientro. Verifica il requisito del paese.",
 "Orçamento previsto × gasto por categoria": "Budget previsto × speso per categoria",
 "Passou do previsto em {v}": "Superato il previsto di {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Inserisci la scadenza di ogni documento: l'app avvisa prima che scada. Le foto dei documenti restano protette nella cassaforte.",
 "Próximo dia": "Giorno successivo",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "Chi è nel gruppo del viaggio viene aggiunto automaticamente. Usa \"+ Aggiungi persona\" per chi non ha l'app.",
 "Recolher o bloco": "Comprimi la sezione",
 "Relatório da viagem": "Resoconto del viaggio",
 "Reserva confirmada": "Prenotazione confermata",
 "Resumo da viagem": "Riepilogo del viaggio",
 "Resumo da viagem (datas, destino, pessoas)": "Riepilogo del viaggio (date, destinazione, persone)",
 "Roteiro por dia (feito e falta)": "Itinerario per giorno (fatto e da fare)",
 "Sem data": "Senza data",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "Il tuo passaporto potrebbe non essere accettato. Verifica il requisito del paese",
 "Subir": "Sposta su",
 "Total do dia: {v}": "Totale del giorno: {v}",
 "Uma frase (opcional)": "Una frase (facoltativo)",
 "Validade mínima exigida (meses)": "Validità minima richiesta del passaporto (mesi)",
 "Validade: {d}": "Scadenza: {d}",
 "Valor por dia": "Importo al giorno",
 "Viagens no My Planner": "Viaggi in My Planner",
 "Visitado": "Visitato",
 "Visitado em {d}": "Visitato il {d}",
 "Voltaria: {r}": "Ci tornerei: {r}",
 "Voltaria?": "Ci torneresti?",
 "confirmada": "confermata",
 "em mãos": "in mano",
 "gasto na viagem {d}": "spesa del viaggio {d}",
 "meses": "mesi",
 "outro gasto": "altra spesa",
 "vence em {d}": "scade il {d}",
 "{a} de {b} confirmadas": "{a} di {b} confermate",
 "{a} de {b} em mãos": "{a} di {b} in mano",
 "{a} de {b} feitos": "{a} di {b} fatti",
 "{a} de {b} na mala": "{a} di {b} in valigia",
 "{a} de {b} pagos": "{a} di {b} pagati",
 "{a} de {b} visitados": "{a} di {b} visitati",
 "{de} deve {v} a {para}": "{de} deve {v} a {para}",
 "{g} de {p}": "{g} di {p}",
 "{n} atividades do roteiro por fazer": "{n} attività dell'itinerario da fare",
 "{n} item(ns) enviado(s).": "{n} elemento/i inviato/i.",
 "{n} itens por pôr na mala": "{n} oggetti da mettere in valigia",
 "{n} já estava(m) no My Planner.": "{n} già presente/i in My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} liste di Viaggi venivano inviate intere a My Planner e sono state rimosse da lì. Ora l'invio è voce per voce, dal ⋮ di ciascuna voce.",
 "{n} lugares não visitados": "{n} luoghi non visitati",
 "{n} reservas por confirmar": "{n} prenotazioni da confermare",
 "{n} sem data (não foi).": "{n} senza data (non inviato).",
 "ARTIGOS E SITES": "ARTICOLI E SITI",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "Ora l’invio è elemento per elemento (dal ⋮ dell’elemento o selezionandone vari). Queste liste venivano inviate intere e sono state tolte da My Planner ({n} elemento/i, niente è stato eliminato):",
 "Artigo científico": "Articolo scientifico",
 "Artigo de site ou blog": "Articolo di sito o blog",
 "Artigo ou site": "Articolo o sito",
 "Artigos e sites": "Articoli e siti",
 "Autor(es)": "Autore/i",
 "Cadastrar pela foto ou PDF": "Aggiungi da foto o PDF",
 "Capítulo de livro": "Capitolo di libro",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea il gruppo e invia il link: chi entra vede gli articoli e segue la lettura. Chi amministra aggiunge, modifica e mette foto, e può consentirlo a chi usa anche la scheda. Solo chi amministra aggiunge o toglie persone.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Data o anno di pubblicazione",
 "Editar artigo ou site": "Modifica articolo o sito",
 "Enviar para o My Planner (lembrete de renovação)": "Invia a My Planner (promemoria di rinnovo)",
 "Envio para o My Planner": "Invio a My Planner",
 "Ex.: 2024 ou 12/03/2024": "Es.: 2024 o 12/03/2024",
 "Ex.: 45-60": "Es.: 45-60",
 "Grupo de artigos": "Gruppo di articoli",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Salva articoli, notizie e pagine web con il riferimento pronto (ABNT e APA). Compilalo dal DOI o dal link.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Letti {a} · In lettura {b} · Interrotti {c} · Da leggere {d}",
 "Minhas anotações do artigo": "Le mie note sull’articolo",
 "Notícia": "Notizia",
 "Novo artigo ou site": "Nuovo articolo o sito",
 "Os dados vêm da ficha do artigo (Editar).": "I dati vengono dalla scheda dell’articolo (Modifica).",
 "Páginas (opcional)": "Pagine (facoltativo)",
 "Revista, site ou veículo": "Rivista, sito o testata",
 "artigos e sites lidos no período": "articoli e siti letti nel periodo",
 "1 confirmado": "1 confermato",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 invitato che era in \"In sospeso\" è passato a \"Da invitare\". Inviando l’invito dall’app, passa da solo a \"Invitato, senza risposta\".",
 "1 extra": "1 extra",
 "1 talvez": "1 forse",
 "A convidar": "Da invitare",
 "Agendar na igreja": "Prenotare in chiesa",
 "Agora": "Ora",
 "Agradeci": "Ringraziato",
 "Agradeci em {d}": "Ringraziato il {d}",
 "Agradecidos": "Ringraziati",
 "Alianças": "Fedi",
 "Aluguéis (mesas, cadeiras, louças)": "Noleggi (tavoli, sedie, stoviglie)",
 "Avisar a data (save the date)": "Comunicare la data (save the date)",
 "Bebidas": "Bevande",
 "Beca e cerimônia": "Toga e cerimonia",
 "Bolo": "Torta",
 "Brincadeiras": "Giochi",
 "Brincadeiras e amigo secreto": "Giochi e Babbo Natale segreto",
 "Brindes": "Omaggi",
 "Buffet": "Catering",
 "Calculado sozinho: valor menos o sinal.": "Calcolato in automatico: importo meno l’acconto.",
 "Calcular quantidades": "Calcola quantità",
 "Categoria do orçamento": "Categoria del budget",
 "Celebrante": "Celebrante",
 "Cerimônia": "Cerimonia",
 "Cerveja (adultos)": "Birra (adulti)",
 "Checklist de preparação": "Checklist di preparazione",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Inserisci la data dell’evento (modifica l’evento) per vedere entro quando fare ogni voce.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Aggiungi le persone in \"Persone dell’evento\" (modifica l’evento).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Inserisci quanto pensi di spendere per ogni categoria. Usa ⊕ per calcolare per invitato. I fornitori ingaggiati entrano da soli nella categoria scelta.",
 "Combinado: {v}": "Concordato: {v}",
 "Comprado": "Comprato",
 "Comprados": "Comprati",
 "Comprar a decoração e as lembrancinhas": "Comprare le decorazioni e le bomboniere",
 "Comprar as alianças": "Comprare le fedi",
 "Comprar as lembrancinhas": "Comprare le bomboniere",
 "Comprar bebidas e gelo": "Comprare bevande e ghiaccio",
 "Comprar comida e bebidas": "Comprare cibo e bevande",
 "Comprar o que falta": "Comprare ciò che manca",
 "Comprar ou alugar a roupa": "Comprare o noleggiare l’abito",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Confermati con gli accompagnatori. Cambia da solo quando qualcuno conferma o disdice.",
 "Confirmar a presença dos convidados": "Confermare la presenza degli invitati",
 "Confirmar os fornecedores": "Confermare i fornitori",
 "Confirmar os fornecedores e os convidados": "Confermare fornitori e invitati",
 "Contratar a comida": "Ingaggiare il catering",
 "Contratar a comida e o bolo": "Ingaggiare catering e torta",
 "Contratar a decoração": "Ingaggiare l’allestimento",
 "Contratar comida e bebidas": "Ingaggiare cibo e bevande",
 "Contratar foto e vídeo": "Ingaggiare foto e video",
 "Contratar o buffet": "Ingaggiare il catering",
 "Convidado, sem resposta": "Invitato, senza risposta",
 "Convidados (por situação, com acompanhantes)": "Invitati (per stato, con accompagnatori)",
 "Convidados que contam no ⊕": "Invitati conteggiati in ⊕",
 "Convites": "Inviti",
 "Cronograma do dia (com responsáveis e situação)": "Programma del giorno (con responsabili e stato)",
 "Data do restante": "Data del saldo",
 "Data do sinal": "Data dell’acconto",
 "Decoração": "Allestimento",
 "Definir a data e o orçamento": "Definire data e budget",
 "Definir a lista de convidados": "Definire la lista degli invitati",
 "Doces": "Dolci",
 "Dá para mudar, tirar e incluir itens depois.": "Potrai modificare, togliere e aggiungere voci in seguito.",
 "Enviar os convites": "Inviare gli inviti",
 "Equipamentos (projetor, som)": "Attrezzature (proiettore, audio)",
 "Equipe (garçons, limpeza)": "Personale (camerieri, pulizie)",
 "Escolha \"Outro\" para escrever o nome.": "Scegli \"Altro\" per scrivere il nome.",
 "Escolher a roupa": "Scegliere l’abito",
 "Escolher a roupa dos noivos": "Scegliere gli abiti degli sposi",
 "Escolher os padrinhos": "Scegliere testimoni e padrini",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Stima per {n} invitati. Modifica ciò che vuoi prima di portarla.",
 "Eu faço": "Lo faccio io",
 "Ex.: 200 un.": "Es.: 200 pz.",
 "Ex.: Copos descartáveis": "Es.: Bicchieri usa e getta",
 "Ex.: Jogo de panelas": "Es.: Set di pentole",
 "Ex.: Reservar o local": "Es.: Prenotare la location",
 "Ex.: em negociação": "Es.: in trattativa",
 "Extras de margem (quem aparece sem avisar)": "Margine extra (chi arriva senza avvisare)",
 "Falta 1 dia": "Manca 1 giorno",
 "Falta agradecer": "Da ringraziare",
 "Falta comprar": "Da comprare",
 "Falta pagar": "Da pagare",
 "Fazer a lista de presentes": "Fare la lista regali",
 "Fazer o curso de batismo": "Fare il corso di battesimo",
 "Fornecedores (contratado, pago, falta)": "Fornitori (concordato, pagato, manca)",
 "Foto e vídeo": "Foto e video",
 "Fraldas": "Pannolini",
 "Frase curta (opcional)": "Frase breve (facoltativa)",
 "Hoje é o dia do evento!": "Oggi è il giorno dell’evento!",
 "Igreja e celebrante": "Chiesa e celebrante",
 "Incluir os Talvez": "Includere i Forse",
 "Incluir telefones": "Includere i telefoni",
 "Item da lista de compras": "Voce della lista della spesa",
 "Item da preparação": "Voce della preparazione",
 "Já deram: {d} · Falta: {f}": "Già dato: {d} · Manca: {f}",
 "Já deu": "Ha già dato",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Registra qui ciò che è stato speso. I pagamenti ai fornitori e gli acquisti spuntati entrano da soli.",
 "Lançar o gasto": "Registrare la spesa",
 "Lembrancinhas": "Bomboniere",
 "Levar para os itens": "Portare nelle voci",
 "Local / espaço": "Location / spazio",
 "Mais um extra": "Un extra in più",
 "Menos um extra": "Un extra in meno",
 "Música / som / DJ": "Musica / audio / DJ",
 "No dia do evento": "Il giorno dell’evento",
 "O que comprar": "Cosa comprare",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "Il totale cambia da solo quando qualcuno conferma o disdice.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "L’importo del contratto entra da solo come previsto in questa categoria, e ciò che viene pagato va nelle spese.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "L’importo entra nelle spese dell’evento, nella categoria della voce. Se preferisci, salta.",
 "Onde comprar": "Dove comprare",
 "Orçamento do evento": "Budget dell’evento",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Le voci spuntate entrano nella categoria con ⊕ per invitato. Poi basta toccare ⊕ e inserire il prezzo unitario.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "I telefoni degli invitati compaiono nel PDF solo se spunti \"Includere i telefoni\". Gli importi in valute diverse sono mostrati separati.",
 "Pago em {d}": "Pagato il {d}",
 "Parte da vaquinha": "Quota della colletta",
 "Pessoas do evento": "Persone dell’evento",
 "Pessoas do evento: {p}": "Persone dell’evento: {p}",
 "Preparar as brincadeiras": "Preparare i giochi",
 "Preparação": "Preparazione",
 "Presente recebido": "Regalo ricevuto",
 "Presentes": "Regali",
 "Prova final da roupa": "Prova finale dell’abito",
 "Pular": "Salta",
 "Quantidade por convidado": "Quantità per invitato",
 "Quantidade por convidado × valor unitário": "Quantità per invitato × prezzo unitario",
 "Quanto custou?": "Quanto è costato?",
 "Quanto já deu": "Quanto ha già dato",
 "Quanto vai contribuir": "Quanto contribuirà",
 "Quantos dias antes do evento": "Quanti giorni prima dell’evento",
 "Quem deu": "Chi l’ha dato",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Chi è nel gruppo dell’evento entra da solo. Usa \"+ Aggiungi persona\" per chi non ha l’app. Questa lista è usata nel programma, nelle spese e nella colletta.",
 "Recreação e brinquedos": "Animazione e giochi",
 "Refrigerante": "Bibite",
 "Relatório do evento": "Report dell’evento",
 "Relatório do evento (PDF)": "Report dell’evento (PDF)",
 "Reservar o local": "Prenotare la location",
 "Reservar o local da cerimônia e da festa": "Prenotare la location di cerimonia e festa",
 "Reservar o local ou a mesa da festa": "Prenotare la location o il tavolo della festa",
 "Restante": "Saldo",
 "Restante pago": "Saldo pagato",
 "Resumo do evento": "Riepilogo dell’evento",
 "Roupa e beleza": "Abiti e bellezza",
 "Salgados": "Salatini",
 "Separar a roupa e o que levar": "Preparare l’abito e cosa portare",
 "Separar os documentos e as alianças": "Preparare i documenti e le fedi",
 "Separar os documentos e os ingressos": "Preparare i documenti e i biglietti",
 "Sinal": "Acconto",
 "Sinal pago": "Acconto pagato",
 "Sinal {v} pago": "Acconto {v} pagato",
 "Usar a lista pronta para {tipo}": "Usa la lista pronta per {tipo}",
 "Vai contribuir": "Contribuirà",
 "Valor unitário": "Prezzo unitario",
 "Vaquinha": "Colletta",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "Segui tutto ciò che è stato condiviso, sempre aggiornato. Per aggiungere, modificare e prendere compiti, abbonati alla scheda.",
 "agradeci": "ringraziato",
 "atrasado": "in ritardo",
 "completo": "completo",
 "deu {d} de {v}": "ha dato {d} su {v}",
 "em {l}": "a {l}",
 "falta o valor": "manca l’importo",
 "falta {v} até {d}": "mancano {v} entro il {d}",
 "gasto em {e}": "speso per {e}",
 "kg": "kg",
 "o evento": "l’evento",
 "restante": "saldo",
 "sinal": "acconto",
 "total": "totale",
 "un.": "pz.",
 "{n} confirmados": "{n} confermati",
 "{n} convidados contam no ⊕ por convidado.": "{n} invitati contano in ⊕ per invitato.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} invitati che erano in \"In sospeso\" sono passati a \"Da invitare\". Inviando l’invito dall’app, passano da soli a \"Invitato, senza risposta\".",
 "{n} extras": "{n} extra",
 "{n} talvez": "{n} forse",
 "{q} por convidado": "{q} per invitato",
 "{v} por convidado": "{v} per invitato",
 "Item completo": "Elemento completo",
 "Nota rápida": "Nota rapida",
 "📝 Nota rápida": "📝 Nota rapida",
 "Conteúdo da nota": "Contenuto della nota",
 "{c} confirmado(s) de {n} convidado(s)": "{c} confermato/i su {n} invitato/i",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "Verranno eliminati per tutti: i documenti, le riunioni programmate e le registrazioni dell’ufficio \"{nome}\". La chat resta in Messaggi.",
 "Confirme para apagar o escritório": "Conferma per eliminare l’ufficio",
 "Escreva o assunto da reunião para poder marcar.": "Scrivi l’argomento della riunione per poterla fissare.",
 "{n} min (marcada para {m} min)": "{n} min (prevista per {m} min)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "Impossibile scaricare il file ora. Controlla la connessione e riprova.",
 "Meus clientes": "I miei clienti",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "Un’unica lista di clienti, usata da tutte le schede di lavoro: contatto, indirizzo, etichette, note e file.",
 "Copiar para Meus clientes": "Copia in I miei clienti",
 "Ver ou mudar": "Vedi o modifica",
 "Ver o documento completo": "Vedi il documento completo",
 "CEP incompleto": "CEP incompleto",
 "O CEP tem 8 números.": "Il CEP ha 8 cifre.",
 "CEP não encontrado": "CEP non trovato",
 "Confira os números ou preencha o endereço à mão.": "Controlla i numeri o compila l’indirizzo a mano.",
 "Não foi possível buscar o CEP": "Impossibile cercare il CEP",
 "Confira a internet ou preencha o endereço à mão.": "Controlla la connessione internet o compila l’indirizzo a mano.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "Sembra che manchi qualcosa in questa e-mail (es.: nome@sito.com).",
 "opcional": "facoltativo",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Ora i tuoi clienti sono in un’unica lista, usata da tutte le schede di lavoro.",
 "Portal do Cliente: {n} cliente(s).": "Portale Cliente: {n} cliente/i.",
 "Freelancer & Projetos: {n} cliente(s).": "Freelance & Progetti: {n} cliente/i.",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} erano lo stesso cliente in più schede e ora sono un’unica scheda.",
 "Nenhum cliente repetido.": "Nessun cliente duplicato.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "Non è stato eliminato nulla: documenti, ordini, schede e ore restano dov’erano.",
 "Já está em Meus clientes": "È già in I miei clienti",
 "{nome} já está na lista.": "{nome} è già nella lista.",
 "Copiado para Meus clientes": "Copiato in I miei clienti",
 "Só o nome e o contato foram copiados.": "Sono stati copiati solo il nome e il contatto.",
 "Aniversário hoje!": "Compleanno oggi!",
 "Fechar tudo": "Chiudi tutto",
 "Abrir tudo": "Apri tutto",
 "Quem é": "Chi è",
 "Razão social": "Ragione sociale",
 "Nome fantasia": "Nome commerciale",
 "Data de abertura": "Data di apertura",
 "Inscrição estadual / municipal": "Iscrizione statale / comunale",
 "Outras pessoas de contato": "Altri referenti",
 "Como chamar": "Come chiamarlo",
 "Cliente desde": "Cliente dal",
 "Outro telefone": "Altro telefono",
 "Site": "Sito web",
 "Melhor jeito de falar": "Modo migliore per contattarlo",
 "Autorizou receber mensagens": "Ha autorizzato a ricevere messaggi",
 "Outros endereços": "Altri indirizzi",
 "Relacionamento": "Relazione",
 "Como me conheceu": "Come mi ha conosciuto",
 "Etiquetas": "Etichette",
 "Nada anotado ainda.": "Ancora nessuna nota.",
 "Bloco da aba {aba}": "Sezione della scheda {aba}",
 "Abrir na aba {aba}": "Apri nella scheda {aba}",
 "Uma lista só, usada por todas as abas de trabalho.": "Un’unica lista, usata da tutte le schede di lavoro.",
 "Escreva o nome do cliente.": "Scrivi il nome del cliente.",
 "Telefone / WhatsApp": "Telefono / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Solo il nome è obbligatorio. Apri le parti che vuoi compilare.",
 "Como chamar (apelido)": "Come chiamarlo (soprannome)",
 "Inscrição estadual / municipal (opcional)": "Iscrizione statale / comunale (facoltativo)",
 "Cargo": "Ruolo",
 "Telefone da pessoa de contato": "Telefono del referente",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Altri referenti (uno per riga: nome, ruolo, telefono)",
 "O telefone principal é WhatsApp": "Il telefono principale è su WhatsApp",
 "O outro telefone é WhatsApp": "L’altro telefono è su WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "Es.: @nome",
 "Ex.: WhatsApp, à tarde": "Es.: WhatsApp, il pomeriggio",
 "Estado (UF)": "Stato (UF)",
 "Endereço (como estava escrito)": "Indirizzo (come era scritto)",
 "Outros endereços (trabalho, entrega...)": "Altri indirizzi (lavoro, consegna...)",
 "Google": "Google",
 "Passou na frente": "È passato davanti",
 "Indicado por": "Segnalato da",
 "Criar etiqueta": "Crea etichetta",
 "Ex.: VIP, Mensal, Atacado": "Es.: VIP, Mensile, Ingrosso",
 "Ativo": "Attivo",
 "Inativo": "Inattivo",
 "Em negociação": "In trattativa",
 "O cliente autorizou receber mensagens?": "Il cliente ha autorizzato a ricevere messaggi?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Senza autorizzazione, niente messaggi di compleanno, solleciti automatici o promozioni per questo cliente.",
 "aniversário hoje": "compleanno oggi",
 "contato: {n}": "contatto: {n}",
 "com esse telefone": "con questo telefono",
 "com esse e-mail": "con questa e-mail",
 "com esse documento": "con questo documento",
 "com esse nome": "con questo nome",
 "Cliente parecido": "Cliente simile",
 "Já existe {nome} {por}. Abrir?": "Esiste già {nome} {por}. Aprire?",
 "Cadastrar mesmo assim": "Aggiungi comunque",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "Verranno eliminati: la scheda, le note e i file di questo cliente.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "Anche nelle schede: {abas} (con i relativi documenti, ordini, schede e ore).",
 "Juntar com outra ficha": "Unisci con un’altra scheda",
 "Juntar fichas": "Unisci schede",
 "Não há outra ficha para juntar.": "Non c’è un’altra scheda da unire.",
 "Juntar \"{nome}\" com:": "Unisci \"{nome}\" con:",
 "Juntar as duas fichas?": "Unire le due schede?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "\"{a}\" riceve tutto da \"{b}\" (dati, note, file e collegamenti alle schede). La scheda \"{b}\" non esisterà più.",
 "Juntar": "Unisci",
 "Confirme para juntar as fichas": "Conferma per unire le schede",
 "Aniversariantes do mês": "Compleanni del mese",
 "Ativos": "Attivi",
 "Inativos": "Inattivi",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Aggiungi ogni cliente una volta: comparirà in tutte le schede di lavoro che usi.",
 "Novo cliente": "Nuovo cliente",
 "Editar cliente": "Modifica cliente",
 "Linha do tempo": "Cronologia",
 "{n} registro(s)": "Registrazioni: {n}",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Ancora niente. Qui compaiono vendite, pagamenti, documenti e ore.",
 "Me deve": "Mi deve",
 "Total pago": "Totale pagato",
 "Última compra ou atendimento": "Ultimo acquisto o servizio",
 "Próximo compromisso": "Prossimo appuntamento",
 "na entrega": "alla consegna",
 "Passou do limite de fiado ({v}).": "Limite di credito superato ({v}).",
 "Recebeu {v} ({p})": "Ricevuto {v} ({p})",
 "Hoje é aniversário de {n}.": "Oggi è il compleanno di {n}.",
 "Mandar parabéns": "Fai gli auguri",
 "{n}: parcela de {v} atrasada.": "{n}: rata di {v} in ritardo.",
 "Cobrar": "Sollecita",
 "{n} não compra há {d} dias.": "{n} non acquista da {d} giorni.",
 "Chamar de volta": "Ricontatta",
 "🟢 em dia · 🟡 sumido": "🟢 in regola · 🟡 assente",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 in regola · 🟡 qualcosa in scadenza o cliente assente · 🔴 in ritardo",
 "Limite de fiado (opcional)": "Limite di credito (facoltativo)",
 "Avisa quando o que ele deve passar deste valor.": "Ti avvisa quando il suo debito supera questo importo.",
 "A prazo": "A rate",
 "parcela atrasada": "rata in ritardo",
 "falta na entrega": "resto alla consegna",
 "Sumidos": "Assenti",
 "Sinal pago, falta o resto": "Acconto pagato, manca il saldo",
 "Pagou {a} de {b}": "Pagato {a} su {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "Questa rata proviene da I miei clienti. Segnala qui come ricevuta o apri il cliente per sollecitare e generare la ricevuta.",
 "Sinal + restante": "Acconto + saldo",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Carta di credito in un’unica soluzione",
 "Cartão de crédito parcelado": "Carta di credito a rate",
 "Fiado / a prazo": "A credito / a rate",
 "Parcela única": "Rata unica",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "Ciao, {nome}! Buon compleanno! 🎉 Ti auguro una splendida giornata. Un abbraccio!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "Ciao, {nome}! È da un po’ che non ci sentiamo. Posso aiutarti in qualcosa? Sarà un piacere servirti di nuovo!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "Ciao, {nome}! Ti ricordo la rata di {v} scaduta il {d}. Per qualsiasi cosa, scrivimi. Grazie!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "Ciao, {nome}! Ti ricordo la rata di {v}{d}. Per qualsiasi cosa, scrivimi. Grazie!",
 "que vence dia {d}": "in scadenza il {d}",
 "Quanto recebeu?": "Quanto hai ricevuto?",
 "Falta {v}. Pode ser só uma parte.": "Mancano {v}. Può essere anche solo una parte.",
 "(seu nome ou sua marca, em Como você recebe?)": "(il tuo nome o marchio, in Come vieni pagato?)",
 "Recibo {c}": "Ricevuta {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "Ho ricevuto da {c} la somma di {v}, relativa a {o}.",
 "{v} no {f} → recebe {l}": "{v} con {f} → ricevi {l}",
 "Pagou {a} de {b}, faltam {c}": "Pagato {a} su {b}, mancano {c}",
 "Recebido em {d}": "Ricevuto il {d}",
 "Cobrar pelo WhatsApp": "Sollecita su WhatsApp",
 "Sem autorização": "Non autorizzato",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "Questo cliente non ha autorizzato a ricevere messaggi (scheda cliente › Relazione).",
 "Sem telefone": "Nessun telefono",
 "Coloque o telefone na ficha do cliente.": "Aggiungi il telefono nella scheda cliente.",
 "Gerar recibo": "Genera ricevuta",
 "Como você recebe?": "Come vieni pagato?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Solo \"Subito\": schermata pulita, senza rate né rosso.",
 "Taxa da maquininha (%)": "Commissione POS (%)",
 "Taxa {k}": "Commissione {k}",
 "Cliente sumido depois de (dias sem comprar)": "Cliente assente dopo (giorni senza acquisti)",
 "Dias para considerar sumido": "Giorni per considerarlo assente",
 "Lembretes de cobrança por parcela atrasada": "Promemoria di pagamento per rate in ritardo",
 "Nome ou marca no recibo": "Nome o marchio sulla ricevuta",
 "Ex.: Ana Beatriz Doces": "Es.: Ana Beatriz Dolci",
 "Venda ou serviço": "Vendita o servizio",
 "O que foi vendido ou feito": "Cosa è stato venduto o fatto",
 "Ex.: Bolo de aniversário": "Es.: Torta di compleanno",
 "Como paga": "Come paga",
 "Sinal (%)": "Acconto (%)",
 "Ou escreva o valor do sinal logo abaixo.": "Oppure scrivi l’importo dell’acconto qui sotto.",
 "Sinal (valor)": "Acconto (importo)",
 "Restante na entrega": "Saldo alla consegna",
 "Próximo vencimento": "Prossima scadenza",
 "Sinal a receber": "Acconto da ricevere",
 "falta {v}{q}": "mancano {v}{q}",
 "quitado": "saldato",
 "Parcelas mantidas": "Rate mantenute",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "C’è già un pagamento registrato: le rate non sono state rifatte. Per cambiarle, annulla prima i pagamenti.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Registra cosa ha acquistato il cliente o il servizio che hai svolto, e come paga.",
 "Débito": "Debito",
 "Crédito à vista": "Credito in un’unica soluzione",
 "Crédito 2x": "Credito in 2 rate",
 "Crédito 3x": "Credito in 3 rate",
 "Crédito 4x": "Credito in 4 rate",
 "Crédito 5x": "Credito in 5 rate",
 "Crédito 6x": "Credito in 6 rate",
 "Crédito 7x": "Credito in 7 rate",
 "Crédito 8x": "Credito in 8 rate",
 "Crédito 9x": "Credito in 9 rate",
 "Crédito 10x": "Credito in 10 rate",
 "Crédito 11x": "Credito in 11 rate",
 "Crédito 12x": "Credito in 12 rate",
 "ATRASADOS": "IN RITARDO",
 "Atrasado (hoje): {v}": "In ritardo (oggi): {v}",
 "Buscar um cliente": "Cerca un cliente",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "CPF/CNPJ completo, indirizzo completo e data di nascita. Richiede la password dell’app.",
 "Cliente cadastrado": "Cliente aggiunto",
 "Com documentos: guarde o arquivo em lugar seguro.": "Con documenti: conserva il file in un luogo sicuro.",
 "Como pagou": "Come ha pagato",
 "Esse contato não tem nome.": "Questo contatto non ha un nome.",
 "Exportar planilha": "Esporta foglio di calcolo",
 "Falta receber": "Da incassare",
 "Falta receber (hoje): {v}": "Da incassare (oggi): {v}",
 "Importar dos contatos": "Importa dai contatti",
 "Importar dos contatos do celular": "Importa dai contatti del telefono",
 "Incluir documentos": "Includi documenti",
 "Incluir documentos no relatório": "Includi documenti nel report",
 "MELHORES CLIENTES": "CLIENTI MIGLIORI",
 "Melhores clientes": "Clienti migliori",
 "Não foi possível gerar a planilha.": "Impossibile generare il foglio di calcolo.",
 "O que foi": "Cosa",
 "Pago em": "Pagato il",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "Per importare clienti dai contatti del telefono, aggiorna My Planner dallo store delle app.",
 "RECEBIDO POR DIA": "INCASSATO PER GIORNO",
 "RECEBIDO POR MÊS": "INCASSATO PER MESE",
 "Recebeu": "Incassato",
 "Recebeu no período": "Incassato nel periodo",
 "Recebeu no período: {v}": "Incassato nel periodo: {v}",
 "Recebido no período": "Incassato nel periodo",
 "Relatório de clientes": "Report clienti",
 "Relatório deste cliente": "Report di questo cliente",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Senza il permesso per i contatti non puoi scegliere un contatto. Puoi attivarlo nelle impostazioni del telefono.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Senza documenti: il CPF/CNPJ mostra solo le ultime 2 cifre. Le note non vengono mai incluse.",
 "Todos os clientes": "Tutti i clienti",
 "Trabalha em: {e}": "Lavora presso: {e}",
 "Trazer outro": "Aggiungine un altro",
 "VENDAS E ATENDIMENTOS": "VENDITE E SERVIZI",
 "Vence": "Scadenza",
 "Venceu": "Scaduto",
 "Vendas e atendimentos": "Vendite e servizi",
 "Vendeu": "Venduto",
 "Vendeu no período": "Venduto nel periodo",
 "Vendeu no período: {v}": "Venduto nel periodo: {v}",
 "venceu {d}": "scaduto il {d}",
 "vendido no período": "venduto nel periodo",
 "{nome} comprou no período": "{nome} ha acquistato nel periodo",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} è stato aggiunto a I miei clienti. Controlla la scheda e indica se ha autorizzato a ricevere messaggi.",
 "{n} compra(s)": "Acquisti: {n}",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Trascina una casella a sinistra per archiviarla o a destra per eliminarla. Tieni premuta una parte libera della casella e trascina per cambiare l’ordine.",
 "Bloco": "Blocco",
 "Confirme para apagar o grupo": "Conferma per eliminare il gruppo",
 "Descer": "Sposta giù",
 "Opções do bloco": "Opzioni del blocco",
 "Exigências do destino": "Requisiti della destinazione",
 "{n} para acertar": "Da saldare: {n}",
 "{n} parada(s)": "Tappe: {n}",
 "Cor do item selecionado": "Colore dell’elemento selezionato",
 "Abrir o grupo": "Apri il gruppo",
 "Recolher o grupo": "Comprimi il gruppo",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Trascina una casella a destra per eliminarla o a sinistra per archiviarla. Tieni premuto e trascina per cambiare l’ordine.",
 "Editar subtítulo": "Modifica sottotitolo",
 "Início da caixa": "Inizio della casella",
 "Mover para…": "Sposta in…",
 "Mover {n} item(ns) para": "Sposta elementi ({n}) in",
 "Opções do item": "Opzioni dell’elemento",
 "Transformar em subtítulo": "Trasforma in sottotitolo",
 "Transformar em texto": "Trasforma in testo",
 "esta caixa": "questa casella",
 "{a} de {n} feitos": "{a} di {n} fatti",
 "1 documento pedido atrasado": "1 documento richiesto in ritardo",
 "1 pedido vence logo": "1 richiesta in scadenza",
 "A lista vem de \"Meus clientes\".": "L’elenco viene da \"I miei clienti\".",
 "Abrir Meus clientes": "Apri I miei clienti",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "Le schede Studio e Portale Clienti ora sono una sola.",
 "Clientes com pendência": "Clienti con sospesi",
 "Com pendência ({n})": "Con sospesi ({n})",
 "Conversa da equipe": "Chat del team",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Crea lo studio e invita il team (amici dell’app o invito via link): chat, riunioni video e documenti interni. Lavori da solo? Usa solo Clienti.",
 "Documentos internos": "Documenti interni",
 "Entrar com um código de convite": "Entra con un codice di invito",
 "Escritório & Clientes": "Studio & Clienti",
 "Escritórios: {n}": "Studi: {n}",
 "Esta parte é para quem trabalha com equipe": "Questa parte è per chi lavora in team",
 "Guias vencendo": "Modelli di pagamento in scadenza",
 "Minhas tarefas": "Le mie attività",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "Non è stato eliminato nulla: team, chat, riunioni, documenti e clienti invitati restano come prima.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "Ancora nessun cliente. Aggiungilo in \"I miei clienti\": compare subito qui.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "Per chi lavora con i clienti, da solo o in team: la cartella di ogni cliente (documenti, richieste, modelli di pagamento), team, chat, riunioni e documenti interni.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Cartelle clienti del Portale: {c} (con {d} documenti e {p} richieste)",
 "Pessoa física": "Persona fisica",
 "Procurar por nome, CNPJ ou CPF": "Cerca per nome, CNPJ o CPF",
 "Reuniões hoje": "Riunioni di oggi",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "Nessuno studio (team). Tocca per crearne uno o entrare con un codice.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Lo vede solo il team. I clienti non vedono mai questa parte.",
 "Tudo em dia": "Tutto in regola",
 "Vencendo ({n})": "In scadenza ({n})",
 "chega na próxima versão": "arriva nella prossima versione",
 "nos próximos 7 dias": "nei prossimi 7 giorni",
 "vence amanhã": "scade domani",
 "vence hoje": "scade oggi",
 "{doc} venceu em {d}": "{doc} è scaduto il {d}",
 "{n} documentos pedidos atrasados": "{n} documenti richiesti in ritardo",
 "{n} pedidos vencem logo": "{n} richieste in scadenza",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 in regola · 🟡 qualcosa in scadenza · 🔴 richiesta in ritardo o modello scaduto",
 "Acesso ao gov.br": "Accesso a gov.br",
 "Alvará": "Licenza di esercizio",
 "Até o dia (do mês)": "Entro il giorno (del mese)",
 "CCMEI (certificado do MEI)": "CCMEI (certificato MEI)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Aggiungi il telefono del cliente per ricordarglielo su WhatsApp.",
 "Cartão CNPJ": "Certificato CNPJ",
 "Checklist criado": "Checklist creata",
 "Checklist de cliente novo": "Checklist nuovo cliente",
 "Cliente viu {doc}": "Il cliente ha visto {doc}",
 "Cole no app do banco, em Pix copia e cola.": "Incollalo nell’app della banca, in Pix copia e incolla.",
 "Cole no app do banco.": "Incollalo nell’app della banca.",
 "Comprovante de endereço": "Prova di residenza",
 "Contrato social e alterações": "Atto costitutivo e modifiche",
 "Copiado": "Copiato",
 "Copiar Pix": "Copia Pix",
 "Copiar código de barras": "Copia codice a barre",
 "Código de barras (linha digitável)": "Codice a barre (riga numerica)",
 "Dados bancários": "Dati bancari",
 "Escreva o recado.": "Scrivi il messaggio.",
 "Escritório enviou {doc}": "Lo studio ha inviato {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "Questo cliente non ha autorizzato a ricevere messaggi (scheda in I miei clienti).",
 "Extratos bancários": "Estratti conto",
 "Ficha completa": "Scheda completa",
 "Guia": "Modello di pagamento",
 "Guias a pagar": "Pagamenti da fare",
 "Honorário": "Onorario",
 "Honorário por": "Onorario per",
 "Informes de rendimentos": "Certificazioni dei redditi",
 "Lembrar pelo WhatsApp": "Ricorda su WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "Leggi il modello o il boleto con la mia IA",
 "Lucro presumido": "Utile presunto",
 "Lucro real": "Utile effettivo",
 "Nada ainda.": "Ancora niente.",
 "Nenhum pedido em aberto.": "Nessuna richiesta aperta.",
 "Notas fiscais emitidas": "Fatture emesse",
 "O cliente": "Il cliente",
 "O pedido entrou em Pedidos de documentos.": "La richiesta è stata aggiunta a Richieste di documenti.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "Ciao {nome}! Manca: {itens}. Puoi mandarlo qui?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "Ciao {nome}! Mancano: {itens}. Puoi mandarli qui?",
 "Oi, {nome}! Tudo certo por aí?": "Ciao {nome}! Tutto bene lì?",
 "Pedido criado": "Richiesta creata",
 "Pedido feito: {o}": "Richiesta inviata: {o}",
 "Pedido recebido: {o}": "Richiesta ricevuta: {o}",
 "Pedidos pendentes": "Richieste in sospeso",
 "Pedir de novo todo mês": "Richiedi di nuovo ogni mese",
 "Pedir nova ({c})": "Richiedi nuova ({c})",
 "Pendentes": "In sospeso",
 "Que tipo de cliente?": "Che tipo di cliente?",
 "RG e CPF": "RG e CPF",
 "RG e CPF do titular": "RG e CPF del titolare",
 "RG e CPF dos sócios": "RG e CPF dei soci",
 "Recados": "Messaggi",
 "Recados entre você e o cliente, presos à pasta dele.": "Messaggi tra te e il cliente, salvati nella sua cartella.",
 "Responde ao pedido": "Risponde alla richiesta",
 "Tipo / regime": "Tipo / regime",
 "Visto pelo cliente em {d}": "Visto dal cliente il {d}",
 "Válido até": "Valido fino al",
 "ano": "anno",
 "código Pix copia e cola, se houver": "codice Pix copia e incolla, se presente",
 "data de vencimento": "data di scadenza",
 "documento": "documento",
 "linha digitável do boleto ou da guia, só números": "riga numerica del boleto o del modello, solo cifre",
 "mês": "mese",
 "novo": "nuovo",
 "todo mês, até o dia {n}": "ogni mese, entro il giorno {n}",
 "valor a pagar": "importo da pagare",
 "válido até {d}": "valido fino al {d}",
 "{c} nova": "{c} nuovo",
 "{doc} pago": "{doc} pagato",
 "{n} a pagar": "{n} da pagare",
 "{n} enviou {doc}": "{n} ha inviato {doc}",
 "{n} novo(s)": "Nuovi: {n}",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "Richieste di documenti create: {n}, con scadenza a 7 giorni.",
 "{n} vencida(s)": "Scadute: {n}",
 "Última declaração do Imposto de Renda": "Ultima dichiarazione dei redditi",
 "Últimas guias pagas": "Ultimi pagamenti effettuati",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "Questa parte dell’Ufficio non è ancora collegata al server. Sul computer, esegui 56-SERVIDOR-0.96.bat (una volta sola).",
 "Só vê": "Solo vede",
 "Nova versão": "Nuova versione",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "Esisteva già un file con questo nome: il precedente viene conservato come versione {n}.",
 "Visto por e comentários": "Visto da e commenti",
 "Arquivar (só neste aparelho)": "Archivia (solo su questo dispositivo)",
 "Tirar do topo": "Rimuovi dalla cima",
 "Fixar no topo (para todos)": "Fissa in alto (per tutti)",
 "Mover para a pasta…": "Sposta nella cartella…",
 "versão {n}": "versione {n}",
 "visto por {n}": "visto da {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "Fino a 50 MB per file. Caricare un file con lo stesso nome conserva il precedente come versione.",
 "Procurar documento ou pasta": "Cerca documento o cartella",
 "Fixados": "Fissati",
 "Abrir o documento": "Apri il documento",
 "enviado por {nome}": "caricato da {nome}",
 "Versões ({n})": "Versioni ({n})",
 "Versão {n} (atual)": "Versione {n} (attuale)",
 "Versão {n}": "Versione {n}",
 "Visto por ({n})": "Visto da ({n})",
 "Ninguém da equipe abriu ainda.": "Nessuno del team l’ha ancora aperto.",
 "{nome} em {d}": "{nome} il {d}",
 "Comentários ({n})": "Commenti ({n})",
 "Escreva um comentário": "Scrivi un commento",
 "Contratos": "Contratti",
 "Financeiro do escritório": "Finanze dell’ufficio",
 "RH": "Risorse umane",
 "Mover para a pasta": "Sposta nella cartella",
 "Ou escreva o nome de uma pasta nova": "Oppure scrivi il nome di una nuova cartella",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "Si ripete ogni settimana: annullandola, scompare da tutte le settimane, dall’elenco e dai Ricevuti del team.",
 "a equipe toda": "tutto il team",
 "Com {quem}": "Con {quem}",
 "toda semana": "ogni settimana",
 "Vão: {n}": "Partecipano: {n}",
 "Não vão: {n}": "Non partecipano: {n}",
 "Vou": "Vado",
 "Não vou": "Non vado",
 "Pauta": "Ordine del giorno",
 "Ata": "Verbale",
 "Escrever a ata": "Scrivere il verbale",
 "Abrir o link": "Apri il link",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Ogni persona invitata riceve la riunione in Ricevuti e la aggiunge al Planner con un tocco, con l’avviso.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "Scrivi prima gli appunti della riunione (cosa è stato detto e deciso); l’IA li organizza in un verbale.",
 "Ata: {nome}": "Verbale: {nome}",
 "Gerando...": "Generazione...",
 "Gerar ata com a minha IA": "Genera verbale con la mia IA",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "L’IA organizza l’ordine del giorno e i tuoi appunti in un verbale. Controlla prima di salvare.",
 "Ainda sem ata.": "Ancora nessun verbale.",
 "Tarefas da reunião ({n})": "Attività della riunione ({n})",
 "Tarefa da reunião": "Attività della riunione",
 "Salvar a ata": "Salva il verbale",
 "Repetir toda semana ({dia})": "Ripeti ogni settimana ({dia})",
 "Quem participa": "Chi partecipa",
 "A equipe toda": "Tutto il team",
 "Link externo (opcional: Meet, Zoom, Teams)": "Link esterno (facoltativo: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "Il link deve iniziare con https://",
 "Marcar e avisar quem participa": "Fissa e avvisa i partecipanti",
 "Cargo e papel": "Ruolo e permessi",
 "Passar o Admin": "Passa l’Admin",
 "Passar o Admin para {nome}?": "Passare l’Admin a {nome}?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} diventa la persona che gestisce l’ufficio (e può eliminarlo). Tu resti nel team come amministratore (chi lo riceve potrà cambiarlo in seguito).",
 "Passar": "Passa",
 "{nome} agora cuida do escritório.": "{nome} ora gestisce l’ufficio.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "Il tuo ruolo qui è \"Solo vede\": segui avvisi, attività, riunioni e documenti.",
 "Edita": "Modifica",
 "Incluir": "Aggiungi",
 "Novo aviso no mural": "Nuovo avviso in bacheca",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "Puoi solo vedere questo ufficio: chi amministra ha scelto per te il ruolo \"Solo vede\". Chiedi a chi amministra di cambiarlo, se serve.",
 "Quem viu": "Chi ha visto",
 "Apagar aviso": "Elimina avviso",
 "Mural de avisos": "Bacheca avvisi",
 "Novo aviso": "Nuovo avviso",
 "Ex.: Feriado na sexta: escritório fechado": "Es.: Festivo venerdì: ufficio chiuso",
 "Fixar no mural": "Fissa in bacheca",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "Nessun avviso. Gli avvisi restano fissati qui per tutto il team.",
 "visto por {n} de {m}": "visto da {n} su {m}",
 "sem responsável": "senza responsabile",
 "atrasada desde {d}": "in ritardo dal {d}",
 "prazo {d}": "scadenza {d}",
 "Comecei": "Iniziato",
 "Terminei": "Finito",
 "Reabrir": "Riapri",
 "Tarefas da equipe": "Attività del team",
 "1 aberta": "1 aperta",
 "{n} abertas": "{n} aperte",
 "Minhas tarefas ({n})": "Le mie attività ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "Nessuna tua attività aperta. Tocca \"Me ne occupo io\" su un’attività del team.",
 "Nenhuma tarefa aberta.": "Nessuna attività aperta.",
 "Feitas ({n})": "Completate ({n})",
 "Apagar a tarefa?": "Eliminare l’attività?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "Cosa c’è da fare? (es.: Calcolare il DAS di marzo)",
 "Cliente (opcional)": "Cliente (facoltativo)",
 "Prazo (opcional)": "Scadenza (facoltativo)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Responsabile (facoltativo; altrimenti qualcuno tocca \"Me ne occupo io\")",
 "Escreva a tarefa para poder salvar.": "Scrivi l’attività per poter salvare.",
 "Membro": "Membro",
 "Cargo (livre)": "Ruolo (libero)",
 "Ex.: Advogada, Assistente, Estagiário": "Es.: Avvocata, Assistente, Stagista",
 "Papel": "Ruolo",
 "Admin: pode tudo no escritório.": "Admin: può fare tutto nell’ufficio.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Modifica: aggiunge attività, avvisi, documenti e riunioni",
 "Só vê: acompanha tudo, sem incluir nem mudar": "Solo vede: segue tutto, senza aggiungere né modificare",
 "Proposta": "Proposta",
 "Documento sensível (pede a senha do app para abrir)": "Documento sensibile (chiede la password dell’app per aprirlo)",
 "Li e concordo: {d}": "Letto e accettato: {d}",
 "Li e concordo": "Ho letto e accetto",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "Toccando Accetto, l’app salva la data e l’ora in cui hai letto e accettato \"{doc}\". È un’accettazione semplice: non sostituisce una firma digitale ufficiale.",
 "Concordo": "Accetto",
 "Fotos (escolha quais entram)": "Foto (scegli quali includere)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 foto non è stata letta su questo dispositivo ed è rimasta fuori.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} foto non sono state lette su questo dispositivo e sono rimaste fuori.",
 "Nenhuma foto no álbum desta viagem.": "Nessuna foto nell’album di questo viaggio.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Tocca le foto per selezionarle o deselezionarle. Entrano ridotte, così il PDF resta leggero.",
 "Sugerir até 12": "Suggerisci fino a 12",
 "1 foto marcada": "1 foto selezionata",
 "{n} fotos marcadas": "{n} foto selezionate",
 "Com mais de 12 fotos o PDF fica mais pesado.": "Con più di 12 foto il PDF diventa più pesante.",
 "Confirme para abrir este documento": "Conferma per aprire questo documento",
 "Como usar esta aba": "Come usare questa scheda",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 cliente era in più di una scheda ed è diventato una scheda sola.",
 "Juntar {n} fotos num PDF?": "Unire {n} foto in un PDF?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "Le foto diventano le pagine di un unico PDF, nell’ordine dell’elenco. Le foto singole vengono rimosse da questa scheda.",
 "Não foi possível ler as fotos neste dispositivo.": "Impossibile leggere le foto su questo dispositivo.",
 "PDF criado": "PDF creato",
 "Montando o PDF...": "Creazione del PDF...",
 "Juntar as {n} fotos num PDF": "Unisci le {n} foto in un PDF",
 "Baixar o mês": "Scarica il mese",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "I file di questo mese si trovano su un altro dispositivo e non è stato possibile leggerli qui.",
 "Os documentos deste mês não têm arquivos.": "I documenti di questo mese non hanno file.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 file si trova su un altro dispositivo ed è stato escluso.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} file si trovano su un altro dispositivo e sono stati esclusi.",
 "Conversa sobre este documento": "Conversazione su questo documento",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Chiedi o rispondi qualcosa su questo documento. Lo vedono lo studio e il cliente.",
 "Escreva a mensagem": "Scrivi il messaggio",
 "Usar um modelo de pedido ({n})": "Usa un modello di richiesta ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "Ricorda a {nome} su WhatsApp: {o}",
 "Sem honorário": "Nessun onorario",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Inserisci l’importo dell’onorario nel blocco \"Studio\" della scheda del cliente, in I miei clienti.",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "Ho ricevuto da {c} la somma di {v}, relativa agli onorari del periodo di competenza {m}.",
 "Recibo honorário {m} {c}": "Ricevuta onorari {m} {c}",
 "Recibo do honorário {m}": "Ricevuta dell’onorario {m}",
 "Recibo criado": "Ricevuta creata",
 "O recibo entrou em Documentos, na competência {m}.": "La ricevuta è stata aggiunta a Documenti, nella competenza {m}.",
 "Vendo como o cliente": "Visualizzi come il cliente",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "Così il cliente vede la sua cartella: senza le note interne e senza ciò che è solo del team. In questa modalità non si può modificare nulla.",
 "Voltar a ver como escritório": "Torna alla vista studio",
 "Ver como o cliente": "Vedi come il cliente",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Note interne (il cliente non le vede mai)",
 "Recibo do honorário…": "Ricevuta dell’onorario…",
 "Competência do recibo": "Competenza della ricevuta",
 "⬇️ Baixar o mês": "⬇️ Scarica il mese",
 "Me avisar para lembrar o cliente": "Avvisami per ricordare al cliente",
 "Guardar como modelo": "Salva come modello",
 "Modelo guardado": "Modello salvato",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "Quando crei una richiesta per un cliente qualsiasi, tocca \"Usa un modello di richiesta\".",
 "Relatório do mês": "Report del mese",
 "Notas rápidas": "Note rapide",
 "Item completo: {o}": "Elemento completo: {o}",
 "Reuniões do mês": "Riunioni del mese",
 "Tarefas feitas e pendentes": "Attività svolte e in sospeso",
 "Documentos internos enviados": "Documenti interni inviati",
 "Documentos enviados e recebidos dos clientes": "Documenti inviati e ricevuti dai clienti",
 "Documentos da competência": "Documenti di competenza",
 "Guias pagas e vencidas": "Bollettini pagati e scaduti",
 "Honorários": "Onorari",
 "Relatório do mês · {m}": "Report del mese · {m}",
 "Reuniões ({n})": "Riunioni ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Attività: {f} svolte nel mese · {p} in sospeso",
 "Quem fez": "Chi l’ha fatto",
 "Feita em": "Fatta il",
 "Documentos internos enviados ({n})": "Documenti interni inviati ({n})",
 "Documentos trocados com os clientes": "Documenti scambiati con i clienti",
 "Enviados pelo escritório": "Inviati dallo studio",
 "Recebidos do cliente": "Ricevuti dal cliente",
 "Nenhum documento trocado neste mês.": "Nessun documento scambiato questo mese.",
 "Clientes com pendência ({n})": "Clienti con pendenze ({n})",
 "Pendência": "Pendenza",
 "Nenhum cliente com pendência.": "Nessun cliente con pendenze.",
 "Documentos da competência {m} ({n})": "Documenti di competenza {m} ({n})",
 "Pedidos de documentos ({n})": "Richieste di documenti ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Bollettini del mese: {p} pagati · {v} scaduti",
 "Vencida": "Scaduta",
 "Recebido no mês": "Ricevuto nel mese",
 "Relatório {m} {q}": "Report {m} {q}",
 "MÊS": "MESE",
 "DE QUEM": "DI CHI",
 "O escritório": "Lo studio",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Riunioni, attività e documenti interni vengono inclusi quando c’è uno studio (team).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, note interne e conversazioni non finiscono mai nel report.",
 "Anotações recebidas": "Note ricevute",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "Gli importi da ricevere di questa lista compaiono in My Planner, anche quelli nuovi.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "Invia solo gli importi da ricevere di questa lista (gli appuntamenti ci vanno già da soli), anche quelli nuovi.",
 "Acrescentar": "Aggiungi",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "Le {n} caselle sono in {aba}, in \"Note ricevute\".",
 "Enviadas": "Inviate",
 "Enviar para": "Invia a",
 "Excluir 1 item?": "Eliminare 1 elemento?",
 "Excluir {n} itens?": "Eliminare {n} elementi?",
 "Inserir abaixo": "Inserisci sotto",
 "Mover para": "Sposta in",
 "Mover {n} selecionados para": "Sposta {n} selezionati in",
 "adicionar aqui": "aggiungi qui",
 "continue segurando para selecionar": "continua a tenere premuto per selezionare"
}
